(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as OI, getPartnerDevApiHeaders as RI, WidgetContextProvider as PI, makeExecuteQuery as AI, makeUseLazyQuery as LI, makeUseQuery as VI, makeUseMutation as zI, validateApiHostName as Iy, useTracking as $n, useWidgetContext as _n, hasDownstreamApiForbiddenError as zl, hasDownstreamApiAuthorizationError as Ul, DisplayErrors as Tn, useCopyWithDelay as ir, defaultDateFormat as It, displayAttributeValue as Gi, useWidgetSettingsMutations as si, useWidgetSettingsQuery as li, useRenderConditions as ci, PartnerSettingsWrapper as ui, handleWidgetSubmit as di, MisconfigurationBanner as mi, OAuthSettings as Da, WidgetSettingsFormFooter as pi, useData as $y, PartnerHookFormSecretText as Zo, isDownstreamApiNotFoundError as UI, isDownstreamApiAuthorizationError as qw, KlaviyoSubscribeSetting as MI, isDownstreamApiPermissionError as BI, capitalizeFirstCharacter as Hw, humanizeKey as qI, hasDownstreamApiTooManyRequestsError as HI, hasDownstreamApiPermissionError as Ww, PartnerHookFormBasicAuth as WI, hasDownstreamApiNotFoundError as Oa, getCountryNameFromCountryCode as KI, parseBoolean as GI, parseString as YI, IntegrationModal as Kw, useInboundOAuthContext as QI, getWidgetConfigurationByIdQuery as JI, createWidgetConfigurationMutation as XI, updateWidgetConfigurationMutation as ZI, trackRenderConditionsSaved as e$, deleteWidgetConfigurationMutation as n$ } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Ee, { useMemo as Xn, useState as ue, useEffect as Xe, useRef as Bi, useCallback as ft, useReducer as t$, useLayoutEffect as r$, useContext as Ey, isValidElement as Gw, createContext as Yw, createElement as i$, Fragment as a$ } from "react";
import { Text as P, FlexBox as b, Spinner as vn, Icon as he, Tooltip as Je, List as Qe, Badge as Bn, Button as et, IconButton as mr, Switch as hl, FieldLabel as Qw, FieldWrapper as rn, InputText as _r, InputSelectionList as _i, FormGrid as mt, FormField as pe, Tag as Yn, NavigationButton as Bt, Select as Or, CollapseCard as xr, Box as ct, Modal as Et, ModalHead as Tt, ModalBody as Dt, ModalFoot as Ht, Textarea as zh, TagsInput as Ml, Image as Ra, Banner as Bl, Divider as Ty, SelectionList as vt, FieldText as ur, FieldTextarea as o$, CopyToClipboardButton as s$, getSelectionListContext as l$, Avatar as Dy, Timestamp as c$, Attachment as u$, FieldSwitch as Oy, EmptyState as yl, Table as st, Checkbox as xv, TextWithHighlight as d$, ErrorBoundaryContext as Jw } from "@dixa/lib-shared-habla";
import dt from "classnames";
import { ApolloLink as Ry, Observable as Xw, ApolloClient as m$, InMemoryCache as p$, createHttpLink as f$, ApolloProvider as h$, useApolloClient as y$, ApolloConsumer as g$, NetworkStatus as dr, isApolloError as Zw, ApolloError as e1, gql as ql, useQuery as v$, useMutation as Sv } from "@apollo/client";
import k$ from "cross-fetch";
import { config as Go } from "lib-shared-backend-config";
import Qn from "moment";
import "moment-timezone";
import { __rest as b$, __assign as gc } from "tslib";
import { useLocation as _$ } from "react-router-dom";
function Py(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gs = { exports: {} }, Ga = {};
var Nv;
function x$() {
  if (Nv) return Ga;
  Nv = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ga.Fragment = r, Ga.jsx = s, Ga.jsxs = s, Ga;
}
var Ya = {};
var jv;
function S$() {
  return jv || (jv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c, $));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Ya.Fragment = i, Ya.jsx = Un, Ya.jsxs = Kn;
  })()), Ya;
}
var wv;
function N$() {
  return wv || (wv = 1, process.env.NODE_ENV === "production" ? gs.exports = x$() : gs.exports = S$()), gs.exports;
}
var We = N$();
function n1(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: j$ } = Object.prototype, { getPrototypeOf: Ca } = Object, { iterator: es, toStringTag: t1 } = Symbol, gl = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), Yo = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), gl(r, n))
      return !0;
    r = Ca(r);
  }
  return !1;
}, w$ = (e, n) => e != null && Yo(e, n) ? e[n] : void 0, Ay = /* @__PURE__ */ ((e) => (n) => {
  const r = j$.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Rr = (e) => (e = e.toLowerCase(), (n) => Ay(n) === e), Hl = (e) => (n) => typeof n === e, { isArray: Yi } = Array, Fa = Hl("undefined");
function Pa(e) {
  return e !== null && !Fa(e) && e.constructor !== null && !Fa(e.constructor) && lr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const r1 = Rr("ArrayBuffer");
function C$(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && r1(e.buffer), n;
}
const F$ = Hl("string"), lr = Hl("function"), i1 = Hl("number"), Aa = (e) => e !== null && typeof e == "object", I$ = (e) => e === !0 || e === !1, Xs = (e) => {
  if (!Aa(e))
    return !1;
  const n = Ca(e);
  return (n === null || n === Object.prototype || Ca(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !Yo(e, t1) && !Yo(e, es);
}, $$ = (e) => {
  if (!Aa(e) || Pa(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, E$ = Rr("Date"), T$ = Rr("File"), D$ = (e) => !!(e && typeof e.uri < "u"), O$ = (e) => e && typeof e.getParts < "u", R$ = Rr("Blob"), P$ = Rr("FileList"), A$ = (e) => Aa(e) && lr(e.pipe);
function L$() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Cv = L$(), Fv = typeof Cv.FormData < "u" ? Cv.FormData : void 0, V$ = (e) => {
  if (!e) return !1;
  if (Fv && e instanceof Fv) return !0;
  const n = Ca(e);
  if (!n || n === Object.prototype || !lr(e.append)) return !1;
  const r = Ay(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && lr(e.toString) && e.toString() === "[object FormData]";
}, z$ = Rr("URLSearchParams"), [U$, M$, B$, q$] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Rr), H$ = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ns(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Yi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Pa(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function a1(e, n) {
  if (Pa(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const Vi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, o1 = (e) => !Fa(e) && e !== Vi;
function Uh(...e) {
  const { caseless: n, skipUndefined: r } = o1(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && a1(i, s) || s, u = gl(i, l) ? i[l] : void 0;
    Xs(u) && Xs(o) ? i[l] = Uh(u, o) : Xs(o) ? i[l] = Uh({}, o) : Yi(o) ? i[l] = o.slice() : (!r || !Fa(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || Pa(l) || (ns(l, a), typeof l != "object" || Yi(l)))
      continue;
    const u = Object.getOwnPropertySymbols(l);
    for (let p = 0; p < u.length; p++) {
      const d = u[p];
      rE.call(l, d) && a(l[d], d);
    }
  }
  return i;
}
const W$ = (e, n, r, { allOwnKeys: i } = {}) => (ns(
  n,
  (a, o) => {
    r && lr(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: n1(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), K$ = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), G$ = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, Y$ = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Ca(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, Q$ = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, J$ = (e) => {
  if (!e) return null;
  if (Yi(e)) return e;
  let n = e.length;
  if (!i1(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, X$ = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ca(Uint8Array)), Z$ = (e, n) => {
  const i = (e && e[es]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, eE = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, nE = Rr("HTMLFormElement"), tE = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: rE } = Object.prototype, iE = Rr("RegExp"), s1 = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  ns(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, aE = (e) => {
  s1(e, (n, r) => {
    if (lr(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (lr(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, oE = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Yi(e) ? i(e) : i(String(e).split(n)), r;
}, sE = () => {
}, lE = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function cE(e) {
  return !!(e && lr(e.append) && e[t1] === "FormData" && e[es]);
}
const uE = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if (Aa(i)) {
      if (n.has(i))
        return;
      if (Pa(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = Yi(i) ? [] : {};
        return ns(i, (o, s) => {
          const l = r(o);
          !Fa(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, dE = Rr("AsyncFunction"), mE = (e) => e && (Aa(e) || lr(e)) && lr(e.then) && lr(e.catch), l1 = ((e, n) => e ? setImmediate : n ? ((r, i) => (Vi.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === Vi && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), Vi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", lr(Vi.postMessage)), pE = typeof queueMicrotask < "u" ? queueMicrotask.bind(Vi) : typeof process < "u" && process.nextTick || l1, c1 = (e) => e != null && lr(e[es]), fE = (e) => e != null && Yo(e, es) && c1(e), me = {
  isArray: Yi,
  isArrayBuffer: r1,
  isBuffer: Pa,
  isFormData: V$,
  isArrayBufferView: C$,
  isString: F$,
  isNumber: i1,
  isBoolean: I$,
  isObject: Aa,
  isPlainObject: Xs,
  isEmptyObject: $$,
  isReadableStream: U$,
  isRequest: M$,
  isResponse: B$,
  isHeaders: q$,
  isUndefined: Fa,
  isDate: E$,
  isFile: T$,
  isReactNativeBlob: D$,
  isReactNative: O$,
  isBlob: R$,
  isRegExp: iE,
  isFunction: lr,
  isStream: A$,
  isURLSearchParams: z$,
  isTypedArray: X$,
  isFileList: P$,
  forEach: ns,
  merge: Uh,
  extend: W$,
  trim: H$,
  stripBOM: K$,
  inherits: G$,
  toFlatObject: Y$,
  kindOf: Ay,
  kindOfTest: Rr,
  endsWith: Q$,
  toArray: J$,
  forEachEntry: Z$,
  matchAll: eE,
  isHTMLForm: nE,
  hasOwnProperty: gl,
  hasOwnProp: gl,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: Yo,
  getSafeProp: w$,
  reduceDescriptors: s1,
  freezeMethods: aE,
  toObjectSet: oE,
  toCamelCase: tE,
  noop: sE,
  toFiniteNumber: lE,
  findKey: a1,
  global: Vi,
  isContextDefined: o1,
  isSpecCompliantForm: cE,
  toJSONObject: uE,
  isAsyncFn: dE,
  isThenable: mE,
  setImmediate: l1,
  asap: pE,
  isIterable: c1,
  isSafeIterable: fE
}, hE = me.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), yE = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && hE[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function gE(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const vE = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), kE = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Ly(e, n) {
  return me.isArray(e) ? e.map((r) => Ly(r, n)) : gE(String(e).replace(n, ""));
}
const bE = (e) => Ly(e, vE), _E = (e) => Ly(e, kE);
function u1(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return me.forEach(e.toJSON(), (r, i) => {
    n[i] = _E(r);
  }), n;
}
const Iv = /* @__PURE__ */ Symbol("internals");
function Qa(e) {
  return e && String(e).trim().toLowerCase();
}
function Zs(e) {
  return e === !1 || e == null ? e : me.isArray(e) ? e.map(Zs) : bE(String(e));
}
function xE(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const SE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function vc(e, n, r, i, a) {
  if (me.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!me.isString(n)) {
    if (me.isString(i))
      return n.indexOf(i) !== -1;
    if (me.isRegExp(i))
      return i.test(n);
  }
}
function NE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function jE(e, n) {
  const r = me.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Kt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, u, p) {
      const d = Qa(u);
      if (!d)
        return;
      const f = me.findKey(a, d);
      (!f || a[f] === void 0 || p === !0 || p === void 0 && a[f] !== !1) && (a[f || u] = Zs(l));
    }
    const s = (l, u) => me.forEach(l, (p, d) => o(p, d, u));
    if (me.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (me.isString(n) && (n = n.trim()) && !SE(n))
      s(yE(n), r);
    else if (me.isObject(n) && me.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), u, p;
      for (const d of n) {
        if (!me.isArray(d))
          throw new TypeError("Object iterator must return a key-value pair");
        p = d[0], me.hasOwnProp(l, p) ? (u = l[p], l[p] = me.isArray(u) ? [...u, d[1]] : [u, d[1]]) : l[p] = d[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Qa(n), n) {
      const i = me.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return xE(a);
        if (me.isFunction(r))
          return r.call(this, a, i);
        if (me.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Qa(n), n) {
      const i = me.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || vc(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Qa(s), s) {
        const l = me.findKey(i, s);
        l && (!r || vc(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return me.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || vc(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return me.forEach(this, (a, o) => {
      const s = me.findKey(i, o);
      if (s) {
        r[s] = Zs(a), delete r[o];
        return;
      }
      const l = n ? NE(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Zs(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return me.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && me.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Iv] = this[Iv] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Qa(s);
      i[l] || (jE(a, s), i[l] = !0);
    }
    return me.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Kt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
me.reduceDescriptors(Kt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
me.freezeMethods(Kt);
const wE = "[REDACTED ****]";
function CE(e) {
  if (me.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (me.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function FE(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || me.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Kt && (o = o.toJSON()), i.push(o);
    let s;
    if (me.isArray(o))
      s = [], o.forEach((l, u) => {
        const p = a(l);
        me.isUndefined(p) || (s[u] = p);
      });
    else {
      if (!me.isPlainObject(o) && CE(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, u] of Object.entries(o)) {
        const p = r.has(l.toLowerCase()) ? wE : a(u);
        me.isUndefined(p) || (s[l] = p);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let cn = class d1 extends Error {
  static from(n, r, i, a, o, s) {
    const l = new d1(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && me.hasOwnProp(n, "redact") ? n.redact : void 0, i = me.isArray(r) && r.length > 0 ? FE(n, r) : me.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
cn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
cn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
cn.ECONNABORTED = "ECONNABORTED";
cn.ETIMEDOUT = "ETIMEDOUT";
cn.ECONNREFUSED = "ECONNREFUSED";
cn.ERR_NETWORK = "ERR_NETWORK";
cn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
cn.ERR_DEPRECATED = "ERR_DEPRECATED";
cn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
cn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
cn.ERR_CANCELED = "ERR_CANCELED";
cn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
cn.ERR_INVALID_URL = "ERR_INVALID_URL";
cn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const IE = null, m1 = 100;
function Mh(e) {
  return me.isPlainObject(e) || me.isArray(e);
}
function p1(e) {
  return me.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function kc(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = p1(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function $E(e) {
  return me.isArray(e) && !e.some(Mh);
}
const EE = me.toFlatObject(me, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Wl(e, n, r) {
  if (!me.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = me.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(y, L) {
      return !me.isUndefined(L[y]);
    }
  );
  const i = r.metaTokens, a = r.visitor || I, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, u = r.maxDepth === void 0 ? m1 : r.maxDepth, p = l && me.isSpecCompliantForm(n), d = [];
  if (!me.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(_) {
    if (_ === null) return "";
    if (me.isDate(_))
      return _.toISOString();
    if (me.isBoolean(_))
      return _.toString();
    if (!p && me.isBlob(_))
      throw new cn("Blob is not supported. Use a Buffer instead.");
    return me.isArrayBuffer(_) || me.isTypedArray(_) ? p && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function h(_) {
    if (_ > u)
      throw new cn(
        "Object is too deeply nested (" + _ + " levels). Max depth: " + u,
        cn.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function v(_, y) {
    if (u === 1 / 0)
      return JSON.stringify(_);
    const L = [];
    return JSON.stringify(_, function(C, F) {
      if (!me.isObject(F))
        return F;
      for (; L.length && L[L.length - 1] !== this; )
        L.pop();
      return L.push(F), h(y + L.length - 1), F;
    });
  }
  function I(_, y, L) {
    let E = _;
    if (me.isReactNative(n) && me.isReactNativeBlob(_))
      return n.append(kc(L, y, o), f(_)), !1;
    if (_ && !L && typeof _ == "object") {
      if (me.endsWith(y, "{}"))
        y = i ? y : y.slice(0, -2), _ = v(_, 1);
      else if (me.isArray(_) && $E(_) || (me.isFileList(_) || me.endsWith(y, "[]")) && (E = me.toArray(_)))
        return y = p1(y), E.forEach(function(F, z) {
          !(me.isUndefined(F) || F === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? kc([y], z, o) : s === null ? y : y + "[]",
            f(F)
          );
        }), !1;
    }
    return Mh(_) ? !0 : (n.append(kc(L, y, o), f(_)), !1);
  }
  const w = Object.assign(EE, {
    defaultVisitor: I,
    convertValue: f,
    isVisitable: Mh
  });
  function j(_, y, L = 0) {
    if (!me.isUndefined(_)) {
      if (h(L), d.indexOf(_) !== -1)
        throw new Error("Circular reference detected in " + y.join("."));
      d.push(_), me.forEach(_, function(C, F) {
        (!(me.isUndefined(C) || C === null) && a.call(n, C, me.isString(F) ? F.trim() : F, y, w)) === !0 && j(C, y ? y.concat(F) : [F], L + 1);
      }), d.pop();
    }
  }
  if (!me.isObject(e))
    throw new TypeError("data must be an object");
  return j(e), n;
}
function $v(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Vy(e, n) {
  this._pairs = [], e && Wl(e, this, n);
}
const f1 = Vy.prototype;
f1.append = function(n, r) {
  this._pairs.push([n, r]);
};
f1.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, $v);
  } : $v;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function TE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function h1(e, n, r) {
  if (!n)
    return e;
  const i = me.isFunction(r) ? {
    serialize: r
  } : r, a = me.getSafeProp(i, "encode") || TE, o = me.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = me.isURLSearchParams(n) ? n.toString() : new Vy(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class Ev {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    me.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const zy = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, DE = typeof URLSearchParams < "u" ? URLSearchParams : Vy, OE = typeof FormData < "u" ? FormData : null, RE = typeof Blob < "u" ? Blob : null, PE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: DE,
    FormData: OE,
    Blob: RE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Uy = typeof window < "u" && typeof document < "u", Bh = typeof navigator == "object" && navigator || void 0, AE = Uy && (!Bh || ["ReactNative", "NativeScript", "NS"].indexOf(Bh.product) < 0), LE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", VE = Uy && window.location.href || "http://localhost", zE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Uy,
  hasStandardBrowserEnv: AE,
  hasStandardBrowserWebWorkerEnv: LE,
  navigator: Bh,
  origin: VE
}, Symbol.toStringTag, { value: "Module" })), Ut = {
  ...zE,
  ...PE
};
function UE(e, n) {
  return Wl(e, new Ut.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ut.isNode && me.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const Tv = m1;
function y1(e) {
  if (e > Tv)
    throw new cn(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + Tv,
      cn.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function ME(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    y1(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function BE(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function g1(e) {
  function n(r, i, a, o) {
    y1(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), u = o >= r.length;
    return s = !s && me.isArray(a) ? a.length : s, u ? (me.hasOwnProp(a, s) ? a[s] = me.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!me.hasOwnProp(a, s) || !me.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && me.isArray(a[s]) && (a[s] = BE(a[s])), !l);
  }
  if (me.isFormData(e) && me.isFunction(e.entries)) {
    const r = {};
    return me.forEachEntry(e, (i, a) => {
      n(ME(i), a, r, 0);
    }), r;
  }
  return null;
}
const aa = (e, n) => e != null && me.hasOwnProp(e, n) ? e[n] : void 0;
function qE(e, n, r) {
  if (me.isString(e))
    try {
      return (n || JSON.parse)(e), me.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const ts = {
  transitional: zy,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = me.isObject(n);
      if (o && me.isHTMLForm(n) && (n = new FormData(n)), me.isFormData(n))
        return a ? JSON.stringify(g1(n)) : n;
      if (me.isArrayBuffer(n) || me.isBuffer(n) || me.isStream(n) || me.isFile(n) || me.isBlob(n) || me.isReadableStream(n))
        return n;
      if (me.isArrayBufferView(n))
        return n.buffer;
      if (me.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const u = aa(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return UE(n, u).toString();
        if ((l = me.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const p = aa(this, "env"), d = p && p.FormData;
          return Wl(
            l ? { "files[]": n } : n,
            d && new d(),
            u
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), qE(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = aa(this, "transitional") || ts.transitional, i = r && r.forcedJSONParsing, a = aa(this, "responseType"), o = a === "json";
      if (me.isResponse(n) || me.isReadableStream(n))
        return n;
      if (n && me.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, aa(this, "parseReviver"));
        } catch (u) {
          if (l)
            throw u.name === "SyntaxError" ? cn.from(u, cn.ERR_BAD_RESPONSE, this, null, aa(this, "response")) : u;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ut.classes.FormData,
    Blob: Ut.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
me.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  ts.headers[e] = {};
});
function bc(e, n) {
  const r = this || ts, i = n || r, a = Kt.from(i.headers);
  let o = i.data;
  return me.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function v1(e) {
  return !!(e && e.__CANCEL__);
}
let rs = class extends cn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", cn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function k1(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new cn(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? cn.ERR_BAD_REQUEST : cn.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function HE(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function WE(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const p = Date.now(), d = i[o];
    s || (s = p), r[a] = u, i[a] = p;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), p - s < n)
      return;
    const v = d && p - d;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function KE(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (p, d = Date.now()) => {
    r = d, a = null, o && (clearTimeout(o), o = null), e(...p);
  };
  return [(...p) => {
    const d = Date.now(), f = d - r;
    f >= i ? s(p, d) : (a = p, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const vl = (e, n, r = 3) => {
  let i = 0;
  const a = WE(50, 250);
  return KE((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, u = l != null ? Math.min(s, l) : s, p = Math.max(0, u - i), d = a(p);
    i = Math.max(i, u);
    const f = {
      loaded: u,
      total: l,
      progress: l ? u / l : void 0,
      bytes: p,
      rate: d || void 0,
      estimated: d && l ? (l - u) / d : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, Dv = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, Ov = (e) => (...n) => me.asap(() => e(...n)), GE = Ut.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ut.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ut.origin),
  Ut.navigator && /(msie|trident)/i.test(Ut.navigator.userAgent)
) : () => !0, YE = Ut.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      me.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), me.isString(i) && l.push(`path=${i}`), me.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), me.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function QE(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function JE(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const XE = /^https?:(?!\/\/)/i, ZE = /[\t\n\r]/g;
function eT(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function nT(e) {
  return eT(e).replace(ZE, "");
}
function Rv(e, n) {
  if (typeof e == "string" && XE.test(nT(e)))
    throw new cn(
      'Invalid URL: missing "//" after protocol',
      cn.ERR_INVALID_URL,
      n
    );
}
function b1(e, n, r, i) {
  Rv(n, i);
  let a = !QE(n);
  return e && (a || r === !1) ? (Rv(e, i), JE(e, n)) : n;
}
const Pv = (e) => e instanceof Kt ? { ...e } : e;
function Qi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(d, f, h, v) {
    return me.isPlainObject(d) && me.isPlainObject(f) ? me.merge.call({ caseless: v }, d, f) : me.isPlainObject(f) ? me.merge({}, f) : me.isArray(f) ? f.slice() : f;
  }
  function a(d, f, h, v) {
    if (me.isUndefined(f)) {
      if (!me.isUndefined(d))
        return i(void 0, d, h, v);
    } else return i(d, f, h, v);
  }
  function o(d, f) {
    if (!me.isUndefined(f))
      return i(void 0, f);
  }
  function s(d, f) {
    if (me.isUndefined(f)) {
      if (!me.isUndefined(d))
        return i(void 0, d);
    } else return i(void 0, f);
  }
  function l(d) {
    const f = me.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!me.isUndefined(f))
      if (me.isPlainObject(f)) {
        if (me.hasOwnProp(f, d))
          return f[d];
      } else
        return;
    const h = me.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (me.isPlainObject(h) && me.hasOwnProp(h, d))
      return h[d];
  }
  function u(d, f, h) {
    if (me.hasOwnProp(n, h))
      return i(d, f);
    if (me.hasOwnProp(e, h))
      return i(void 0, d);
  }
  const p = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: u,
    headers: (d, f, h) => a(Pv(d), Pv(f), h, !0)
  };
  return me.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = me.hasOwnProp(p, f) ? p[f] : a, v = me.hasOwnProp(e, f) ? e[f] : void 0, I = me.hasOwnProp(n, f) ? n[f] : void 0, w = h(v, I, f);
    me.isUndefined(w) && h !== u || (r[f] = w);
  }), me.hasOwnProp(n, "validateStatus") && me.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (me.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const tT = ["content-type", "content-length"];
function rT(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    tT.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const iT = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function _1(e) {
  const n = Qi({}, e), r = (h) => me.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const u = r("auth"), p = r("baseURL"), d = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Kt.from(l), n.url = h1(
    b1(p, f, d, n),
    r("params"),
    r("paramsSerializer")
  ), u) {
    const h = me.getSafeProp(u, "username") || "", v = me.getSafeProp(u, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (v ? iT(v) : ""))
    );
  }
  if (me.isFormData(i) && (Ut.hasStandardBrowserEnv || Ut.hasStandardBrowserWebWorkerEnv || me.isReactNative(i) ? l.setContentType(void 0) : me.isFunction(i.getHeaders) && rT(l, i.getHeaders(), r("formDataHeaderPolicy"))), Ut.hasStandardBrowserEnv && (me.isFunction(a) && (a = a(n)), a === !0 || a == null && GE(n.url))) {
    const v = o && s && YE.read(s);
    v && l.set(o, v);
  }
  return n;
}
const aT = typeof XMLHttpRequest < "u", oT = aT && function(e) {
  return new Promise(function(r, i) {
    const a = _1(e);
    let o = a.data;
    const s = Kt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: u, onDownloadProgress: p } = a, d, f, h, v, I;
    function w() {
      v && v(), I && I(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function _() {
      if (!j)
        return;
      const L = Kt.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: L,
        config: e,
        request: j
      };
      k1(
        function(z) {
          r(z), w();
        },
        function(z) {
          i(z), w();
        },
        C
      ), j = null;
    }
    "onloadend" in j ? j.onloadend = _ : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.startsWith("file:")) || setTimeout(_);
    }, j.onabort = function() {
      j && (i(new cn("Request aborted", cn.ECONNABORTED, e, j)), w(), j = null);
    }, j.onerror = function(E) {
      const C = E && E.message ? E.message : "Network Error", F = new cn(C, cn.ERR_NETWORK, e, j);
      F.event = E || null, i(F), w(), j = null;
    }, j.ontimeout = function() {
      let E = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const C = a.transitional || zy;
      a.timeoutErrorMessage && (E = a.timeoutErrorMessage), i(
        new cn(
          E,
          C.clarifyTimeoutError ? cn.ETIMEDOUT : cn.ECONNABORTED,
          e,
          j
        )
      ), w(), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && me.forEach(u1(s), function(E, C) {
      j.setRequestHeader(C, E);
    }), me.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), p && ([h, I] = vl(p, !0), j.addEventListener("progress", h)), u && j.upload && ([f, v] = vl(u), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (d = (L) => {
      j && (i(!L || L.type ? new rs(null, e, j) : L), j.abort(), w(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const y = HE(a.url);
    if (y && !Ut.protocols.includes(y)) {
      i(
        new cn(
          "Unsupported protocol " + y + ":",
          cn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    j.send(o || null);
  });
}, sT = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(u) {
    if (!i) {
      i = !0, s();
      const p = u instanceof Error ? u : this.reason;
      r.abort(
        p instanceof cn ? p : new rs(p instanceof Error ? p.message : p)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new cn(`timeout of ${n}ms exceeded`, cn.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((u) => {
      u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((u) => u.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => me.asap(s), l;
}, lT = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, cT = async function* (e, n) {
  for await (const r of uT(e))
    yield* lT(r, n);
}, uT = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Av = (e, n, r, i) => {
  const a = cT(e, n);
  let o = 0, s, l = (u) => {
    s || (s = !0, i && i(u));
  };
  return new ReadableStream(
    {
      async pull(u) {
        try {
          const { done: p, value: d } = await a.next();
          if (p) {
            l(), u.close();
            return;
          }
          let f = d.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          u.enqueue(new Uint8Array(d));
        } catch (p) {
          throw l(p), p;
        }
      },
      cancel(u) {
        return l(u), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, kl = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, dT = (e, n, r) => n + 2 < r && kl(e.charCodeAt(n + 1)) && kl(e.charCodeAt(n + 2));
function mT(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let v = 0; v < l; v++)
      if (i.charCodeAt(v) === 37 && v + 2 < l) {
        const I = i.charCodeAt(v + 1), w = i.charCodeAt(v + 2);
        kl(I) && kl(w) && (s -= 2, v += 2);
      }
    let u = 0, p = l - 1;
    const d = (v) => v >= 2 && i.charCodeAt(v - 2) === 37 && // '%'
    i.charCodeAt(v - 1) === 51 && // '3'
    (i.charCodeAt(v) === 68 || i.charCodeAt(v) === 100);
    p >= 0 && (i.charCodeAt(p) === 61 ? (u++, p--) : d(p) && (u++, p -= 3)), u === 1 && p >= 0 && (i.charCodeAt(p) === 61 || d(p)) && u++;
    const h = Math.floor(s / 4) * 3 - (u || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const u = i.charCodeAt(s);
    if (u === 37 && dT(i, s, l))
      o += 1, s += 2;
    else if (u < 128)
      o += 1;
    else if (u < 2048)
      o += 2;
    else if (u >= 55296 && u <= 56319 && s + 1 < l) {
      const p = i.charCodeAt(s + 1);
      p >= 56320 && p <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const My = "1.18.0", Lv = 64 * 1024, { isFunction: vs } = me, pT = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), Vv = (e) => {
  if (!me.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, zv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, fT = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, hT = (e) => {
  const n = me.global !== void 0 && me.global !== null ? me.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = me.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? vs(a) : typeof fetch == "function", u = vs(o), p = vs(s);
  if (!l)
    return !1;
  const d = l && vs(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((_) => (y) => _.encode(y))(new i()) : async (_) => new Uint8Array(await new o(_).arrayBuffer())), h = u && d && zv(() => {
    let _ = !1;
    const y = new o(Ut.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return _ = !0, "half";
      }
    }), L = y.headers.has("Content-Type");
    return y.body != null && y.body.cancel(), _ && !L;
  }), v = p && d && zv(() => me.isReadableStream(new s("").body)), I = {
    stream: v && ((_) => _.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((_) => {
    !I[_] && (I[_] = (y, L) => {
      let E = y && y[_];
      if (E)
        return E.call(y);
      throw new cn(
        `Response type '${_}' is not supported`,
        cn.ERR_NOT_SUPPORT,
        L
      );
    });
  });
  const w = async (_) => {
    if (_ == null)
      return 0;
    if (me.isBlob(_))
      return _.size;
    if (me.isSpecCompliantForm(_))
      return (await new o(Ut.origin, {
        method: "POST",
        body: _
      }).arrayBuffer()).byteLength;
    if (me.isArrayBufferView(_) || me.isArrayBuffer(_))
      return _.byteLength;
    if (me.isURLSearchParams(_) && (_ = _ + ""), me.isString(_))
      return (await f(_)).byteLength;
  }, j = async (_, y) => {
    const L = me.toFiniteNumber(_.getContentLength());
    return L ?? w(y);
  };
  return async (_) => {
    let {
      url: y,
      method: L,
      data: E,
      signal: C,
      cancelToken: F,
      timeout: z,
      onDownloadProgress: Q,
      onUploadProgress: Z,
      responseType: te,
      headers: G,
      withCredentials: B = "same-origin",
      fetchOptions: R,
      maxContentLength: U,
      maxBodyLength: ee
    } = _1(_);
    const Se = me.isNumber(U) && U > -1, fe = me.isNumber(ee) && ee > -1, ye = (we) => me.hasOwnProp(_, we) ? _[we] : void 0;
    let ve = a || fetch;
    te = te ? (te + "").toLowerCase() : "text";
    let K = sT(
      [C, F && F.toAbortSignal()],
      z
    ), _e = null;
    const Te = K && K.unsubscribe && (() => {
      K.unsubscribe();
    });
    let J, Ke = null;
    const an = () => new cn(
      "Request body larger than maxBodyLength limit",
      cn.ERR_BAD_REQUEST,
      _,
      _e
    );
    try {
      let we;
      const Me = ye("auth");
      if (Me) {
        const se = me.getSafeProp(Me, "username") || "", xe = me.getSafeProp(Me, "password") || "";
        we = {
          username: se,
          password: xe
        };
      }
      if (fT(y)) {
        const se = new URL(y, Ut.origin);
        if (!we && (se.username || se.password)) {
          const xe = Vv(se.username), Le = Vv(se.password);
          we = {
            username: xe,
            password: Le
          };
        }
        (se.username || se.password) && (se.username = "", se.password = "", y = se.href);
      }
      if (we && (G.delete("authorization"), G.set(
        "Authorization",
        "Basic " + btoa(pT((we.username || "") + ":" + (we.password || "")))
      )), Se && typeof y == "string" && y.startsWith("data:") && mT(y) > U)
        throw new cn(
          "maxContentLength size of " + U + " exceeded",
          cn.ERR_BAD_RESPONSE,
          _,
          _e
        );
      if (fe && L !== "get" && L !== "head") {
        const se = await w(E);
        if (typeof se == "number" && isFinite(se) && (J = se, se > ee))
          throw an();
      }
      const Re = fe && (me.isReadableStream(E) || me.isStream(E)), Be = (se, xe, Le) => Av(
        se,
        Lv,
        (Pe) => {
          if (fe && Pe > ee)
            throw Ke = an();
          xe && xe(Pe);
        },
        Le
      );
      if (h && L !== "get" && L !== "head" && (Z || Re)) {
        if (J = J ?? await j(G, E), J !== 0 || Re) {
          let se = new o(y, {
            method: "POST",
            body: E,
            duplex: "half"
          }), xe;
          if (me.isFormData(E) && (xe = se.headers.get("content-type")) && G.setContentType(xe), se.body) {
            const [Le, Pe] = Z && Dv(
              J,
              vl(Ov(Z))
            ) || [];
            E = Be(se.body, Le, Pe);
          }
        }
      } else if (Re && !u && d && L !== "get" && L !== "head")
        E = Be(E);
      else if (Re && u && !h && L !== "get" && L !== "head")
        throw new cn(
          "Stream request bodies are not supported by the current fetch implementation",
          cn.ERR_NOT_SUPPORT,
          _,
          _e
        );
      me.isString(B) || (B = B ? "include" : "omit");
      const Ae = u && "credentials" in o.prototype;
      if (me.isFormData(E)) {
        const se = G.getContentType();
        se && /^multipart\/form-data/i.test(se) && !/boundary=/i.test(se) && G.delete("content-type");
      }
      G.set("User-Agent", "axios/" + My, !1);
      const Ge = {
        ...R,
        signal: K,
        method: L.toUpperCase(),
        headers: u1(G.normalize()),
        body: E,
        duplex: "half",
        credentials: Ae ? B : void 0
      };
      _e = u && new o(y, Ge);
      let Ce = await (u ? ve(_e, R) : ve(y, Ge));
      const qe = Kt.from(Ce.headers);
      if (Se) {
        const se = me.toFiniteNumber(qe.getContentLength());
        if (se != null && se > U)
          throw new cn(
            "maxContentLength size of " + U + " exceeded",
            cn.ERR_BAD_RESPONSE,
            _,
            _e
          );
      }
      const en = v && (te === "stream" || te === "response");
      if (v && Ce.body && (Q || Se || en && Te)) {
        const se = {};
        ["status", "statusText", "headers"].forEach((x) => {
          se[x] = Ce[x];
        });
        const xe = me.toFiniteNumber(qe.getContentLength()), [Le, Pe] = Q && Dv(
          xe,
          vl(Ov(Q), !0)
        ) || [];
        let yn = 0;
        const T = (x) => {
          if (Se && (yn = x, yn > U))
            throw new cn(
              "maxContentLength size of " + U + " exceeded",
              cn.ERR_BAD_RESPONSE,
              _,
              _e
            );
          Le && Le(x);
        };
        Ce = new s(
          Av(Ce.body, Lv, T, () => {
            Pe && Pe(), Te && Te();
          }),
          se
        );
      }
      te = te || "text";
      let ie = await I[me.findKey(I, te) || "text"](
        Ce,
        _
      );
      if (Se && !v && !en) {
        let se;
        if (ie != null && (typeof ie.byteLength == "number" ? se = ie.byteLength : typeof ie.size == "number" ? se = ie.size : typeof ie == "string" && (se = typeof i == "function" ? new i().encode(ie).byteLength : ie.length)), typeof se == "number" && se > U)
          throw new cn(
            "maxContentLength size of " + U + " exceeded",
            cn.ERR_BAD_RESPONSE,
            _,
            _e
          );
      }
      return !en && Te && Te(), await new Promise((se, xe) => {
        k1(se, xe, {
          data: ie,
          headers: Kt.from(Ce.headers),
          status: Ce.status,
          statusText: Ce.statusText,
          config: _,
          request: _e
        });
      });
    } catch (we) {
      if (Te && Te(), K && K.aborted && K.reason instanceof cn) {
        const Me = K.reason;
        throw Me.config = _, _e && (Me.request = _e), we !== Me && (Me.cause = we), Me;
      }
      throw Ke ? (_e && !Ke.request && (Ke.request = _e), Ke) : we instanceof cn ? (_e && !we.request && (we.request = _e), we) : we && we.name === "TypeError" && /Load failed|fetch/i.test(we.message) ? Object.assign(
        new cn(
          "Network Error",
          cn.ERR_NETWORK,
          _,
          _e,
          we && we.response
        ),
        {
          cause: we.cause || we
        }
      ) : cn.from(we, we && we.code, _, _e, we && we.response);
    }
  };
}, yT = /* @__PURE__ */ new Map(), x1 = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, u, p, d = yT;
  for (; l--; )
    u = o[l], p = d.get(u), p === void 0 && d.set(u, p = l ? /* @__PURE__ */ new Map() : hT(n)), d = p;
  return p;
};
x1();
const By = {
  http: IE,
  xhr: oT,
  fetch: {
    get: x1
  }
};
me.forEach(By, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const Uv = (e) => `- ${e}`, gT = (e) => me.isFunction(e) || e === null || e === !1;
function vT(e, n) {
  e = me.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !gT(i) && (a = By[(l = String(i)).toLowerCase()], a === void 0))
      throw new cn(`Unknown adapter '${l}'`);
    if (a && (me.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([u, p]) => `adapter ${u} ` + (p === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(Uv).join(`
`) : " " + Uv(s[0]) : "as no adapter specified";
    throw new cn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const S1 = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: vT,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: By
};
function _c(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new rs(null, e);
}
function Mv(e) {
  return _c(e), e.headers = Kt.from(e.headers), e.data = bc.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), S1.getAdapter(e.adapter || ts.adapter, e)(e).then(
    function(i) {
      _c(e), e.response = i;
      try {
        i.data = bc.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Kt.from(i.headers), i;
    },
    function(i) {
      if (!v1(i) && (_c(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = bc.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Kt.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const Kl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Kl[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Bv = {};
Kl.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + My + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new cn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        cn.ERR_DEPRECATED
      );
    return r && !Bv[s] && (Bv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Kl.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function kT(e, n, r) {
  if (typeof e != "object")
    throw new cn("options must be an object", cn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], u = l === void 0 || s(l, o, e);
      if (u !== !0)
        throw new cn(
          "option " + o + " must be " + u,
          cn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new cn("Unknown option " + o, cn.ERR_BAD_OPTION);
  }
}
const el = {
  assertOptions: kT,
  validators: Kl
}, Wt = el.validators;
let qi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Ev(),
      response: new Ev()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), u = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(u) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Qi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && el.assertOptions(
      i,
      {
        silentJSONParsing: Wt.transitional(Wt.boolean),
        forcedJSONParsing: Wt.transitional(Wt.boolean),
        clarifyTimeoutError: Wt.transitional(Wt.boolean),
        legacyInterceptorReqResOrdering: Wt.transitional(Wt.boolean),
        advertiseZstdAcceptEncoding: Wt.transitional(Wt.boolean),
        validateStatusUndefinedResolves: Wt.transitional(Wt.boolean)
      },
      !1
    ), a != null && (me.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : el.assertOptions(
      a,
      {
        encode: Wt.function,
        serialize: Wt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), el.assertOptions(
      r,
      {
        baseUrl: Wt.spelling("baseURL"),
        withXsrfToken: Wt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && me.merge(o.common, o[r.method]);
    o && me.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (I) => {
      delete o[I];
    }), r.headers = Kt.concat(s, o);
    const l = [];
    let u = !0;
    this.interceptors.request.forEach(function(w) {
      if (typeof w.runWhen == "function" && w.runWhen(r) === !1)
        return;
      u = u && w.synchronous;
      const j = r.transitional || zy;
      j && j.legacyInterceptorReqResOrdering ? l.unshift(w.fulfilled, w.rejected) : l.push(w.fulfilled, w.rejected);
    });
    const p = [];
    this.interceptors.response.forEach(function(w) {
      p.push(w.fulfilled, w.rejected);
    });
    let d, f = 0, h;
    if (!u) {
      const I = [Mv.bind(this), void 0];
      for (I.unshift(...l), I.push(...p), h = I.length, d = Promise.resolve(r); f < h; )
        d = d.then(I[f++], I[f++]);
      return d;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const I = l[f++], w = l[f++];
      try {
        v = I(v);
      } catch (j) {
        w.call(this, j);
        break;
      }
    }
    try {
      d = Mv.call(this, v);
    } catch (I) {
      return Promise.reject(I);
    }
    for (f = 0, h = p.length; f < h; )
      d = d.then(p[f++], p[f++]);
    return d;
  }
  getUri(n) {
    n = Qi(this.defaults, n);
    const r = b1(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return h1(r, n.params, n.paramsSerializer);
  }
};
me.forEach(["delete", "get", "head", "options"], function(n) {
  qi.prototype[n] = function(r, i) {
    return this.request(
      Qi(i || {}, {
        method: n,
        url: r,
        data: i && me.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
me.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        Qi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  qi.prototype[n] = r(), n !== "query" && (qi.prototype[n + "Form"] = r(!0));
});
let bT = class N1 {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new rs(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new N1(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function _T(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function xT(e) {
  return me.isObject(e) && e.isAxiosError === !0;
}
const qh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(qh).forEach(([e, n]) => {
  qh[n] = e;
});
function j1(e) {
  const n = new qi(e), r = n1(qi.prototype.request, n);
  return me.extend(r, qi.prototype, n, { allOwnKeys: !0 }), me.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return j1(Qi(e, a));
  }, r;
}
const xt = j1(ts);
xt.Axios = qi;
xt.CanceledError = rs;
xt.CancelToken = bT;
xt.isCancel = v1;
xt.VERSION = My;
xt.toFormData = Wl;
xt.AxiosError = cn;
xt.Cancel = xt.CanceledError;
xt.all = function(n) {
  return Promise.all(n);
};
xt.spread = _T;
xt.isAxiosError = xT;
xt.mergeConfig = Qi;
xt.AxiosHeaders = Kt;
xt.formToJSON = (e) => g1(me.isHTMLForm(e) ? new FormData(e) : e);
xt.getAdapter = S1.getAdapter;
xt.HttpStatusCode = qh;
xt.default = xt;
const {
  Axios: _Y,
  AxiosError: xY,
  CanceledError: SY,
  isCancel: NY,
  CancelToken: jY,
  VERSION: wY,
  all: CY,
  Cancel: FY,
  isAxiosError: ST,
  spread: IY,
  toFormData: $Y,
  AxiosHeaders: EY,
  HttpStatusCode: TY,
  formToJSON: DY,
  getAdapter: OY,
  mergeConfig: RY,
  create: PY
} = xt;
class NT {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const qv = new NT();
function jT(e, n) {
  return Hv(e), Hv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Hv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const wT = Object.prototype.toString;
function CT(e, n) {
  return wT.call(e) === `[object ${n}]`;
}
function FT(e) {
  return CT(e, "Object");
}
function IT(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Ro = "8.36.0", oi = globalThis;
function qy(e, n, r) {
  const i = r || oi, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Ro] = a[Ro] || {};
  return o[e] || (o[e] = n());
}
const w1 = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, $T = "Sentry Logger ", Wv = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Kv = {};
function C1(e) {
  if (!("console" in oi))
    return e();
  const n = oi.console, r = {}, i = Object.keys(Kv);
  i.forEach((a) => {
    const o = Kv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function ET() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return w1 ? Wv.forEach((r) => {
    n[r] = (...i) => {
      e && C1(() => {
        oi.console[r](`${$T}[${r}]:`, ...i);
      });
    };
  }) : Wv.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const nl = qy("logger", ET);
function TT(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    w1 && nl.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const F1 = 1e3;
function Hy() {
  return Date.now() / F1;
}
function DT() {
  const { performance: e } = oi;
  if (!e || !e.now)
    return Hy;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / F1;
}
const OT = DT();
(() => {
  const { performance: e } = oi;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, u = typeof s == "number" ? Math.abs(s + r - i) : n, p = u < n;
  return o || p ? a <= u ? e.timeOrigin : s : i;
})();
function _a() {
  const e = oi, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Gv() {
  return {
    traceId: _a(),
    spanId: _a().substring(16)
  };
}
function Wy() {
  return Ky(oi), oi;
}
function Ky(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Ro, n[Ro] = n[Ro] || {};
}
function RT(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || OT(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : _a()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Hh = "_sentrySpan";
function Yv(e, n) {
  n ? TT(e, Hh, n) : delete e[Hh];
}
function Qv(e) {
  return e[Hh];
}
const PT = 100;
class Gy {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Gv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Gy();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Yv(n, Qv(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && RT(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Ia ? [r.getScopeData(), r.getRequestSession()] : FT(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: u, level: p, fingerprint: d = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...u }, l && Object.keys(l).length && (this._user = l), p && (this._level = p), d.length && (this._fingerprint = d), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Yv(this, void 0), this._attachments = [], this._propagationContext = Gv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : PT;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Hy(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Qv(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : _a();
    if (!this._client)
      return nl.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : _a();
    if (!this._client)
      return nl.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : _a();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (nl.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Ia = Gy;
function AT() {
  return qy("defaultCurrentScope", () => new Ia());
}
function LT() {
  return qy("defaultIsolationScope", () => new Ia());
}
class VT {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Ia();
    let a;
    r ? a = r : a = new Ia(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return IT(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function $a() {
  const e = Wy(), n = Ky(e);
  return n.stack = n.stack || new VT(AT(), LT());
}
function zT(e) {
  return $a().withScope(e);
}
function UT(e, n) {
  const r = $a();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Jv(e) {
  return $a().withScope(() => e($a().getIsolationScope()));
}
function MT() {
  return {
    withIsolationScope: Jv,
    withScope: zT,
    withSetScope: UT,
    withSetIsolationScope: (e, n) => Jv(n),
    getCurrentScope: () => $a().getScope(),
    getIsolationScope: () => $a().getIsolationScope()
  };
}
function I1(e) {
  const n = Ky(e);
  return n.acs ? n.acs : MT();
}
function Yy() {
  const e = Wy();
  return I1(e).getCurrentScope();
}
function $1() {
  const e = Wy();
  return I1(e).getIsolationScope();
}
function BT() {
  return Yy().getClient();
}
function qT(e) {
  if (e)
    return HT(e) ? { captureContext: e } : KT(e) ? {
      captureContext: e
    } : e;
}
function HT(e) {
  return e instanceof Ia || typeof e == "function";
}
const WT = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function KT(e) {
  return Object.keys(e).some((n) => WT.includes(n));
}
function Xv(e, n) {
  return Yy().captureException(e, qT(n));
}
function GT(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Yy().captureMessage(e, r, i);
}
function YT(e, n) {
  $1().setContext(e, n);
}
const QT = 100;
function Pi(e, n) {
  const r = BT(), i = $1();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = QT } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Hy(), ...e }, u = a ? C1(() => a(l, n)) : l;
  u !== null && (r.emit && r.emit("beforeAddBreadcrumb", u, n), i.addBreadcrumb(u, o));
}
var Qo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Qo || (Qo = {}));
function xa(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const JT = Go.backendDomain ? {
  "backend-domain": Go.backendDomain
} : void 0;
function tl() {
  const e = new URLSearchParams({
    noToken: "true",
    ...JT
  }).toString();
  document.location.href = `${Go.url.logIn}?${e}`;
}
const xc = "authData", Sc = 30, XT = 600, Nc = 5;
class ZT {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Nc || this.clientServerTimeDiff <= -Nc ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + XT, a = xa(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Nc) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(xc, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(xc), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(xc);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Sc;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = xa(n), i = r.exp - Sc;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Sc - this.estimatedServerTime()) * 1e3;
  }
}
const Ot = new ZT();
async function eD(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? xa(o).exp : "None", l = await Gl.getAuthData({ localStorageOnly: !0 }), u = Math.floor(Date.now() / 1e3), p = l?.access_token, d = l?.refresh_token, f = p ? xa(p).exp : "None", h = d ? xa(d).exp : "None", v = typeof s == "number" ? u - s : "Unknown", I = typeof f == "number" ? u - f : "Unknown", w = typeof h == "number" ? u - h : "Unknown", j = e.response.headers["x-dixa-rid"];
      YT("Expires", {
        currentTimestamp: u,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: I,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: w,
        xDixaRid: j,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    GT("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Qo.Platform,
        domain: n
      }
    });
  }
}
const jc = /* @__PURE__ */ new Map(), nD = 3;
function tD(e) {
  e.interceptors.response.use((n) => (jc.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Wh.Unauthorized:
          if (!Gl.isRefreshTokenExpired() && n.config) {
            Pi({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = jc.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= nD)
              return jc.set(n.config.url, i + 1), e(n.config);
          }
          eD(n), console.error("401 unauthorized interceptor"), tl();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const E1 = xt.create();
tD(E1);
const Xr = console.log;
async function Zv(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class rD extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function iD(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const aD = 5;
class oD {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      Ot.setAuthData(r);
    else {
      const i = Ot.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new rD("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Ot.getAccessToken();
    if (!n)
      return {};
    const r = xa(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Ot.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = Ot.getAuthData();
    return r ? Ot.isAccessTokenExpired() ? (Pi({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && Ot.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return Ot.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Ot.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Ot.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Ot.getAuthData();
    return n ? Ot.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!qv.isElectron())
      return !0;
    const n = await qv.getVersion();
    return jT(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = aD) {
    try {
      return await E1.post(`${Go.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Xr("AUTH", "Network connection offline - waiting..."), Pi({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Zv(5);
    n && (Xr("AUTH", "Network connection restored"), Pi({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = iD(this.retryCount);
    return Xr("AUTH", `Retrying in ${i} seconds`), await Zv(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (Ot.isRefreshTokenExpired(r))
      return Xr("AUTH", "Refresh token expired"), Pi({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Ot.removeAuthData(), tl(), null;
    if (ST(n)) {
      if (n.message === "timeout exceeded")
        return Xr("AUTH", "Timeout exceeded"), Pi({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Xr("AUTH", "Network error"), Pi({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Xr("AUTH", "Refresh token invalid (401)"), Ot.removeAuthData(), tl(), null;
      Xv(n, {
        level: "error",
        tags: {
          team: Qo.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Xr("AUTH", "Retries exhausted, logging out"), Xv(n, {
      level: "error",
      tags: {
        team: Qo.Platform,
        errorSource: "authManager.refresh"
      }
    }), Ot.removeAuthData(), tl(), null) : (Xr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return Ot.accessTokenExpiresInMs();
  }
}
const Gl = new oD();
var Wh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Wh || (Wh = {}));
const sD = new Ry((e, n) => new Xw((r) => {
  Gl.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), lD = new Ry(
  (e, n) => new Xw((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Gl.getAuthData().then((u) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...OI(Go.url.partnerIntegrations) && u?.access_token && RI(u.access_token)
      }
    }), n(e).subscribe(r))).catch((u) => r.error(u));
  })
), cD = new AbortController(), T1 = (e) => new m$({
  queryDeduplication: !1,
  cache: new p$(),
  link: Ry.from([
    sD,
    lD,
    f$({
      uri: `${e}/graphql`,
      fetch: k$,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: cD.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), uD = ({
  configuration: e,
  children: n
}) => {
  const r = Xn(
    () => T1(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ We.jsx(h$, { client: r, children: n });
};
function dD() {
  try {
    return y$(), !0;
  } catch {
    return !1;
  }
}
const mD = ({
  configuration: e,
  children: n
}) => dD() ? n : /* @__PURE__ */ We.jsx(uD, { configuration: e, children: n }), pD = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ We.jsx(g$, { children: (o) => /* @__PURE__ */ We.jsx(
  PI,
  {
    value: {
      useMutation: zI(e, n),
      useQuery: VI(e, n),
      useLazyQuery: LI(e, n),
      executeQuery: AI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), D1 = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ We.jsx(mD, { configuration: r, children: s ? /* @__PURE__ */ We.jsx(
    pD,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, fD = "_unmatchedHeader_qcj19_1", hD = {
  unmatchedHeader: fD
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var wc = { exports: {} }, Ja = {}, ek;
function yD() {
  if (ek) return Ja;
  ek = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ja.Fragment = r, Ja.jsx = s, Ja.jsxs = s, Ja;
}
var ks = {}, nk;
function gD() {
  return nk || (nk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    ks.Fragment = i, ks.jsx = Un, ks.jsxs = Kn;
  })()), ks;
}
var tk;
function vD() {
  return tk || (tk = 1, process.env.NODE_ENV === "production" ? wc.exports = yD() : wc.exports = gD()), wc.exports;
}
var ce = vD();
const kD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, bD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, _D = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": kD,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": bD
};
function O1(e) {
  return _D[e] ?? {};
}
const xD = O1(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), SD = O1(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), ND = "_copyIcon_1wjfs_48", jD = "_list_1wjfs_53", wD = "_listItem_1wjfs_63", CD = "_collapsible_1wjfs_72", FD = "_collapsibleIsOpen_1wjfs_80", ID = "_collapsibleHeader_1wjfs_83", $D = "_collapsibleIconTrue_1wjfs_86", ED = "_collapsibleIconFalse_1wjfs_89", Mn = {
  copyIcon: ND,
  list: jD,
  listItem: wD,
  collapsible: CD,
  collapsibleIsOpen: FD,
  collapsibleHeader: ID,
  collapsibleIconTrue: $D,
  collapsibleIconFalse: ED
}, TD = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: u,
    last_used: p
  } = e;
  return /* @__PURE__ */ ce.jsxs(
    b,
    {
      className: dt(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ce.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ce.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ce.jsxs(Qe, { className: Mn.list, children: [
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: Qn(u).format(It) })
          ] }) }),
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: Qn(p).format(It) })
          ] }) })
        ] })
      ]
    }
  );
}, DD = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ce.jsx(P.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ce.jsx(Bn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ce.jsx(
      P.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ce.jsx(TD, { app: r, openByDefault: i === 0 }, i))
  ] });
}, OD = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(P.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ce.jsx(Qe, { className: Mn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ce.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: i }),
          Gi(a)
        ] })
      },
      o
    )) })
  ] }) });
}, RD = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(P.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ce.jsx(Qe, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ ce.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ce.jsx(
            Je,
            {
              content: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ce.jsx(b, { children: `First ${Qn(a?.first).format(
                  It
                )}` }),
                /* @__PURE__ */ ce.jsx(b, { children: `Last ${Qn(a?.last).format(
                  It
                )}` })
              ] }),
              children: /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, bl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const u = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${u}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${u}.` : `Opted in: The user has explicitly confirmed they want to receive ${u}.`;
  };
  return /* @__PURE__ */ ce.jsx(Je, { content: n ? null : l(), children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(he, { size: 14, name: o(), color: s() }) }) });
}, PD = "_wrapper_1xucg_1", AD = "_externalLink_1xucg_7", Cc = {
  wrapper: PD,
  externalLink: AD
}, LD = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = ir(), { isCopied: i, copy: a } = ir(), { isCopied: o, copy: s } = ir(), { isCopied: l, copy: u } = ir(), { isCopied: p, copy: d } = ir();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: I,
    home_city: w,
    country: j,
    email: _,
    phone: y,
    dob: L,
    created_at: E,
    email_subscribe: C,
    push_subscribe: F
  } = e, z = 14, Q = `${v || ""} ${I || ""}`.trim() || "A customer has no name", Z = `${w ? `${w} /` : ""} ${j || ""}`.trim(), te = L ? Qn(L).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ce.jsxs(b, { className: Cc.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Cc.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ce.jsx(P.Heading, { variant: "heading-2", children: Q }),
          te && /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    E && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: Qn(E).format(It) })
    ] }),
    Z && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(he, { size: z, name: "map-pin" }),
        /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: Z })
      ] }),
      /* @__PURE__ */ ce.jsx(Je, { content: "Copy location", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        he,
        {
          size: z,
          name: o ? "done" : "copy",
          onClick: () => s(Z),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    _ && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(he, { size: z, name: "mail" }),
        /* @__PURE__ */ ce.jsx("span", { className: Cc.externalLink, children: _ })
      ] }),
      /* @__PURE__ */ ce.jsx(Je, { content: "Copy email", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        he,
        {
          size: z,
          name: n ? "done" : "copy",
          onClick: () => r(_),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(he, { size: z, name: "phone" }),
        /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ ce.jsx(Je, { content: "Copy phone number", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        he,
        {
          size: z,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(he, { size: z, name: "user" }),
        /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ce.jsxs(P.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ce.jsx(Je, { content: "Copy Braze ID", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        he,
        {
          size: z,
          name: l ? "done" : "copy",
          onClick: () => u(h),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(he, { size: z, name: "tag" }),
        /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ce.jsxs(P.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ce.jsx(Je, { content: "Copy External ID", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        he,
        {
          size: z,
          name: p ? "done" : "copy",
          onClick: () => d(f),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    C && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(he, { size: z, name: "sync" }),
        /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ce.jsx(bl, { state: C })
    ] }),
    F && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(he, { size: z, name: "bell" }),
        /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ce.jsx(bl, { isPush: !0, state: F })
    ] })
  ] }) });
}, VD = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: u,
    idfa: p,
    idfv: d,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ce.jsxs(
    b,
    {
      className: dt(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ce.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ce.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ce.jsxs(Qe, { className: Mn.list, children: [
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ce.jsx(
              he,
              {
                size: a,
                className: dt({
                  [Mn.collapsibleIconTrue]: u,
                  [Mn.collapsibleIconFalse]: !u
                }),
                name: u ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ce.jsx(Je, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: d })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ce.jsx(Je, { content: "For iOS", children: /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: p })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, zD = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ce.jsx(P.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ce.jsx(Bn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ce.jsx(
      P.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ce.jsx(VD, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Xa = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, bs = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = $n(), { useMutation: a } = _n(), [o, s] = ue(!1), [l] = a(
    SD,
    {
      onCompleted: (p) => {
        p?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), u = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Xa[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ce.jsx(Je, { content: Xa[n].tooltipContent, children: /* @__PURE__ */ ce.jsx(
    et,
    {
      variant: "secondary",
      color: Xa[n].color,
      isLoading: o,
      onClick: () => u(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(
          bl,
          {
            noTooltip: !0,
            state: Xa[n].parameter
          }
        ),
        Xa[n].label
      ] })
    }
  ) });
}, UD = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(P.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ce.jsx(Qe, { className: Mn.list, children: /* @__PURE__ */ ce.jsx(Qe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(he, { size: 14, name: "sync" }),
        /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ce.jsx(bl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
        /* @__PURE__ */ ce.jsx(
          bs,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ce.jsx(
          bs,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ce.jsx(
        bs,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ce.jsx(
        bs,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, MD = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(P.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ce.jsx(Qe, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ ce.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ce.jsx(
            Je,
            {
              content: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ce.jsx(b, { children: `First ${Qn(a?.first).format(
                  It
                )}` }),
                /* @__PURE__ */ ce.jsx(b, { children: `Last ${Qn(a?.last).format(
                  It
                )}` })
              ] }),
              children: /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ce.jsx(P.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, BD = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = $n(), { useMutation: i } = _n(), [a, o] = ue(), [s, l] = ue(!1), [u, p] = ue(!1), d = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, I = n.displayCustomAttributes ?? !1, w = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, _ = n.displayDevices ?? !1, y = n.displayApps ?? !1, L = !h && !v && !I && !w && !j, [E, { error: C }] = i(
    xD,
    {
      onError: () => {
      },
      onCompleted: (z) => {
        const Q = z?.Braze?.exportUserDetails?.users?.[0];
        Q ? (o(Q), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), F = async () => {
    d || f ? await E({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...d ? { email_address: d } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Xe(() => {
    async function z() {
      p(!0), await F();
    }
    z().finally(() => p(!1));
  }, [d, f]), C) {
    const z = C.graphQLErrors;
    return zl({ errors: z }) ? /* @__PURE__ */ ce.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ul({ errors: z }) ? /* @__PURE__ */ ce.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ce.jsx(Tn, { error: C });
  }
  return u ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ce.jsx(vn, {}) }) : L ? /* @__PURE__ */ ce.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ce.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ce.jsx(LD, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ ce.jsx(
          UD,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await F()
          }
        ),
        I && !!a && /* @__PURE__ */ ce.jsx(OD, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ ce.jsx(RD, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ ce.jsx(MD, { customerDetails: a }),
        _ && !!a && /* @__PURE__ */ ce.jsx(zD, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ ce.jsx(DD, { apps: a?.apps })
      ]
    }
  );
}, qD = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Iy(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function HD() {
  var e = Bi(!1), n = ft(function() {
    return e.current;
  }, []);
  return Xe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var WD = function(e) {
  e === void 0 && (e = {});
  var n = ue(e), r = n[0], i = n[1], a = ft(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, KD = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, rk = function(e) {
  return t$(KD, e);
}, Fc, ik;
function GD() {
  return ik || (ik = 1, Fc = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), Fc;
}
var Ic, ak;
function YD() {
  if (ak) return Ic;
  ak = 1;
  var e = GD(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, u, p, d, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      p = e(), d = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(w) {
        if (w.stopPropagation(), s.format)
          if (w.preventDefault(), typeof w.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            w.clipboardData.clearData(), w.clipboardData.setData(s.format, o);
        s.onCopy && (w.preventDefault(), s.onCopy(w.clipboardData));
      }), document.body.appendChild(h), d.selectNodeContents(h), f.addRange(d);
      var I = document.execCommand("copy");
      if (!I)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (w) {
      l && console.error("unable to copy using execCommand: ", w), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), u = i("message" in s ? s.message : r), window.prompt(u, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(d) : f.removeAllRanges()), h && document.body.removeChild(h), p();
    }
    return v;
  }
  return Ic = a, Ic;
}
var QD = YD();
const JD = /* @__PURE__ */ Py(QD);
var R1 = function() {
  var e = HD(), n = WD({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = ft(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var u = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var u = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = JD(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (p) {
        i({
          value: l,
          error: p,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function XD(e, n) {
  n === void 0 && (n = 0);
  var r = Bi(!1), i = Bi(), a = Bi(e), o = ft(function() {
    return r.current;
  }, []), s = ft(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = ft(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Xe(function() {
    a.current = e;
  }, [e]), Xe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Ji(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = XD(e, n), a = i[0], o = i[1], s = i[2];
  return Xe(s, r), [a, o];
}
var ZD = function(e) {
  Xe(e, []);
}, eO = function(e, n) {
  var r = Bi(function() {
  });
  Xe(function() {
    r.current = e;
  }), Xe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, nO = function(e) {
  e === void 0 && (e = {});
  var n = ue(e), r = n[0], i = n[1], a = Xn(function() {
    return {
      set: function(s, l) {
        i(function(u) {
          var p;
          return gc(gc({}, u), (p = {}, p[s] = l, p));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var u = l, p = s;
          u[p];
          var d = b$(u, [typeof p == "symbol" ? p : p + ""]);
          return d;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = gc({ get: ft(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, tO = function(e) {
  var n = Bi(e);
  n.current = e, ZD(function() {
    return function() {
      return n.current();
    };
  });
}, is = (e) => e.type === "checkbox", zi = (e) => e instanceof Date, nr = (e) => e == null;
const P1 = (e) => typeof e == "object";
var kt = (e) => !nr(e) && !Array.isArray(e) && P1(e) && !zi(e), A1 = (e) => kt(e) && e.target ? is(e.target) ? e.target.checked : e.target.value : e, rO = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, L1 = (e, n) => e.has(rO(n)), iO = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return kt(n) && n.hasOwnProperty("isPrototypeOf");
}, Qy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function At(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Qy && (e instanceof Blob || i)) && (r || kt(e)))
    if (n = r ? [] : {}, !r && !iO(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = At(e[a]));
  else
    return e;
  return n;
}
var Yl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ht = (e) => e === void 0, on = (e, n, r) => {
  if (!n || !kt(e))
    return r;
  const i = Yl(n.split(/[,[\].]+?/)).reduce((a, o) => nr(a) ? a : a[o], e);
  return ht(i) || i === e ? ht(e[n]) ? r : e[n] : i;
}, fr = (e) => typeof e == "boolean", Jy = (e) => /^\w*$/.test(e), V1 = (e) => Yl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = Jy(n) ? [n] : V1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const p = e[l];
      u = kt(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const _l = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, wr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Zr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, z1 = Ee.createContext(null), Gr = () => Ee.useContext(z1), Xy = (e) => {
  const { children: n, ...r } = e;
  return Ee.createElement(z1.Provider, { value: r }, n);
};
var U1 = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== wr.all && (n._proxyFormState[s] = !i || wr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function aO(e) {
  const n = Gr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ee.useState(r._formState), u = Ee.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = Ee.useRef(a);
  return p.current = a, Ee.useEffect(() => r._subscribe({
    name: p.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), Ee.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), Ee.useMemo(() => U1(s, r, u.current, !1), [s, r]);
}
var Br = (e) => typeof e == "string", M1 = (e, n, r, i, a) => Br(e) ? (i && n.watch.add(e), on(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), on(r, o))) : (i && (n.watchAll = !0), r);
function Po(e) {
  const n = Gr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ee.useRef(i), u = Ee.useRef(a);
  l.current = i, Ee.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(M1(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [p, d] = Ee.useState(r._getWatch(i, a));
  return Ee.useEffect(() => r._removeUnmounted()), p;
}
function Zy(e) {
  const n = Gr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = L1(a._names.array, r), l = Po({
    control: a,
    name: r,
    defaultValue: on(a._formValues, r, on(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = aO({
    control: a,
    name: r,
    exact: !0
  }), p = Ee.useRef(e), d = Ee.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...fr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ee.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!on(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!on(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!on(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!on(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => on(u.errors, r)
    }
  }), [u, r]), h = Ee.useCallback((j) => d.current.onChange({
    target: {
      value: A1(j),
      name: r
    },
    type: _l.CHANGE
  }), [r]), v = Ee.useCallback(() => d.current.onBlur({
    target: {
      value: on(a._formValues, r),
      name: r
    },
    type: _l.BLUR
  }), [r, a._formValues]), I = Ee.useCallback((j) => {
    const _ = on(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), w = Ee.useMemo(() => ({
    name: r,
    value: l,
    ...fr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: I
  }), [r, i, u.disabled, h, v, I, l]);
  return Ee.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...fr(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const _ = (y, L) => {
      const E = on(a._fields, y);
      E && E._f && (E._f.mount = L);
    };
    if (_(r, !0), j) {
      const y = At(on(a._options.defaultValues, r));
      it(a._defaultValues, r, y), ht(on(a._formValues, r)) && it(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), Ee.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ee.useMemo(() => ({
    field: w,
    formState: u,
    fieldState: f
  }), [w, u, f]);
}
const zt = (e) => e.render(Zy(e));
var oO = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ao = (e) => Array.isArray(e) ? e : [e], ok = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Kh = (e) => nr(e) || !P1(e);
function xi(e, n) {
  if (Kh(e) || Kh(n))
    return e === n;
  if (zi(e) && zi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (zi(o) && zi(s) || kt(o) && kt(s) || Array.isArray(o) && Array.isArray(s) ? !xi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Xt = (e) => kt(e) && !Object.keys(e).length, eg = (e) => e.type === "file", Cr = (e) => typeof e == "function", xl = (e) => {
  if (!Qy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, B1 = (e) => e.type === "select-multiple", ng = (e) => e.type === "radio", sO = (e) => ng(e) || is(e), $c = (e) => xl(e) && e.isConnected;
function lO(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ht(e) ? i++ : e[n[i++]];
  return e;
}
function cO(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ht(e[n]))
      return !1;
  return !0;
}
function wt(e, n) {
  const r = Array.isArray(n) ? n : Jy(n) ? [n] : V1(n), i = r.length === 1 ? e : lO(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (kt(i) && Xt(i) || Array.isArray(i) && cO(i)) && wt(e, r.slice(0, -1)), e;
}
var q1 = (e) => {
  for (const n in e)
    if (Cr(e[n]))
      return !0;
  return !1;
};
function Sl(e, n = {}) {
  const r = Array.isArray(e);
  if (kt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || kt(e[i]) && !q1(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Sl(e[i], n[i])) : nr(e[i]) || (n[i] = !0);
  return n;
}
function H1(e, n, r) {
  const i = Array.isArray(e);
  if (kt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || kt(e[a]) && !q1(e[a]) ? ht(n) || Kh(r[a]) ? r[a] = Array.isArray(e[a]) ? Sl(e[a], []) : { ...Sl(e[a]) } : H1(e[a], nr(n) ? {} : n[a], r[a]) : r[a] = !xi(e[a], n[a]);
  return r;
}
var Za = (e, n) => H1(e, n, Sl(n));
const sk = {
  value: !1,
  isValid: !1
}, lk = { value: !0, isValid: !0 };
var W1 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ht(e[0].attributes.value) ? ht(e[0].value) || e[0].value === "" ? lk : { value: e[0].value, isValid: !0 } : lk
    ) : sk;
  }
  return sk;
}, K1 = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ht(e) ? e : n ? e === "" ? NaN : e && +e : r && Br(e) ? new Date(e) : i ? i(e) : e;
const ck = {
  isValid: !1,
  value: null
};
var G1 = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, ck) : ck;
function uk(e) {
  const n = e.ref;
  return eg(n) ? n.files : ng(n) ? G1(e.refs).value : B1(n) ? [...n.selectedOptions].map(({ value: r }) => r) : is(n) ? W1(e.refs).value : K1(ht(n.value) ? e.ref.value : n.value, e);
}
var uO = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = on(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Nl = (e) => e instanceof RegExp, eo = (e) => ht(e) ? e : Nl(e) ? e.source : kt(e) ? Nl(e.value) ? e.value.source : e.value : e, dk = (e) => ({
  isOnSubmit: !e || e === wr.onSubmit,
  isOnBlur: e === wr.onBlur,
  isOnChange: e === wr.onChange,
  isOnAll: e === wr.all,
  isOnTouch: e === wr.onTouched
});
const mk = "AsyncFunction";
var dO = (e) => !!e && !!e.validate && !!(Cr(e.validate) && e.validate.constructor.name === mk || kt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === mk)), mO = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), pk = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Lo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = on(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Lo(l, n))
          break;
      } else if (kt(l) && Lo(l, n))
        break;
    }
  }
};
function fk(e, n, r) {
  const i = on(e, r);
  if (i || Jy(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = on(n, o), l = on(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var pO = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Xt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || wr.all));
}, fO = (e, n, r) => !e || !n || e === n || Ao(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), hO = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, yO = (e, n) => !Yl(on(e, n)).length && wt(e, n), gO = (e, n, r) => {
  const i = Ao(on(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, rl = (e) => Br(e);
function hk(e, n, r = "validate") {
  if (rl(e) || Array.isArray(e) && e.every(rl) || fr(e) && !e)
    return {
      type: r,
      message: rl(e) ? e : "",
      ref: n
    };
}
var oa = (e) => kt(e) && !Nl(e) ? e : {
  value: e,
  message: ""
}, yk = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: p, minLength: d, min: f, max: h, pattern: v, validate: I, name: w, valueAsNumber: j, mount: _ } = e._f, y = on(r, w);
  if (!_ || n.has(w))
    return {};
  const L = l ? l[0] : s, E = (B) => {
    a && L.reportValidity && (L.setCustomValidity(fr(B) ? "" : B || ""), L.reportValidity());
  }, C = {}, F = ng(s), z = is(s), Q = F || z, Z = (j || eg(s)) && ht(s.value) && ht(y) || xl(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, te = oO.bind(null, w, i, C), G = (B, R, U, ee = Zr.maxLength, Se = Zr.minLength) => {
    const fe = B ? R : U;
    C[w] = {
      type: B ? ee : Se,
      message: fe,
      ref: s,
      ...te(B ? ee : Se, fe)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Q && (Z || nr(y)) || fr(y) && !y || z && !W1(l).isValid || F && !G1(l).isValid)) {
    const { value: B, message: R } = rl(u) ? { value: !!u, message: u } : oa(u);
    if (B && (C[w] = {
      type: Zr.required,
      message: R,
      ref: L,
      ...te(Zr.required, R)
    }, !i))
      return E(R), C;
  }
  if (!Z && (!nr(f) || !nr(h))) {
    let B, R;
    const U = oa(h), ee = oa(f);
    if (!nr(y) && !isNaN(y)) {
      const Se = s.valueAsNumber || y && +y;
      nr(U.value) || (B = Se > U.value), nr(ee.value) || (R = Se < ee.value);
    } else {
      const Se = s.valueAsDate || new Date(y), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), ye = s.type == "time", ve = s.type == "week";
      Br(U.value) && y && (B = ye ? fe(y) > fe(U.value) : ve ? y > U.value : Se > new Date(U.value)), Br(ee.value) && y && (R = ye ? fe(y) < fe(ee.value) : ve ? y < ee.value : Se < new Date(ee.value));
    }
    if ((B || R) && (G(!!B, U.message, ee.message, Zr.max, Zr.min), !i))
      return E(C[w].message), C;
  }
  if ((p || d) && !Z && (Br(y) || o && Array.isArray(y))) {
    const B = oa(p), R = oa(d), U = !nr(B.value) && y.length > +B.value, ee = !nr(R.value) && y.length < +R.value;
    if ((U || ee) && (G(U, B.message, R.message), !i))
      return E(C[w].message), C;
  }
  if (v && !Z && Br(y)) {
    const { value: B, message: R } = oa(v);
    if (Nl(B) && !y.match(B) && (C[w] = {
      type: Zr.pattern,
      message: R,
      ref: s,
      ...te(Zr.pattern, R)
    }, !i))
      return E(R), C;
  }
  if (I) {
    if (Cr(I)) {
      const B = await I(y, r), R = hk(B, L);
      if (R && (C[w] = {
        ...R,
        ...te(Zr.validate, R.message)
      }, !i))
        return E(R.message), C;
    } else if (kt(I)) {
      let B = {};
      for (const R in I) {
        if (!Xt(B) && !i)
          break;
        const U = hk(await I[R](y, r), L, R);
        U && (B = {
          ...U,
          ...te(R, U.message)
        }, E(U.message), i && (C[w] = B));
      }
      if (!Xt(B) && (C[w] = {
        ref: L,
        ...B
      }, !i))
        return C;
    }
  }
  return E(!0), C;
};
const vO = {
  mode: wr.onSubmit,
  reValidateMode: wr.onChange,
  shouldFocusError: !0
};
function kO(e = {}) {
  let n = {
    ...vO,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Cr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = kt(n.defaultValues) || kt(n.values) ? At(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : At(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, p = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: ok(),
    state: ok()
  }, v = dk(n.mode), I = dk(n.reValidateMode), w = n.criteriaMode === wr.all, j = (x) => (D) => {
    clearTimeout(p), p = setTimeout(x, D);
  }, _ = async (x) => {
    if (!n.disabled && (d.isValid || f.isValid || x)) {
      const D = n.resolver ? Xt((await Z()).errors) : await G(i, !0);
      D !== r.isValid && h.state.next({
        isValid: D
      });
    }
  }, y = (x, D) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((x || Array.from(l.mount)).forEach((H) => {
      H && (D ? it(r.validatingFields, H, D) : wt(r.validatingFields, H));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Xt(r.validatingFields)
    }));
  }, L = (x, D = [], H, Y, A = !0, M = !0) => {
    if (Y && H && !n.disabled) {
      if (s.action = !0, M && Array.isArray(on(i, x))) {
        const ae = H(on(i, x), Y.argA, Y.argB);
        A && it(i, x, ae);
      }
      if (M && Array.isArray(on(r.errors, x))) {
        const ae = H(on(r.errors, x), Y.argA, Y.argB);
        A && it(r.errors, x, ae), yO(r.errors, x);
      }
      if ((d.touchedFields || f.touchedFields) && M && Array.isArray(on(r.touchedFields, x))) {
        const ae = H(on(r.touchedFields, x), Y.argA, Y.argB);
        A && it(r.touchedFields, x, ae);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = Za(a, o)), h.state.next({
        name: x,
        isDirty: R(x, D),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, x, D);
  }, E = (x, D) => {
    it(r.errors, x, D), h.state.next({
      errors: r.errors
    });
  }, C = (x) => {
    r.errors = x, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (x, D, H, Y) => {
    const A = on(i, x);
    if (A) {
      const M = on(o, x, ht(H) ? on(a, x) : H);
      ht(M) || Y && Y.defaultChecked || D ? it(o, x, D ? M : uk(A._f)) : Se(x, M), s.mount && _();
    }
  }, z = (x, D, H, Y, A) => {
    let M = !1, ae = !1;
    const ge = {
      name: x
    };
    if (!n.disabled) {
      if (!H || Y) {
        (d.isDirty || f.isDirty) && (ae = r.isDirty, r.isDirty = ge.isDirty = R(), M = ae !== ge.isDirty);
        const Ne = xi(on(a, x), D);
        ae = !!on(r.dirtyFields, x), Ne ? wt(r.dirtyFields, x) : it(r.dirtyFields, x, !0), ge.dirtyFields = r.dirtyFields, M = M || (d.dirtyFields || f.dirtyFields) && ae !== !Ne;
      }
      if (H) {
        const Ne = on(r.touchedFields, x);
        Ne || (it(r.touchedFields, x, H), ge.touchedFields = r.touchedFields, M = M || (d.touchedFields || f.touchedFields) && Ne !== H);
      }
      M && A && h.state.next(ge);
    }
    return M ? ge : {};
  }, Q = (x, D, H, Y) => {
    const A = on(r.errors, x), M = (d.isValid || f.isValid) && fr(D) && r.isValid !== D;
    if (n.delayError && H ? (u = j(() => E(x, H)), u(n.delayError)) : (clearTimeout(p), u = null, H ? it(r.errors, x, H) : wt(r.errors, x)), (H ? !xi(A, H) : A) || !Xt(Y) || M) {
      const ae = {
        ...Y,
        ...M && fr(D) ? { isValid: D } : {},
        errors: r.errors,
        name: x
      };
      r = {
        ...r,
        ...ae
      }, h.state.next(ae);
    }
  }, Z = async (x) => {
    y(x, !0);
    const D = await n.resolver(o, n.context, uO(x || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(x), D;
  }, te = async (x) => {
    const { errors: D } = await Z(x);
    if (x)
      for (const H of x) {
        const Y = on(D, H);
        Y ? it(r.errors, H, Y) : wt(r.errors, H);
      }
    else
      r.errors = D;
    return D;
  }, G = async (x, D, H = {
    valid: !0
  }) => {
    for (const Y in x) {
      const A = x[Y];
      if (A) {
        const { _f: M, ...ae } = A;
        if (M) {
          const ge = l.array.has(M.name), Ne = A._f && dO(A._f);
          Ne && d.validatingFields && y([Y], !0);
          const tn = await yk(A, l.disabled, o, w, n.shouldUseNativeValidation && !D, ge);
          if (Ne && d.validatingFields && y([Y]), tn[M.name] && (H.valid = !1, D))
            break;
          !D && (on(tn, M.name) ? ge ? gO(r.errors, tn, M.name) : it(r.errors, M.name, tn[M.name]) : wt(r.errors, M.name));
        }
        !Xt(ae) && await G(ae, D, H);
      }
    }
    return H.valid;
  }, B = () => {
    for (const x of l.unMount) {
      const D = on(i, x);
      D && (D._f.refs ? D._f.refs.every((H) => !$c(H)) : !$c(D._f.ref)) && Be(x);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (x, D) => !n.disabled && (x && D && it(o, x, D), !xi(Te(), a)), U = (x, D, H) => M1(x, l, {
    ...s.mount ? o : ht(D) ? a : Br(x) ? { [x]: D } : D
  }, H, D), ee = (x) => Yl(on(s.mount ? o : a, x, n.shouldUnregister ? on(a, x, []) : [])), Se = (x, D, H = {}) => {
    const Y = on(i, x);
    let A = D;
    if (Y) {
      const M = Y._f;
      M && (!M.disabled && it(o, x, K1(D, M)), A = xl(M.ref) && nr(D) ? "" : D, B1(M.ref) ? [...M.ref.options].forEach((ae) => ae.selected = A.includes(ae.value)) : M.refs ? is(M.ref) ? M.refs.length > 1 ? M.refs.forEach((ae) => (!ae.defaultChecked || !ae.disabled) && (ae.checked = Array.isArray(A) ? !!A.find((ge) => ge === ae.value) : A === ae.value)) : M.refs[0] && (M.refs[0].checked = !!A) : M.refs.forEach((ae) => ae.checked = ae.value === A) : eg(M.ref) ? M.ref.value = "" : (M.ref.value = A, M.ref.type || h.state.next({
        name: x,
        values: At(o)
      })));
    }
    (H.shouldDirty || H.shouldTouch) && z(x, A, H.shouldTouch, H.shouldDirty, !0), H.shouldValidate && _e(x);
  }, fe = (x, D, H) => {
    for (const Y in D) {
      const A = D[Y], M = `${x}.${Y}`, ae = on(i, M);
      (l.array.has(x) || kt(A) || ae && !ae._f) && !zi(A) ? fe(M, A, H) : Se(M, A, H);
    }
  }, ye = (x, D, H = {}) => {
    const Y = on(i, x), A = l.array.has(x), M = At(D);
    it(o, x, M), A ? (h.array.next({
      name: x,
      values: At(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && H.shouldDirty && h.state.next({
      name: x,
      dirtyFields: Za(a, o),
      isDirty: R(x, M)
    })) : Y && !Y._f && !nr(M) ? fe(x, M, H) : Se(x, M, H), pk(x, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? x : void 0,
      values: At(o)
    });
  }, ve = async (x) => {
    s.mount = !0;
    const D = x.target;
    let H = D.name, Y = !0;
    const A = on(i, H), M = (ae) => {
      Y = Number.isNaN(ae) || zi(ae) && isNaN(ae.getTime()) || xi(ae, on(o, H, ae));
    };
    if (A) {
      let ae, ge;
      const Ne = D.type ? uk(A._f) : A1(x), tn = x.type === _l.BLUR || x.type === _l.FOCUS_OUT, gn = !mO(A._f) && !n.resolver && !on(r.errors, H) && !A._f.deps || hO(tn, on(r.touchedFields, H), r.isSubmitted, I, v), nn = pk(H, l, tn);
      it(o, H, Ne), tn ? (A._f.onBlur && A._f.onBlur(x), u && u(0)) : A._f.onChange && A._f.onChange(x);
      const dn = z(H, Ne, tn), wn = !Xt(dn) || nn;
      if (!tn && h.state.next({
        name: H,
        type: x.type,
        values: At(o)
      }), gn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? tn && _() : tn || _()), wn && h.state.next({ name: H, ...nn ? {} : dn });
      if (!tn && nn && h.state.next({ ...r }), n.resolver) {
        const { errors: xn } = await Z([H]);
        if (M(Ne), Y) {
          const Cn = fk(r.errors, i, H), Ze = fk(xn, i, Cn.name || H);
          ae = Ze.error, H = Ze.name, ge = Xt(xn);
        }
      } else
        y([H], !0), ae = (await yk(A, l.disabled, o, w, n.shouldUseNativeValidation))[H], y([H]), M(Ne), Y && (ae ? ge = !1 : (d.isValid || f.isValid) && (ge = await G(i, !0)));
      Y && (A._f.deps && _e(A._f.deps), Q(H, ge, ae, dn));
    }
  }, K = (x, D) => {
    if (on(r.errors, D) && x.focus)
      return x.focus(), 1;
  }, _e = async (x, D = {}) => {
    let H, Y;
    const A = Ao(x);
    if (n.resolver) {
      const M = await te(ht(x) ? x : A);
      H = Xt(M), Y = x ? !A.some((ae) => on(M, ae)) : H;
    } else x ? (Y = (await Promise.all(A.map(async (M) => {
      const ae = on(i, M);
      return await G(ae && ae._f ? { [M]: ae } : ae);
    }))).every(Boolean), !(!Y && !r.isValid) && _()) : Y = H = await G(i);
    return h.state.next({
      ...!Br(x) || (d.isValid || f.isValid) && H !== r.isValid ? {} : { name: x },
      ...n.resolver || !x ? { isValid: H } : {},
      errors: r.errors
    }), D.shouldFocus && !Y && Lo(i, K, x ? A : l.mount), Y;
  }, Te = (x) => {
    const D = {
      ...s.mount ? o : a
    };
    return ht(x) ? D : Br(x) ? on(D, x) : x.map((H) => on(D, H));
  }, J = (x, D) => ({
    invalid: !!on((D || r).errors, x),
    isDirty: !!on((D || r).dirtyFields, x),
    error: on((D || r).errors, x),
    isValidating: !!on(r.validatingFields, x),
    isTouched: !!on((D || r).touchedFields, x)
  }), Ke = (x) => {
    x && Ao(x).forEach((D) => wt(r.errors, D)), h.state.next({
      errors: x ? r.errors : {}
    });
  }, an = (x, D, H) => {
    const Y = (on(i, x, { _f: {} })._f || {}).ref, A = on(r.errors, x) || {}, { ref: M, message: ae, type: ge, ...Ne } = A;
    it(r.errors, x, {
      ...Ne,
      ...D,
      ref: Y
    }), h.state.next({
      name: x,
      errors: r.errors,
      isValid: !1
    }), H && H.shouldFocus && Y && Y.focus && Y.focus();
  }, we = (x, D) => Cr(x) ? h.state.subscribe({
    next: (H) => x(U(void 0, D), H)
  }) : U(x, D, !0), Me = (x) => h.state.subscribe({
    next: (D) => {
      fO(x.name, D.name, x.exact) && pO(D, x.formState || d, Pe, x.reRenderRoot) && x.callback({
        values: { ...o },
        ...r,
        ...D
      });
    }
  }).unsubscribe, Re = (x) => (s.mount = !0, f = {
    ...f,
    ...x.formState
  }, Me({
    ...x,
    formState: f
  })), Be = (x, D = {}) => {
    for (const H of x ? Ao(x) : l.mount)
      l.mount.delete(H), l.array.delete(H), D.keepValue || (wt(i, H), wt(o, H)), !D.keepError && wt(r.errors, H), !D.keepDirty && wt(r.dirtyFields, H), !D.keepTouched && wt(r.touchedFields, H), !D.keepIsValidating && wt(r.validatingFields, H), !n.shouldUnregister && !D.keepDefaultValue && wt(a, H);
    h.state.next({
      values: At(o)
    }), h.state.next({
      ...r,
      ...D.keepDirty ? { isDirty: R() } : {}
    }), !D.keepIsValid && _();
  }, Ae = ({ disabled: x, name: D }) => {
    (fr(x) && s.mount || x || l.disabled.has(D)) && (x ? l.disabled.add(D) : l.disabled.delete(D));
  }, Ge = (x, D = {}) => {
    let H = on(i, x);
    const Y = fr(D.disabled) || fr(n.disabled);
    return it(i, x, {
      ...H || {},
      _f: {
        ...H && H._f ? H._f : { ref: { name: x } },
        name: x,
        mount: !0,
        ...D
      }
    }), l.mount.add(x), H ? Ae({
      disabled: fr(D.disabled) ? D.disabled : n.disabled,
      name: x
    }) : F(x, !0, D.value), {
      ...Y ? { disabled: D.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!D.required,
        min: eo(D.min),
        max: eo(D.max),
        minLength: eo(D.minLength),
        maxLength: eo(D.maxLength),
        pattern: eo(D.pattern)
      } : {},
      name: x,
      onChange: ve,
      onBlur: ve,
      ref: (A) => {
        if (A) {
          Ge(x, D), H = on(i, x);
          const M = ht(A.value) && A.querySelectorAll && A.querySelectorAll("input,select,textarea")[0] || A, ae = sO(M), ge = H._f.refs || [];
          if (ae ? ge.find((Ne) => Ne === M) : M === H._f.ref)
            return;
          it(i, x, {
            _f: {
              ...H._f,
              ...ae ? {
                refs: [
                  ...ge.filter($c),
                  M,
                  ...Array.isArray(on(a, x)) ? [{}] : []
                ],
                ref: { type: M.type, name: x }
              } : { ref: M }
            }
          }), F(x, !1, void 0, M);
        } else
          H = on(i, x, {}), H._f && (H._f.mount = !1), (n.shouldUnregister || D.shouldUnregister) && !(L1(l.array, x) && s.action) && l.unMount.add(x);
      }
    };
  }, Ce = () => n.shouldFocusError && Lo(i, K, l.mount), qe = (x) => {
    fr(x) && (h.state.next({ disabled: x }), Lo(i, (D, H) => {
      const Y = on(i, H);
      Y && (D.disabled = Y._f.disabled || x, Array.isArray(Y._f.refs) && Y._f.refs.forEach((A) => {
        A.disabled = Y._f.disabled || x;
      }));
    }, 0, !1));
  }, en = (x, D) => async (H) => {
    let Y;
    H && (H.preventDefault && H.preventDefault(), H.persist && H.persist());
    let A = At(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: M, values: ae } = await Z();
      r.errors = M, A = ae;
    } else
      await G(i);
    if (l.disabled.size)
      for (const M of l.disabled)
        it(A, M, void 0);
    if (wt(r.errors, "root"), Xt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await x(A, H);
      } catch (M) {
        Y = M;
      }
    } else
      D && await D({ ...r.errors }, H), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Xt(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, ie = (x, D = {}) => {
    on(i, x) && (ht(D.defaultValue) ? ye(x, At(on(a, x))) : (ye(x, D.defaultValue), it(a, x, At(D.defaultValue))), D.keepTouched || wt(r.touchedFields, x), D.keepDirty || (wt(r.dirtyFields, x), r.isDirty = D.defaultValue ? R(x, At(on(a, x))) : R()), D.keepError || (wt(r.errors, x), d.isValid && _()), h.state.next({ ...r }));
  }, se = (x, D = {}) => {
    const H = x ? At(x) : a, Y = At(H), A = Xt(x), M = A ? a : Y;
    if (D.keepDefaultValues || (a = H), !D.keepValues) {
      if (D.keepDirtyValues) {
        const ae = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Za(a, o))
        ]);
        for (const ge of Array.from(ae))
          on(r.dirtyFields, ge) ? it(M, ge, on(o, ge)) : ye(ge, on(M, ge));
      } else {
        if (Qy && ht(x))
          for (const ae of l.mount) {
            const ge = on(i, ae);
            if (ge && ge._f) {
              const Ne = Array.isArray(ge._f.refs) ? ge._f.refs[0] : ge._f.ref;
              if (xl(Ne)) {
                const tn = Ne.closest("form");
                if (tn) {
                  tn.reset();
                  break;
                }
              }
            }
          }
        for (const ae of l.mount)
          ye(ae, on(M, ae));
      }
      o = At(M), h.array.next({
        values: { ...M }
      }), h.state.next({
        values: { ...M }
      });
    }
    l = {
      mount: D.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!D.keepIsValid || !!D.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: D.keepSubmitCount ? r.submitCount : 0,
      isDirty: A ? !1 : D.keepDirty ? r.isDirty : !!(D.keepDefaultValues && !xi(x, a)),
      isSubmitted: D.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: A ? {} : D.keepDirtyValues ? D.keepDefaultValues && o ? Za(a, o) : r.dirtyFields : D.keepDefaultValues && x ? Za(a, x) : D.keepDirty ? r.dirtyFields : {},
      touchedFields: D.keepTouched ? r.touchedFields : {},
      errors: D.keepErrors ? r.errors : {},
      isSubmitSuccessful: D.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (x, D) => se(Cr(x) ? x(o) : x, D), Le = (x, D = {}) => {
    const H = on(i, x), Y = H && H._f;
    if (Y) {
      const A = Y.refs ? Y.refs[0] : Y.ref;
      A.focus && (A.focus(), D.shouldSelect && Cr(A.select) && A.select());
    }
  }, Pe = (x) => {
    r = {
      ...r,
      ...x
    };
  }, T = {
    control: {
      register: Ge,
      unregister: Be,
      getFieldState: J,
      handleSubmit: en,
      setError: an,
      _subscribe: Me,
      _runSchema: Z,
      _getWatch: U,
      _getDirty: R,
      _setValid: _,
      _setFieldArray: L,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: ee,
      _reset: se,
      _resetDefaultValues: () => Cr(n.defaultValues) && n.defaultValues().then((x) => {
        xe(x, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(x) {
        s = x;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(x) {
        l = x;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(x) {
        n = {
          ...n,
          ...x
        };
      }
    },
    subscribe: Re,
    trigger: _e,
    register: Ge,
    handleSubmit: en,
    watch: we,
    setValue: ye,
    getValues: Te,
    reset: xe,
    resetField: ie,
    clearErrors: Ke,
    unregister: Be,
    setError: an,
    setFocus: Le,
    getFieldState: J
  };
  return {
    ...T,
    formControl: T
  };
}
function St(e = {}) {
  const n = Ee.useRef(void 0), r = Ee.useRef(void 0), [i, a] = Ee.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Cr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Cr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : kO(e),
    formState: i
  }, e.formControl && e.defaultValues && !Cr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ee.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ee.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ee.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ee.useEffect(() => {
    e.values && !xi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ee.useEffect(() => {
    e.errors && !Xt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ee.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ee.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = U1(i, o), n.current;
}
var _s = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Y1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ec = { exports: {} }, no = {}, gk;
function bO() {
  if (gk) return no;
  gk = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return no.Fragment = r, no.jsx = s, no.jsxs = s, no;
}
var xs = {}, vk;
function _O() {
  return vk || (vk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    xs.Fragment = i, xs.jsx = Un, xs.jsxs = Kn;
  })()), xs;
}
var kk;
function xO() {
  return kk || (kk = 1, process.env.NODE_ENV === "production" ? Ec.exports = bO() : Ec.exports = _O()), Ec.exports;
}
var Hi = xO();
function SO(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Tc, bk;
function wi() {
  if (bk) return Tc;
  bk = 1;
  var e = Array.isArray;
  return Tc = e, Tc;
}
var Dc, _k;
function Q1() {
  if (_k) return Dc;
  _k = 1;
  var e = typeof _s == "object" && _s && _s.Object === Object && _s;
  return Dc = e, Dc;
}
var Oc, xk;
function Yr() {
  if (xk) return Oc;
  xk = 1;
  var e = Q1(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Oc = r, Oc;
}
var Rc, Sk;
function as() {
  if (Sk) return Rc;
  Sk = 1;
  var e = Yr(), n = e.Symbol;
  return Rc = n, Rc;
}
var Pc, Nk;
function NO() {
  if (Nk) return Pc;
  Nk = 1;
  var e = as(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var p = !0;
    } catch {
    }
    var d = i.call(s);
    return p && (l ? s[a] = u : delete s[a]), d;
  }
  return Pc = o, Pc;
}
var Ac, jk;
function jO() {
  if (jk) return Ac;
  jk = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Ac = r, Ac;
}
var Lc, wk;
function La() {
  if (wk) return Lc;
  wk = 1;
  var e = as(), n = NO(), r = jO(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Lc = s, Lc;
}
var Vc, Ck;
function Xi() {
  if (Ck) return Vc;
  Ck = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Vc = e, Vc;
}
var zc, Fk;
function tg() {
  if (Fk) return zc;
  Fk = 1;
  var e = La(), n = Xi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return zc = i, zc;
}
var Uc, Ik;
function wO() {
  if (Ik) return Uc;
  Ik = 1;
  var e = wi(), n = tg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Uc = a, Uc;
}
var Mc, $k;
function Va() {
  if ($k) return Mc;
  $k = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Mc = e, Mc;
}
var Bc, Ek;
function J1() {
  if (Ek) return Bc;
  Ek = 1;
  var e = La(), n = Va(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == r || u == o;
  }
  return Bc = s, Bc;
}
var qc, Tk;
function CO() {
  if (Tk) return qc;
  Tk = 1;
  var e = Yr(), n = e["__core-js_shared__"];
  return qc = n, qc;
}
var Hc, Dk;
function FO() {
  if (Dk) return Hc;
  Dk = 1;
  var e = CO(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Hc = r, Hc;
}
var Wc, Ok;
function X1() {
  if (Ok) return Wc;
  Ok = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Wc = r, Wc;
}
var Kc, Rk;
function IO() {
  if (Rk) return Kc;
  Rk = 1;
  var e = J1(), n = FO(), r = Va(), i = X1(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, p = l.hasOwnProperty, d = RegExp(
    "^" + u.call(p).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return Kc = f, Kc;
}
var Gc, Pk;
function $O() {
  if (Pk) return Gc;
  Pk = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Gc = e, Gc;
}
var Yc, Ak;
function Zi() {
  if (Ak) return Yc;
  Ak = 1;
  var e = IO(), n = $O();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Yc = r, Yc;
}
var Qc, Lk;
function Ql() {
  if (Lk) return Qc;
  Lk = 1;
  var e = Zi(), n = e(Object, "create");
  return Qc = n, Qc;
}
var Jc, Vk;
function EO() {
  if (Vk) return Jc;
  Vk = 1;
  var e = Ql();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Jc = n, Jc;
}
var Xc, zk;
function TO() {
  if (zk) return Xc;
  zk = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Xc = e, Xc;
}
var Zc, Uk;
function DO() {
  if (Uk) return Zc;
  Uk = 1;
  var e = Ql(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Zc = a, Zc;
}
var eu, Mk;
function OO() {
  if (Mk) return eu;
  Mk = 1;
  var e = Ql(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return eu = i, eu;
}
var nu, Bk;
function RO() {
  if (Bk) return nu;
  Bk = 1;
  var e = Ql(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return nu = r, nu;
}
var tu, qk;
function PO() {
  if (qk) return tu;
  qk = 1;
  var e = EO(), n = TO(), r = DO(), i = OO(), a = RO();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, tu = o, tu;
}
var ru, Hk;
function AO() {
  if (Hk) return ru;
  Hk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return ru = e, ru;
}
var iu, Wk;
function Z1() {
  if (Wk) return iu;
  Wk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return iu = e, iu;
}
var au, Kk;
function Jl() {
  if (Kk) return au;
  Kk = 1;
  var e = Z1();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return au = n, au;
}
var ou, Gk;
function LO() {
  if (Gk) return ou;
  Gk = 1;
  var e = Jl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return ou = i, ou;
}
var su, Yk;
function VO() {
  if (Yk) return su;
  Yk = 1;
  var e = Jl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return su = n, su;
}
var lu, Qk;
function zO() {
  if (Qk) return lu;
  Qk = 1;
  var e = Jl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return lu = n, lu;
}
var cu, Jk;
function UO() {
  if (Jk) return cu;
  Jk = 1;
  var e = Jl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return cu = n, cu;
}
var uu, Xk;
function Xl() {
  if (Xk) return uu;
  Xk = 1;
  var e = AO(), n = LO(), r = VO(), i = zO(), a = UO();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, uu = o, uu;
}
var du, Zk;
function rg() {
  if (Zk) return du;
  Zk = 1;
  var e = Zi(), n = Yr(), r = e(n, "Map");
  return du = r, du;
}
var mu, eb;
function MO() {
  if (eb) return mu;
  eb = 1;
  var e = PO(), n = Xl(), r = rg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return mu = i, mu;
}
var pu, nb;
function BO() {
  if (nb) return pu;
  nb = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return pu = e, pu;
}
var fu, tb;
function Zl() {
  if (tb) return fu;
  tb = 1;
  var e = BO();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return fu = n, fu;
}
var hu, rb;
function qO() {
  if (rb) return hu;
  rb = 1;
  var e = Zl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return hu = n, hu;
}
var yu, ib;
function HO() {
  if (ib) return yu;
  ib = 1;
  var e = Zl();
  function n(r) {
    return e(this, r).get(r);
  }
  return yu = n, yu;
}
var gu, ab;
function WO() {
  if (ab) return gu;
  ab = 1;
  var e = Zl();
  function n(r) {
    return e(this, r).has(r);
  }
  return gu = n, gu;
}
var vu, ob;
function KO() {
  if (ob) return vu;
  ob = 1;
  var e = Zl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return vu = n, vu;
}
var ku, sb;
function eC() {
  if (sb) return ku;
  sb = 1;
  var e = MO(), n = qO(), r = HO(), i = WO(), a = KO();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ku = o, ku;
}
var bu, lb;
function GO() {
  if (lb) return bu;
  lb = 1;
  var e = eC(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var p = i.apply(this, s);
      return o.cache = u.set(l, p) || u, p;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, bu = r, bu;
}
var _u, cb;
function YO() {
  if (cb) return _u;
  cb = 1;
  var e = GO(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return _u = r, _u;
}
var xu, ub;
function QO() {
  if (ub) return xu;
  ub = 1;
  var e = YO(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, p) {
      o.push(u ? p.replace(r, "$1") : l || s);
    }), o;
  });
  return xu = i, xu;
}
var Su, db;
function nC() {
  if (db) return Su;
  db = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Su = e, Su;
}
var Nu, mb;
function JO() {
  if (mb) return Nu;
  mb = 1;
  var e = as(), n = nC(), r = wi(), i = tg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return Nu = s, Nu;
}
var ju, pb;
function XO() {
  if (pb) return ju;
  pb = 1;
  var e = JO();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return ju = n, ju;
}
var wu, fb;
function za() {
  if (fb) return wu;
  fb = 1;
  var e = wi(), n = wO(), r = QO(), i = XO();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return wu = a, wu;
}
var Cu, hb;
function ec() {
  if (hb) return Cu;
  hb = 1;
  var e = tg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Cu = n, Cu;
}
var Fu, yb;
function tC() {
  if (yb) return Fu;
  yb = 1;
  var e = za(), n = ec();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Fu = r, Fu;
}
var Iu, gb;
function rC() {
  if (gb) return Iu;
  gb = 1;
  var e = Zi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Iu = n, Iu;
}
var $u, vb;
function iC() {
  if (vb) return $u;
  vb = 1;
  var e = rC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return $u = n, $u;
}
var Eu, kb;
function ig() {
  if (kb) return Eu;
  kb = 1;
  var e = iC(), n = Z1(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Eu = a, Eu;
}
var Tu, bb;
function ag() {
  if (bb) return Tu;
  bb = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Tu = r, Tu;
}
var Du, _b;
function ZO() {
  if (_b) return Du;
  _b = 1;
  var e = ig(), n = za(), r = ag(), i = Va(), a = ec();
  function o(s, l, u, p) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var I = a(l[d]), w = u;
      if (I === "__proto__" || I === "constructor" || I === "prototype")
        return s;
      if (d != h) {
        var j = v[I];
        w = p ? p(j, I, v) : void 0, w === void 0 && (w = i(j) ? j : r(l[d + 1]) ? [] : {});
      }
      e(v, I, w), v = v[I];
    }
    return s;
  }
  return Du = o, Du;
}
var Ou, xb;
function eR() {
  if (xb) return Ou;
  xb = 1;
  var e = tC(), n = ZO(), r = za();
  function i(a, o, s) {
    for (var l = -1, u = o.length, p = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(p, r(d, a), f);
    }
    return p;
  }
  return Ou = i, Ou;
}
var Ru, Sb;
function nR() {
  if (Sb) return Ru;
  Sb = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Ru = e, Ru;
}
var Pu, Nb;
function tR() {
  if (Nb) return Pu;
  Nb = 1;
  var e = La(), n = Xi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Pu = i, Pu;
}
var Au, jb;
function og() {
  if (jb) return Au;
  jb = 1;
  var e = tR(), n = Xi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Au = o, Au;
}
var Lu, wb;
function sg() {
  if (wb) return Lu;
  wb = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Lu = n, Lu;
}
var Vu, Cb;
function rR() {
  if (Cb) return Vu;
  Cb = 1;
  var e = za(), n = og(), r = wi(), i = ag(), a = sg(), o = ec();
  function s(l, u, p) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && p(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Vu = s, Vu;
}
var zu, Fb;
function iR() {
  if (Fb) return zu;
  Fb = 1;
  var e = nR(), n = rR();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return zu = r, zu;
}
var Uu, Ib;
function aR() {
  if (Ib) return Uu;
  Ib = 1;
  var e = eR(), n = iR();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Uu = r, Uu;
}
var Mu, $b;
function lg() {
  if ($b) return Mu;
  $b = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Mu = e, Mu;
}
var Bu, Eb;
function oR() {
  if (Eb) return Bu;
  Eb = 1;
  var e = as(), n = og(), r = wi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Bu = a, Bu;
}
var qu, Tb;
function sR() {
  if (Tb) return qu;
  Tb = 1;
  var e = lg(), n = oR();
  function r(i, a, o, s, l) {
    var u = -1, p = i.length;
    for (o || (o = n), l || (l = []); ++u < p; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? r(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return qu = r, qu;
}
var Hu, Db;
function lR() {
  if (Db) return Hu;
  Db = 1;
  var e = sR();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Hu = n, Hu;
}
var Wu, Ob;
function cR() {
  if (Ob) return Wu;
  Ob = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Wu = e, Wu;
}
var Ku, Rb;
function uR() {
  if (Rb) return Ku;
  Rb = 1;
  var e = cR(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), p = Array(u); ++l < u; )
        p[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(p), e(i, this, d);
    };
  }
  return Ku = r, Ku;
}
var Gu, Pb;
function dR() {
  if (Pb) return Gu;
  Pb = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Gu = e, Gu;
}
var Yu, Ab;
function aC() {
  if (Ab) return Yu;
  Ab = 1;
  function e(n) {
    return n;
  }
  return Yu = e, Yu;
}
var Qu, Lb;
function mR() {
  if (Lb) return Qu;
  Lb = 1;
  var e = dR(), n = rC(), r = aC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Qu = i, Qu;
}
var Ju, Vb;
function pR() {
  if (Vb) return Ju;
  Vb = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Ju = i, Ju;
}
var Xu, zb;
function fR() {
  if (zb) return Xu;
  zb = 1;
  var e = mR(), n = pR(), r = n(e);
  return Xu = r, Xu;
}
var Zu, Ub;
function oC() {
  if (Ub) return Zu;
  Ub = 1;
  var e = lR(), n = uR(), r = fR();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Zu = i, Zu;
}
var ed, Mb;
function hR() {
  if (Mb) return ed;
  Mb = 1;
  var e = aR(), n = oC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return ed = r, ed;
}
var yR = hR();
const sC = /* @__PURE__ */ Y1(yR), gR = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function lC(e) {
  const n = sC(e, gR);
  return {
    controller: Zy(n),
    controllerProps: n
  };
}
const vR = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function cC(e) {
  const { controller: n, controllerProps: r } = lC(e), i = {
    ...sC(e, vR),
    required: SO(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var nd, Bb;
function kR() {
  if (Bb) return nd;
  Bb = 1;
  var e = Xl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return nd = n, nd;
}
var td, qb;
function bR() {
  if (qb) return td;
  qb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return td = e, td;
}
var rd, Hb;
function _R() {
  if (Hb) return rd;
  Hb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return rd = e, rd;
}
var id, Wb;
function xR() {
  if (Wb) return id;
  Wb = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return id = e, id;
}
var ad, Kb;
function SR() {
  if (Kb) return ad;
  Kb = 1;
  var e = Xl(), n = rg(), r = eC(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return ad = a, ad;
}
var od, Gb;
function NR() {
  if (Gb) return od;
  Gb = 1;
  var e = Xl(), n = kR(), r = bR(), i = _R(), a = xR(), o = SR();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, od = s, od;
}
var sd, Yb;
function jR() {
  if (Yb) return sd;
  Yb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return sd = e, sd;
}
var ld, Qb;
function os() {
  if (Qb) return ld;
  Qb = 1;
  var e = ig(), n = iC();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, p = a.length; ++u < p; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return ld = r, ld;
}
var cd, Jb;
function wR() {
  if (Jb) return cd;
  Jb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return cd = e, cd;
}
var il = { exports: {} }, ud, Xb;
function CR() {
  if (Xb) return ud;
  Xb = 1;
  function e() {
    return !1;
  }
  return ud = e, ud;
}
il.exports;
var Zb;
function uC() {
  return Zb || (Zb = 1, (function(e, n) {
    var r = Yr(), i = CR(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, u = l ? l.isBuffer : void 0, p = u || i;
    e.exports = p;
  })(il, il.exports)), il.exports;
}
var dd, e_;
function FR() {
  if (e_) return dd;
  e_ = 1;
  var e = La(), n = sg(), r = Xi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", p = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", I = "[object String]", w = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", y = "[object Float32Array]", L = "[object Float64Array]", E = "[object Int8Array]", C = "[object Int16Array]", F = "[object Int32Array]", z = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", Z = "[object Uint16Array]", te = "[object Uint32Array]", G = {};
  G[y] = G[L] = G[E] = G[C] = G[F] = G[z] = G[Q] = G[Z] = G[te] = !0, G[i] = G[a] = G[j] = G[o] = G[_] = G[s] = G[l] = G[u] = G[p] = G[d] = G[f] = G[h] = G[v] = G[I] = G[w] = !1;
  function B(R) {
    return r(R) && n(R.length) && !!G[e(R)];
  }
  return dd = B, dd;
}
var md, n_;
function cg() {
  if (n_) return md;
  n_ = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return md = e, md;
}
var al = { exports: {} };
al.exports;
var t_;
function ug() {
  return t_ || (t_ = 1, (function(e, n) {
    var r = Q1(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(al, al.exports)), al.exports;
}
var pd, r_;
function IR() {
  if (r_) return pd;
  r_ = 1;
  var e = FR(), n = cg(), r = ug(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return pd = a, pd;
}
var fd, i_;
function dC() {
  if (i_) return fd;
  i_ = 1;
  var e = wR(), n = og(), r = wi(), i = uC(), a = ag(), o = IR(), s = Object.prototype, l = s.hasOwnProperty;
  function u(p, d) {
    var f = r(p), h = !f && n(p), v = !f && !h && i(p), I = !f && !h && !v && o(p), w = f || h || v || I, j = w ? e(p.length, String) : [], _ = j.length;
    for (var y in p)
      (d || l.call(p, y)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      I && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, _))) && j.push(y);
    return j;
  }
  return fd = u, fd;
}
var hd, a_;
function dg() {
  if (a_) return hd;
  a_ = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return hd = n, hd;
}
var yd, o_;
function mC() {
  if (o_) return yd;
  o_ = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return yd = e, yd;
}
var gd, s_;
function $R() {
  if (s_) return gd;
  s_ = 1;
  var e = mC(), n = e(Object.keys, Object);
  return gd = n, gd;
}
var vd, l_;
function ER() {
  if (l_) return vd;
  l_ = 1;
  var e = dg(), n = $R(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return vd = a, vd;
}
var kd, c_;
function pC() {
  if (c_) return kd;
  c_ = 1;
  var e = J1(), n = sg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return kd = r, kd;
}
var bd, u_;
function mg() {
  if (u_) return bd;
  u_ = 1;
  var e = dC(), n = ER(), r = pC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return bd = i, bd;
}
var _d, d_;
function TR() {
  if (d_) return _d;
  d_ = 1;
  var e = os(), n = mg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return _d = r, _d;
}
var xd, m_;
function DR() {
  if (m_) return xd;
  m_ = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return xd = e, xd;
}
var Sd, p_;
function OR() {
  if (p_) return Sd;
  p_ = 1;
  var e = Va(), n = dg(), r = DR(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), u = [];
    for (var p in s)
      p == "constructor" && (l || !a.call(s, p)) || u.push(p);
    return u;
  }
  return Sd = o, Sd;
}
var Nd, f_;
function pg() {
  if (f_) return Nd;
  f_ = 1;
  var e = dC(), n = OR(), r = pC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Nd = i, Nd;
}
var jd, h_;
function RR() {
  if (h_) return jd;
  h_ = 1;
  var e = os(), n = pg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return jd = r, jd;
}
var ol = { exports: {} };
ol.exports;
var y_;
function PR() {
  return y_ || (y_ = 1, (function(e, n) {
    var r = Yr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(p, d) {
      if (d)
        return p.slice();
      var f = p.length, h = l ? l(f) : new p.constructor(f);
      return p.copy(h), h;
    }
    e.exports = u;
  })(ol, ol.exports)), ol.exports;
}
var wd, g_;
function AR() {
  if (g_) return wd;
  g_ = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return wd = e, wd;
}
var Cd, v_;
function LR() {
  if (v_) return Cd;
  v_ = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Cd = e, Cd;
}
var Fd, k_;
function fC() {
  if (k_) return Fd;
  k_ = 1;
  function e() {
    return [];
  }
  return Fd = e, Fd;
}
var Id, b_;
function fg() {
  if (b_) return Id;
  b_ = 1;
  var e = LR(), n = fC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Id = o, Id;
}
var $d, __;
function VR() {
  if (__) return $d;
  __ = 1;
  var e = os(), n = fg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return $d = r, $d;
}
var Ed, x_;
function hg() {
  if (x_) return Ed;
  x_ = 1;
  var e = mC(), n = e(Object.getPrototypeOf, Object);
  return Ed = n, Ed;
}
var Td, S_;
function hC() {
  if (S_) return Td;
  S_ = 1;
  var e = lg(), n = hg(), r = fg(), i = fC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Td = o, Td;
}
var Dd, N_;
function zR() {
  if (N_) return Dd;
  N_ = 1;
  var e = os(), n = hC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Dd = r, Dd;
}
var Od, j_;
function yC() {
  if (j_) return Od;
  j_ = 1;
  var e = lg(), n = wi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Od = r, Od;
}
var Rd, w_;
function UR() {
  if (w_) return Rd;
  w_ = 1;
  var e = yC(), n = fg(), r = mg();
  function i(a) {
    return e(a, r, n);
  }
  return Rd = i, Rd;
}
var Pd, C_;
function gC() {
  if (C_) return Pd;
  C_ = 1;
  var e = yC(), n = hC(), r = pg();
  function i(a) {
    return e(a, r, n);
  }
  return Pd = i, Pd;
}
var Ad, F_;
function MR() {
  if (F_) return Ad;
  F_ = 1;
  var e = Zi(), n = Yr(), r = e(n, "DataView");
  return Ad = r, Ad;
}
var Ld, I_;
function BR() {
  if (I_) return Ld;
  I_ = 1;
  var e = Zi(), n = Yr(), r = e(n, "Promise");
  return Ld = r, Ld;
}
var Vd, $_;
function qR() {
  if ($_) return Vd;
  $_ = 1;
  var e = Zi(), n = Yr(), r = e(n, "Set");
  return Vd = r, Vd;
}
var zd, E_;
function HR() {
  if (E_) return zd;
  E_ = 1;
  var e = Zi(), n = Yr(), r = e(n, "WeakMap");
  return zd = r, zd;
}
var Ud, T_;
function yg() {
  if (T_) return Ud;
  T_ = 1;
  var e = MR(), n = rg(), r = BR(), i = qR(), a = HR(), o = La(), s = X1(), l = "[object Map]", u = "[object Object]", p = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), I = s(n), w = s(r), j = s(i), _ = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != p || i && y(new i()) != d || a && y(new a()) != f) && (y = function(L) {
    var E = o(L), C = E == u ? L.constructor : void 0, F = C ? s(C) : "";
    if (F)
      switch (F) {
        case v:
          return h;
        case I:
          return l;
        case w:
          return p;
        case j:
          return d;
        case _:
          return f;
      }
    return E;
  }), Ud = y, Ud;
}
var Md, D_;
function WR() {
  if (D_) return Md;
  D_ = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Md = r, Md;
}
var Bd, O_;
function KR() {
  if (O_) return Bd;
  O_ = 1;
  var e = Yr(), n = e.Uint8Array;
  return Bd = n, Bd;
}
var qd, R_;
function gg() {
  if (R_) return qd;
  R_ = 1;
  var e = KR();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return qd = n, qd;
}
var Hd, P_;
function GR() {
  if (P_) return Hd;
  P_ = 1;
  var e = gg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Hd = n, Hd;
}
var Wd, A_;
function YR() {
  if (A_) return Wd;
  A_ = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Wd = n, Wd;
}
var Kd, L_;
function QR() {
  if (L_) return Kd;
  L_ = 1;
  var e = as(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Kd = i, Kd;
}
var Gd, V_;
function JR() {
  if (V_) return Gd;
  V_ = 1;
  var e = gg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Gd = n, Gd;
}
var Yd, z_;
function XR() {
  if (z_) return Yd;
  z_ = 1;
  var e = gg(), n = GR(), r = YR(), i = QR(), a = JR(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", p = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", I = "[object DataView]", w = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", y = "[object Int16Array]", L = "[object Int32Array]", E = "[object Uint8Array]", C = "[object Uint8ClampedArray]", F = "[object Uint16Array]", z = "[object Uint32Array]";
  function Q(Z, te, G) {
    var B = Z.constructor;
    switch (te) {
      case v:
        return e(Z);
      case o:
      case s:
        return new B(+Z);
      case I:
        return n(Z, G);
      case w:
      case j:
      case _:
      case y:
      case L:
      case E:
      case C:
      case F:
      case z:
        return a(Z, G);
      case l:
        return new B();
      case u:
      case f:
        return new B(Z);
      case p:
        return r(Z);
      case d:
        return new B();
      case h:
        return i(Z);
    }
  }
  return Yd = Q, Yd;
}
var Qd, U_;
function ZR() {
  if (U_) return Qd;
  U_ = 1;
  var e = Va(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Qd = r, Qd;
}
var Jd, M_;
function eP() {
  if (M_) return Jd;
  M_ = 1;
  var e = ZR(), n = hg(), r = dg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Jd = i, Jd;
}
var Xd, B_;
function nP() {
  if (B_) return Xd;
  B_ = 1;
  var e = yg(), n = Xi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Xd = i, Xd;
}
var Zd, q_;
function tP() {
  if (q_) return Zd;
  q_ = 1;
  var e = nP(), n = cg(), r = ug(), i = r && r.isMap, a = i ? n(i) : e;
  return Zd = a, Zd;
}
var em, H_;
function rP() {
  if (H_) return em;
  H_ = 1;
  var e = yg(), n = Xi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return em = i, em;
}
var nm, W_;
function iP() {
  if (W_) return nm;
  W_ = 1;
  var e = rP(), n = cg(), r = ug(), i = r && r.isSet, a = i ? n(i) : e;
  return nm = a, nm;
}
var tm, K_;
function aP() {
  if (K_) return tm;
  K_ = 1;
  var e = NR(), n = jR(), r = ig(), i = TR(), a = RR(), o = PR(), s = AR(), l = VR(), u = zR(), p = UR(), d = gC(), f = yg(), h = WR(), v = XR(), I = eP(), w = wi(), j = uC(), _ = tP(), y = Va(), L = iP(), E = mg(), C = pg(), F = 1, z = 2, Q = 4, Z = "[object Arguments]", te = "[object Array]", G = "[object Boolean]", B = "[object Date]", R = "[object Error]", U = "[object Function]", ee = "[object GeneratorFunction]", Se = "[object Map]", fe = "[object Number]", ye = "[object Object]", ve = "[object RegExp]", K = "[object Set]", _e = "[object String]", Te = "[object Symbol]", J = "[object WeakMap]", Ke = "[object ArrayBuffer]", an = "[object DataView]", we = "[object Float32Array]", Me = "[object Float64Array]", Re = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Ge = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", qe = "[object Uint16Array]", en = "[object Uint32Array]", ie = {};
  ie[Z] = ie[te] = ie[Ke] = ie[an] = ie[G] = ie[B] = ie[we] = ie[Me] = ie[Re] = ie[Be] = ie[Ae] = ie[Se] = ie[fe] = ie[ye] = ie[ve] = ie[K] = ie[_e] = ie[Te] = ie[Ge] = ie[Ce] = ie[qe] = ie[en] = !0, ie[R] = ie[U] = ie[J] = !1;
  function se(xe, Le, Pe, yn, T, x) {
    var D, H = Le & F, Y = Le & z, A = Le & Q;
    if (Pe && (D = T ? Pe(xe, yn, T, x) : Pe(xe)), D !== void 0)
      return D;
    if (!y(xe))
      return xe;
    var M = w(xe);
    if (M) {
      if (D = h(xe), !H)
        return s(xe, D);
    } else {
      var ae = f(xe), ge = ae == U || ae == ee;
      if (j(xe))
        return o(xe, H);
      if (ae == ye || ae == Z || ge && !T) {
        if (D = Y || ge ? {} : I(xe), !H)
          return Y ? u(xe, a(D, xe)) : l(xe, i(D, xe));
      } else {
        if (!ie[ae])
          return T ? xe : {};
        D = v(xe, ae, H);
      }
    }
    x || (x = new e());
    var Ne = x.get(xe);
    if (Ne)
      return Ne;
    x.set(xe, D), L(xe) ? xe.forEach(function(nn) {
      D.add(se(nn, Le, Pe, nn, xe, x));
    }) : _(xe) && xe.forEach(function(nn, dn) {
      D.set(dn, se(nn, Le, Pe, dn, xe, x));
    });
    var tn = A ? Y ? d : p : Y ? C : E, gn = M ? void 0 : tn(xe);
    return n(gn || xe, function(nn, dn) {
      gn && (dn = nn, nn = xe[dn]), r(D, dn, se(nn, Le, Pe, dn, xe, x));
    }), D;
  }
  return tm = se, tm;
}
var rm, G_;
function oP() {
  if (G_) return rm;
  G_ = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return rm = e, rm;
}
var im, Y_;
function sP() {
  if (Y_) return im;
  Y_ = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return im = e, im;
}
var am, Q_;
function lP() {
  if (Q_) return am;
  Q_ = 1;
  var e = tC(), n = sP();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return am = r, am;
}
var om, J_;
function cP() {
  if (J_) return om;
  J_ = 1;
  var e = za(), n = oP(), r = lP(), i = ec(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, u) {
    u = e(u, l);
    var p = -1, d = u.length;
    if (!d)
      return !0;
    for (; ++p < d; ) {
      var f = i(u[p]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && p < d - 1)
        return !1;
    }
    var h = r(l, u);
    return h == null || delete h[i(n(u))];
  }
  return om = s, om;
}
var sm, X_;
function uP() {
  if (X_) return sm;
  X_ = 1;
  var e = La(), n = hg(), r = Xi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function p(d) {
    if (!r(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return sm = p, sm;
}
var lm, Z_;
function dP() {
  if (Z_) return lm;
  Z_ = 1;
  var e = uP();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return lm = n, lm;
}
var cm, ex;
function mP() {
  if (ex) return cm;
  ex = 1;
  var e = nC(), n = aP(), r = cP(), i = za(), a = os(), o = dP(), s = oC(), l = gC(), u = 1, p = 2, d = 4, f = s(function(h, v) {
    var I = {};
    if (h == null)
      return I;
    var w = !1;
    v = e(v, function(_) {
      return _ = i(_, h), w || (w = _.length > 1), _;
    }), a(h, l(h), I), w && (I = n(I, u | p | d, o));
    for (var j = v.length; j--; )
      r(I, v[j]);
    return I;
  });
  return cm = f, cm;
}
mP();
const Dr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = cC(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...u
  } = r.field;
  return /* @__PURE__ */ Hi.jsx(rn, { ...a, children: /* @__PURE__ */ Hi.jsx(
    _i,
    {
      ...n.componentProps,
      ...u,
      multiple: !1,
      value: u.value ? [u.value] : [],
      onBlur: (p) => {
        n.componentProps?.onBlur?.(p), s();
      },
      onChange: (p) => {
        n.componentProps?.onChange?.(p), l(p.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: rn.getStatus(a.meta),
      children: e
    }
  ) });
};
var pP = aC();
const fP = /* @__PURE__ */ Y1(pP), An = ({
  transformValue: e = fP,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = lC(a);
  return /* @__PURE__ */ Hi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Hi.jsx(
      hl,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Hi.jsx(Qw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, tt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = cC(e);
  return /* @__PURE__ */ Hi.jsx(rn, { ...i, children: /* @__PURE__ */ Hi.jsx(
    _r,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: rn.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var um = { exports: {} }, to = {}, nx;
function hP() {
  if (nx) return to;
  nx = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return to.Fragment = r, to.jsx = s, to.jsxs = s, to;
}
var Ss = {}, tx;
function yP() {
  return tx || (tx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Ss.Fragment = i, Ss.jsx = Un, Ss.jsxs = Kn;
  })()), Ss;
}
var rx;
function gP() {
  return rx || (rx = 1, process.env.NODE_ENV === "production" ? um.exports = hP() : um.exports = yP()), um.exports;
}
var be = gP();
const vP = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, kP = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, bP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, _P = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, xP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, SP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, NP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, jP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, wP = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": bP,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": _P,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": xP,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": vP,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": kP,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SP,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": NP,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": jP
};
function Ua(e) {
  return wP[e] ?? {};
}
const CP = Ua(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), FP = Ua(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), IP = Ua(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), ix = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, kr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, $P = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), ax = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Gh = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ be.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ be.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ be.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ be.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ be.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ be.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function EP({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = ue(
    []
  ), [o, s] = ue([]), [l, u] = ue([]), [p, d] = ue([]), [f, h] = ue(), { showNotification: v, showModal: I, executeQuery: w } = _n(), { track: j } = $n(), {
    loading: _,
    data: y,
    error: L,
    store: E
  } = $y(e ?? null), C = y?.github?.issues || [], F = y?.github?.pullRequests || [], [z, Q] = ue(!1), [Z, te] = ue();
  Xe(
    () => h(L || Z || void 0),
    [L, Z]
  ), Xe(
    () => {
      !_ && (C?.length || F?.length) ? (a(C), s(F), B(C, F)) : (a([]), s([]), u([]), d([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const G = async (ve, K) => {
    await E(ve).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: K.success.title,
        text: K.success.text
      });
    }).catch((_e) => {
      v({
        title: K.error.title,
        text: `${K.error.text} ${_e.message && " (" + _e.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (ve, K) => {
    if (!ve?.length && !K?.length) {
      u([]), d([]);
      return;
    }
    const _e = (ve || []).map(
      (Ke) => w(FP, {
        owner: Ke.owner,
        repositoryName: Ke.repository,
        issueNumber: Ke.number
      })
    ), Te = (K || []).map(
      (Ke) => w(IP, {
        owner: Ke.owner,
        repositoryName: Ke.repository,
        prNumber: Ke.number
      })
    ), J = [..._e, ...Te];
    Q(!0), Promise.all(J).then((Ke) => {
      const an = [], we = [];
      Ke.forEach((Me) => {
        const Re = Me?.data?.GitHub;
        if (!Re) {
          u([]), d([]);
          return;
        }
        Object.keys(Re).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Ae = Re[Be];
            Object.keys(Ae).forEach((Ge) => {
              const Ce = Ae[Ge], qe = {
                number: Ce?.number,
                owner: Ce?.repository?.owner?.login,
                repository: Ce?.repository?.name
              };
              Ge.startsWith("issue") && an.push({
                ...Ce,
                type: "ISSUE",
                key: qe
              }), Ge.startsWith("pullRequest") && we.push({
                ...Ce,
                type: "PR",
                key: qe
              });
            });
          }
        });
      }), u(an), d(we);
    }).catch(te).finally(() => {
      Q(!1);
    });
  }, R = ({ key: ve, type: K }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const _e = y && (C.length || F.length) ? y : r, Te = K === "ISSUE" ? "issues" : "pullRequests";
    _e.github[Te] = Array.from(
      new Set(_e.github[Te]).add(ve)
    ), G(_e, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${kr(
          ve
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${kr(ve)} failed. Please try again.`
      }
    });
  }, U = async ({ key: ve, type: K }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const _e = y && (C.length || F.length) ? y : r, Te = K === "ISSUE" ? "issues" : "pullRequests";
    _e.github[Te] = Array.from(
      new Set(_e.github[Te]).add(ve)
    ), await E(_e).catch((J) => {
      v({
        title: "Linking failed",
        text: `Linking ${ve} failed. Please try again. ${J.message && " (" + J.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: ve, type: K }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const _e = K === "ISSUE" ? "issue" : "pull request";
    I({
      headline: `Unlink ${_e} ${kr(ve)}?`,
      text: `You are about to unlink the ${_e} ${kr(
        ve
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${_e}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Te = K === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const J = {
          ...y,
          github: {
            ...y?.github,
            [Te]: y?.github?.[Te].filter(
              (Ke) => Ke.number !== ve.number || Ke.owner !== ve.owner || Ke.repository !== ve.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), G(J, {
          success: {
            title: `GitHub ${_e} unlinked`,
            text: `You unlinked the GitHub ${_e} ${kr(
              ve
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${kr(ve)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, Se = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), I({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), G(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, fe = C.filter(
    (ve) => !i?.includes(ve)
  ) || [], ye = F.filter(
    (ve) => !o?.includes(ve)
  ) || [];
  return {
    linkGithubItem: R,
    linkGithubItemQuietly: U,
    unlinkGithubItem: ee,
    loadGithubItems: B,
    removeDanglingGithubItemLinks: () => {
      const ve = {
        ...y,
        github: {
          ...y?.github,
          issues: C.filter(
            (K) => !fe.includes(K)
          ) || [],
          pullRequests: F.filter(
            (K) => !ye.includes(K)
          ) || []
        }
      };
      E(ve);
    },
    unlinkAllGithubItems: Se,
    isLoadingGithubItemLinks: _,
    danglingIssueLinks: fe,
    danglingPullRequestLinks: ye,
    isLoadingGithubItems: z,
    issues: l,
    pullRequests: p,
    error: f
  };
}
const TP = "_contentWrapper_1vx3c_1", DP = "_contentWrapperHeadline_1vx3c_4", OP = "_contentWrapperBody_1vx3c_11", RP = "_contentWrapperAssigneeIcon_1vx3c_15", PP = "_contentWrapperStatusTag_1vx3c_20", ei = {
  contentWrapper: TP,
  contentWrapperHeadline: DP,
  contentWrapperBody: OP,
  contentWrapperAssigneeIcon: RP,
  contentWrapperStatusTag: PP
}, vC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
  e && /* @__PURE__ */ be.jsxs(ct, { className: ei.contentWrapper, children: [
    /* @__PURE__ */ be.jsx(ct, { className: ei.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ be.jsx(ct, { className: ei.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ be.jsxs(ct, { className: ei.contentWrapper, children: [
    /* @__PURE__ */ be.jsx(ct, { className: ei.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ be.jsx(ct, { className: ei.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ be.jsxs(ct, { margin: "100 0", children: [
        /* @__PURE__ */ be.jsx(
          "img",
          {
            className: ei.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ be.jsx(ct, { className: ei.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ be.jsx(
      Yn,
      {
        className: ei.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), AP = "_collapse_1bdjy_1", LP = "_collapseHeader_1bdjy_10", VP = "_collapseHeaderKey_1bdjy_31", zP = "_collapseHeaderKeyIcon_1bdjy_36", UP = "_collapseHeaderKeyLink_1bdjy_41", MP = "_collapseHeaderIcon_1bdjy_44", BP = "_collapseHeaderTitle_1bdjy_49", qP = "_collapseContent_1bdjy_57", HP = "_collapseContentButtonSpacer_1bdjy_60", WP = "_collapseContentButtonLink_1bdjy_63", Pr = {
  collapse: AP,
  collapseHeader: LP,
  collapseHeaderKey: VP,
  collapseHeaderKeyIcon: zP,
  collapseHeaderKeyLink: UP,
  collapseHeaderIcon: MP,
  collapseHeaderTitle: BP,
  collapseContent: qP,
  collapseContentButtonSpacer: HP,
  collapseContentButtonLink: WP
}, KP = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (u, p) => ({ ...u, [p.id]: !1 }),
    {}
  ), [a, o] = ue(i), { track: s } = $n(), l = (u, p) => {
    o({ ...a, [u]: p });
  };
  return /* @__PURE__ */ be.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const {
      id: p,
      number: d,
      key: f,
      title: h,
      bodyText: v,
      repository: I,
      type: w,
      state: j,
      assignees: _,
      labels: y
    } = u, L = a[p];
    return /* @__PURE__ */ be.jsxs(
      xr,
      {
        onToggle: () => l(p, !a[p]),
        isOpen: L,
        className: Pr.collapse,
        children: [
          /* @__PURE__ */ be.jsx(xr.Header, { className: Pr.collapseHeader, children: /* @__PURE__ */ be.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ be.jsx(ct, { children: /* @__PURE__ */ be.jsxs(ct, { as: "span", className: Pr.collapseHeaderKey, children: [
                  Gh(
                    w,
                    j,
                    Pr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ be.jsxs(
                    "a",
                    {
                      href: ix(f),
                      className: Pr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (E) => {
                        E.stopPropagation();
                      },
                      children: [
                        kr(f),
                        /* @__PURE__ */ be.jsx(
                          he,
                          {
                            className: Pr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ be.jsx(ct, { className: Pr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ be.jsx(xr.Content, { className: Pr.collapseContent, children: /* @__PURE__ */ be.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ be.jsx(
              vC,
              {
                description: v,
                assignees: _,
                labels: y
              }
            ),
            /* @__PURE__ */ be.jsxs(
              et,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Pr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: d,
                    owner: I?.owner.login,
                    repository: u.repository.name
                  },
                  type: w
                }),
                children: [
                  "Unlink ",
                  ax(w)
                ]
              }
            ),
            /* @__PURE__ */ be.jsxs(
              Bt,
              {
                slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: Pr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(ix(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  ax(w),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      p
    );
  }) : /* @__PURE__ */ be.jsx(be.Fragment, {}) });
}, GP = "_result_1uaom_1", YP = "_resultName_1uaom_21", QP = "_resultItemIcon_1uaom_29", JP = "_resultDescription_1uaom_34", XP = "_resultLinkIcon_1uaom_46", ZP = "_tooltip_1uaom_55", eA = "_tooltipName_1uaom_61", nA = "_tooltipTag_1uaom_71", ni = {
  result: GP,
  resultName: YP,
  resultItemIcon: QP,
  resultDescription: JP,
  resultLinkIcon: XP,
  tooltip: ZP,
  tooltipName: eA,
  tooltipTag: nA
}, tA = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: u } = e, [p, d] = ue(!1);
  return /* @__PURE__ */ be.jsx(
    Je,
    {
      className: ni.tooltip,
      content: /* @__PURE__ */ be.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ be.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ be.jsxs(ct, { as: "span", className: ni.tooltipName, children: [
                Gh(a, o, ni.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ be.jsx(Yn, { className: ni.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ be.jsx(
          vC,
          {
            description: l,
            assignees: u,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ be.jsxs(
        "button",
        {
          className: ni.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => d(!0),
          onMouseLeave: () => d(!1),
          children: [
            /* @__PURE__ */ be.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: p ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ be.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ be.jsxs(ct, { as: "span", className: ni.resultName, children: [
                    Gh(a, o, ni.resultItemIcon),
                    kr(r)
                  ] }) }),
                  /* @__PURE__ */ be.jsx(ct, { className: ni.resultDescription, children: i })
                ]
              }
            ),
            p && /* @__PURE__ */ be.jsx(
              he,
              {
                className: ni.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, rA = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ be.jsx(
  Bt,
  {
    slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), jl = "[a-zA-z0-9_.-]+", kC = "[0-9]+", iA = new RegExp(
  `(${jl})/(${jl})/(?:issues|pull)/(${kC})`,
  "i"
), ox = new RegExp(`^${iA.source}$`), sx = new RegExp(
  `https://github.com/(${jl})/(${jl})/(?:issues|pull)/(${kC})`,
  "i"
), aA = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Xn(() => r?.map((F) => F.id) || [], [r]), o = Xn(() => i?.map((F) => F.id) || [], [i]), [s, l] = ue([]), { useLazyQuery: u } = _n(), [p, d] = ue(), [f, { loading: h, error: v, data: I, networkStatus: w }] = u(CP, {
    notifyOnNetworkStatusChange: !0
  });
  Ji(
    () => {
      !h && p && w === dr.ready ? f({
        variables: {
          issueQuery: `${p} type:issue`,
          prQuery: `${p} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [p]
  ), Xe(() => {
    let F = I?.GitHub?.issues?.nodes || [], z = I?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (F = F.filter((Q) => !a.includes(Q.id))), o.length > 0 && (z = z.filter(
      (Q) => !o.includes(Q.id)
    )), l([
      ...F.map((Q) => ({
        ...Q,
        type: "ISSUE",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      })),
      ...z.map((Q) => ({
        ...Q,
        type: "PR",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      }))
    ]);
  }, [I, a, o]);
  function j(F) {
    const z = F?.trim();
    if (ox.test(z)) {
      const [Q, Z, te, G] = z.match(ox) || [];
      return Z !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(G)
      };
    }
    if (sx.test(z)) {
      const [Q, Z, te, G] = z.match(sx) || [];
      return Z !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(G)
      };
    }
  }
  const _ = (F) => {
    e({
      key: $P(F),
      type: F.type
    }), d(void 0);
  }, y = (F) => {
    const z = j(F);
    d(
      z ? `org:${z.owner} repo:${z.repository} ${z.number}` : `org:${n} ${F}`
    );
  }, L = () => {
    d(void 0);
  }, E = ({ className: F, searched: z }) => /* @__PURE__ */ be.jsx(
    rA,
    {
      className: F,
      searched: z,
      githubOrganization: n
    }
  ), C = ({ item: F, onSelect: z }) => /* @__PURE__ */ be.jsx(tA, { item: F, onSelect: z });
  return !h && v ? /* @__PURE__ */ be.jsx(Tn, { error: v }) : /* @__PURE__ */ be.jsx(
    Or,
    {
      items: s?.map((F) => ({ name: F.title, ...F })),
      loading: h,
      onSearch: y,
      onSelect: _,
      onClear: L,
      emptyMessage: p ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: E,
      itemComponent: C,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, oA = "_itemButton_3sxfy_1", sA = "_result_3sxfy_6", lA = "_resultName_3sxfy_30", cA = "_resultCheckIcon_3sxfy_38", uA = "_resultAssigneeIcon_3sxfy_41", ro = {
  itemButton: oA,
  result: sA,
  resultName: lA,
  resultCheckIcon: cA,
  resultAssigneeIcon: uA
}, bC = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ be.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ be.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: ro.itemButton,
        children: /* @__PURE__ */ be.jsxs(b, { className: ro.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ be.jsx(ct, { margin: "100 0", children: /* @__PURE__ */ be.jsx(
            "img",
            {
              className: ro.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ be.jsx(ct, { className: ro.resultName, children: e.name }),
          n && /* @__PURE__ */ be.jsx(ct, { className: ro.resultCheckIcon, children: /* @__PURE__ */ be.jsx(he, { name: "done" }) })
        ] })
      }
    )
  }
), dA = Ua(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), mA = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = _n(), [o, s] = ue([]), [l, u] = ue(""), p = 2, [d, { loading: f, error: h, data: v, networkStatus: I }] = a(
    dA,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Ji(
    () => {
      !f && l && l.length >= p && I === dr.ready ? d({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Xe(() => {
    const w = v?.GitHub?.organization?.teams || { edges: [] }, j = [];
    w?.edges?.forEach((_) => {
      const y = _?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((L) => {
        const E = L?.node;
        E && (E?.id && j.find((C) => C.id === E.id) || j.push(E));
      });
    }), s(
      j.sort((_, y) => {
        const L = _.name?.toLowerCase() || _.login?.toLowerCase(), E = y.name?.toLowerCase() || y.login?.toLowerCase();
        return L.localeCompare(E, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ be.jsx(Tn, { error: h }) : /* @__PURE__ */ be.jsx(
    Or,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: w, name: j, login: _, avatarUrl: y }) => ({
        id: w,
        name: j || _,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (w) => u(w),
      onChange: (w, j) => {
        const _ = w.id;
        i ? (j && !n.find(
          (y) => y.id === _
        ) && n.push(w), j || (n = n.filter(
          (y) => y.id !== _
        ))) : n = j ? [w] : [], r(n);
      },
      onClear: () => u(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: w, onSelect: j, checked: _ }) => /* @__PURE__ */ be.jsx(
        bC,
        {
          item: w,
          checked: _,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, pA = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ be.jsx(_r, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ be.jsx(
        Or,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: u }) => ({
            id: s,
            name: l || u
          }))
        }
      ) : /* @__PURE__ */ be.jsx(
        Ml,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ be.jsx(_r, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ be.jsx(
        Or,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: u }) => ({
              id: s,
              name: l || u
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ be.jsx(_r, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ be.jsx(zh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ be.jsx(
        mA,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ be.jsx(be.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, fA = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ be.jsx(be.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ be.jsx(
  zt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ be.jsx(
      rn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: pA({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), hA = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ be.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ be.jsxs(P.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ be.jsxs(P.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ be.jsx(he, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ be.jsx(rn, { label: "GitHub issue link", children: /* @__PURE__ */ be.jsx(
          _r,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, yA = "_modalBody_1hk1o_1", gA = "_modalBodyFormFields_1hk1o_4", dm = {
  modalBody: yA,
  modalBodyFormFields: gA
}, vA = Ua(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), kA = Ua(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), bA = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], _A = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = _n(), { track: u } = $n(), {
    control: p,
    handleSubmit: d,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = St(), [I, w] = ue(""), [j, _] = ue([]), [y, L] = ue(), [E, C] = ue(!1), [F, z] = ue(!1), [Q, Z] = R1(), [
    te,
    {
      loading: G,
      error: B,
      networkStatus: R
    }
  ] = s(vA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Te) => {
      _(
        Te.GitHub.search?.edges?.map((J) => J?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), _([]);
    }
  });
  Ji(
    () => {
      !G && I && R === dr.ready ? te({
        variables: {
          query: I,
          maxResults: 10
        }
      }) : _([]);
    },
    500,
    [I]
  );
  const [U, { error: ee }] = l(
    kA,
    {
      onError: (Te) => {
        C(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Te);
      },
      onCompleted: (Te) => {
        C(!1);
        const J = Te.GitHub.createIssue?.issue;
        L(J), o({
          title: "Success",
          text: `GitHub issue '${J.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: J.repository.name,
          number: J.number
        });
      }
    }
  ), Se = (Te) => {
    w(`org:${a} ${Te}`);
  }, fe = (Te, J) => {
    J(Te), w("");
  }, ye = () => {
    w("");
  }, ve = (Te) => {
    u("github:create:issue:confirmed", {
      githubOrganization: a
    }), C(!0), U({
      variables: {
        input: {
          repositoryId: Te.repository.id,
          title: Te.title,
          body: Te.body,
          assigneeIds: Te.assignees?.length > 0 ? Te.assignees.map((J) => J.id) : void 0
        }
      }
    });
  };
  Xe(() => {
    const Te = F ? window.setTimeout(() => z(!1), 2e3) : void 0;
    return () => window.clearTimeout(Te);
  }, [F]);
  const K = () => {
    w(""), _([]), L(void 0), C(!1), z(!1);
  }, _e = () => {
    u("github:create:issue:canceled", {
      githubOrganization: a
    }), K(), h(), n();
  };
  return /* @__PURE__ */ be.jsxs(
    Et,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: _e,
      children: [
        /* @__PURE__ */ be.jsx(
          Tt,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: _e
          }
        ),
        /* @__PURE__ */ be.jsxs(Dt, { className: dm.modalBody, children: [
          !G && B && /* @__PURE__ */ be.jsx(Tn, { error: B }),
          !E && ee && /* @__PURE__ */ be.jsx(Tn, { error: ee }),
          y ? /* @__PURE__ */ be.jsx(
            hA,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: F,
              setIssueLinkCopied: z,
              copyToClipboard: Z
            }
          ) : /* @__PURE__ */ be.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: d(ve),
              children: /* @__PURE__ */ be.jsxs(mt, { children: [
                /* @__PURE__ */ be.jsx(pe, { children: /* @__PURE__ */ be.jsx(rn, { label: "Repository", required: !0, children: /* @__PURE__ */ be.jsx(
                  zt,
                  {
                    control: p,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Te, value: J } }) => /* @__PURE__ */ be.jsx(
                      Or,
                      {
                        className: dm.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: G,
                        onSearch: Se,
                        onSelect: (Ke) => fe(Ke, Te),
                        onClear: ye,
                        selectedItems: [J],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: B ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: Ke, onSelect: an, checked: we }) => /* @__PURE__ */ be.jsx(
                          bC,
                          {
                            item: Ke,
                            checked: we,
                            onSelectItem: an
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ be.jsx(pe, { className: dm.modalBodyFormFields, children: /* @__PURE__ */ be.jsx(
                  fA,
                  {
                    control: p,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: bA
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ be.jsx(
          Ht,
          {
            confirmOnClick: y ? _e : d(ve),
            confirmProps: {
              isLoading: E,
              loadingIndicator: /* @__PURE__ */ be.jsx(vn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : _e
          }
        )
      ]
    }
  );
}, xA = "_wrapper_19v8w_1", SA = "_inputWrapper_19v8w_6", NA = "_buttonLink_19v8w_19", jA = "_noItemsFound_19v8w_23", wA = "_createIssueButton_19v8w_28", sa = {
  wrapper: xA,
  inputWrapper: SA,
  buttonLink: NA,
  noItemsFound: jA,
  createIssueButton: wA
}, CA = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = ue(!1), { track: a } = $n(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: u,
    unlinkGithubItem: p,
    loadGithubItems: d,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: I,
    danglingPullRequestLinks: w,
    isLoadingGithubItems: j,
    issues: _,
    pullRequests: y,
    error: L
  } = EP({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), E = (Z) => u({ key: Z, type: "ISSUE" }), C = !(!!_?.length).valueOf() && !(!!y?.length).valueOf() && !(!!I?.length).valueOf() && !(!!w?.length).valueOf(), F = !v && !j && !!I?.length && !!w?.length && !!n?.showDanglingLinks, z = n?.enableCreateIssue, Q = !!_?.length || !!y?.length;
  return !j && L ? /* @__PURE__ */ be.jsx(Tn, { error: L, retry: () => d() }) : /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsxs(b, { className: sa.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ be.jsxs(b, { className: sa.inputWrapper, flexDirection: "column", children: [
        z && /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
          /* @__PURE__ */ be.jsx(
            et,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: sa.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ be.jsx("div", { className: sa.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ be.jsx(
          aA,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: _,
            linkedPullRequests: y
          }
        )
      ] }),
      j ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ be.jsx(vn, { "data-testid": "github-widget-item-spinner" }) }) : Q ? /* @__PURE__ */ be.jsx(
        KP,
        {
          items: [..._, ...y],
          unlinkGithubItem: p,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ be.jsx(P.Paragraph, { align: "center", className: sa.noItemsFound, children: "No linked items found." }),
      F && /* @__PURE__ */ be.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ be.jsx(P.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ be.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              I.map((Z) => /* @__PURE__ */ be.jsx(
                Yn,
                {
                  onDelete: () => p({
                    key: Z,
                    type: "ISSUE"
                  }),
                  children: kr(Z)
                },
                kr(Z)
              )),
              w.map((Z) => /* @__PURE__ */ be.jsx(
                Yn,
                {
                  onDelete: () => p({ key: Z, type: "PR" }),
                  children: kr(Z)
                },
                kr(Z)
              ))
            ] }),
            /* @__PURE__ */ be.jsx(
              et,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Q && /* @__PURE__ */ be.jsx(
        et,
        {
          variant: "secondary",
          disabled: C,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ be.jsx(
        Bt,
        {
          slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: sa.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ be.jsx(
      _A,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: E,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, Yh = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], $i = "GITHUB", FA = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, IA = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = St({
    mode: "onChange",
    defaultValues: FA
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: I
  } = si({
    integrationId: e,
    integrationType: $i,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: w,
    error: j,
    isWidgetUnknown: _,
    refetch: y,
    widgetConfiguration: L
  } = li({
    integrationId: e,
    fieldDefinitions: Yh,
    form: l,
    onMisconfigured: I
  }), { renderConditions: E, setRenderConditions: C, renderConditionsForSubmit: F } = ci({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), z = (Z) => di(Z, {
    fieldDefinitions: Yh,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: F
  }), Q = l.watch("name");
  return /* @__PURE__ */ be.jsxs(
    ui,
    {
      form: l,
      integrationId: e,
      onValidSubmit: z,
      error: j ?? h,
      onRetry: j ? y : void 0,
      isLoading: f || w,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ be.jsx(mi, { cause: v }),
        /* @__PURE__ */ be.jsxs(mt, { children: [
          /* @__PURE__ */ be.jsx(pe, { children: /* @__PURE__ */ be.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ be.jsx(
            An,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(pe, { span: 3, children: /* @__PURE__ */ be.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(pe, { span: 3 }),
          /* @__PURE__ */ be.jsx(pe, { span: 3, children: /* @__PURE__ */ be.jsx(
            tt,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(pe, { span: 3 }),
          /* @__PURE__ */ be.jsx(pe, { span: 3, children: /* @__PURE__ */ be.jsx(rn, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ be.jsx(
            An,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(pe, { span: 3 }),
          /* @__PURE__ */ be.jsx(pe, { span: 3, children: /* @__PURE__ */ be.jsx(rn, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ be.jsx(
            An,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(pe, { span: 3 }),
          /* @__PURE__ */ be.jsx(pe, { span: 3, children: /* @__PURE__ */ be.jsx(rn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ be.jsx(
            An,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(pe, { span: 3 }),
          !s && e && /* @__PURE__ */ be.jsx(
            Da,
            {
              configuration: n,
              integrationId: e,
              integrationType: $i,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ be.jsx(pe, { children: o({
            value: E,
            onChange: C,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          pi,
          {
            integrationType: $i,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ be.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ be.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ be.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  $i,
                  " integration, all links between Dixa and ",
                  $i,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ be.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  $i,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ be.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  $i,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var mm = { exports: {} }, io = {}, lx;
function $A() {
  if (lx) return io;
  lx = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return io.Fragment = r, io.jsx = s, io.jsxs = s, io;
}
var Ns = {}, cx;
function EA() {
  return cx || (cx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Ns.Fragment = i, Ns.jsx = Un, Ns.jsxs = Kn;
  })()), Ns;
}
var ux;
function TA() {
  return ux || (ux = 1, process.env.NODE_ENV === "production" ? mm.exports = $A() : mm.exports = EA()), mm.exports;
}
var je = TA(), Do = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Do || {}), Ai = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Ai || {}), or = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(or || {});
const DA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, OA = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": DA
};
function RA(e) {
  return OA[e] ?? {};
}
const PA = RA(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), dx = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, _C = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, AA = "_listItem_16pij_4", LA = "_clickableIcon_16pij_15", Jo = {
  listItem: AA,
  clickableIcon: LA
}, xC = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = ue(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ je.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ je.jsx(he, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Jo.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ je.jsx(
              he,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ je.jsx(Qe, { children: e.map((l, u) => {
      if (!l) return null;
      const { name: p, quantity: d, price: f, image: h, sku: v } = l, I = l.currency ?? r;
      return /* @__PURE__ */ je.jsx(
        Qe.Item,
        {
          contentLeft: /* @__PURE__ */ je.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { children: d }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ je.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: p }),
            f != null && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: _C(f / 100, I) })
          ] }),
          contentRight: h && /* @__PURE__ */ je.jsx(Ra, { src: h, alt: p ?? "Product image" }),
          className: Jo.listItem
        },
        `item-${u}-${v}`
      );
    }) })
  ] }) });
}, VA = "_boxWrapper_89s7l_1", zA = "_trackButton_89s7l_10", mx = {
  boxWrapper: VA,
  trackButton: zA
}, UA = {
  [or.StepUnknown]: "Unknown",
  [or.StepConfirmedByMerchant]: "Confirmed by merchant",
  [or.StepPreparedByMerchant]: "Prepared by merchant",
  [or.StepSubmittedToCarrier]: "Submitted to carrier",
  [or.StepLinehaulToCarrier]: "Linehaul to carrier",
  [or.StepOnRoute]: "On route",
  [or.StepDeliveredToPickupPoint]: "At pickup point",
  [or.StepDeliveredToConsumer]: "Delivered to customer",
  [or.StepDeliveredToMerchant]: "Returned to merchant",
  [or.StepReturnRequested]: "Return requested",
  [or.StepSentBack]: "Sent back",
  [or.StepTerminated]: "Terminated",
  [or.StepAwaitingSupplier]: "Awaiting supplier"
}, MA = {
  [Ai.Delivery]: "Home delivery",
  [Ai.Pickup]: "Pickup point",
  [Ai.Instore]: "In-store pickup",
  [Ai.Mailbox]: "Mailbox",
  [Ai.Inwarehouse]: "Warehouse",
  [Ai.Unknown]: "Unknown"
}, BA = {
  [Do.Outbound]: "From merchant to customer",
  [Do.Return]: "Return from customer to merchant",
  [Do.Unspecified]: "Unspecified",
  [Do.UnknownDirectionType]: "Unknown"
}, qA = (e) => e ? UA[e] ?? e : "", HA = (e) => e ? MA[e] ?? e : "", WA = (e) => e ? BA[e] ?? e : "", KA = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, GA = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = ir();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: u,
    display_carrier_name: p,
    delivery_type: d,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = p || l || i, I = a?.filter((E) => E?.time !== ""), w = qA(I?.[0]?.step), j = HA(d), _ = WA(f), y = KA(e.location?.address), L = 14;
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: mx.boxWrapper,
      children: [
        /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(
              he,
              {
                size: L,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Je, { content: "Copy tracking ID", children: /* @__PURE__ */ je.jsx(
            he,
            {
              size: L,
              name: n ? "done" : "copy",
              className: Jo.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        w && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        _ && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: _ })
          ] })
        ] }),
        h && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ je.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
              dx(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: dx(h.end) })
          ] })
        ] }),
        d && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "info", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        y && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(he, { size: L, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ je.jsx(xC, { title: "Parcel items", items: s }),
        u && /* @__PURE__ */ je.jsxs(
          Bt,
          {
            variant: "secondary",
            className: mx.trackButton,
            navigate: () => window.open(u, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ je.jsx(he, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, YA = "_order_135ze_1", QA = "_orderIsOpen_135ze_9", JA = "_orderHeader_135ze_12", pm = {
  order: YA,
  orderIsOpen: QA,
  orderHeader: JA
}, px = "No order number found", XA = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n), { isCopied: a, copy: o } = ir(), { isCopied: s, copy: l } = ir();
  if (!e)
    return null;
  const { cart: u, parcels: p, sender_name: d, tos_id: f } = e, h = e.external_id?.trim(), v = u?.currency || "", I = u?.prices?.total?.price ?? 0, w = _C(I / 100, v), j = 14, _ = d && d.trim() !== "" ? d : "unknown sender";
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      className: dt(pm.order, {
        [pm.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ je.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: pm.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsxs(P.Paragraph, { variant: "4", children: [
                  "From ",
                  _
                ] }),
                h ? /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: /* @__PURE__ */ je.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: px })
              ] }),
              /* @__PURE__ */ je.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ je.jsx(he, { size: j, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ je.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: px }) })
              ] })
            ] }),
            h && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Je, { content: "Copy order number", children: /* @__PURE__ */ je.jsx(
              he,
              {
                size: j,
                name: s ? "done" : "copy",
                className: Jo.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ je.jsx(
                he,
                {
                  size: j,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Je, { content: "Copy tracking ID", children: /* @__PURE__ */ je.jsx(
              he,
              {
                size: j,
                name: a ? "done" : "copy",
                className: Jo.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          d && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(he, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: d })
            ] })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(he, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: w })
            ] })
          ] }),
          /* @__PURE__ */ je.jsx(
            xC,
            {
              openByDefault: !0,
              title: "Order items",
              items: u?.items?.map((y) => y),
              currency: u?.currency
            }
          ),
          p && /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-4", children: "Parcels" }),
              p.length > 0 && /* @__PURE__ */ je.jsx(Bn, { variant: "success", size: "small", children: p.length })
            ] }),
            p.length === 0 && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            p.map((y, L) => /* @__PURE__ */ je.jsx(
              GA,
              {
                parcel: y
              },
              `parcel-${L}-${y?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, ZA = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, fx = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, e2 = (e) => [...e].sort(
  (n, r) => fx(r) - fx(n)
), n2 = ({
  customerEmail: e
}) => {
  const { useQuery: n } = _n(), [r, i] = ue([]), a = !e, { data: o, loading: s, error: l } = n(PA, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), u = !s && r.length > 0, p = l ? UI({
    error: l.graphQLErrors?.[0]
  }) : !1, d = l ? qw({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Xe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      e2(
        ZA(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ je.jsx(vn, {}) }) : p || !u && !l ? /* @__PURE__ */ je.jsx(P.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : d ? /* @__PURE__ */ je.jsx(P.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ je.jsx(Tn, { error: l }) : /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ je.jsx(Bn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ je.jsx(
      XA,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, t2 = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ je.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ je.jsx(n2, { customerEmail: n })
    }
  );
}, Qh = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], r2 = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, i2 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = St({
    mode: "onChange",
    defaultValues: r2
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = si({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = li({
    integrationId: e,
    fieldDefinitions: Qh,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: C } = ci({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => di(Q, {
    fieldDefinitions: Qh,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ je.jsxs(
    ui,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ je.jsx(mi, { cause: h }),
        /* @__PURE__ */ je.jsxs(mt, { children: [
          /* @__PURE__ */ je.jsx(pe, { children: /* @__PURE__ */ je.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ je.jsx(
            An,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(pe, { span: 3, children: /* @__PURE__ */ je.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(pe, { span: 3 }),
          /* @__PURE__ */ je.jsx(pe, { span: 3, children: /* @__PURE__ */ je.jsx(rn, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ je.jsx(
            An,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(pe, { span: 3 }),
          /* @__PURE__ */ je.jsx(pe, { span: 3, children: /* @__PURE__ */ je.jsx(
            tt,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(pe, { span: 3 }),
          /* @__PURE__ */ je.jsx(pe, { span: 3, children: /* @__PURE__ */ je.jsx(
            Zo,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(pe, { span: 3 }),
          a && L !== null && /* @__PURE__ */ je.jsx(pe, { children: a({
            value: L,
            onChange: E,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          pi,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fm = { exports: {} }, ao = {}, hx;
function a2() {
  if (hx) return ao;
  hx = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ao.Fragment = r, ao.jsx = s, ao.jsxs = s, ao;
}
var js = {}, yx;
function o2() {
  return yx || (yx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    js.Fragment = i, js.jsx = Un, js.jsxs = Kn;
  })()), js;
}
var gx;
function s2() {
  return gx || (gx = 1, process.env.NODE_ENV === "production" ? fm.exports = a2() : fm.exports = o2()), fm.exports;
}
var de = s2();
const vg = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => vg(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, l2 = "_jiraCode_h30p6_1", c2 = "_jiraCodeInline_h30p6_8", hm = {
  jiraCode: l2,
  jiraCodeInline: c2
}, SC = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ de.jsx(de.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ de.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ de.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ de.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ de.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ de.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ de.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ de.jsx("pre", { children: /* @__PURE__ */ de.jsx("code", { className: hm.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ de.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ de.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ de.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ de.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ de.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ de.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ de.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ de.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ de.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ de.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ de.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ de.jsx("code", { className: dt(hm.jiraCode, hm.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, wl = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = ue(!1);
  return !e || i ? /* @__PURE__ */ de.jsx(he, { size: r, name: "question", className: n }) : /* @__PURE__ */ de.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, u2 = "_collapse_m2gjh_1", d2 = "_collapseHeader_m2gjh_10", m2 = "_collapseHeaderLink_m2gjh_31", p2 = "_collapseHeaderStatus_m2gjh_40", f2 = "_collapseHeaderTitle_m2gjh_51", h2 = "_collapseContent_m2gjh_59", y2 = "_collapseContentHeadline_m2gjh_62", g2 = "_collapseContentButtonSpacer_m2gjh_68", v2 = "_collapseContentButtonLink_m2gjh_71", k2 = "_collapseContentStatusTag_m2gjh_74", b2 = "_collapseContentDescription_m2gjh_77", jr = {
  collapse: u2,
  collapseHeader: d2,
  collapseHeaderLink: m2,
  collapseHeaderStatus: p2,
  collapseHeaderTitle: f2,
  collapseContent: h2,
  collapseContentHeadline: y2,
  collapseContentButtonSpacer: g2,
  collapseContentButtonLink: v2,
  collapseContentStatusTag: k2,
  collapseContentDescription: b2
}, NC = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, _2 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (u, p) => p?.id ? { ...u, [p.id]: !1 } : u,
    {}
  ), [a, o] = ue(i), { track: s } = $n(), l = (u, p) => {
    o({ ...a, [u]: p });
  };
  return /* @__PURE__ */ de.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const { summary: p, description: d, status: f, issuetype: h } = u?.fields || {}, v = NC({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), I = !!(u?.id && a[u.id]);
    return /* @__PURE__ */ de.jsxs(
      xr,
      {
        onToggle: () => u?.id && l(u.id, !a[u.id]),
        isOpen: I,
        className: jr.collapse,
        children: [
          /* @__PURE__ */ de.jsx(xr.Header, { className: jr.collapseHeader, children: /* @__PURE__ */ de.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ de.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ de.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ de.jsx(wl, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ de.jsx(
                      "a",
                      {
                        className: jr.collapseHeaderLink,
                        href: `${n}/browse/${u?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (w) => {
                          w.stopPropagation(), u?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: u.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ de.jsxs(b, { alignItems: "center", gap: "200", children: [
                          u?.key,
                          /* @__PURE__ */ de.jsx(he, { name: "external-link", size: 16 })
                        ] })
                      },
                      u?.key
                    )
                  ] }),
                  /* @__PURE__ */ de.jsx("span", { className: jr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ de.jsx(Yn, { className: jr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ de.jsx("div", { className: jr.collapseHeaderTitle, children: p })
              ]
            }
          ) }),
          /* @__PURE__ */ de.jsx(xr.Content, { className: jr.collapseContent, children: /* @__PURE__ */ de.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ de.jsx("div", { className: jr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ de.jsx(ct, { className: jr.collapseContentDescription, children: d ? vg(d, SC) : "" }),
            /* @__PURE__ */ de.jsx(
              et,
              {
                icon: "link-slash",
                variant: "secondary",
                className: jr.collapseContentButtonSpacer,
                onClick: () => u?.key && r(u.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ de.jsx(
              Bt,
              {
                slotEnd: /* @__PURE__ */ de.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: jr.collapseContentButtonLink,
                navigate: () => {
                  u?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: u.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${u.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      u?.id
    );
  }) : /* @__PURE__ */ de.jsx(de.Fragment, {}) });
}, x2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, S2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, N2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, j2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, w2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, C2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, F2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, I2 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': x2,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": S2,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": N2,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": j2,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': w2,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': C2,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": F2
};
function ea(e) {
  return I2[e] ?? {};
}
const jC = ea(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), $2 = ea(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), E2 = ea(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), T2 = ea(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), D2 = ea(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), O2 = ea(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), R2 = ea(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), kg = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), P2 = new RegExp(`^${kg.source}$`), A2 = new RegExp(`/${kg.source}$`), vx = new RegExp(
  `.+?[&?]selectedIssue=(${kg.source})[&?]?.*`
);
function wC(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = ue([]), [o, s] = ue([]), [l, u] = ue(), { track: p } = $n(), { showNotification: d, showModal: f, useLazyQuery: h, useMutation: v } = _n(), {
    loading: I,
    data: w,
    error: j,
    store: _
  } = $y(e ?? null), [
    y,
    { loading: L, error: E, data: C }
  ] = h(jC, {
    notifyOnNetworkStatusChange: !0
  });
  Xe(() => {
    const ye = C?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ye?.length && (s(ye), a(ye.map((ve) => ve?.key).filter(Boolean)));
  }, [C]), Xe(
    () => u(j || E || void 0),
    [j, E]
  ), Xe(
    () => {
      I || B();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [w?.jira?.issues, I]
  );
  const F = async (ye, ve) => {
    await _(ye).then(() => {
      d({
        icon: "check-circle-filled",
        severity: "success",
        title: ve.success.title,
        text: ve.success.text
      });
    }).catch((K) => {
      d({
        title: ve.error.title,
        text: `${ve.error.text} ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [z] = v($2, {
    onError: (ye) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ye.message && " (" + ye.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Q = (ye, ve) => {
    const K = window.location.href, _e = ve ? K.replace(
      e?.toString() ?? "",
      ve?.toString()
    ) : K, Te = ve ? `# ${ve}` : `# ${e}`;
    z({
      variables: {
        issueKey: ye,
        title: Te,
        url: _e,
        globalId: `system=${_e}`
      }
    });
  }, [Z] = v(E2, {
    onError: (ye) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ye.message && " (" + ye.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), te = (ye) => {
    const ve = window.location.href;
    Z({
      variables: {
        issueKey: ye,
        globalId: `system=${ve}`
      }
    });
  }, G = (ye) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ye
  }), B = () => {
    w && w.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${w?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, R = async (ye, ve) => {
    p("jira:issue:link:clicked", G(ye));
    const K = w?.jira?.issues ? w : r;
    K.jira.issues = Array.from(
      new Set(K.jira.issues).add(ye)
    ), await _(K, ve?.toString()).then(() => Q(ye, ve)).catch((_e) => {
      d({
        title: "Linking failed",
        text: `Linking ${ye} failed. Please try again. ${_e.message && " (" + _e.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, U = (ye) => {
    p("jira:issue:link:clicked", G(ye));
    const ve = w?.jira?.issues ? w : r;
    ve.jira.issues = Array.from(
      new Set(ve.jira.issues).add(ye)
    ), F(ve, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ye} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ye} failed. Please try again.`
      }
    }).then(() => Q(ye));
  }, ee = (ye) => {
    p("jira:issue:unlink:clicked", G(ye)), f({
      headline: `Unlink issue ${ye}?`,
      text: `You are about to unlink the issue ${ye}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        p("jira:issue:unlink:confirmed", G(ye));
        const ve = {
          ...w,
          jira: {
            ...w?.jira,
            issues: w?.jira?.issues.filter((K) => K !== ye) || []
          }
        };
        F(ve, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ye}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ye} failed.`
          }
        }).then(() => te(ye));
      },
      onCancel: () => p("jira:issue:unlink:cancelled", G(ye))
    });
  }, Se = () => {
    p("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        p("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ye) => ye?.key && te(ye.key)), F(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => p("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, fe = w?.jira?.issues?.filter(
    (ye) => !i?.includes(ye)
  ) || [];
  return {
    linkIssue: U,
    linkIssueQuietly: R,
    unlinkIssue: ee,
    loadIssues: B,
    removeDanglingIssueLinks: () => {
      p("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ye = {
        ...w,
        jira: {
          ...w?.jira,
          issues: w?.jira?.issues.filter(
            (ve) => !fe.includes(ve)
          ) || []
        }
      };
      _(ye);
    },
    unlinkAllIssues: Se,
    maybeExtractIssueKey: (ye) => {
      const ve = ye.replace(/\s/g, "");
      if (P2.test(ve))
        return ve;
      if (vx.test(ye))
        return ye.match(vx)?.[1];
      if (ye.startsWith(n) && A2.test(ye))
        return ye.substring(ye.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: I,
    danglingIssueLinks: fe,
    isLoadingIssues: L,
    issues: o,
    error: l
  };
}
function L2(e = !1, n) {
  const [r, i] = ue(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const V2 = "_result_axxxc_48", z2 = "_resultName_axxxc_68", U2 = "_resultNameIcon_axxxc_76", M2 = "_resultDescription_axxxc_81", B2 = "_resultLinkIcon_axxxc_93", q2 = "_tooltip_axxxc_102", H2 = "_tooltipContent_axxxc_108", W2 = "_tooltipName_axxxc_115", K2 = "_tooltipNameIcon_axxxc_120", G2 = "_tooltipDescription_axxxc_125", Y2 = "_tooltipSummary_axxxc_133", Q2 = "_tooltipTag_axxxc_137", vr = {
  result: V2,
  resultName: z2,
  resultNameIcon: U2,
  resultDescription: M2,
  resultLinkIcon: B2,
  tooltip: q2,
  tooltipContent: H2,
  tooltipName: W2,
  tooltipNameIcon: K2,
  tooltipDescription: G2,
  tooltipSummary: Y2,
  tooltipTag: Q2
}, J2 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: u, description: p } = e, [d, f] = ue(!1), h = NC({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ de.jsx(
    Je,
    {
      disabled: i,
      className: vr.tooltip,
      content: /* @__PURE__ */ de.jsxs("div", { className: vr.tooltipContent, children: [
        /* @__PURE__ */ de.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ de.jsxs("span", { className: vr.tooltipName, children: [
                /* @__PURE__ */ de.jsx(
                  wl,
                  {
                    width: 16,
                    iconUrl: h,
                    className: vr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ de.jsx(Yn, { className: vr.tooltipTag, children: l.name })
            ]
          }
        ),
        p && /* @__PURE__ */ de.jsx("div", { className: vr.tooltipSummary, children: p }),
        u && /* @__PURE__ */ de.jsx("div", { className: vr.tooltipDescription, children: u })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ de.jsxs(
        "button",
        {
          ...a,
          className: vr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ de.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: d ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ de.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ de.jsxs("span", { className: vr.resultName, children: [
                    /* @__PURE__ */ de.jsx(
                      wl,
                      {
                        width: 16,
                        iconUrl: h,
                        className: vr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  p && /* @__PURE__ */ de.jsx("div", { className: vr.resultDescription, children: p })
                ]
              }
            ),
            d && /* @__PURE__ */ de.jsx(
              he,
              {
                className: vr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, X2 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ de.jsx(
  Bt,
  {
    slotEnd: /* @__PURE__ */ de.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), Z2 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = _n(), [o, s] = ue([]), [l, u] = ue(""), [p, { loading: d, error: f, data: h, networkStatus: v }] = a(jC, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: I } = wC(null, n);
  Ji(
    () => {
      !d && l && v === dr.ready ? p({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Xe(() => {
    const E = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      E.map((C) => ({
        id: C?.key ?? "",
        name: C?.key ?? "",
        description: C?.fields.summary,
        status: C?.fields.status,
        issuetype: C?.fields.issuetype,
        text: C?.fields.description ? vg(C?.fields.description, SC) : /* @__PURE__ */ de.jsx(de.Fragment, {})
      }))
    );
  }, [h]);
  const w = (E) => {
    e(E.id), u("");
  }, j = (E) => {
    const C = E.trim(), F = I(C);
    if (F) {
      const z = F.replaceAll("[-_|]", "\\\\$0");
      u(`key = '${z}'`);
    } else C !== "" && u(
      `text ~ '${C}'${r ? " and project = " + r : ""}`
    );
  }, _ = () => {
    u("");
  }, y = (E) => /* @__PURE__ */ de.jsx(X2, { ...E, jiraInstanceUrl: n }), L = (E) => /* @__PURE__ */ de.jsx(
    J2,
    {
      ...E,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !d && f ? /* @__PURE__ */ de.jsx(Tn, { error: f }) : /* @__PURE__ */ de.jsx(
    Or,
    {
      items: o,
      loading: d,
      onSearch: j,
      onSelect: w,
      onClear: _,
      emptyMessage: l ? d ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: L,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, eL = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = ue(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: u }) => u !== s.id)
    );
  };
  return Xe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ de.jsx(
    Or,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: u }) => ({
          id: s,
          name: l || u
        })
      )
    }
  );
}, nL = "_itemButton_1hl53_1", tL = "_result_1hl53_6", rL = "_resultIcon_1hl53_26", iL = "_resultName_1hl53_30", aL = "_resultCheckIcon_1hl53_38", oo = {
  itemButton: nL,
  result: tL,
  resultIcon: rL,
  resultName: iL,
  resultCheckIcon: aL
}, Jh = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ de.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ de.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: oo.itemButton,
          children: /* @__PURE__ */ de.jsxs(b, { className: oo.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ de.jsx(
              wl,
              {
                width: 36,
                iconUrl: o || "",
                className: oo.resultIcon
              }
            ),
            /* @__PURE__ */ de.jsx(ct, { className: oo.resultName, children: e.name }),
            n && /* @__PURE__ */ de.jsx(ct, { className: oo.resultCheckIcon, children: /* @__PURE__ */ de.jsx(he, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, oL = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = _n(), [o, s] = ue([]), [l, u] = ue(), p = 2, [d, { loading: f, error: h, data: v, networkStatus: I }] = a(R2, {
    notifyOnNetworkStatusChange: !0
  });
  return Ji(
    () => {
      !f && l && l.length >= p && I === dr.ready ? d({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Xe(() => {
    n && d({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((w) => {
      if (w?.data?.Jira.findUsers?.length === 1) {
        const j = w?.data?.Jira?.findUsers[0];
        r(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), Xe(() => {
    const w = v?.Jira?.findUsers || [];
    s(
      w.filter(({ active: j }) => j).map(({ accountId: j, displayName: _, avatarUrls: y, active: L }) => ({
        id: j,
        name: _,
        avatarUrls: y,
        active: L
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ de.jsx(Tn, { error: h }) : /* @__PURE__ */ de.jsx(
    Or,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (w) => u(w),
      onSelect: r,
      onClear: () => u(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: w, onSelect: j, checked: _ }) => /* @__PURE__ */ de.jsx(
        Jh,
        {
          item: w,
          checked: _,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, kx = ({
  field: e
}) => {
  const [n, r] = ue(!1), [i, a] = R1();
  return Xe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ de.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ de.jsx(b, { children: /* @__PURE__ */ de.jsx(he, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ de.jsx(P.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ de.jsx(Je, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ de.jsx(
      mr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, sL = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ de.jsx(kx, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ de.jsx(_r, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ de.jsx(zh, { onChange: n, value: r }) : /* @__PURE__ */ de.jsx(_r, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ de.jsx(zh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ de.jsx(_r, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ de.jsx(
        oL,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ de.jsx(
        Or,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: u, value: p }) => ({
              id: l,
              name: u || p
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ de.jsx(eL, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ de.jsx(kx, { field: e });
  }
}, lL = ["description", "reporter", "summary"], cL = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ de.jsx(de.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || lL.includes(o)
).map((o) => /* @__PURE__ */ de.jsx(
  zt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ de.jsx(
      rn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: sL({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), uL = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ de.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ de.jsxs(P.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ de.jsxs(
          P.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ de.jsx(he, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ de.jsx(rn, { label: "Jira issue link", children: /* @__PURE__ */ de.jsx(
        _r,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), dL = "_modalBody_1hk1o_1", mL = "_modalBodyFormFields_1hk1o_4", bx = {
  modalBody: dL,
  modalBodyFormFields: mL
}, pL = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), fL = (e) => e?.custom?.split(":")?.[1] || null, hL = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, yL = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = hL(a, n), l = fL(s) ?? a;
        return r.includes(l) ? i[a] = pL(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, gL = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, u] = ue([]), [p, d] = ue(), [f, h] = ue(0), [v, I] = ue([]), [w, j] = ue([]), [_, y] = ue(!1), [L, E] = ue(!1), [C, F] = ue({}), { track: z } = $n(), { isCopied: Q, copyToClipboard: Z } = L2(), te = Xn(() => i?.conversationId, [e]), { useMutation: G, useLazyQuery: B, showNotification: R } = _n(), {
    control: U,
    handleSubmit: ee,
    formState: { errors: Se },
    reset: fe,
    setValue: ye,
    getValues: ve
  } = St({
    defaultValues: s
  }), K = w.length > 0, _e = `${a}/browse`, Te = Object.keys(C).length > 0, [J, { loading: Ke, error: an }] = B(T2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (se) => {
      u(se.Jira.getAllProjects);
    },
    onError: (se) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", se), u([]);
    }
  }), [
    we,
    { loading: Me, error: Re }
  ] = B(D2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (se) => {
      h(0);
      const xe = se?.Jira?.getCreateIssueMeta?.projects[0];
      if (xe) {
        const Le = xe?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        I(Le || []), ye(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), I([]), j([]);
    },
    onError: (se) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", se), I([]), j([]), h(0);
    }
  }), [Be, { error: Ae }] = G(
    O2,
    {
      onError: () => {
        y(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), z("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (se) => {
        if (y(!1), se?.Jira && "key" in se.Jira.createIssue)
          d(se?.Jira?.createIssue), R({
            title: "Success",
            text: `Jira issue '${se.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), z("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: se.Jira.createIssue.key
          }), te && r(
            se.Jira.createIssue.key,
            te
          );
        else if ("errorMessages" in se.Jira.createIssue || "errors" in se.Jira.createIssue) {
          const xe = se?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", xe), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Ge = (se) => {
    y(!0), F({}), Be({
      variables: {
        input: yL(se, w)
      }
    });
  };
  Xe(() => {
    if (e)
      try {
        J();
      } catch (se) {
        console.warn("Error when fetching initial projects", se);
      }
  }, [e]), Xe(() => {
    const se = L ? window.setTimeout(() => E(!1), 2e3) : void 0;
    return () => window.clearTimeout(se);
  }, [L]), Xe(() => {
    if (v?.length > 0) {
      ye("issuetype", v[f]);
      const se = v[f]?.fields?.additionalProperties;
      if (se?.length > 0) {
        const xe = se.map(
          ({ value: T }) => T
        ), Le = (o ? xe.sort(({ name: T }, { name: x }) => T.localeCompare(x)) : xe).sort(
          ({ required: T }, { required: x }) => Number(x) - Number(T)
        ), { project: Pe, issuetype: yn } = ve();
        fe({ project: Pe, issuetype: yn }), j(Le);
      }
    } else
      j([]), ye("issuetype", void 0);
  }, [v, ye, f]), Xe(() => {
    if (Ae && Zw(Ae)) {
      if (Ae?.graphQLErrors?.length > 0) {
        const { graphQLErrors: se } = Ae, xe = se[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(xe);
          if (Le?.errors) {
            const Pe = Object.keys(Le.errors).reduce(
              (yn, T) => ({
                ...yn,
                [T]: {
                  type: "required",
                  message: Le.errors[T],
                  ref: {
                    name: T
                  }
                }
              }),
              {}
            );
            F(Pe);
          }
        } catch {
        }
      }
    } else
      F({});
  }, [Ae]);
  const Ce = () => {
    u([]), j([]), I([]), d(void 0), h(0), y(!1), F({});
  }, qe = () => {
    Ce(), fe(s), n();
  }, en = (se) => {
    se && we({
      variables: {
        projectKey: se
      }
    });
  }, ie = (se) => {
    const xe = v.map((Le) => Le.id).indexOf(se);
    h(xe ?? 0);
  };
  return /* @__PURE__ */ de.jsxs(
    Et,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: qe,
      children: [
        /* @__PURE__ */ de.jsx(
          Tt,
          {
            title: p ? "Issue creation successful" : "Create new Jira issue",
            onClose: qe
          }
        ),
        /* @__PURE__ */ de.jsxs(Dt, { className: bx.modalBody, children: [
          !Ke && an && /* @__PURE__ */ de.jsx(Tn, { error: an, retry: J }),
          !Me && Re && /* @__PURE__ */ de.jsx(
            Tn,
            {
              error: Re,
              retry: we
            }
          ),
          !_ && Te && /* @__PURE__ */ de.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ de.jsx(
            Bl,
            {
              variant: "warning",
              description: /* @__PURE__ */ de.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ de.jsx(P.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ de.jsx(
                      et,
                      {
                        icon: Q ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Z(JSON.stringify(w, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          p ? /* @__PURE__ */ de.jsx(
            uL,
            {
              createdIssue: p,
              issueBaseLink: _e,
              issueLinkCopied: L,
              setIssueLinkCopied: E,
              copyToClipboard: Z
            }
          ) : /* @__PURE__ */ de.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(Ge),
              children: /* @__PURE__ */ de.jsxs(mt, { children: [
                /* @__PURE__ */ de.jsx(pe, { span: 3, children: /* @__PURE__ */ de.jsx(rn, { label: "Project", required: !0, children: /* @__PURE__ */ de.jsx(
                  zt,
                  {
                    control: U,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: se, value: xe } }) => /* @__PURE__ */ de.jsx(
                      Or,
                      {
                        searchable: !0,
                        loading: Ke,
                        onSelect: (Le) => {
                          en(Le.key), se(Le);
                        },
                        selectedItems: [xe],
                        placeholder: "Select Jira project",
                        emptyMessage: an ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Pe, checked: yn }) => /* @__PURE__ */ de.jsx(
                          Jh,
                          {
                            item: Le,
                            checked: yn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ de.jsx(pe, { span: 3, children: /* @__PURE__ */ de.jsx(rn, { label: "Issue type", required: !0, children: /* @__PURE__ */ de.jsx(
                  zt,
                  {
                    control: U,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: se, value: xe } }) => /* @__PURE__ */ de.jsx(
                      Or,
                      {
                        disabled: v.length === 0,
                        loading: Me,
                        onSelect: (Le) => {
                          ie(Le.id), se(Le);
                        },
                        selectedItems: [xe],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Re ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Le, onSelect: Pe, checked: yn }) => /* @__PURE__ */ de.jsx(
                          Jh,
                          {
                            item: Le,
                            checked: yn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                K && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ de.jsx(pe, { className: bx.modalBodyFormFields, children: /* @__PURE__ */ de.jsx(
                  cL,
                  {
                    control: U,
                    errors: { ...Se, ...C },
                    getValues: ve,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: w
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ de.jsx(
          Ht,
          {
            confirmOnClick: p ? qe : ee(Ge),
            confirmProps: {
              disabled: !K,
              isLoading: _,
              loadingIndicator: /* @__PURE__ */ de.jsx(vn, { size: 16 })
            },
            confirmName: p ? "Close" : "Save",
            cancelOnClick: p ? void 0 : qe
          }
        )
      ]
    }
  );
}, vL = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, kL = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, bL = "_wrapper_1bylq_1", _L = "_inputWrapper_1bylq_6", xL = "_inputSeparator_1bylq_18", SL = "_buttonLink_1bylq_23", NL = "_noIssuesFound_1bylq_27", so = {
  wrapper: bL,
  inputWrapper: _L,
  inputSeparator: xL,
  buttonLink: SL,
  noIssuesFound: NL
}, jL = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = $n(), i = vL(n?.jiraSiteUrl), [a, o] = ue(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: u,
    unlinkIssue: p,
    unlinkAllIssues: d,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: I,
    isLoadingIssues: w,
    issues: j,
    error: _
  } = wC(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, L = !!n?.enableSortIssueTypeByLabel, E = !!(j?.length || v?.length), C = !!n?.enableRemoveAllLinks && E, F = !I && !w && v?.length > 0 && !!n?.showDanglingLinks;
  return !w && _ ? /* @__PURE__ */ de.jsx(Tn, { error: _, retry: () => f() }) : /* @__PURE__ */ de.jsxs(de.Fragment, { children: [
    /* @__PURE__ */ de.jsxs(b, { className: so.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ de.jsxs(b, { className: so.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ de.jsxs(de.Fragment, { children: [
          /* @__PURE__ */ de.jsx(
            et,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ de.jsx("div", { className: so.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ de.jsx(
          Z2,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      w ? /* @__PURE__ */ de.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ de.jsx(vn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ de.jsx(
        _2,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: p
        }
      ) : /* @__PURE__ */ de.jsx(P.Paragraph, { align: "center", className: so.noIssuesFound, children: "No linked issues found" }),
      C && j?.length > 0 && /* @__PURE__ */ de.jsx(
        et,
        {
          variant: "secondary",
          disabled: !j?.length && !v?.length,
          onClick: d,
          children: "Unlink all issues"
        }
      ),
      F && /* @__PURE__ */ de.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ de.jsx(P.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ de.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((z) => /* @__PURE__ */ de.jsx(Yn, { onDelete: () => p(z), children: z }, z)) }),
            /* @__PURE__ */ de.jsx(
              et,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ de.jsx(
        Bt,
        {
          slotEnd: /* @__PURE__ */ de.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: so.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ de.jsx(
      gL,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: u,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: L
      }
    )
  ] });
}, Xh = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], wL = (e) => {
  const n = kL(e);
  return typeof n == "string" ? n : !0;
}, Ei = "JIRA", CL = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, FL = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = St({
    mode: "onChange",
    defaultValues: CL
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: I
  } = si({
    integrationId: e,
    integrationType: Ei,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: w,
    error: j,
    isWidgetUnknown: _,
    refetch: y,
    widgetConfiguration: L
  } = li({
    integrationId: e,
    fieldDefinitions: Xh,
    form: l,
    onMisconfigured: I
  }), { renderConditions: E, setRenderConditions: C, renderConditionsForSubmit: F } = ci({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), z = (Z) => di(Z, {
    fieldDefinitions: Xh,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: F
  }), Q = l.watch("name");
  return /* @__PURE__ */ de.jsxs(
    ui,
    {
      form: l,
      integrationId: e,
      onValidSubmit: z,
      error: j ?? h,
      onRetry: j ? y : void 0,
      isLoading: f || w,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ de.jsx(mi, { cause: v }),
        /* @__PURE__ */ de.jsxs(mt, { children: [
          /* @__PURE__ */ de.jsx(pe, { children: /* @__PURE__ */ de.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ de.jsx(
            An,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ de.jsx(pe, { span: 3, children: /* @__PURE__ */ de.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ de.jsx(pe, { span: 3 }),
          /* @__PURE__ */ de.jsx(pe, { span: 3, children: /* @__PURE__ */ de.jsx(
            tt,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (Z) => wL(Z)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ de.jsx(pe, { span: 3 }),
          /* @__PURE__ */ de.jsx(pe, { span: 3, children: /* @__PURE__ */ de.jsx(rn, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ de.jsx(
            An,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ de.jsx(pe, { span: 3 }),
          /* @__PURE__ */ de.jsx(pe, { span: 3, children: /* @__PURE__ */ de.jsx(rn, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ de.jsx(
            An,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ de.jsx(pe, { span: 3 }),
          /* @__PURE__ */ de.jsx(pe, { span: 3, children: /* @__PURE__ */ de.jsx(rn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ de.jsx(
            An,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ de.jsx(pe, { span: 3 }),
          /* @__PURE__ */ de.jsx(pe, { span: 3, children: /* @__PURE__ */ de.jsx(rn, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ de.jsx(
            An,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ de.jsx(pe, { span: 3 }),
          !s && e && /* @__PURE__ */ de.jsx(
            Da,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ei,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ de.jsx(pe, { children: o({
            value: E,
            onChange: C,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ de.jsx(
          pi,
          {
            integrationType: Ei,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ de.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ de.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ de.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ de.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ei,
                  " integration, all links between Dixa and ",
                  Ei,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ de.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  Ei,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ de.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ei,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ym = { exports: {} }, lo = {}, _x;
function IL() {
  if (_x) return lo;
  _x = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return lo.Fragment = r, lo.jsx = s, lo.jsxs = s, lo;
}
var ws = {}, xx;
function $L() {
  return xx || (xx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    ws.Fragment = i, ws.jsx = Un, ws.jsxs = Kn;
  })()), ws;
}
var Sx;
function EL() {
  return Sx || (Sx = 1, process.env.NODE_ENV === "production" ? ym.exports = IL() : ym.exports = $L()), ym.exports;
}
var Oe = EL();
function TL({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = _n(), [a, o] = ue([]), [s] = i(e, n), [l, u] = ue(
    []
  );
  return Xe(() => () => {
    l.forEach((p) => window.clearTimeout(p));
  }, []), [async (p) => {
    const d = [];
    for (const [f, h] of p.entries()) {
      f !== 0 && await new Promise((I) => {
        const w = setTimeout(I, r);
        u([...l, w]);
      });
      const v = await s({
        variables: h
      });
      d.push(v);
    }
    o(d);
  }, a];
}
var CC = /* @__PURE__ */ ((e) => (e.List = "list", e))(CC || {}), Zh = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(Zh || {}), ey = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(ey || {}), ny = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(ny || {});
const DL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, OL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, RL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, PL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, AL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, LL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, VL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, zL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, UL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ML = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, qL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HL = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": DL,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": OL,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": PL,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": AL,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": RL,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": LL,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": VL,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": zL,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": UL,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ML,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": BL,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": qL
};
function fi(e) {
  return HL[e] ?? {};
}
const WL = fi(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), KL = fi(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), GL = fi(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), YL = fi(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), QL = fi(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), JL = fi(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), XL = fi(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), ZL = fi(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), eV = fi(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function ty(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function Nx(e) {
  return ty(e) && e?.attributes?.event_properties?.$message;
}
function nV(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function jx(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function tV(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function rV(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function iV(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function aV(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function oV(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function sV(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function wx(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function lV(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function cV(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const uV = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function dV(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function mV(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function pV({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = _n(), { track: a } = $n(), [o, s] = ue(null), [l, u] = ue(
    null
  ), [p, d] = ue(null), [f, h] = ue(null), [v, I] = ue(
    null
  ), [w, j] = ue([]), {
    data: _,
    error: y,
    loading: L,
    networkStatus: E
  } = i(GL, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    C,
    {
      data: F,
      error: z,
      loading: Q,
      networkStatus: Z
    }
  ] = r(WL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Xe(() => {
    if (_ && !L && E === dr.ready) {
      const te = tV(_);
      s(
        te.find((G) => G?.attributes?.name === "Received Email")?.id || null
      ), u(
        te.find((G) => G?.attributes?.name === "Opened Email")?.id || null
      ), d(
        te.find((G) => G?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        te.find((G) => G?.attributes?.name === "Bounced Email")?.id || null
      ), I(
        te.find((G) => G?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), u(null), d(null), h(null), I(null);
  }, [_]), Xe(() => {
    o && l && p && f && v && !Q && Z === dr.ready ? C({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${p}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    p,
    f,
    v
  ]), Xe(() => {
    if (!Q && F) {
      const te = rV(F), G = aV(
        F
      ).map(
        (fe) => fe?.attributes?.event_properties.$message
      ), B = oV(
        F
      ).map(
        (fe) => fe?.attributes?.event_properties.$message
      );
      te.forEach((fe) => {
        const ye = fe.attributes?.event_properties.$message;
        fe.opened = G.includes(ye), fe.clicked = B.includes(ye);
      });
      const R = iV(F), U = sV(F), ee = [
        ...te,
        ...U,
        ...R
      ].sort((fe, ye) => {
        const ve = jx(fe), K = jx(ye);
        return ve == null && K == null ? 0 : ve == null ? 1 : K == null ? -1 : K - ve;
      }).slice(0, n);
      j(ee);
      const Se = ee.map((fe) => fe.id);
      a("klaviyo:messages:received", {
        emailsReceived: te.filter(
          (fe) => Se.includes(fe.id)
        ).length,
        emailsBounced: U.filter(
          (fe) => Se.includes(fe.id)
        ).length,
        smsReceived: R.filter(
          (fe) => Se.includes(fe.id)
        ).length,
        total: Se.length
      });
    } else
      j([]);
  }, [Q, F]), Xn(
    () => ({
      receivedMessages: w,
      isLoading: L || Q,
      error: y || z
    }),
    [
      w,
      L,
      Q,
      y,
      z
    ]
  );
}
function fV({ profileId: e }) {
  const { useQuery: n } = _n(), [r, i] = ue(), [a, o] = ue(), {
    data: s,
    error: l,
    loading: u,
    refetch: p
  } = n(QL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Xe(() => {
    l && o(l);
  }, [l]), Xe(() => {
    !u && s && i(s.Klaviyo.get_profile);
  }, [u, s]);
  const d = async () => {
    const f = await p();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Xn(
    () => ({
      profile: r,
      refetchProfile: d,
      isLoading: u,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, u, a]
  );
}
function hV({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = $n(), { useLazyQuery: i } = _n(), [a, o] = ue(), [s, l] = ue(), [
    u,
    { data: p, error: d, loading: f }
  ] = i(YL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Xe(() => {
    if (!f && p) {
      const v = p.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByEmail || void 0, I = p.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByPhoneNumber || void 0;
      h(v, I);
    }
  }, [f, p]);
  const h = (v, I) => {
    const w = v?.data?.length === 1 && v.data[0]?.id || void 0, j = I?.data?.length === 1 && I.data[0]?.id || void 0, _ = w || j, y = !w || !j || w === j;
    if (_ && y) {
      o(w || j), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${w}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Xn(
    () => ({
      profileId: a,
      getProfileId: u,
      isLoading: f,
      error: d || s
    }),
    [a, u, f, d, s]
  );
}
const Cx = 800, yV = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, gV = 3, vV = 1.5, kV = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = gV,
  useDelayRange: a = !1
}) => {
  const o = (z) => Math.floor(Math.random() * (z.max - z.min) + z.min), [s, l] = ue(0), [u, p] = ue(n || Cx), [d, f] = ue(r || yV), [h, v] = ue(!1), [I, w] = ue(!1), j = a || !!r, _ = j ? o(d) : n || Cx, [y, L] = ue(_);
  eO(
    async () => {
      const z = s + 1, Q = vV ** z;
      l(z), L(
        (j ? o(d) : u) * Q
      ), await e().then(() => {
        w(!0), F();
      });
    },
    h ? y : null
  ), tO(() => F());
  const E = ft(() => {
    l(0), L(_);
  }, [_]), C = ft(
    (z = {}) => {
      const { delay: Q, delayRange: Z } = z;
      w(!1), E(), Z && (f(Z), L(o(Z))), Q && (p(Q), L(Q)), v(!0);
    },
    [E]
  ), F = ft(() => {
    v(!1), E();
  }, [E]);
  return Xe(() => {
    s >= i && F();
  }, [s, i, F]), Xn(
    () => ({ isRunning: h, isSuccessful: I, start: C, stop: F }),
    [h, I, C, F]
  );
}, bV = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, _V = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function xV({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = _n(), [i, a] = ue(), [o, s] = ue(), {
    data: l,
    error: u,
    loading: p,
    refetch: d,
    networkStatus: f
  } = r(
    n === "lists" ? JL : XL,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: I
  } = kV({
    query: d,
    useDelayRange: !0
  }), w = p || h;
  return Xe(() => {
    if (u)
      if (HI({
        errors: u.graphQLErrors
      })) {
        if (!h) {
          const j = bV(u);
          v({
            ...j && {
              delayRange: _V(j)
            }
          });
        }
      } else
        s(u);
  }, [u]), Xe(() => {
    if (!p && l?.Klaviyo) {
      let j = {}, _ = {};
      n === "lists" && (j = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (_ = l?.Klaviyo?.get_segments_for_profile), (j?.data || _?.data) && (I(), a(
        (n === "lists" ? j?.data : _?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [p, l]), Xn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: w,
      error: o,
      networkStatus: f
    }),
    [i, w, o, f, v]
  );
}
const SV = "_notificationText_1polx_1", bg = {
  notificationText: SV
}, nc = ({ error: e }) => {
  const { track: n } = $n();
  let r = e;
  if (Zw(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && qw({ error: i[0] }), o = i.length === 1 && BI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Oe.jsx(Tn, { error: e });
  }
  return /* @__PURE__ */ Oe.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Oe.jsx(
    Qe.Item,
    {
      contentLeft: /* @__PURE__ */ Oe.jsx(he, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, NV = "_message_1vrar_48", jV = "_messageIsOpen_1vrar_56", wV = "_messageHeader_1vrar_59", CV = "_messageLabel_1vrar_65", FV = "_messageText_1vrar_68", Sa = {
  message: NV,
  messageIsOpen: jV,
  messageHeader: wV,
  messageLabel: CV,
  messageText: FV
}, IV = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && lV(e.flowMessage);
  return /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
    /* @__PURE__ */ Oe.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", className: Sa.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Oe.jsx(P.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Oe.jsx(vn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Oe.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Oe.jsx(b, { children: /* @__PURE__ */ Oe.jsx(
            P.Paragraph,
            {
              variant: "4",
              className: Sa.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", className: Sa.messageText, children: i })
        ]
      }
    )
  ] });
}, $V = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: /* @__PURE__ */ Oe.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Oe.jsx(b, { children: /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Oe.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, EV = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = ue(r), { attributes: o, eventType: s } = e, l = o?.datetime, u = o?.timestamp, p = "DD MMM YYYY @ HH:mm", d = Xn(
    () => () => l ? Qn(l).format(p) : u ? Qn.unix(u).format(p) : null,
    [u, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, I = f && e.clicked, w = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], _ = f ? "mail" : "sms";
  return /* @__PURE__ */ Oe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: dt(Sa.message, {
        [Sa.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Oe.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Sa.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Oe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Oe.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Oe.jsx(he, { size: 16, name: _ }),
                  " ",
                  uV(s),
                  d && /* @__PURE__ */ Oe.jsx(Bn, { size: "small", variant: "info", children: d })
                ] }),
                w && w,
                j && j
              ] }),
              /* @__PURE__ */ Oe.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Oe.jsx(Ty, {}),
          nV(e) && /* @__PURE__ */ Oe.jsx(b, { children: /* @__PURE__ */ Oe.jsx(Bn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
            /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Oe.jsx(Yn, { children: /* @__PURE__ */ Oe.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Oe.jsx(
                  he,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Oe.jsx(Yn, { children: /* @__PURE__ */ Oe.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Oe.jsx(
                  he,
                  {
                    size: 16,
                    color: I ? "green.400" : "red.400",
                    name: I ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Oe.jsx(IV, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Oe.jsx($V, { event: e })
        ] })
      ]
    }
  );
}, TV = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, DV = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = ue(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = pV({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, u] = TL({
    query: KL,
    options: TV,
    delayMs: 1e3
  }), [p, d] = ue([]);
  Xe(() => {
    if (a.length > 0) {
      d(a);
      const h = a.filter((v) => ty(v)).map((v) => Nx(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Xe(() => {
    u.length > 0 && d(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && ty(h) && !h.flowMessage) {
          const v = Nx(h), I = u.find((j) => (j.data && wx(j.data))?.id === v), w = I?.data && wx(I.data);
          if (w)
            return {
              ...cV(h),
              flowMessage: w
            };
        }
        return h;
      })
    );
  }, [u]);
  const f = [];
  return s && f.push(s), u.length > 0 && f.push(
    ...u.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ Oe.jsx(
    Tn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ Oe.jsx(
    nc,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ Oe.jsxs(Oe.Fragment, { children: [
    /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Oe.jsx(vn, {}) }) : /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: p?.length > 0 ? /* @__PURE__ */ Oe.jsx(b, { gap: "200", flexDirection: "column", children: p.map((h, v) => /* @__PURE__ */ Oe.jsx(
      EV,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Oe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: bg.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, OV = "_list_ld0hf_1", RV = "_listItem_ld0hf_4", ai = {
  list: OV,
  listItem: RV
}, PV = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ Oe.jsx(Qe, { className: ai.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: ai.listItem, children: /* @__PURE__ */ Oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", children: qI(a) }),
          /* @__PURE__ */ Oe.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Gi(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, Fx = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = ue(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: u
  } = xV({ profileId: e, query: n });
  Xe(() => {
    l === 4 && i(!0);
  }, [l]);
  const p = () => {
    a || u();
  }, d = a || [];
  return o ? /* @__PURE__ */ Oe.jsx(nc, { error: o }) : s ? /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: ai.listItem, children: /* @__PURE__ */ Oe.jsx(vn, { size: 14 }) }, "loading") : d.length > 0 ? /* @__PURE__ */ Oe.jsx(Oe.Fragment, { children: d.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: ai.listItem, children: /* @__PURE__ */ Oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Oe.jsx(Yn, { children: Hw(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: ai.listItem, children: /* @__PURE__ */ Oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Oe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Oe.jsx(he, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Oe.jsxs(P.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Oe.jsx(Je, { content: "Refresh lists and segments", children: /* @__PURE__ */ Oe.jsx(et, { icon: "sync", variant: "secondary", onClick: () => p(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: ai.listItem, children: /* @__PURE__ */ Oe.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Oe.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, AV = 0.7, LV = 0.3, VV = (e) => e >= AV ? { variant: "error", label: "High risk" } : e >= LV ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, zV = (e) => /* @__PURE__ */ Oe.jsx(P.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), UV = (e) => {
  const n = VV(e);
  return /* @__PURE__ */ Oe.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ Oe.jsx(Bn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ Oe.jsx(P.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, MV = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: zV(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Gi(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: UV(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Gi(o)
      }
    ] : []
  ];
}, BV = ({
  profile: e
}) => {
  const n = MV(e);
  return /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ Oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ Oe.jsx(Qe, { className: ai.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ Oe.jsx(Qe.Text, { variant: "dense", className: ai.listItem, children: /* @__PURE__ */ Oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ Oe.jsx(P.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, qV = "_tagHover_kzbzk_1", HV = "_channelUnsubscribed_kzbzk_6", Ix = {
  tagHover: qV,
  channelUnsubscribed: HV
}, $x = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Oe.jsx(
    Je,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Oe.jsx(
        Yn,
        {
          className: Ix.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Oe.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: dt({
                [Ix.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Oe.jsx(vn, { size: 16 }) : /* @__PURE__ */ Oe.jsx(he, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, WV = "_subscriptionError_1qhhx_1", KV = {
  subscriptionError: WV
}, GV = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = ue(!1), [u, p] = ue(!1), [d, f] = ue(), { track: h } = $n(), [v, I] = nO({
    channel: null,
    request: null
  }), w = dV(n), j = mV(n), _ = !!e, { useMutation: y } = _n(), [L] = y(
    ZL
  ), [E] = y(
    eV
  ), C = (Q) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Q }), I.setAll({
      channel: Q,
      request: "subscribed"
    }), ((Z) => L({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: Zh.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...Z === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ey.Subscribed
                        }
                      }
                    },
                    ...Z === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ey.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: CC.List,
              id: e
            }
          }
        }
      }
    }))(Q).then(
      (Z) => z({
        channel: Q,
        mutationResponse: Z,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Z) => z({
        channel: Q,
        mutationErrorResponse: Z,
        isSubscriptionRequest: !0
      })
    );
  }, F = (Q) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Q }), I.setAll({
      channel: Q,
      request: "unsubscribed"
    }), E({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: Zh.Profile,
                attributes: {
                  ...Q === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Q === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ny.Unsubscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ny.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (Z) => z({
        channel: Q,
        mutationResponse: Z,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Z) => z({
        channel: Q,
        mutationErrorResponse: Z,
        isSubscriptionRequest: !1
      })
    );
  }, z = async ({
    channel: Q,
    mutationResponse: Z,
    mutationErrorResponse: te,
    isSubscriptionRequest: G
  }) => {
    const B = te?.networkError, R = B ? B?.statusCode : NaN, U = Z?.errors, ee = !!U && Ww({
      errors: U
    });
    R === 202 ? (h(
      G ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Q }
    ), await o()) : ee ? (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${G ? "opt-in" : "opt-out"}.`
    )) : (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: B?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${G ? "opt-in" : "opt-out"}.`
    )), p(!1), l(!1);
  };
  return Xe(() => {
    if (v.request === "subscribed") {
      const Q = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Q), I.reset()), v.channel === "SMS" && !u && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Q), I.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    u
  ]), /* @__PURE__ */ Oe.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Oe.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Oe.jsx(
            $x,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: w,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                l(!0), f(void 0), w ? F("EMAIL") : C("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Oe.jsx(
            $x,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: u,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                p(!0), f(void 0), j ? F("SMS") : C("SMS");
              }
            }
          )
        ] }),
        d && /* @__PURE__ */ Oe.jsx(b, { className: KV.subscriptionError, children: d })
      ] })
    }
  );
}, YV = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: u,
  subscriptionListId: p
}) => {
  const {
    profile: d,
    error: f,
    isLoading: h,
    refetchProfile: v
  } = fV({ profileId: e });
  return f ? /* @__PURE__ */ Oe.jsx(nc, { error: f }) : h ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Oe.jsx(vn, {}) }) : !d && !h ? /* @__PURE__ */ Oe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: bg.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Oe.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Oe.jsx(P.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Oe.jsxs(Qe, { className: ai.list, children: [
        i && /* @__PURE__ */ Oe.jsx(Fx, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Oe.jsx(
          Fx,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ Oe.jsx(
      GV,
      {
        profile: d,
        profileId: e,
        subscriptionListId: p,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    d && l && /* @__PURE__ */ Oe.jsx(BV, { profile: d }),
    d && s && /* @__PURE__ */ Oe.jsx(PV, { profile: d }),
    /* @__PURE__ */ Oe.jsx(
      DV,
      {
        profileId: e,
        noOfMessagesToShow: u
      }
    )
  ] });
}, QV = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, u = n?.showPredictiveAnalytics, p = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: v,
    error: I
  } = hV({ email: r, phoneNumber: i });
  return r$(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : v ? /* @__PURE__ */ Oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Oe.jsx(vn, {}) }) : I ? /* @__PURE__ */ Oe.jsx(nc, { error: I }) : f ? /* @__PURE__ */ Oe.jsx(
    YV,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: u,
      noOfMessagesToShow: p,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ Oe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: bg.notificationText,
      children: "No profile ID found"
    }
  );
}, JV = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: MI
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], XV = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Da
  }
], ZV = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function e3(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const n3 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, t3 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, r3 = {};
function Ex(e, n) {
  return (r3.jsx ? t3 : n3).test(e);
}
const i3 = /[ \t\n\f\r]/g;
function a3(e) {
  return typeof e == "object" ? e.type === "text" ? Tx(e.value) : !1 : Tx(e);
}
function Tx(e) {
  return e.replace(i3, "") === "";
}
class ss {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
ss.prototype.property = {};
ss.prototype.normal = {};
ss.prototype.space = null;
function FC(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new ss(r, i, n);
}
function ry(e) {
  return e.toLowerCase();
}
class Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
Sr.prototype.space = null;
Sr.prototype.boolean = !1;
Sr.prototype.booleanish = !1;
Sr.prototype.overloadedBoolean = !1;
Sr.prototype.number = !1;
Sr.prototype.commaSeparated = !1;
Sr.prototype.spaceSeparated = !1;
Sr.prototype.commaOrSpaceSeparated = !1;
Sr.prototype.mustUseProperty = !1;
Sr.prototype.defined = !1;
let o3 = 0;
const Dn = na(), Nt = na(), IC = na(), Ye = na(), lt = na(), Na = na(), pr = na();
function na() {
  return 2 ** ++o3;
}
const iy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Dn,
  booleanish: Nt,
  commaOrSpaceSeparated: pr,
  commaSeparated: Na,
  number: Ye,
  overloadedBoolean: IC,
  spaceSeparated: lt
}, Symbol.toStringTag, { value: "Module" })), gm = Object.keys(iy);
class _g extends Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), Dx(this, "space", a), typeof i == "number")
      for (; ++o < gm.length; ) {
        const s = gm[o];
        Dx(this, gm[o], (i & iy[s]) === iy[s]);
      }
  }
}
_g.prototype.defined = !0;
function Dx(e, n, r) {
  r && (e[n] = r);
}
const s3 = {}.hasOwnProperty;
function Ma(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (s3.call(e.properties, i)) {
      const a = e.properties[i], o = new _g(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[ry(i)] = i, r[ry(o.attribute)] = i;
    }
  return new ss(n, r, e.space);
}
const $C = Ma({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), EC = Ma({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function TC(e, n) {
  return n in e ? e[n] : n;
}
function DC(e, n) {
  return TC(e, n.toLowerCase());
}
const OC = Ma({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: DC,
  properties: { xmlns: null, xmlnsXLink: null }
}), RC = Ma({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Nt,
    ariaAutoComplete: null,
    ariaBusy: Nt,
    ariaChecked: Nt,
    ariaColCount: Ye,
    ariaColIndex: Ye,
    ariaColSpan: Ye,
    ariaControls: lt,
    ariaCurrent: null,
    ariaDescribedBy: lt,
    ariaDetails: null,
    ariaDisabled: Nt,
    ariaDropEffect: lt,
    ariaErrorMessage: null,
    ariaExpanded: Nt,
    ariaFlowTo: lt,
    ariaGrabbed: Nt,
    ariaHasPopup: null,
    ariaHidden: Nt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: lt,
    ariaLevel: Ye,
    ariaLive: null,
    ariaModal: Nt,
    ariaMultiLine: Nt,
    ariaMultiSelectable: Nt,
    ariaOrientation: null,
    ariaOwns: lt,
    ariaPlaceholder: null,
    ariaPosInSet: Ye,
    ariaPressed: Nt,
    ariaReadOnly: Nt,
    ariaRelevant: null,
    ariaRequired: Nt,
    ariaRoleDescription: lt,
    ariaRowCount: Ye,
    ariaRowIndex: Ye,
    ariaRowSpan: Ye,
    ariaSelected: Nt,
    ariaSetSize: Ye,
    ariaSort: null,
    ariaValueMax: Ye,
    ariaValueMin: Ye,
    ariaValueNow: Ye,
    ariaValueText: null,
    role: null
  }
}), l3 = Ma({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: DC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Na,
    acceptCharset: lt,
    accessKey: lt,
    action: null,
    allow: null,
    allowFullScreen: Dn,
    allowPaymentRequest: Dn,
    allowUserMedia: Dn,
    alt: null,
    as: null,
    async: Dn,
    autoCapitalize: null,
    autoComplete: lt,
    autoFocus: Dn,
    autoPlay: Dn,
    blocking: lt,
    capture: null,
    charSet: null,
    checked: Dn,
    cite: null,
    className: lt,
    cols: Ye,
    colSpan: null,
    content: null,
    contentEditable: Nt,
    controls: Dn,
    controlsList: lt,
    coords: Ye | Na,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Dn,
    defer: Dn,
    dir: null,
    dirName: null,
    disabled: Dn,
    download: IC,
    draggable: Nt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Dn,
    formTarget: null,
    headers: lt,
    height: Ye,
    hidden: Dn,
    high: Ye,
    href: null,
    hrefLang: null,
    htmlFor: lt,
    httpEquiv: lt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Dn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Dn,
    itemId: null,
    itemProp: lt,
    itemRef: lt,
    itemScope: Dn,
    itemType: lt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Dn,
    low: Ye,
    manifest: null,
    max: null,
    maxLength: Ye,
    media: null,
    method: null,
    min: null,
    minLength: Ye,
    multiple: Dn,
    muted: Dn,
    name: null,
    nonce: null,
    noModule: Dn,
    noValidate: Dn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Dn,
    optimum: Ye,
    pattern: null,
    ping: lt,
    placeholder: null,
    playsInline: Dn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Dn,
    referrerPolicy: null,
    rel: lt,
    required: Dn,
    reversed: Dn,
    rows: Ye,
    rowSpan: Ye,
    sandbox: lt,
    scope: null,
    scoped: Dn,
    seamless: Dn,
    selected: Dn,
    shadowRootClonable: Dn,
    shadowRootDelegatesFocus: Dn,
    shadowRootMode: null,
    shape: null,
    size: Ye,
    sizes: null,
    slot: null,
    span: Ye,
    spellCheck: Nt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ye,
    step: null,
    style: null,
    tabIndex: Ye,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Dn,
    useMap: null,
    value: Nt,
    width: Ye,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: lt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ye,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ye,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Dn,
    // Lists. Use CSS to reduce space between items instead
    declare: Dn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ye,
    // `<img>` and `<object>`
    leftMargin: Ye,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ye,
    // `<body>`
    marginWidth: Ye,
    // `<body>`
    noResize: Dn,
    // `<frame>`
    noHref: Dn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Dn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Dn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ye,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Nt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ye,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ye,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Dn,
    disableRemotePlayback: Dn,
    prefix: null,
    property: null,
    results: Ye,
    security: null,
    unselectable: null
  }
}), c3 = Ma({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: TC,
  properties: {
    about: pr,
    accentHeight: Ye,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ye,
    amplitude: Ye,
    arabicForm: null,
    ascent: Ye,
    attributeName: null,
    attributeType: null,
    azimuth: Ye,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ye,
    by: null,
    calcMode: null,
    capHeight: Ye,
    className: lt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ye,
    diffuseConstant: Ye,
    direction: null,
    display: null,
    dur: null,
    divisor: Ye,
    dominantBaseline: null,
    download: Dn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ye,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ye,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ye,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Na,
    g2: Na,
    glyphName: Na,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ye,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ye,
    horizOriginX: Ye,
    horizOriginY: Ye,
    id: null,
    ideographic: Ye,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ye,
    k: Ye,
    k1: Ye,
    k2: Ye,
    k3: Ye,
    k4: Ye,
    kernelMatrix: pr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ye,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ye,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ye,
    overlineThickness: Ye,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ye,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: lt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ye,
    pointsAtY: Ye,
    pointsAtZ: Ye,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: pr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: pr,
    rev: pr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: pr,
    requiredFeatures: pr,
    requiredFonts: pr,
    requiredFormats: pr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ye,
    specularExponent: Ye,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ye,
    strikethroughThickness: Ye,
    string: null,
    stroke: null,
    strokeDashArray: pr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ye,
    strokeOpacity: Ye,
    strokeWidth: null,
    style: null,
    surfaceScale: Ye,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: pr,
    tabIndex: Ye,
    tableValues: null,
    target: null,
    targetX: Ye,
    targetY: Ye,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: pr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ye,
    underlineThickness: Ye,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ye,
    values: null,
    vAlphabetic: Ye,
    vMathematical: Ye,
    vectorEffect: null,
    vHanging: Ye,
    vIdeographic: Ye,
    version: null,
    vertAdvY: Ye,
    vertOriginX: Ye,
    vertOriginY: Ye,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ye,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), u3 = /^data[-\w.:]+$/i, Ox = /-[a-z]/g, d3 = /[A-Z]/g;
function m3(e, n) {
  const r = ry(n);
  let i = n, a = Sr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && u3.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(Ox, f3);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!Ox.test(o)) {
        let s = o.replace(d3, p3);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = _g;
  }
  return new a(i, n);
}
function p3(e) {
  return "-" + e.toLowerCase();
}
function f3(e) {
  return e.charAt(1).toUpperCase();
}
const h3 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, y3 = FC([EC, $C, OC, RC, l3], "html"), xg = FC([EC, $C, OC, RC, c3], "svg");
function g3(e) {
  return e.join(" ").trim();
}
var la = {}, vm, Rx;
function v3() {
  if (Rx) return vm;
  Rx = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, u = `
`, p = "/", d = "*", f = "", h = "comment", v = "declaration";
  vm = function(w, j) {
    if (typeof w != "string")
      throw new TypeError("First argument must be a string");
    if (!w) return [];
    j = j || {};
    var _ = 1, y = 1;
    function L(R) {
      var U = R.match(n);
      U && (_ += U.length);
      var ee = R.lastIndexOf(u);
      y = ~ee ? R.length - ee : y + R.length;
    }
    function E() {
      var R = { line: _, column: y };
      return function(U) {
        return U.position = new C(R), Q(), U;
      };
    }
    function C(R) {
      this.start = R, this.end = { line: _, column: y }, this.source = j.source;
    }
    C.prototype.content = w;
    function F(R) {
      var U = new Error(
        j.source + ":" + _ + ":" + y + ": " + R
      );
      if (U.reason = R, U.filename = j.source, U.line = _, U.column = y, U.source = w, !j.silent) throw U;
    }
    function z(R) {
      var U = R.exec(w);
      if (U) {
        var ee = U[0];
        return L(ee), w = w.slice(ee.length), U;
      }
    }
    function Q() {
      z(r);
    }
    function Z(R) {
      var U;
      for (R = R || []; U = te(); )
        U !== !1 && R.push(U);
      return R;
    }
    function te() {
      var R = E();
      if (!(p != w.charAt(0) || d != w.charAt(1))) {
        for (var U = 2; f != w.charAt(U) && (d != w.charAt(U) || p != w.charAt(U + 1)); )
          ++U;
        if (U += 2, f === w.charAt(U - 1))
          return F("End of comment missing");
        var ee = w.slice(2, U - 2);
        return y += 2, L(ee), w = w.slice(U), y += 2, R({
          type: h,
          comment: ee
        });
      }
    }
    function G() {
      var R = E(), U = z(i);
      if (U) {
        if (te(), !z(a)) return F("property missing ':'");
        var ee = z(o), Se = R({
          type: v,
          property: I(U[0].replace(e, f)),
          value: ee ? I(ee[0].replace(e, f)) : f
        });
        return z(s), Se;
      }
    }
    function B() {
      var R = [];
      Z(R);
      for (var U; U = G(); )
        U !== !1 && (R.push(U), Z(R));
      return R;
    }
    return Q(), B();
  };
  function I(w) {
    return w ? w.replace(l, f) : f;
  }
  return vm;
}
var Px;
function k3() {
  if (Px) return la;
  Px = 1;
  var e = la && la.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(la, "__esModule", { value: !0 }), la.default = r;
  var n = e(v3());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(u) {
      if (u.type === "declaration") {
        var p = u.property, d = u.value;
        l ? a(p, d, u) : d && (o = o || {}, o[p] = d);
      }
    }), o;
  }
  return la;
}
var b3 = k3();
const Ax = /* @__PURE__ */ Py(b3), _3 = Ax.default || Ax, PC = AC("end"), Sg = AC("start");
function AC(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function x3(e) {
  const n = Sg(e), r = PC(e);
  if (n && r)
    return { start: n, end: r };
}
function Vo(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Lx(e.position) : "start" in e || "end" in e ? Lx(e) : "line" in e || "column" in e ? ay(e) : "";
}
function ay(e) {
  return Vx(e && e.line) + ":" + Vx(e && e.column);
}
function Lx(e) {
  return ay(e && e.start) + "-" + ay(e && e.end);
}
function Vx(e) {
  return e && typeof e == "number" ? e : 1;
}
class Yt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? o.ruleId = i : (o.source = i.slice(0, u), o.ruleId = i.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Vo(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Yt.prototype.file = "";
Yt.prototype.name = "";
Yt.prototype.reason = "";
Yt.prototype.message = "";
Yt.prototype.stack = "";
Yt.prototype.column = void 0;
Yt.prototype.line = void 0;
Yt.prototype.ancestors = void 0;
Yt.prototype.cause = void 0;
Yt.prototype.fatal = void 0;
Yt.prototype.place = void 0;
Yt.prototype.ruleId = void 0;
Yt.prototype.source = void 0;
const Ng = {}.hasOwnProperty, S3 = /* @__PURE__ */ new Map(), N3 = /[A-Z]/g, j3 = /-([a-z])/g, w3 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), C3 = /* @__PURE__ */ new Set(["td", "th"]), LC = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function F3(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = P3(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = R3(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? xg : y3,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = VC(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function VC(e, n, r) {
  if (n.type === "element")
    return I3(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return $3(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return T3(e, n, r);
  if (n.type === "mdxjsEsm")
    return E3(e, n);
  if (n.type === "root")
    return D3(e, n, r);
  if (n.type === "text")
    return O3(e, n);
}
function I3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = xg, e.schema = a), e.ancestors.push(n);
  const o = UC(e, n.tagName, !1), s = A3(e, n);
  let l = wg(e, n);
  return w3.has(n.tagName) && (l = l.filter(function(u) {
    return typeof u == "string" ? !a3(u) : !0;
  })), zC(e, s, o, n), jg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function $3(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Xo(e, n.position);
}
function E3(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Xo(e, n.position);
}
function T3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = xg, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : UC(e, n.name, !0), s = L3(e, n), l = wg(e, n);
  return zC(e, s, o, n), jg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function D3(e, n, r) {
  const i = {};
  return jg(i, wg(e, n)), e.create(n, e.Fragment, i, r);
}
function O3(e, n) {
  return n.value;
}
function zC(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function jg(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function R3(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const p = Array.isArray(s.children) ? r : n;
    return l ? p(o, s, l) : p(o, s);
  }
}
function P3(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), u = Sg(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function A3(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Ng.call(n.properties, a)) {
      const o = V3(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && C3.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function L3(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Xo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Xo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function wg(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : S3;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const u = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (u) {
        const p = a.get(u) || 0;
        s = u + "-" + p, a.set(u, p + 1);
      }
    }
    const l = VC(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function V3(e, n, r) {
  const i = m3(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? e3(r) : g3(r)), i.property === "style") {
      let a = typeof r == "object" ? r : z3(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = U3(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? h3[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function z3(e, n) {
  const r = {};
  try {
    _3(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Yt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = LC + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(j3, B3)), r[s] = o;
  }
}
function UC(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = Ex(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = Ex(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Ng.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Xo(e);
}
function Xo(e, n) {
  const r = new Yt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = LC + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function U3(e) {
  const n = {};
  let r;
  for (r in e)
    Ng.call(e, r) && (n[M3(r)] = e[r]);
  return n;
}
function M3(e) {
  let n = e.replace(N3, q3);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function B3(e, n) {
  return n.toUpperCase();
}
function q3(e) {
  return "-" + e.toLowerCase();
}
const km = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, H3 = {};
function W3(e, n) {
  const r = H3, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return MC(e, i, a);
}
function MC(e, n, r) {
  if (K3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return zx(e.children, n, r);
  }
  return Array.isArray(e) ? zx(e, n, r) : "";
}
function zx(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = MC(e[a], n, r);
  return i.join("");
}
function K3(e) {
  return !!(e && typeof e == "object");
}
const Ux = document.createElement("i");
function Cg(e) {
  const n = "&" + e + ";";
  Ux.innerHTML = n;
  const r = Ux.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Kr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function br(e, n) {
  return e.length > 0 ? (Kr(e, e.length, 0, n), e) : n;
}
const Mx = {}.hasOwnProperty;
function G3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    Y3(n, e[r]);
  return n;
}
function Y3(e, n) {
  let r;
  for (r in n) {
    const a = (Mx.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Mx.call(a, s) || (a[s] = []);
        const l = o[s];
        Q3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function Q3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Kr(e, 0, 0, i);
}
function BC(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ja(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Ur = Ci(/[A-Za-z]/), gr = Ci(/[\dA-Za-z]/), J3 = Ci(/[#-'*+\--9=?A-Z^-~]/);
function oy(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const sy = Ci(/\d/), X3 = Ci(/[\dA-Fa-f]/), Z3 = Ci(/[!-/:-@[-`{-~]/);
function En(e) {
  return e !== null && e < -2;
}
function cr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Jn(e) {
  return e === -2 || e === -1 || e === 32;
}
const ez = Ci(new RegExp("\\p{P}|\\p{S}", "u")), nz = Ci(/\s/);
function Ci(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Ba(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && gr(e.charCodeAt(r + 1)) && gr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function ut(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(u) {
    return Jn(u) ? (e.enter(r), l(u)) : n(u);
  }
  function l(u) {
    return Jn(u) && o++ < a ? (e.consume(u), l) : (e.exit(r), n(u));
  }
}
const tz = {
  tokenize: rz
};
function rz(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), ut(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = u), r = u, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return En(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const iz = {
  tokenize: az
}, Bx = {
  tokenize: oz
};
function az(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(L) {
    if (i < r.length) {
      const E = r[i];
      return n.containerState = E[1], e.attempt(E[0].continuation, u, p)(L);
    }
    return p(L);
  }
  function u(L) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const E = n.events.length;
      let C = E, F;
      for (; C--; )
        if (n.events[C][0] === "exit" && n.events[C][1].type === "chunkFlow") {
          F = n.events[C][1].end;
          break;
        }
      _(i);
      let z = E;
      for (; z < n.events.length; )
        n.events[z][1].end = {
          ...F
        }, z++;
      return Kr(n.events, C + 1, 0, n.events.slice(E)), n.events.length = z, p(L);
    }
    return l(L);
  }
  function p(L) {
    if (i === r.length) {
      if (!a)
        return h(L);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return I(L);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Bx, d, f)(L);
  }
  function d(L) {
    return a && y(), _(i), h(L);
  }
  function f(L) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, I(L);
  }
  function h(L) {
    return n.containerState = {}, e.attempt(Bx, v, I)(L);
  }
  function v(L) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(L);
  }
  function I(L) {
    if (L === null) {
      a && y(), _(0), e.consume(L);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), w(L);
  }
  function w(L) {
    if (L === null) {
      j(e.exit("chunkFlow"), !0), _(0), e.consume(L);
      return;
    }
    return En(L) ? (e.consume(L), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(L), w);
  }
  function j(L, E) {
    const C = n.sliceStream(L);
    if (E && C.push(null), L.previous = o, o && (o.next = L), o = L, a.defineSkip(L.start), a.write(C), n.parser.lazy[L.start.line]) {
      let F = a.events.length;
      for (; F--; )
        if (
          // The token starts before the line ending…
          a.events[F][1].start.offset < s && // …and either is not ended yet…
          (!a.events[F][1].end || // …or ends after it.
          a.events[F][1].end.offset > s)
        )
          return;
      const z = n.events.length;
      let Q = z, Z, te;
      for (; Q--; )
        if (n.events[Q][0] === "exit" && n.events[Q][1].type === "chunkFlow") {
          if (Z) {
            te = n.events[Q][1].end;
            break;
          }
          Z = !0;
        }
      for (_(i), F = z; F < n.events.length; )
        n.events[F][1].end = {
          ...te
        }, F++;
      Kr(n.events, Q + 1, 0, n.events.slice(z)), n.events.length = F;
    }
  }
  function _(L) {
    let E = r.length;
    for (; E-- > L; ) {
      const C = r[E];
      n.containerState = C[1], C[0].exit.call(n, e);
    }
    r.length = L;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function oz(e, n, r) {
  return ut(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function qx(e) {
  if (e === null || cr(e) || nz(e))
    return 1;
  if (ez(e))
    return 2;
}
function Fg(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const ly = {
  name: "attention",
  resolveAll: sz,
  tokenize: lz
};
function sz(e, n) {
  let r = -1, i, a, o, s, l, u, p, d;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Hx(f, -u), Hx(h, u), s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, p = [], e[i][1].end.offset - e[i][1].start.offset && (p = br(p, [["enter", e[i][1], n], ["exit", e[i][1], n]])), p = br(p, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), p = br(p, Fg(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), p = br(p, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (d = 2, p = br(p, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : d = 0, Kr(e, i - 1, r - i + 3, p), r = i + p.length - d - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function lz(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = qx(i);
  let o;
  return s;
  function s(u) {
    return o = u, e.enter("attentionSequence"), l(u);
  }
  function l(u) {
    if (u === o)
      return e.consume(u), l;
    const p = e.exit("attentionSequence"), d = qx(u), f = !d || d === 2 && a || r.includes(u), h = !a || a === 2 && d || r.includes(i);
    return p._open = !!(o === 42 ? f : f && (a || !h)), p._close = !!(o === 42 ? h : h && (d || !f)), n(u);
  }
}
function Hx(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const cz = {
  name: "autolink",
  tokenize: uz
};
function uz(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Ur(v) ? (e.consume(v), s) : v === 64 ? r(v) : p(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || gr(v) ? (i = 1, l(v)) : p(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, u) : (v === 43 || v === 45 || v === 46 || gr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, p(v));
  }
  function u(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || oy(v) ? r(v) : (e.consume(v), u);
  }
  function p(v) {
    return v === 64 ? (e.consume(v), d) : J3(v) ? (e.consume(v), p) : r(v);
  }
  function d(v) {
    return gr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, d) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || gr(v)) && i++ < 63) {
      const I = v === 45 ? h : f;
      return e.consume(v), I;
    }
    return r(v);
  }
}
const tc = {
  partial: !0,
  tokenize: dz
};
function dz(e, n, r) {
  return i;
  function i(o) {
    return Jn(o) ? ut(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || En(o) ? n(o) : r(o);
  }
}
const qC = {
  continuation: {
    tokenize: pz
  },
  exit: fz,
  name: "blockQuote",
  tokenize: mz
};
function mz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Jn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function pz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Jn(s) ? ut(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(qC, n, r)(s);
  }
}
function fz(e) {
  e.exit("blockQuote");
}
const HC = {
  name: "characterEscape",
  tokenize: hz
};
function hz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return Z3(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const WC = {
  name: "characterReference",
  tokenize: yz
};
function yz(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), p) : (e.enter("characterReferenceValue"), o = 31, s = gr, d(f));
  }
  function p(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = X3, d) : (e.enter("characterReferenceValue"), o = 7, s = sy, d(f));
  }
  function d(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === gr && !Cg(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), d) : r(f);
  }
}
const Wx = {
  partial: !0,
  tokenize: vz
}, Kx = {
  concrete: !0,
  name: "codeFenced",
  tokenize: gz
};
function gz(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: C
  };
  let o = 0, s = 0, l;
  return u;
  function u(F) {
    return p(F);
  }
  function p(F) {
    const z = i.events[i.events.length - 1];
    return o = z && z[1].type === "linePrefix" ? z[2].sliceSerialize(z[1], !0).length : 0, l = F, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(F);
  }
  function d(F) {
    return F === l ? (s++, e.consume(F), d) : s < 3 ? r(F) : (e.exit("codeFencedFenceSequence"), Jn(F) ? ut(e, f, "whitespace")(F) : f(F));
  }
  function f(F) {
    return F === null || En(F) ? (e.exit("codeFencedFence"), i.interrupt ? n(F) : e.check(Wx, w, E)(F)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(F));
  }
  function h(F) {
    return F === null || En(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(F)) : Jn(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ut(e, v, "whitespace")(F)) : F === 96 && F === l ? r(F) : (e.consume(F), h);
  }
  function v(F) {
    return F === null || En(F) ? f(F) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), I(F));
  }
  function I(F) {
    return F === null || En(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(F)) : F === 96 && F === l ? r(F) : (e.consume(F), I);
  }
  function w(F) {
    return e.attempt(a, E, j)(F);
  }
  function j(F) {
    return e.enter("lineEnding"), e.consume(F), e.exit("lineEnding"), _;
  }
  function _(F) {
    return o > 0 && Jn(F) ? ut(e, y, "linePrefix", o + 1)(F) : y(F);
  }
  function y(F) {
    return F === null || En(F) ? e.check(Wx, w, E)(F) : (e.enter("codeFlowValue"), L(F));
  }
  function L(F) {
    return F === null || En(F) ? (e.exit("codeFlowValue"), y(F)) : (e.consume(F), L);
  }
  function E(F) {
    return e.exit("codeFenced"), n(F);
  }
  function C(F, z, Q) {
    let Z = 0;
    return te;
    function te(ee) {
      return F.enter("lineEnding"), F.consume(ee), F.exit("lineEnding"), G;
    }
    function G(ee) {
      return F.enter("codeFencedFence"), Jn(ee) ? ut(F, B, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : B(ee);
    }
    function B(ee) {
      return ee === l ? (F.enter("codeFencedFenceSequence"), R(ee)) : Q(ee);
    }
    function R(ee) {
      return ee === l ? (Z++, F.consume(ee), R) : Z >= s ? (F.exit("codeFencedFenceSequence"), Jn(ee) ? ut(F, U, "whitespace")(ee) : U(ee)) : Q(ee);
    }
    function U(ee) {
      return ee === null || En(ee) ? (F.exit("codeFencedFence"), z(ee)) : Q(ee);
    }
  }
}
function vz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const bm = {
  name: "codeIndented",
  tokenize: bz
}, kz = {
  partial: !0,
  tokenize: _z
};
function bz(e, n, r) {
  const i = this;
  return a;
  function a(p) {
    return e.enter("codeIndented"), ut(e, o, "linePrefix", 5)(p);
  }
  function o(p) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? s(p) : r(p);
  }
  function s(p) {
    return p === null ? u(p) : En(p) ? e.attempt(kz, s, u)(p) : (e.enter("codeFlowValue"), l(p));
  }
  function l(p) {
    return p === null || En(p) ? (e.exit("codeFlowValue"), s(p)) : (e.consume(p), l);
  }
  function u(p) {
    return e.exit("codeIndented"), n(p);
  }
}
function _z(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : En(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : ut(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : En(s) ? a(s) : r(s);
  }
}
const xz = {
  name: "codeText",
  previous: Nz,
  resolve: Sz,
  tokenize: jz
};
function Sz(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function Nz(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function jz(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, d(f)) : En(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), p(f));
  }
  function p(f) {
    return f === null || f === 32 || f === 96 || En(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), p);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), a++, d) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", p(f));
  }
}
class wz {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && co(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), co(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), co(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        co(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        co(this.left, r.reverse());
      }
  }
}
function co(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function KC(e) {
  const n = {};
  let r = -1, i, a, o, s, l, u, p;
  const d = new wz(e);
  for (; ++r < d.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = d.get(r), r && i[1].type === "chunkFlow" && d.get(r - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, Cz(d, r)), r = n[r], p = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = d.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (d.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...d.get(a)[1].start
      }, l = d.slice(a, r), l.unshift(i), d.splice(a, r - a + 1, l));
    }
  }
  return Kr(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !p;
}
function Cz(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, u = [], p = {};
  let d, f, h = -1, v = r, I = 0, w = 0;
  const j = [w];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (d = i.sliceStream(v), v.next || d.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(d), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (w = h + 1, j.push(w), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const _ = l.slice(j[h], j[h + 1]), y = o.pop();
    u.push([y, y + _.length - 1]), e.splice(y, 2, _);
  }
  for (u.reverse(), h = -1; ++h < u.length; )
    p[I + u[h][0]] = I + u[h][1], I += u[h][1] - u[h][0] - 1;
  return p;
}
const Fz = {
  resolve: $z,
  tokenize: Ez
}, Iz = {
  partial: !0,
  tokenize: Tz
};
function $z(e) {
  return KC(e), e;
}
function Ez(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : En(l) ? e.check(Iz, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function Tz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ut(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || En(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function GC(e, n, r, i, a, o, s, l, u) {
  const p = u || Number.POSITIVE_INFINITY;
  let d = 0;
  return f;
  function f(_) {
    return _ === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(_), e.exit(o), h) : _ === null || _ === 32 || _ === 41 || oy(_) ? r(_) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), w(_));
  }
  function h(_) {
    return _ === 62 ? (e.enter(o), e.consume(_), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(_));
  }
  function v(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(l), h(_)) : _ === null || _ === 60 || En(_) ? r(_) : (e.consume(_), _ === 92 ? I : v);
  }
  function I(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), v) : v(_);
  }
  function w(_) {
    return !d && (_ === null || _ === 41 || cr(_)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(_)) : d < p && _ === 40 ? (e.consume(_), d++, w) : _ === 41 ? (e.consume(_), d--, w) : _ === null || _ === 32 || _ === 40 || oy(_) ? r(_) : (e.consume(_), _ === 92 ? j : w);
  }
  function j(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), w) : w(_);
  }
}
function YC(e, n, r, i, a, o) {
  const s = this;
  let l = 0, u;
  return p;
  function p(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), d;
  }
  function d(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : En(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || En(v) || l++ > 999 ? (e.exit("chunkString"), d(v)) : (e.consume(v), u || (u = !Jn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function QC(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, u) : r(h);
  }
  function u(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), p(h));
  }
  function p(h) {
    return h === s ? (e.exit(o), u(s)) : h === null ? r(h) : En(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), ut(e, p, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === s || h === null || En(h) ? (e.exit("chunkString"), p(h)) : (e.consume(h), h === 92 ? f : d);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), d) : d(h);
  }
}
function zo(e, n) {
  let r;
  return i;
  function i(a) {
    return En(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Jn(a) ? ut(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const Dz = {
  name: "definition",
  tokenize: Rz
}, Oz = {
  partial: !0,
  tokenize: Pz
};
function Rz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return YC.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = ja(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), u) : r(v);
  }
  function u(v) {
    return cr(v) ? zo(e, p)(v) : p(v);
  }
  function p(v) {
    return GC(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function d(v) {
    return e.attempt(Oz, f, f)(v);
  }
  function f(v) {
    return Jn(v) ? ut(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || En(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function Pz(e, n, r) {
  return i;
  function i(l) {
    return cr(l) ? zo(e, a)(l) : r(l);
  }
  function a(l) {
    return QC(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Jn(l) ? ut(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || En(l) ? n(l) : r(l);
  }
}
const Az = {
  name: "hardBreakEscape",
  tokenize: Lz
};
function Lz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return En(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const Vz = {
  name: "headingAtx",
  resolve: zz,
  tokenize: Uz
};
function zz(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Kr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function Uz(e, n, r) {
  let i = 0;
  return a;
  function a(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), s(d);
  }
  function s(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), s) : d === null || cr(d) ? (e.exit("atxHeadingSequence"), l(d)) : r(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), u(d)) : d === null || En(d) ? (e.exit("atxHeading"), n(d)) : Jn(d) ? ut(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), p(d));
  }
  function u(d) {
    return d === 35 ? (e.consume(d), u) : (e.exit("atxHeadingSequence"), l(d));
  }
  function p(d) {
    return d === null || d === 35 || cr(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), p);
  }
}
const Mz = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Gx = ["pre", "script", "style", "textarea"], Bz = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Wz,
  tokenize: Kz
}, qz = {
  partial: !0,
  tokenize: Yz
}, Hz = {
  partial: !0,
  tokenize: Gz
};
function Wz(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function Kz(e, n, r) {
  const i = this;
  let a, o, s, l, u;
  return p;
  function p(J) {
    return d(J);
  }
  function d(J) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(J), f;
  }
  function f(J) {
    return J === 33 ? (e.consume(J), h) : J === 47 ? (e.consume(J), o = !0, w) : J === 63 ? (e.consume(J), a = 3, i.interrupt ? n : K) : Ur(J) ? (e.consume(J), s = String.fromCharCode(J), j) : r(J);
  }
  function h(J) {
    return J === 45 ? (e.consume(J), a = 2, v) : J === 91 ? (e.consume(J), a = 5, l = 0, I) : Ur(J) ? (e.consume(J), a = 4, i.interrupt ? n : K) : r(J);
  }
  function v(J) {
    return J === 45 ? (e.consume(J), i.interrupt ? n : K) : r(J);
  }
  function I(J) {
    const Ke = "CDATA[";
    return J === Ke.charCodeAt(l++) ? (e.consume(J), l === Ke.length ? i.interrupt ? n : B : I) : r(J);
  }
  function w(J) {
    return Ur(J) ? (e.consume(J), s = String.fromCharCode(J), j) : r(J);
  }
  function j(J) {
    if (J === null || J === 47 || J === 62 || cr(J)) {
      const Ke = J === 47, an = s.toLowerCase();
      return !Ke && !o && Gx.includes(an) ? (a = 1, i.interrupt ? n(J) : B(J)) : Mz.includes(s.toLowerCase()) ? (a = 6, Ke ? (e.consume(J), _) : i.interrupt ? n(J) : B(J)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(J) : o ? y(J) : L(J));
    }
    return J === 45 || gr(J) ? (e.consume(J), s += String.fromCharCode(J), j) : r(J);
  }
  function _(J) {
    return J === 62 ? (e.consume(J), i.interrupt ? n : B) : r(J);
  }
  function y(J) {
    return Jn(J) ? (e.consume(J), y) : te(J);
  }
  function L(J) {
    return J === 47 ? (e.consume(J), te) : J === 58 || J === 95 || Ur(J) ? (e.consume(J), E) : Jn(J) ? (e.consume(J), L) : te(J);
  }
  function E(J) {
    return J === 45 || J === 46 || J === 58 || J === 95 || gr(J) ? (e.consume(J), E) : C(J);
  }
  function C(J) {
    return J === 61 ? (e.consume(J), F) : Jn(J) ? (e.consume(J), C) : L(J);
  }
  function F(J) {
    return J === null || J === 60 || J === 61 || J === 62 || J === 96 ? r(J) : J === 34 || J === 39 ? (e.consume(J), u = J, z) : Jn(J) ? (e.consume(J), F) : Q(J);
  }
  function z(J) {
    return J === u ? (e.consume(J), u = null, Z) : J === null || En(J) ? r(J) : (e.consume(J), z);
  }
  function Q(J) {
    return J === null || J === 34 || J === 39 || J === 47 || J === 60 || J === 61 || J === 62 || J === 96 || cr(J) ? C(J) : (e.consume(J), Q);
  }
  function Z(J) {
    return J === 47 || J === 62 || Jn(J) ? L(J) : r(J);
  }
  function te(J) {
    return J === 62 ? (e.consume(J), G) : r(J);
  }
  function G(J) {
    return J === null || En(J) ? B(J) : Jn(J) ? (e.consume(J), G) : r(J);
  }
  function B(J) {
    return J === 45 && a === 2 ? (e.consume(J), Se) : J === 60 && a === 1 ? (e.consume(J), fe) : J === 62 && a === 4 ? (e.consume(J), _e) : J === 63 && a === 3 ? (e.consume(J), K) : J === 93 && a === 5 ? (e.consume(J), ve) : En(J) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(qz, Te, R)(J)) : J === null || En(J) ? (e.exit("htmlFlowData"), R(J)) : (e.consume(J), B);
  }
  function R(J) {
    return e.check(Hz, U, Te)(J);
  }
  function U(J) {
    return e.enter("lineEnding"), e.consume(J), e.exit("lineEnding"), ee;
  }
  function ee(J) {
    return J === null || En(J) ? R(J) : (e.enter("htmlFlowData"), B(J));
  }
  function Se(J) {
    return J === 45 ? (e.consume(J), K) : B(J);
  }
  function fe(J) {
    return J === 47 ? (e.consume(J), s = "", ye) : B(J);
  }
  function ye(J) {
    if (J === 62) {
      const Ke = s.toLowerCase();
      return Gx.includes(Ke) ? (e.consume(J), _e) : B(J);
    }
    return Ur(J) && s.length < 8 ? (e.consume(J), s += String.fromCharCode(J), ye) : B(J);
  }
  function ve(J) {
    return J === 93 ? (e.consume(J), K) : B(J);
  }
  function K(J) {
    return J === 62 ? (e.consume(J), _e) : J === 45 && a === 2 ? (e.consume(J), K) : B(J);
  }
  function _e(J) {
    return J === null || En(J) ? (e.exit("htmlFlowData"), Te(J)) : (e.consume(J), _e);
  }
  function Te(J) {
    return e.exit("htmlFlow"), n(J);
  }
}
function Gz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return En(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function Yz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(tc, n, r);
  }
}
const Qz = {
  name: "htmlText",
  tokenize: Jz
};
function Jz(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(K) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(K), u;
  }
  function u(K) {
    return K === 33 ? (e.consume(K), p) : K === 47 ? (e.consume(K), C) : K === 63 ? (e.consume(K), L) : Ur(K) ? (e.consume(K), Q) : r(K);
  }
  function p(K) {
    return K === 45 ? (e.consume(K), d) : K === 91 ? (e.consume(K), o = 0, I) : Ur(K) ? (e.consume(K), y) : r(K);
  }
  function d(K) {
    return K === 45 ? (e.consume(K), v) : r(K);
  }
  function f(K) {
    return K === null ? r(K) : K === 45 ? (e.consume(K), h) : En(K) ? (s = f, fe(K)) : (e.consume(K), f);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), v) : f(K);
  }
  function v(K) {
    return K === 62 ? Se(K) : K === 45 ? h(K) : f(K);
  }
  function I(K) {
    const _e = "CDATA[";
    return K === _e.charCodeAt(o++) ? (e.consume(K), o === _e.length ? w : I) : r(K);
  }
  function w(K) {
    return K === null ? r(K) : K === 93 ? (e.consume(K), j) : En(K) ? (s = w, fe(K)) : (e.consume(K), w);
  }
  function j(K) {
    return K === 93 ? (e.consume(K), _) : w(K);
  }
  function _(K) {
    return K === 62 ? Se(K) : K === 93 ? (e.consume(K), _) : w(K);
  }
  function y(K) {
    return K === null || K === 62 ? Se(K) : En(K) ? (s = y, fe(K)) : (e.consume(K), y);
  }
  function L(K) {
    return K === null ? r(K) : K === 63 ? (e.consume(K), E) : En(K) ? (s = L, fe(K)) : (e.consume(K), L);
  }
  function E(K) {
    return K === 62 ? Se(K) : L(K);
  }
  function C(K) {
    return Ur(K) ? (e.consume(K), F) : r(K);
  }
  function F(K) {
    return K === 45 || gr(K) ? (e.consume(K), F) : z(K);
  }
  function z(K) {
    return En(K) ? (s = z, fe(K)) : Jn(K) ? (e.consume(K), z) : Se(K);
  }
  function Q(K) {
    return K === 45 || gr(K) ? (e.consume(K), Q) : K === 47 || K === 62 || cr(K) ? Z(K) : r(K);
  }
  function Z(K) {
    return K === 47 ? (e.consume(K), Se) : K === 58 || K === 95 || Ur(K) ? (e.consume(K), te) : En(K) ? (s = Z, fe(K)) : Jn(K) ? (e.consume(K), Z) : Se(K);
  }
  function te(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || gr(K) ? (e.consume(K), te) : G(K);
  }
  function G(K) {
    return K === 61 ? (e.consume(K), B) : En(K) ? (s = G, fe(K)) : Jn(K) ? (e.consume(K), G) : Z(K);
  }
  function B(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), a = K, R) : En(K) ? (s = B, fe(K)) : Jn(K) ? (e.consume(K), B) : (e.consume(K), U);
  }
  function R(K) {
    return K === a ? (e.consume(K), a = void 0, ee) : K === null ? r(K) : En(K) ? (s = R, fe(K)) : (e.consume(K), R);
  }
  function U(K) {
    return K === null || K === 34 || K === 39 || K === 60 || K === 61 || K === 96 ? r(K) : K === 47 || K === 62 || cr(K) ? Z(K) : (e.consume(K), U);
  }
  function ee(K) {
    return K === 47 || K === 62 || cr(K) ? Z(K) : r(K);
  }
  function Se(K) {
    return K === 62 ? (e.consume(K), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(K);
  }
  function fe(K) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ye;
  }
  function ye(K) {
    return Jn(K) ? ut(e, ve, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(K) : ve(K);
  }
  function ve(K) {
    return e.enter("htmlTextData"), s(K);
  }
}
const Ig = {
  name: "labelEnd",
  resolveAll: nU,
  resolveTo: tU,
  tokenize: rU
}, Xz = {
  tokenize: iU
}, Zz = {
  tokenize: aU
}, eU = {
  tokenize: oU
};
function nU(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Kr(e, 0, e.length, r), e;
}
function tU(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const u = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, p = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, d = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", u, n], ["enter", p, n]], l = br(l, e.slice(o + 1, o + i + 3)), l = br(l, [["enter", d, n]]), l = br(l, Fg(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = br(l, [["exit", d, n], e[s - 2], e[s - 1], ["exit", p, n]]), l = br(l, e.slice(s + 1)), l = br(l, [["exit", u, n]]), Kr(e, o, e.length, l), e;
}
function rU(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ja(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), u) : r(h);
  }
  function u(h) {
    return h === 40 ? e.attempt(Xz, d, s ? d : f)(h) : h === 91 ? e.attempt(Zz, d, s ? p : f)(h) : s ? d(h) : f(h);
  }
  function p(h) {
    return e.attempt(eU, d, f)(h);
  }
  function d(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function iU(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return cr(f) ? zo(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? d(f) : GC(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return cr(f) ? zo(e, u)(f) : d(f);
  }
  function l(f) {
    return r(f);
  }
  function u(f) {
    return f === 34 || f === 39 || f === 40 ? QC(e, p, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : d(f);
  }
  function p(f) {
    return cr(f) ? zo(e, d)(f) : d(f);
  }
  function d(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function aU(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return YC.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ja(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function oU(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const sU = {
  name: "labelStartImage",
  resolveAll: Ig.resolveAll,
  tokenize: lU
};
function lU(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const cU = {
  name: "labelStartLink",
  resolveAll: Ig.resolveAll,
  tokenize: uU
};
function uU(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const _m = {
  name: "lineEnding",
  tokenize: dU
};
function dU(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), ut(e, n, "linePrefix");
  }
}
const sl = {
  name: "thematicBreak",
  tokenize: mU
};
function mU(e, n, r) {
  let i = 0, a;
  return o;
  function o(p) {
    return e.enter("thematicBreak"), s(p);
  }
  function s(p) {
    return a = p, l(p);
  }
  function l(p) {
    return p === a ? (e.enter("thematicBreakSequence"), u(p)) : i >= 3 && (p === null || En(p)) ? (e.exit("thematicBreak"), n(p)) : r(p);
  }
  function u(p) {
    return p === a ? (e.consume(p), i++, u) : (e.exit("thematicBreakSequence"), Jn(p) ? ut(e, l, "whitespace")(p) : l(p));
  }
}
const sr = {
  continuation: {
    tokenize: yU
  },
  exit: vU,
  name: "list",
  tokenize: hU
}, pU = {
  partial: !0,
  tokenize: kU
}, fU = {
  partial: !0,
  tokenize: gU
};
function hU(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const I = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (I === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : sy(v)) {
      if (i.containerState.type || (i.containerState.type = I, e.enter(I, {
        _container: !0
      })), I === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(sl, r, p)(v) : p(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(v);
    }
    return r(v);
  }
  function u(v) {
    return sy(v) && ++s < 10 ? (e.consume(v), u) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), p(v)) : r(v);
  }
  function p(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      tc,
      // Can’t be empty when interrupting.
      i.interrupt ? r : d,
      e.attempt(pU, h, f)
    );
  }
  function d(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return Jn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function yU(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(tc, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, ut(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Jn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(fU, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, ut(e, e.attempt(sr, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function gU(e, n, r) {
  const i = this;
  return ut(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function vU(e) {
  e.exit(this.containerState.type);
}
function kU(e, n, r) {
  const i = this;
  return ut(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Jn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Yx = {
  name: "setextUnderline",
  resolveTo: bU,
  tokenize: _U
};
function bU(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function _U(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(p) {
    let d = i.events.length, f;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        f = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = p, s(p)) : r(p);
  }
  function s(p) {
    return e.enter("setextHeadingLineSequence"), l(p);
  }
  function l(p) {
    return p === a ? (e.consume(p), l) : (e.exit("setextHeadingLineSequence"), Jn(p) ? ut(e, u, "lineSuffix")(p) : u(p));
  }
  function u(p) {
    return p === null || En(p) ? (e.exit("setextHeadingLine"), n(p)) : r(p);
  }
}
const xU = {
  tokenize: SU
};
function SU(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    tc,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, ut(e, e.attempt(this.parser.constructs.flow, a, e.attempt(Fz, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const NU = {
  resolveAll: XC()
}, jU = JC("string"), wU = JC("text");
function JC(e) {
  return {
    resolveAll: XC(e === "text" ? CU : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(d) {
      return p(d) ? o(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        r.consume(d);
        return;
      }
      return r.enter("data"), r.consume(d), u;
    }
    function u(d) {
      return p(d) ? (r.exit("data"), o(d)) : (r.consume(d), u);
    }
    function p(d) {
      if (d === null)
        return !0;
      const f = a[d];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function XC(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function CU(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, u;
      for (; o--; ) {
        const p = a[o];
        if (typeof p == "string") {
          for (s = p.length; p.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (p === -2)
          u = !0, l++;
        else if (p !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const p = {
          type: r === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...p.start
        }, i.start.offset === i.end.offset ? Object.assign(i, p) : (e.splice(r, 0, ["enter", p, n], ["exit", p, n]), r += 2);
      }
      r++;
    }
  return e;
}
const FU = {
  42: sr,
  43: sr,
  45: sr,
  48: sr,
  49: sr,
  50: sr,
  51: sr,
  52: sr,
  53: sr,
  54: sr,
  55: sr,
  56: sr,
  57: sr,
  62: qC
}, IU = {
  91: Dz
}, $U = {
  [-2]: bm,
  [-1]: bm,
  32: bm
}, EU = {
  35: Vz,
  42: sl,
  45: [Yx, sl],
  60: Bz,
  61: Yx,
  95: sl,
  96: Kx,
  126: Kx
}, TU = {
  38: WC,
  92: HC
}, DU = {
  [-5]: _m,
  [-4]: _m,
  [-3]: _m,
  33: sU,
  38: WC,
  42: ly,
  60: [cz, Qz],
  91: cU,
  92: [Az, HC],
  93: Ig,
  95: ly,
  96: xz
}, OU = {
  null: [ly, NU]
}, RU = {
  null: [42, 95]
}, PU = {
  null: []
}, AU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: RU,
  contentInitial: IU,
  disable: PU,
  document: FU,
  flow: EU,
  flowInitial: $U,
  insideSpan: OU,
  string: TU,
  text: DU
}, Symbol.toStringTag, { value: "Module" }));
function LU(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const u = {
    attempt: z(C),
    check: z(F),
    consume: y,
    enter: L,
    exit: E,
    interrupt: z(F, {
      interrupt: !0
    })
  }, p = {
    code: null,
    containerState: {},
    defineSkip: w,
    events: [],
    now: I,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let d = n.tokenize.call(p, u);
  return n.resolveAll && o.push(n), p;
  function f(G) {
    return s = br(s, G), j(), s[s.length - 1] !== null ? [] : (Q(n, 0), p.events = Fg(o, p.events, p), p.events);
  }
  function h(G, B) {
    return zU(v(G), B);
  }
  function v(G) {
    return VU(s, G);
  }
  function I() {
    const {
      _bufferIndex: G,
      _index: B,
      line: R,
      column: U,
      offset: ee
    } = i;
    return {
      _bufferIndex: G,
      _index: B,
      line: R,
      column: U,
      offset: ee
    };
  }
  function w(G) {
    a[G.line] = G.column, te();
  }
  function j() {
    let G;
    for (; i._index < s.length; ) {
      const B = s[i._index];
      if (typeof B == "string")
        for (G = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === G && i._bufferIndex < B.length; )
          _(B.charCodeAt(i._bufferIndex));
      else
        _(B);
    }
  }
  function _(G) {
    d = d(G);
  }
  function y(G) {
    En(G) ? (i.line++, i.column = 1, i.offset += G === -3 ? 2 : 1, te()) : G !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), p.previous = G;
  }
  function L(G, B) {
    const R = B || {};
    return R.type = G, R.start = I(), p.events.push(["enter", R, p]), l.push(R), R;
  }
  function E(G) {
    const B = l.pop();
    return B.end = I(), p.events.push(["exit", B, p]), B;
  }
  function C(G, B) {
    Q(G, B.from);
  }
  function F(G, B) {
    B.restore();
  }
  function z(G, B) {
    return R;
    function R(U, ee, Se) {
      let fe, ye, ve, K;
      return Array.isArray(U) ? (
        /* c8 ignore next 1 */
        Te(U)
      ) : "tokenize" in U ? (
        // Looks like a construct.
        Te([
          /** @type {Construct} */
          U
        ])
      ) : _e(U);
      function _e(we) {
        return Me;
        function Me(Re) {
          const Be = Re !== null && we[Re], Ae = Re !== null && we.null, Ge = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return Te(Ge)(Re);
        }
      }
      function Te(we) {
        return fe = we, ye = 0, we.length === 0 ? Se : J(we[ye]);
      }
      function J(we) {
        return Me;
        function Me(Re) {
          return K = Z(), ve = we, we.partial || (p.currentConstruct = we), we.name && p.parser.constructs.disable.null.includes(we.name) ? an() : we.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            B ? Object.assign(Object.create(p), B) : p,
            u,
            Ke,
            an
          )(Re);
        }
      }
      function Ke(we) {
        return G(ve, K), ee;
      }
      function an(we) {
        return K.restore(), ++ye < fe.length ? J(fe[ye]) : Se;
      }
    }
  }
  function Q(G, B) {
    G.resolveAll && !o.includes(G) && o.push(G), G.resolve && Kr(p.events, B, p.events.length - B, G.resolve(p.events.slice(B), p)), G.resolveTo && (p.events = G.resolveTo(p.events, p));
  }
  function Z() {
    const G = I(), B = p.previous, R = p.currentConstruct, U = p.events.length, ee = Array.from(l);
    return {
      from: U,
      restore: Se
    };
    function Se() {
      i = G, p.previous = B, p.currentConstruct = R, p.events.length = U, l = ee, te();
    }
  }
  function te() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function VU(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function zU(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function UU(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      G3([AU, ...(e || {}).extensions || []])
    ),
    content: a(tz),
    defined: [],
    document: a(iz),
    flow: a(xU),
    lazy: {},
    string: a(jU),
    text: a(wU)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return LU(i, o, l);
    }
  }
}
function MU(e) {
  for (; !KC(e); )
    ;
  return e;
}
const Qx = /[\0\t\n\r]/g;
function BU() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const u = [];
    let p, d, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Qx.lastIndex = f, p = Qx.exec(o), h = p && p.index !== void 0 ? p.index : o.length, v = o.charCodeAt(h), !p) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), f < h && (u.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, u.push(-2); e++ < d; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && u.push(-5), n && u.push(n), u.push(null)), u;
  }
}
const qU = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function HU(e) {
  return e.replace(qU, WU);
}
function WU(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return BC(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Cg(r) || e;
}
const ZC = {}.hasOwnProperty;
function KU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), GU(r)(MU(UU(r).document().write(BU()(e, n, !0))));
}
function GU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: Z,
      autolinkEmail: Z,
      atxHeading: o(ie),
      blockQuote: o(Ae),
      characterEscape: Z,
      characterReference: Z,
      codeFenced: o(Ge),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Ge, s),
      codeText: o(Ce, s),
      codeTextData: Z,
      data: Z,
      codeFlowValue: Z,
      definition: o(qe),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(en),
      hardBreakEscape: o(se),
      hardBreakTrailing: o(se),
      htmlFlow: o(xe, s),
      htmlFlowData: Z,
      htmlText: o(xe, s),
      htmlTextData: Z,
      image: o(Le),
      label: s,
      link: o(Pe),
      listItem: o(T),
      listItemValue: h,
      listOrdered: o(yn, f),
      listUnordered: o(yn),
      paragraph: o(x),
      reference: J,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(ie),
      strong: o(D),
      thematicBreak: o(Y)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: C,
      autolink: u(),
      autolinkEmail: Be,
      autolinkProtocol: Re,
      blockQuote: u(),
      characterEscapeValue: te,
      characterReferenceMarkerHexadecimal: an,
      characterReferenceMarkerNumeric: an,
      characterReferenceValue: we,
      characterReference: Me,
      codeFenced: u(j),
      codeFencedFence: w,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: I,
      codeFlowValue: te,
      codeIndented: u(_),
      codeText: u(ee),
      codeTextData: te,
      data: te,
      definition: u(),
      definitionDestinationString: E,
      definitionLabelString: y,
      definitionTitleString: L,
      emphasis: u(),
      hardBreakEscape: u(B),
      hardBreakTrailing: u(B),
      htmlFlow: u(R),
      htmlFlowData: te,
      htmlText: u(U),
      htmlTextData: te,
      image: u(fe),
      label: ve,
      labelText: ye,
      lineEnding: G,
      link: u(Se),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Ke,
      resourceDestinationString: K,
      resourceTitleString: _e,
      resource: Te,
      setextHeading: u(Q),
      setextHeadingLineSequence: z,
      setextHeadingText: F,
      strong: u(),
      thematicBreak: u()
    }
  };
  eF(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(A) {
    let M = {
      type: "root",
      children: []
    };
    const ae = {
      stack: [M],
      tokenStack: [],
      config: n,
      enter: l,
      exit: p,
      buffer: s,
      resume: d,
      data: r
    }, ge = [];
    let Ne = -1;
    for (; ++Ne < A.length; )
      if (A[Ne][1].type === "listOrdered" || A[Ne][1].type === "listUnordered")
        if (A[Ne][0] === "enter")
          ge.push(Ne);
        else {
          const tn = ge.pop();
          Ne = a(A, tn, Ne);
        }
    for (Ne = -1; ++Ne < A.length; ) {
      const tn = n[A[Ne][0]];
      ZC.call(tn, A[Ne][1].type) && tn[A[Ne][1].type].call(Object.assign({
        sliceSerialize: A[Ne][2].sliceSerialize
      }, ae), A[Ne][1]);
    }
    if (ae.tokenStack.length > 0) {
      const tn = ae.tokenStack[ae.tokenStack.length - 1];
      (tn[1] || Jx).call(ae, void 0, tn[0]);
    }
    for (M.position = {
      start: vi(A.length > 0 ? A[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: vi(A.length > 0 ? A[A.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ne = -1; ++Ne < n.transforms.length; )
      M = n.transforms[Ne](M) || M;
    return M;
  }
  function a(A, M, ae) {
    let ge = M - 1, Ne = -1, tn = !1, gn, nn, dn, wn;
    for (; ++ge <= ae; ) {
      const xn = A[ge];
      switch (xn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          xn[0] === "enter" ? Ne++ : Ne--, wn = void 0;
          break;
        }
        case "lineEndingBlank": {
          xn[0] === "enter" && (gn && !wn && !Ne && !dn && (dn = ge), wn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          wn = void 0;
      }
      if (!Ne && xn[0] === "enter" && xn[1].type === "listItemPrefix" || Ne === -1 && xn[0] === "exit" && (xn[1].type === "listUnordered" || xn[1].type === "listOrdered")) {
        if (gn) {
          let Cn = ge;
          for (nn = void 0; Cn--; ) {
            const Ze = A[Cn];
            if (Ze[1].type === "lineEnding" || Ze[1].type === "lineEndingBlank") {
              if (Ze[0] === "exit") continue;
              nn && (A[nn][1].type = "lineEndingBlank", tn = !0), Ze[1].type = "lineEnding", nn = Cn;
            } else if (!(Ze[1].type === "linePrefix" || Ze[1].type === "blockQuotePrefix" || Ze[1].type === "blockQuotePrefixWhitespace" || Ze[1].type === "blockQuoteMarker" || Ze[1].type === "listItemIndent")) break;
          }
          dn && (!nn || dn < nn) && (gn._spread = !0), gn.end = Object.assign({}, nn ? A[nn][1].start : xn[1].end), A.splice(nn || ge, 0, ["exit", gn, xn[2]]), ge++, ae++;
        }
        if (xn[1].type === "listItemPrefix") {
          const Cn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, xn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          gn = Cn, A.splice(ge, 0, ["enter", Cn, xn[2]]), ge++, ae++, dn = void 0, wn = !0;
        }
      }
    }
    return A[M][1]._spread = tn, ae;
  }
  function o(A, M) {
    return ae;
    function ae(ge) {
      l.call(this, A(ge), ge), M && M.call(this, ge);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(A, M, ae) {
    this.stack[this.stack.length - 1].children.push(A), this.stack.push(A), this.tokenStack.push([M, ae || void 0]), A.position = {
      start: vi(M.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(A) {
    return M;
    function M(ae) {
      A && A.call(this, ae), p.call(this, ae);
    }
  }
  function p(A, M) {
    const ae = this.stack.pop(), ge = this.tokenStack.pop();
    if (ge)
      ge[0].type !== A.type && (M ? M.call(this, A, ge[0]) : (ge[1] || Jx).call(this, A, ge[0]));
    else throw new Error("Cannot close `" + A.type + "` (" + Vo({
      start: A.start,
      end: A.end
    }) + "): it’s not open");
    ae.position.end = vi(A.end);
  }
  function d() {
    return W3(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(A) {
    if (this.data.expectingFirstListItemValue) {
      const M = this.stack[this.stack.length - 2];
      M.start = Number.parseInt(this.sliceSerialize(A), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.lang = A;
  }
  function I() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.meta = A;
  }
  function w() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function _() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A.replace(/(\r?\n|\r)$/g, "");
  }
  function y(A) {
    const M = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.label = M, ae.identifier = ja(this.sliceSerialize(A)).toLowerCase();
  }
  function L() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.title = A;
  }
  function E() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.url = A;
  }
  function C(A) {
    const M = this.stack[this.stack.length - 1];
    if (!M.depth) {
      const ae = this.sliceSerialize(A).length;
      M.depth = ae;
    }
  }
  function F() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function z(A) {
    const M = this.stack[this.stack.length - 1];
    M.depth = this.sliceSerialize(A).codePointAt(0) === 61 ? 1 : 2;
  }
  function Q() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Z(A) {
    const ae = this.stack[this.stack.length - 1].children;
    let ge = ae[ae.length - 1];
    (!ge || ge.type !== "text") && (ge = H(), ge.position = {
      start: vi(A.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ae.push(ge)), this.stack.push(ge);
  }
  function te(A) {
    const M = this.stack.pop();
    M.value += this.sliceSerialize(A), M.position.end = vi(A.end);
  }
  function G(A) {
    const M = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ae = M.children[M.children.length - 1];
      ae.position.end = vi(A.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(M.type) && (Z.call(this, A), te.call(this, A));
  }
  function B() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A;
  }
  function U() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A;
  }
  function ee() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = A;
  }
  function Se() {
    const A = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const M = this.data.referenceType || "shortcut";
      A.type += "Reference", A.referenceType = M, delete A.url, delete A.title;
    } else
      delete A.identifier, delete A.label;
    this.data.referenceType = void 0;
  }
  function fe() {
    const A = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const M = this.data.referenceType || "shortcut";
      A.type += "Reference", A.referenceType = M, delete A.url, delete A.title;
    } else
      delete A.identifier, delete A.label;
    this.data.referenceType = void 0;
  }
  function ye(A) {
    const M = this.sliceSerialize(A), ae = this.stack[this.stack.length - 2];
    ae.label = HU(M), ae.identifier = ja(M).toLowerCase();
  }
  function ve() {
    const A = this.stack[this.stack.length - 1], M = this.resume(), ae = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ae.type === "link") {
      const ge = A.children;
      ae.children = ge;
    } else
      ae.alt = M;
  }
  function K() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.url = A;
  }
  function _e() {
    const A = this.resume(), M = this.stack[this.stack.length - 1];
    M.title = A;
  }
  function Te() {
    this.data.inReference = void 0;
  }
  function J() {
    this.data.referenceType = "collapsed";
  }
  function Ke(A) {
    const M = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.label = M, ae.identifier = ja(this.sliceSerialize(A)).toLowerCase(), this.data.referenceType = "full";
  }
  function an(A) {
    this.data.characterReferenceType = A.type;
  }
  function we(A) {
    const M = this.sliceSerialize(A), ae = this.data.characterReferenceType;
    let ge;
    ae ? (ge = BC(M, ae === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ge = Cg(M);
    const Ne = this.stack[this.stack.length - 1];
    Ne.value += ge;
  }
  function Me(A) {
    const M = this.stack.pop();
    M.position.end = vi(A.end);
  }
  function Re(A) {
    te.call(this, A);
    const M = this.stack[this.stack.length - 1];
    M.url = this.sliceSerialize(A);
  }
  function Be(A) {
    te.call(this, A);
    const M = this.stack[this.stack.length - 1];
    M.url = "mailto:" + this.sliceSerialize(A);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Ge() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ce() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function qe() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function en() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ie() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function se() {
    return {
      type: "break"
    };
  }
  function xe() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function yn(A) {
    return {
      type: "list",
      ordered: A.type === "listOrdered",
      start: null,
      spread: A._spread,
      children: []
    };
  }
  function T(A) {
    return {
      type: "listItem",
      spread: A._spread,
      checked: null,
      children: []
    };
  }
  function x() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function D() {
    return {
      type: "strong",
      children: []
    };
  }
  function H() {
    return {
      type: "text",
      value: ""
    };
  }
  function Y() {
    return {
      type: "thematicBreak"
    };
  }
}
function vi(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function eF(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? eF(e, i) : YU(e, i);
  }
}
function YU(e, n) {
  let r;
  for (r in n)
    if (ZC.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Jx(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Vo({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Vo({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Vo({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function QU(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return KU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function JU(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function XU(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function ZU(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function e4(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function n4(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function t4(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Ba(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, u);
  const p = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(n, p), e.applyData(n, p);
}
function r4(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function i4(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function nF(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function a4(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return nF(e, n);
  const a = { src: Ba(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function o4(e, n) {
  const r = { src: Ba(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function s4(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function l4(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return nF(e, n);
  const a = { href: Ba(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function c4(e, n) {
  const r = { href: Ba(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function u4(e, n, r) {
  const i = e.all(n), a = r ? d4(r) : tF(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const d = i[0];
    let f;
    d && d.type === "element" && d.tagName === "p" ? f = d : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const d = i[l];
    (a || l !== 0 || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !a ? s.push(...d.children) : s.push(d);
  }
  const u = i[i.length - 1];
  u && (a || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` });
  const p = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, p), e.applyData(n, p);
}
function d4(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = tF(r[i]);
  }
  return n;
}
function tF(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function m4(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function p4(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function f4(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function h4(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function y4(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Sg(n.children[1]), u = PC(n.children[n.children.length - 1]);
    l && u && (s.position = { start: l, end: u }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function g4(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let u = -1;
  const p = [];
  for (; ++u < l; ) {
    const f = n.children[u], h = {}, v = s ? s[u] : void 0;
    v && (h.align = v);
    let I = { type: "element", tagName: o, properties: h, children: [] };
    f && (I.children = e.all(f), e.patch(f, I), I = e.applyData(f, I)), p.push(I);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(p, !0)
  };
  return e.patch(n, d), e.applyData(n, d);
}
function v4(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Xx = 9, Zx = 32;
function k4(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      eS(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(eS(n.slice(a), a > 0, !1)), o.join("");
}
function eS(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Xx || o === Zx; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Xx || o === Zx; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function b4(e, n) {
  const r = { type: "text", value: k4(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function _4(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const x4 = {
  blockquote: JU,
  break: XU,
  code: ZU,
  delete: e4,
  emphasis: n4,
  footnoteReference: t4,
  heading: r4,
  html: i4,
  imageReference: a4,
  image: o4,
  inlineCode: s4,
  linkReference: l4,
  link: c4,
  listItem: u4,
  list: m4,
  paragraph: p4,
  // @ts-expect-error: root is different, but hard to type.
  root: f4,
  strong: h4,
  table: y4,
  tableCell: v4,
  tableRow: g4,
  text: b4,
  thematicBreak: _4,
  toml: Cs,
  yaml: Cs,
  definition: Cs,
  footnoteDefinition: Cs
};
function Cs() {
}
const rF = -1, rc = 0, Cl = 1, Fl = 2, $g = 3, Eg = 4, Tg = 5, Dg = 6, iF = 7, aF = 8, nS = typeof self == "object" ? self : globalThis, S4 = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case rc:
      case rF:
        return r(s, a);
      case Cl: {
        const l = r([], a);
        for (const u of s)
          l.push(i(u));
        return l;
      }
      case Fl: {
        const l = r({}, a);
        for (const [u, p] of s)
          l[i(u)] = i(p);
        return l;
      }
      case $g:
        return r(new Date(s), a);
      case Eg: {
        const { source: l, flags: u } = s;
        return r(new RegExp(l, u), a);
      }
      case Tg: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [u, p] of s)
          l.set(i(u), i(p));
        return l;
      }
      case Dg: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const u of s)
          l.add(i(u));
        return l;
      }
      case iF: {
        const { name: l, message: u } = s;
        return r(new nS[l](u), a);
      }
      case aF:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new nS[o](s), a);
  };
  return i;
}, tS = (e) => S4(/* @__PURE__ */ new Map(), e)(0), ca = "", { toString: N4 } = {}, { keys: j4 } = Object, uo = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [rc, n];
  const r = N4.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [Cl, ca];
    case "Object":
      return [Fl, ca];
    case "Date":
      return [$g, ca];
    case "RegExp":
      return [Eg, ca];
    case "Map":
      return [Tg, ca];
    case "Set":
      return [Dg, ca];
  }
  return r.includes("Array") ? [Cl, r] : r.includes("Error") ? [iF, r] : [Fl, r];
}, Fs = ([e, n]) => e === rc && (n === "function" || n === "symbol"), w4 = (e, n, r, i) => {
  const a = (s, l) => {
    const u = i.push(s) - 1;
    return r.set(l, u), u;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, u] = uo(s);
    switch (l) {
      case rc: {
        let d = s;
        switch (u) {
          case "bigint":
            l = aF, d = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            d = null;
            break;
          case "undefined":
            return a([rF], s);
        }
        return a([l, d], s);
      }
      case Cl: {
        if (u)
          return a([u, [...s]], s);
        const d = [], f = a([l, d], s);
        for (const h of s)
          d.push(o(h));
        return f;
      }
      case Fl: {
        if (u)
          switch (u) {
            case "BigInt":
              return a([u, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([u, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const d = [], f = a([l, d], s);
        for (const h of j4(s))
          (e || !Fs(uo(s[h]))) && d.push([o(h), o(s[h])]);
        return f;
      }
      case $g:
        return a([l, s.toISOString()], s);
      case Eg: {
        const { source: d, flags: f } = s;
        return a([l, { source: d, flags: f }], s);
      }
      case Tg: {
        const d = [], f = a([l, d], s);
        for (const [h, v] of s)
          (e || !(Fs(uo(h)) || Fs(uo(v)))) && d.push([o(h), o(v)]);
        return f;
      }
      case Dg: {
        const d = [], f = a([l, d], s);
        for (const h of s)
          (e || !Fs(uo(h))) && d.push(o(h));
        return f;
      }
    }
    const { message: p } = s;
    return a([l, { name: u, message: p }], s);
  };
  return o;
}, rS = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return w4(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, Il = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? tS(rS(e, n)) : structuredClone(e)
) : (e, n) => tS(rS(e, n));
function C4(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function F4(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function I4(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || C4, i = e.options.footnoteBackLabel || F4, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const p = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!p)
      continue;
    const d = e.all(p), f = String(p.identifier).toUpperCase(), h = Ba(f.toLowerCase());
    let v = 0;
    const I = [], w = e.footnoteCounts.get(f);
    for (; w !== void 0 && ++v <= w; ) {
      I.length > 0 && I.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(u, v);
      typeof y == "string" && (y = { type: "text", value: y }), I.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const j = d[d.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const y = j.children[j.children.length - 1];
      y && y.type === "text" ? y.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...I);
    } else
      d.push(...I);
    const _ = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(d, !0)
    };
    e.patch(p, _), l.push(_);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...Il(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const oF = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return D4;
    if (typeof e == "function")
      return ic(e);
    if (typeof e == "object")
      return Array.isArray(e) ? $4(e) : E4(e);
    if (typeof e == "string")
      return T4(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function $4(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = oF(e[r]);
  return ic(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function E4(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return ic(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function T4(e) {
  return ic(n);
  function n(r) {
    return r && r.type === e;
  }
}
function ic(e) {
  return n;
  function n(r, i, a) {
    return !!(O4(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function D4() {
  return !0;
}
function O4(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const sF = [], R4 = !0, iS = !1, P4 = "skip";
function A4(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = oF(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(u, p, d) {
    const f = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (u.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = sF, I, w, j;
      if ((!n || o(u, p, d[d.length - 1] || void 0)) && (v = L4(r(u, d)), v[0] === iS))
        return v;
      if ("children" in u && u.children) {
        const _ = (
          /** @type {UnistParent} */
          u
        );
        if (_.children && v[0] !== P4)
          for (w = (i ? _.children.length : -1) + s, j = d.concat(_); w > -1 && w < _.children.length; ) {
            const y = _.children[w];
            if (I = l(y, w, j)(), I[0] === iS)
              return I;
            w = typeof I[1] == "number" ? I[1] : w + s;
          }
      }
      return v;
    }
  }
}
function L4(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [R4, e] : e == null ? sF : [e];
}
function lF(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), A4(e, o, l, a);
  function l(u, p) {
    const d = p[p.length - 1], f = d ? d.children.indexOf(u) : void 0;
    return s(u, f, d);
  }
}
const cy = {}.hasOwnProperty, V4 = {};
function z4(e, n) {
  const r = n || V4, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...x4, ...r.handlers }, l = {
    all: p,
    applyData: M4,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: u,
    options: r,
    patch: U4,
    wrap: q4
  };
  return lF(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const f = d.type === "definition" ? i : a, h = String(d.identifier).toUpperCase();
      f.has(h) || f.set(h, d);
    }
  }), l;
  function u(d, f) {
    const h = d.type, v = l.handlers[h];
    if (cy.call(l.handlers, h) && v)
      return v(l, d, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in d) {
        const { children: w, ...j } = d, _ = Il(j);
        return _.children = l.all(d), _;
      }
      return Il(d);
    }
    return (l.options.unknownHandler || B4)(l, d, f);
  }
  function p(d) {
    const f = [];
    if ("children" in d) {
      const h = d.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const I = l.one(h[v], d);
        if (I) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(I) && I.type === "text" && (I.value = aS(I.value)), !Array.isArray(I) && I.type === "element")) {
            const w = I.children[0];
            w && w.type === "text" && (w.value = aS(w.value));
          }
          Array.isArray(I) ? f.push(...I) : f.push(I);
        }
      }
    }
    return f;
  }
}
function U4(e, n) {
  e.position && (n.position = x3(e));
}
function M4(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, Il(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function B4(e, n) {
  const r = n.data || {}, i = "value" in n && !(cy.call(r, "hProperties") || cy.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function q4(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function aS(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function oS(e, n) {
  const r = z4(e, n), i = r.one(e, void 0), a = I4(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function H4(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      oS(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      oS(r, { file: i, ...e || n })
    );
  };
}
function sS(e) {
  if (e)
    throw e;
}
var xm, lS;
function W4() {
  if (lS) return xm;
  lS = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(p) {
    return typeof Array.isArray == "function" ? Array.isArray(p) : n.call(p) === "[object Array]";
  }, o = function(p) {
    if (!p || n.call(p) !== "[object Object]")
      return !1;
    var d = e.call(p, "constructor"), f = p.constructor && p.constructor.prototype && e.call(p.constructor.prototype, "isPrototypeOf");
    if (p.constructor && !d && !f)
      return !1;
    var h;
    for (h in p)
      ;
    return typeof h > "u" || e.call(p, h);
  }, s = function(p, d) {
    r && d.name === "__proto__" ? r(p, d.name, {
      enumerable: !0,
      configurable: !0,
      value: d.newValue,
      writable: !0
    }) : p[d.name] = d.newValue;
  }, l = function(p, d) {
    if (d === "__proto__")
      if (e.call(p, d)) {
        if (i)
          return i(p, d).value;
      } else return;
    return p[d];
  };
  return xm = function u() {
    var p, d, f, h, v, I, w = arguments[0], j = 1, _ = arguments.length, y = !1;
    for (typeof w == "boolean" && (y = w, w = arguments[1] || {}, j = 2), (w == null || typeof w != "object" && typeof w != "function") && (w = {}); j < _; ++j)
      if (p = arguments[j], p != null)
        for (d in p)
          f = l(w, d), h = l(p, d), w !== h && (y && h && (o(h) || (v = a(h))) ? (v ? (v = !1, I = f && a(f) ? f : []) : I = f && o(f) ? f : {}, s(w, { name: d, newValue: u(y, I, h) })) : typeof h < "u" && s(w, { name: d, newValue: h }));
    return w;
  }, xm;
}
var K4 = W4();
const Sm = /* @__PURE__ */ Py(K4);
function uy(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function G4() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(u, ...p) {
      const d = e[++o];
      let f = -1;
      if (u) {
        s(u);
        return;
      }
      for (; ++f < a.length; )
        (p[f] === null || p[f] === void 0) && (p[f] = a[f]);
      a = p, d ? Y4(d, l)(...p) : s(null, ...p);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function Y4(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let u;
    l && s.push(a);
    try {
      u = e.apply(this, s);
    } catch (p) {
      const d = (
        /** @type {Error} */
        p
      );
      if (l && r)
        throw d;
      return a(d);
    }
    l || (u instanceof Promise ? u.then(o, a) : u instanceof Error ? a(u) : o(u));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Vr = { basename: Q4, dirname: J4, extname: X4, join: Z4, sep: "/" };
function Q4(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  ls(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function J4(e) {
  if (ls(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function X4(e) {
  ls(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function Z4(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    ls(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : eM(r);
}
function eM(e) {
  ls(e);
  const n = e.codePointAt(0) === 47;
  let r = nM(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function nM(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, u;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (u = r.lastIndexOf("/"), u !== r.length - 1) {
              u < 0 ? (r = "", i = 0) : (r = r.slice(0, u), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function ls(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const tM = { cwd: rM };
function rM() {
  return "/";
}
function dy(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function iM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!dy(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return aM(e);
}
function aM(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const Nm = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class cF {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? dy(n) ? r = { path: n } : typeof n == "string" || oM(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : tM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < Nm.length; ) {
      const o = Nm[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      Nm.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Vr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    wm(n, "basename"), jm(n, "basename"), this.path = Vr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Vr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    cS(this.basename, "dirname"), this.path = Vr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Vr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (jm(n, "extname"), cS(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Vr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    dy(n) && (n = iM(n)), wm(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Vr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    wm(n, "stem"), jm(n, "stem"), this.path = Vr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Yt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function jm(e, n) {
  if (e && e.includes(Vr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Vr.sep + "`"
    );
}
function wm(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function cS(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function oM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const sM = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), lM = {}.hasOwnProperty;
class Og extends sM {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = G4();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Og()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(Sm(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Im("data", this.frozen), this.namespace[n] = r, this) : lM.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Im("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = Is(n), i = this.parser || this.Parser;
    return Cm("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Cm("process", this.parser || this.Parser), Fm("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = Is(n), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(u, l, function(d, f, h) {
        if (d || !f || !h)
          return p(d);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), I = i.stringify(v, h);
        dM(I) ? h.value = I : h.result = I, p(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function p(d, f) {
        d || !f ? s(d) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Cm("processSync", this.parser || this.Parser), Fm("processSync", this.compiler || this.Compiler), this.process(n, a), dS("processSync", "process", r), i;
    function a(o, s) {
      r = !0, sS(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    uS(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const u = Is(r);
      a.run(n, u, p);
      function p(d, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        d ? l(d) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), dS("runSync", "run", i), a;
    function o(s, l) {
      sS(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = Is(r), a = this.compiler || this.Compiler;
    return Fm("stringify", a), uS(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Im("use", this.frozen), n != null) if (typeof n == "function")
      u(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(p) {
      if (typeof p == "function")
        u(p, []);
      else if (typeof p == "object")
        if (Array.isArray(p)) {
          const [d, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            p
          );
          u(d, f);
        } else
          s(p);
      else
        throw new TypeError("Expected usable value, not `" + p + "`");
    }
    function s(p) {
      if (!("plugins" in p) && !("settings" in p))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(p.plugins), p.settings && (a.settings = Sm(!0, a.settings, p.settings));
    }
    function l(p) {
      let d = -1;
      if (p != null) if (Array.isArray(p))
        for (; ++d < p.length; ) {
          const f = p[d];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + p + "`");
    }
    function u(p, d) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === p) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([p, ...d]);
      else if (d.length > 0) {
        let [v, ...I] = d;
        const w = i[h][1];
        uy(w) && uy(v) && (v = Sm(!0, w, v)), i[h] = [p, v, ...I];
      }
    }
  }
}
const cM = new Og().freeze();
function Cm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Fm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Im(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function uS(e) {
  if (!uy(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function dS(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Is(e) {
  return uM(e) ? e : new cF(e);
}
function uM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function dM(e) {
  return typeof e == "string" || mM(e);
}
function mM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const pM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", mS = [], pS = { allowDangerousHtml: !0 }, fM = /^(https?|ircs?|mailto|xmpp)$/i, hM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function yM(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || mS, u = e.remarkPlugins || mS, p = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...pS } : pS, d = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || gM, v = cM().use(QU).use(u).use(H4, p).use(l), I = new cF();
  typeof i == "string" && (I.value = i);
  for (const y of hM)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + pM + y.id, void 0);
  const w = v.parse(I);
  let j = v.runSync(w, I);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), lF(j, _), F3(j, {
    Fragment: We.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: We.jsx,
    jsxs: We.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function _(y, L, E) {
    if (y.type === "raw" && E && typeof L == "number")
      return d ? E.children.splice(L, 1) : E.children[L] = { type: "text", value: y.value }, L;
    if (y.type === "element") {
      let C;
      for (C in km)
        if (Object.hasOwn(km, C) && Object.hasOwn(y.properties, C)) {
          const F = y.properties[C], z = km[C];
          (z === null || z.includes(y.tagName)) && (y.properties[C] = h(String(F || ""), C, y));
        }
    }
    if (y.type === "element") {
      let C = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!C && r && typeof L == "number" && (C = !r(y, L, E)), C && E && typeof L == "number")
        return f && y.children ? E.children.splice(L, 1, ...y.children) : E.children.splice(L, 1), L;
    }
  }
}
function gM(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    fM.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var $m = { exports: {} }, mo = {}, fS;
function vM() {
  if (fS) return mo;
  fS = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return mo.Fragment = r, mo.jsx = s, mo.jsxs = s, mo;
}
var $s = {}, hS;
function kM() {
  return hS || (hS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    $s.Fragment = i, $s.jsx = Un, $s.jsxs = Kn;
  })()), $s;
}
var yS;
function bM() {
  return yS || (yS = 1, process.env.NODE_ENV === "production" ? $m.exports = vM() : $m.exports = kM()), $m.exports;
}
var oe = bM();
const _M = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, xM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, SM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, NM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, jM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, wM = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": _M,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": xM,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": SM,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": NM,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": jM
};
function cs(e) {
  return wM[e] ?? {};
}
const CM = cs(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), FM = cs(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Es = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), IM = "_issueAvatar_kc0sw_1", $M = "_issueField_kc0sw_9", EM = "_issueDescription_kc0sw_12", Ts = {
  issueAvatar: IM,
  issueField: $M,
  issueDescription: EM
}, uF = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(Es, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Ts.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          Dy,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(Es, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    P.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Ts.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(Es, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    P.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Ts.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(Es, { title: "Description", children: /* @__PURE__ */ oe.jsx(yM, { className: Ts.issueDescription, children: e.description }) })
] }), TM = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), DM = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), OM = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), RM = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), PM = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), dF = {
  0: TM,
  1: PM,
  2: RM,
  3: OM,
  4: DM
}, AM = (e) => e in dF, $l = ({ priority: e }) => AM(e) ? dF[e] : /* @__PURE__ */ oe.jsx(Yn, { "data-testid": "defaultPriorityTag", children: e }), LM = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), VM = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), zM = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), UM = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), MM = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), BM = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), my = {
  backlog: (e, n) => LM(e, n),
  unstarted: (e, n) => VM(e, n),
  started: (e, n) => zM(e, n),
  done: (e, n) => UM(e, n),
  canceled: (e, n) => MM(e, n),
  completed: (e, n) => BM(e, n)
}, qM = (e) => e in my, El = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => qM(e) ? my[e](n, r) : my.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), HM = "_wrapper_e0qj3_1", WM = "_resultTitle_e0qj3_21", KM = "_resultTooltipTitle_e0qj3_28", GM = "_resultLinkIcon_e0qj3_31", po = {
  wrapper: HM,
  resultTitle: WM,
  resultTooltipTitle: KM,
  resultLinkIcon: GM
}, YM = ({
  issue: e
}) => {
  const [n, r] = ue(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Ey(l$()), o = ft(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Je,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: po.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              El,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx($l, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Yn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            P.Heading,
            {
              variant: "heading-3",
              className: po.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(uF, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        vt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: po.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    El,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx($l, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", className: po.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  he,
                  {
                    className: po.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, QM = "_loader_13xpk_1", JM = "_dropdown_13xpk_8", XM = "_loadMore_13xpk_13", Em = {
  loader: QM,
  dropdown: JM,
  loadMore: XM
}, ZM = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = ue(), [a, o] = ue([]), [s, l] = ue(""), [u, p] = ue(!1), { useLazyQuery: d } = _n(), [f, { data: h, loading: v, networkStatus: I }] = d(
    CM,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Ji(
    () => {
      !v && s !== "" && I === dr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Xe(() => {
    v || o([]);
  }, [s]), Xe(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.searchIssues.edges.map(
        ({ node: E }) => E
      ), _ = a.filter(
        (E) => !n.find((C) => C.id === E.id)
      ), y = _.filter(
        (E) => !j.find(
          (C) => C.id === E.id
        )
      ), L = j.filter(
        (E) => !n.find((C) => C.id === E.id)
      );
      n.length > 0 ? o(
        u ? [...y, ...L] : L
      ) : h?.Linear?.searchIssues?.edges && o(
        u ? [..._, ...j] : j
      ), h.Linear.searchIssues.pageInfo.hasNextPage && p(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const w = () => {
    !v && s !== "" && I === dr.ready ? (p(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    _i,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: Em.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const _ = j.target.value;
          l(_);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ oe.jsx(YM, { issue: j }, j.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => w(),
            className: Em.loadMore,
            children: /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: Em.loader, children: /* @__PURE__ */ oe.jsx(vn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, eB = "_collapse_su0f9_1", nB = "_collapseHeader_su0f9_8", tB = "_collapseContent_su0f9_31", rB = "_url_su0f9_35", iB = "_externalLink_su0f9_51", aB = "_emptyState_su0f9_55", ki = {
  collapse: eB,
  collapseHeader: nB,
  collapseContent: tB,
  url: rB,
  externalLink: iB,
  emptyState: aB
}, oB = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (d, f) => ({ ...d, [f.id]: !1 }),
    {}
  ), [l, u] = ue(s), { track: p } = $n();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(vn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          P.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: ki.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Bt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: ki.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((d) => {
          const f = l[d.id];
          return /* @__PURE__ */ oe.jsxs(
            xr,
            {
              "data-testid": "collapseCard",
              onToggle: () => u({ ...l, [d.id]: !l[d.id] }),
              isOpen: f,
              className: ki.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(xr.Header, { className: ki.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Je, { content: /* @__PURE__ */ oe.jsx(b, { children: d.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        El,
                        {
                          type: d.state.type,
                          color: d.state.color,
                          name: d.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        P.ExternalLink,
                        {
                          className: ki.url,
                          href: d.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            d.identifier,
                            /* @__PURE__ */ oe.jsx(he, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Je, { content: /* @__PURE__ */ oe.jsx(b, { children: d.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx($l, { priority: d.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Yn, { children: d.state.name })
                  ] }),
                  d.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(xr.Content, { className: ki.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  d?.labels && d?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: d.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(Yn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(uF, { issue: d }),
                  /* @__PURE__ */ oe.jsx(
                    et,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(he, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(d.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    Bt,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
                      variant: "tertiary",
                      className: ki.externalLink,
                      onClick: () => {
                        p("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: d.id
                        });
                      },
                      navigate: () => window.open(d.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        d.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            d.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          et,
          {
            slotStart: /* @__PURE__ */ oe.jsx(he, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Bt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: ki.externalLink,
            onClick: () => {
              p("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, sB = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, mF = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => mF(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, lB = "_modalBody_iv3ua_1", cB = "_error_iv3ua_5", uB = "_dropdown_iv3ua_16", ua = {
  modalBody: lB,
  error: cB,
  dropdown: uB
}, dB = cs(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), mB = cs(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), pB = cs(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), fB = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: u } = _n(), { control: p, handleSubmit: d, reset: f } = St(), [h, v] = ue([]), [I, w] = ue(), [j, _] = ue([]), [y, L] = ue(), [E, C] = ue([]), [F, z] = ue(), [Q, Z] = ue([]), [te, G] = ue(), [B, R] = ue([]), [U, ee] = ue(), [Se, fe] = ue(!1), { useMutation: ye } = _n(), { track: ve } = $n(), [K, { loading: _e }] = ye(
    dB,
    {
      onError: () => {
        fe(!1), u({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ce) => {
        const qe = {
          identifier: Ce.Linear?.issueCreate?.issue?.identifier,
          url: Ce.Linear?.issueCreate?.issue?.url
        };
        Ce.Linear && Ce.Linear?.issueCreate?.issue?.id && (a(Ce.Linear?.issueCreate?.issue?.id), Be(qe), fe(!1), u({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ce.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ve("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Te,
    { data: J, loading: Ke, error: an }
  ] = l(mB, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const qe = Ce.Linear.teams.edges.map(
        ({ node: en }) => en
      );
      v(qe), Z(Ce.Linear.issuePriorityValues), s(`${SB}${Ce.Linear.organization.urlKey}`);
    }
  }), [we, { data: Me, loading: Re }] = l(pB, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const qe = Ce?.Linear?.team?.projects?.edges?.map(
        ({ node: se }) => se
      );
      _(qe);
      const en = Ce?.Linear?.team?.states?.edges?.map(
        ({ node: se }) => se
      );
      C(en);
      const ie = Ce?.Linear?.team?.templates?.edges?.map(
        ({ node: se }) => se
      );
      R(
        ie.filter(
          (se) => se.type === "issue"
        )
      );
    }
  }), Be = (Ce) => {
    r(!1), L(void 0), w(void 0), z(void 0), G(void 0), ee(void 0), Ce && (e(Ce), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Ae = (Ce) => {
    J && !Ke && (K({
      variables: {
        issueTitle: Ce.title,
        issueDescription: Ce?.description,
        teamId: Ce.team.id,
        projectId: Ce?.project?.id,
        statusId: Ce?.status?.id,
        priority: Ce?.priority?.priority
      }
    }), fe(!0));
  };
  Xe(() => {
    n && Te();
  }, [n]);
  const Ge = () => {
    ve("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    Et,
    {
      isOpen: n,
      onClose: () => {
        Ge(), Be();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          Tt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Ge(), Be();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Dt,
          {
            className: ua.modalBody,
            "data-testid": "createIssueModalBody",
            children: an ? /* @__PURE__ */ oe.jsx(Tn, { error: an }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: d(Ae), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(mt, { children: [
              /* @__PURE__ */ oe.jsx(pe, { span: 3, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: p,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ce, onChange: qe },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    rn,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: en?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        _i,
                        {
                          dropdownProps: { className: ua.dropdown },
                          placeholder: "Select Linear team",
                          className: dt({ [ua.error]: en }),
                          getItemTitleByValue: (ie) => ie?.name,
                          onChange: (ie) => {
                            L(void 0), z(void 0), G(void 0), ee(void 0), w(ie.selectedValues[0]), we({
                              variables: { teamId: ie.selectedValues[0].id }
                            }), qe(ie.selectedValues[0]);
                          },
                          value: I ? [Ce] : void 0,
                          children: h?.map((ie) => /* @__PURE__ */ oe.jsx(
                            vt.Item,
                            {
                              value: ie,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(P.Paragraph, { children: ie.name })
                            },
                            ie.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(pe, { span: 3, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: p,
                  name: "project",
                  render: ({ field: { value: Ce, onChange: qe } }) => {
                    const en = Re ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(rn, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      _i,
                      {
                        dropdownProps: { className: ua.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (ie) => ie?.name,
                        disabled: I === void 0,
                        placeholder: I ? "Select Linear project" : "Select a Team first",
                        onChange: (ie) => {
                          L(ie.selectedValues[0]), qe(ie.selectedValues[0]);
                        },
                        value: y ? [Ce] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Re && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(vn, { size: 24 })
                            }
                          ),
                          Me && !Re && j.map((ie) => /* @__PURE__ */ oe.jsx(
                            vt.Item,
                            {
                              value: ie,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(P.Paragraph, { children: ie.name })
                            },
                            ie.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(pe, { span: 6, children: /* @__PURE__ */ oe.jsx(rn, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                _i,
                {
                  clearable: !0,
                  dropdownProps: { className: ua.dropdown },
                  disabled: !I || Re,
                  placeholder: I ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ce) => Ce?.name,
                  onChange: (Ce) => {
                    if (Ce.selectedValues.length > 0) {
                      ee(Ce.selectedValues[0]);
                      const qe = JSON.parse(
                        Ce.selectedValues[0].templateData
                      ), en = Q.filter(
                        (Le) => Le.priority === qe.priority
                      );
                      G(
                        en ? en[0] : void 0
                      );
                      const ie = E.filter(
                        (Le) => Le.id === qe.stateId
                      );
                      z(
                        ie ? ie[0] : void 0
                      );
                      const se = j.filter(
                        (Le) => Le.id === qe.projectId
                      );
                      L(
                        se ? se[0] : void 0
                      );
                      const xe = qe.description;
                      f({
                        title: qe?.title,
                        priority: en[0],
                        status: ie[0],
                        project: se[0],
                        description: xe ? mF(xe, sB) : "",
                        team: I
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: I
                      }), L(void 0), G(void 0), z(void 0), ee(void 0);
                  },
                  value: U ? [U] : void 0,
                  children: B?.map((Ce) => /* @__PURE__ */ oe.jsx(
                    vt.Item,
                    {
                      value: Ce,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(P.Paragraph, { children: Ce.name })
                    },
                    Ce.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(pe, { span: 6, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: p,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ce, value: qe },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    ur,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: qe || "",
                        onChange: Ce
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(pe, { span: 3, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: p,
                  name: "status",
                  render: ({ field: { value: Ce, onChange: qe } }) => {
                    const en = Re ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(rn, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      _i,
                      {
                        dropdownProps: { className: ua.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (ie) => ie?.name,
                        disabled: I === void 0,
                        placeholder: I ? "Select Issue status" : "Select a Team first",
                        onChange: (ie) => {
                          z(ie.selectedValues[0]), qe(ie.selectedValues[0]);
                        },
                        value: F ? [Ce] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Re && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(vn, { size: 24 })
                            }
                          ),
                          Me && !Re && E.map((ie) => /* @__PURE__ */ oe.jsx(
                            vt.Item,
                            {
                              value: ie,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      El,
                                      {
                                        type: ie.type,
                                        color: ie.color,
                                        name: ie.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(P.Paragraph, { children: ie.name })
                                  ]
                                }
                              )
                            },
                            ie.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(pe, { span: 3, children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: p,
                  name: "priority",
                  render: ({ field: { value: Ce, onChange: qe } }) => {
                    const en = Ke ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(rn, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      _i,
                      {
                        clearable: !0,
                        getItemTitleByValue: (ie) => ie?.label,
                        disabled: I === void 0,
                        placeholder: I ? "Select Issue priority" : "Select a Team first",
                        onChange: (ie) => {
                          G(ie.selectedValues[0]), qe(ie.selectedValues[0]);
                        },
                        value: te ? [Ce] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Re && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(vn, { size: 24 })
                            }
                          ),
                          J && !Ke && Q.map((ie) => /* @__PURE__ */ oe.jsx(
                            vt.Item,
                            {
                              value: ie,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      $l,
                                      {
                                        priority: ie.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(P.Paragraph, { children: ie.label })
                                  ]
                                }
                              )
                            },
                            ie.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(pe, { children: /* @__PURE__ */ oe.jsx(
                zt,
                {
                  control: p,
                  name: "description",
                  render: ({
                    field: { onChange: Ce, value: qe },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    o$,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: qe || "",
                        onChange: Ce
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Ht,
          {
            confirmOnClick: d(Ae),
            confirmProps: {
              disabled: _e || !J,
              isLoading: Se || Ke || Re,
              loadingIndicator: /* @__PURE__ */ oe.jsx(vn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Ge(), Be();
            }
          }
        )
      ]
    }
  );
}, hB = "_modalWrapper_4kh9u_1", yB = "_copyButton_4kh9u_6", gB = "_copyWrapper_4kh9u_15", vB = "_copyField_4kh9u_24", kB = "_externalLink_4kh9u_47", bB = "_externalLinkIcon_4kh9u_52", _B = "_textWrapper_4kh9u_56", Ti = {
  modalWrapper: hB,
  copyButton: yB,
  copyWrapper: gB,
  copyField: vB,
  externalLink: kB,
  externalLinkIcon: bB,
  textWrapper: _B
}, xB = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  Et,
  {
    isOpen: !!n && e,
    className: Ti.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        Tt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(Dt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(P.Paragraph, { className: Ti.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                P.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: Ti.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(he, { name: "external-link", className: Ti.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(rn, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: Ti.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    _r,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: Ti.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    s$,
                    {
                      className: Ti.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        Ht,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), SB = "https://linear.app/", NB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = ue([]), [a, o] = ue([]), [s, l] = ue(!1), [u, p] = ue(!1), [d, f] = ue(!1), [h, v] = ue(), { useLazyQuery: I } = _n(), [w, j] = ue(""), _ = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: L } = $n(), {
    loading: E,
    data: C,
    error: F,
    store: z
  } = $y(e?.conversationId ?? null), [
    Q,
    {
      data: Z,
      loading: te,
      networkStatus: G,
      error: B
    }
  ] = I(FM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Xe(() => {
    !E && !F && C && C?.linear?.issues?.length > 0 ? (o(C.linear.issues), Q({
      variables: {
        linkedIssues: C.linear.issues
      }
    })) : !E && !F && (i([]), o([]));
  }, [C, E, F]), Xe(() => {
    Z && Z?.Linear && !te && G === dr.ready && Object.keys(Z).length > 0 && i(Z.Linear.issues?.edges?.map(({ node: fe }) => fe));
  }, [Z, te, G]);
  const R = (fe) => {
    fe && fe?.team?.organization?.urlKey && L("linear:link:issue:clicked", {
      linearInstanceUrl: w,
      linearIssueKey: fe.id
    });
    const ye = (ve) => ve.id === fe?.id;
    r.some((ve) => ve && ye(ve)) || (C && a.length === 0 && o([]), z({
      linear: {
        issues: [...a, fe.id]
      }
    }));
  }, U = (fe) => {
    const ye = C?.linear.issues.filter((ve) => ve !== fe) || [];
    L("linear:unlink:issue:clicked", {
      linearInstanceUrl: w,
      linearIssueKey: fe
    }), i(r.filter(({ id: ve }) => ve !== fe)), o(ye), z({
      linear: {
        issues: ye
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), z({
      linear: {
        issues: []
      }
    });
  }, Se = E || te || !C && !F || (C?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !E && !te && (B || F) ? /* @__PURE__ */ oe.jsx(Tn, { error: B || F }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      Et,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            Tt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(Dt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            Ht,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      fB,
      {
        isCreateIssueModalOpen: u,
        setIsCreateIssueModalOpen: (fe) => p(fe),
        setIsCreationSuccessfulModalOpen: (fe) => f(fe),
        addToLinkedIssueIds: (fe) => {
          z({
            linear: {
              issues: [...a, fe]
            }
          });
        },
        setCreatedIssue: (fe) => v(fe),
        organizationUrl: w,
        setOrganizationUrl: (fe) => j(fe)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      xB,
      {
        isCreationSuccessfulModalOpen: d,
        setIsCreationSuccessfulModalOpen: (fe) => f(fe),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          _ && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              et,
              {
                variant: "primary",
                onClick: () => {
                  L("linear:create:new:issue:clicked", {
                    linearInstanceUrl: w
                  }), p(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(ZM, { handleSelect: R, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      oB,
      {
        linkedIssues: r,
        isLoading: Se,
        handleUnlinkIssue: U,
        showUnlinkAllModal: (fe) => l(fe),
        showUnlinkAllButton: y,
        organizationUrl: w
      }
    )
  ] });
}, py = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Di = "LINEAR", jB = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, wB = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = St({
    mode: "onChange",
    defaultValues: jB
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: I
  } = si({
    integrationId: e,
    integrationType: Di,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: w,
    error: j,
    isWidgetUnknown: _,
    refetch: y,
    widgetConfiguration: L
  } = li({
    integrationId: e,
    fieldDefinitions: py,
    form: l,
    onMisconfigured: I
  }), { renderConditions: E, setRenderConditions: C, renderConditionsForSubmit: F } = ci({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), z = (Z) => di(Z, {
    fieldDefinitions: py,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: F
  }), Q = l.watch("name");
  return /* @__PURE__ */ oe.jsxs(
    ui,
    {
      form: l,
      integrationId: e,
      onValidSubmit: z,
      error: j ?? h,
      onRetry: j ? y : void 0,
      isLoading: f || w,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ oe.jsx(mi, { cause: v }),
        /* @__PURE__ */ oe.jsxs(mt, { children: [
          /* @__PURE__ */ oe.jsx(pe, { children: /* @__PURE__ */ oe.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ oe.jsx(
            An,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(pe, { span: 3, children: /* @__PURE__ */ oe.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ oe.jsx(pe, { span: 3 }),
          /* @__PURE__ */ oe.jsx(pe, { span: 3, children: /* @__PURE__ */ oe.jsx(rn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ oe.jsx(
            An,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(pe, { span: 3 }),
          /* @__PURE__ */ oe.jsx(pe, { span: 3, children: /* @__PURE__ */ oe.jsx(rn, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ oe.jsx(
            An,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(pe, { span: 3 }),
          !s && e && /* @__PURE__ */ oe.jsx(
            Da,
            {
              configuration: n,
              integrationId: e,
              integrationType: Di,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ oe.jsx(pe, { children: o({
            value: E,
            onChange: C,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ oe.jsx(
          pi,
          {
            integrationType: Di,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ oe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ oe.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Di,
                  " integration, all links between Dixa and ",
                  Di,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ oe.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  Di,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ oe.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Di,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Tm = { exports: {} }, fo = {}, gS;
function CB() {
  if (gS) return fo;
  gS = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return fo.Fragment = r, fo.jsx = s, fo.jsxs = s, fo;
}
var Ds = {}, vS;
function FB() {
  return vS || (vS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Ds.Fragment = i, Ds.jsx = Un, Ds.jsxs = Kn;
  })()), Ds;
}
var kS;
function IB() {
  return kS || (kS = 1, process.env.NODE_ENV === "production" ? Tm.exports = CB() : Tm.exports = FB()), Tm.exports;
}
var Ie = IB();
const $B = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, EB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, TB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, DB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, OB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, RB = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": $B,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": EB,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": TB,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": DB,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": OB
};
function ac(e) {
  return RB[e] ?? {};
}
const PB = ac(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), AB = ac(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), LB = ac(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), VB = ac(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Dm(e = !1, n) {
  const [r, i] = ue(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const zB = "_wrapper_27vny_1", UB = "_copyIcon_27vny_12", ho = {
  wrapper: zB,
  copyIcon: UB
}, MB = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Dm(), { isCopied: i, copy: a } = Dm(), { isCopied: o, copy: s } = Dm();
  if (!e)
    return null;
  const l = 14, {
    email: u,
    properties: p,
    metadata: d,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: I,
    referral_url: w
  } = e, j = f ? Qn(f).isSame(Date.now(), "day") : !1, { name: _, first_name: y, last_name: L } = p ?? {}, E = _ ?? (`${y} ${L}`.trim() || "A customer has no name"), C = d?.shopify_source_url ? d.shopify_source_url.startsWith("https://") ? d.shopify_source_url : `https://${d.shopify_source_url}` : "";
  return /* @__PURE__ */ Ie.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ie.jsxs(b, { className: ho.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ho.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Ie.jsx(P.Heading, { variant: "heading-2", children: E }),
          j && /* @__PURE__ */ Ie.jsx(P.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Ie.jsx(P.Paragraph, { variant: "4", color: "secondary", children: Qn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Ie.jsx(b, { gap: "200", children: /* @__PURE__ */ Ie.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Qn(I).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ie.jsx(he, { size: l, name: "mail" }),
        /* @__PURE__ */ Ie.jsx(P.ExternalLink, { href: `mailto:${u}`, children: u })
      ] }),
      /* @__PURE__ */ Ie.jsx(Je, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Ie.jsx(
        he,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: ho.copyIcon
        }
      ) })
    ] }),
    C && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ie.jsx(he, { size: l, name: "link" }),
        /* @__PURE__ */ Ie.jsx(Je, { content: "Shopify shop", children: /* @__PURE__ */ Ie.jsx(
          P.ExternalLink,
          {
            href: C,
            target: "_blank",
            rel: "noreferrer",
            children: C.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ie.jsx(Je, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Ie.jsx(
        he,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: ho.copyIcon
        }
      ) })
    ] }),
    w && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ie.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ Ie.jsx(Je, { content: "Referral link", children: /* @__PURE__ */ Ie.jsx(
          P.ExternalLink,
          {
            href: w,
            target: "_blank",
            rel: "noreferrer",
            children: w.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ie.jsx(Je, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Ie.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(w),
          className: ho.copyIcon
        }
      ) })
    ] })
  ] }) });
}, BB = "_list_1q5b5_5", qB = "_listItem_1q5b5_8", HB = "_listItemEdit_1q5b5_15", WB = "_notificationText_1q5b5_19", Ea = {
  list: BB,
  listItem: qB,
  listItemEdit: HB,
  notificationText: WB
}, KB = "_modalBody_1clhs_1", GB = {
  modalBody: KB
}, YB = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = $n(), [u, p] = ue(n), [d, f] = ue(""), [h, v] = ue(), [I, { loading: w }] = o(
    LB,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), G();
      }
    }
  ), [j, { loading: _ }] = o(VB), y = w || _, L = !!h, E = n === u ? "Change the value to update the points" : "", C = isNaN(u), F = C ? "Points can not be empty" : "", z = u > n && u - n > 1e6, Q = z ? "Points can not exceed 1,000,000" : "", Z = () => {
    if (!r) {
      v(["Merchant information is missing."]), u > n ? l("loyaltylion:add:points:failed") : u < n && l("loyaltylion:remove:points:failed");
      return;
    }
    u > n && I({
      variables: {
        input: {
          points: u - n,
          reason: d
        },
        merchantId: r
      }
    }).catch((B) => {
      const R = B?.networkError;
      (R ? R?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), u < n && j({
      variables: {
        input: {
          points: n - u,
          reason: d
        },
        merchantId: r
      }
    }).then((B) => {
      B.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : "errors" in B && (l("loyaltylion:remove:points:failed"), v(
        B.errors?.map((R) => R.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, te = () => {
    C && p(n), f(""), i();
  }, G = () => {
    a(), te();
  };
  return /* @__PURE__ */ Ie.jsxs(
    Et,
    {
      isOpen: e,
      onClose: te,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Ie.jsx(Tt, { title: "Change points", onClose: te }),
        /* @__PURE__ */ Ie.jsxs(Dt, { className: GB.modalBody, children: [
          /* @__PURE__ */ Ie.jsxs(mt, { children: [
            /* @__PURE__ */ Ie.jsx(pe, { span: 6, children: /* @__PURE__ */ Ie.jsx(
              ur,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Q || F,
                  warning: E
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (B) => p(B?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Ie.jsx(pe, { span: 6, children: /* @__PURE__ */ Ie.jsx(
              ur,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: d,
                  onChange: (B) => f(B?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && L && /* @__PURE__ */ Ie.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Ie.jsx(Qe, { children: h?.map((B, R) => /* @__PURE__ */ Ie.jsx(
            Qe.Item,
            {
              variant: "dense",
              title: B,
              contentLeft: /* @__PURE__ */ Ie.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            R
          )) }) })
        ] }),
        /* @__PURE__ */ Ie.jsx(
          Ht,
          {
            confirmName: "Save",
            confirmOnClick: () => Z(),
            confirmProps: {
              isLoading: y,
              disabled: C || z || n === u,
              loadingIndicator: /* @__PURE__ */ Ie.jsx(vn, { size: 16 })
            },
            cancelOnClick: te
          }
        )
      ]
    }
  );
}, QB = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Ie.jsx(Qe.Text, { variant: "dense", className: Ea.listItem, children: /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(he, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Ie.jsx(P.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Ie.jsx(Je, { content: "Edit points", children: /* @__PURE__ */ Ie.jsx(
        he,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Ea.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Ie.jsx(Bn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, JB = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = ue(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: u
  } = e, p = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: u ?? 0
    }
  ];
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx(P.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Ie.jsx(Qe, { className: Ea.list, children: p.map(({ id: d, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Ie.jsx(
      QB,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      d
    )) }),
    /* @__PURE__ */ Ie.jsx(
      YB,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, XB = "_reward_1wxia_1", ZB = {
  reward: XB
}, e5 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Ie.jsx(b, { gap: "100", flexDirection: "column", className: ZB.reward, children: /* @__PURE__ */ Ie.jsx(Je, { content: a ?? "No description", children: /* @__PURE__ */ Ie.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Ie.jsxs(Bn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Ie.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(he, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Ie.jsx(
        P.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, n5 = ({ customer: e }) => {
  const { useQuery: n } = _n(), [r, i] = ue(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(AB, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Xe(() => {
    if (l?.LoyaltyLion) {
      const u = l.LoyaltyLion?.getAvailableRewards?.rewards;
      u && i(u);
    }
  }, [l]), s) {
    const u = s.graphQLErrors;
    return Oa({ errors: u }) ? /* @__PURE__ */ Ie.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ea.notificationText,
        children: "No rewards found"
      }
    ) : Ww({ errors: u }) ? /* @__PURE__ */ Ie.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ea.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Ie.jsx(Tn, { error: s });
  }
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx(P.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ie.jsx(vn, {}) }) : /* @__PURE__ */ Ie.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((u) => /* @__PURE__ */ Ie.jsx(e5, { reward: u }, u.id)) })
  ] });
}, t5 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Ie.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ie.jsx(Yn, { children: /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(
        he,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Ie.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ie.jsx(Yn, { children: /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(he, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Ie.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ie.jsx(Je, { content: "Insights segment", children: /* @__PURE__ */ Ie.jsx(Yn, { children: /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx(he, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, r5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = _n(), { track: i } = $n(), [a, o] = ue(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: u,
    showPointsBalance: p,
    showAvailableRewards: d
  } = n, f = !l && !u && !p && !d, {
    loading: h,
    error: v,
    data: I,
    refetch: w
  } = r(PB, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Xe(() => {
    if (I && !h) {
      const j = (I?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [I, h]), s?.email ? v ? Oa({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Ie.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ea.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Ie.jsx(Tn, { error: v }) : h ? /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ie.jsx(vn, {}) }) : f ? /* @__PURE__ */ Ie.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Ie.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Ie.jsxs(Ie.Fragment, { children: [
        l && /* @__PURE__ */ Ie.jsx(MB, { customer: a }),
        u && /* @__PURE__ */ Ie.jsx(t5, { customer: a }),
        p && /* @__PURE__ */ Ie.jsx(
          JB,
          {
            customer: a,
            refetchCustomerData: w
          }
        ),
        d && /* @__PURE__ */ Ie.jsx(n5, { customer: a })
      ] }) : /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Ie.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, fy = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], bS = "LOYALTYLION", i5 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, a5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = St({
    mode: "onChange",
    defaultValues: i5
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = si({
    integrationId: e,
    integrationType: bS,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = li({
    integrationId: e,
    fieldDefinitions: fy,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: C } = ci({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => di(Q, {
    fieldDefinitions: fy,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ Ie.jsxs(
    ui,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Ie.jsx(mi, { cause: h }),
        /* @__PURE__ */ Ie.jsxs(mt, { children: [
          /* @__PURE__ */ Ie.jsx(pe, { children: /* @__PURE__ */ Ie.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ie.jsx(
            An,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3, children: /* @__PURE__ */ Ie.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3, children: /* @__PURE__ */ Ie.jsx(
            WI,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3, children: /* @__PURE__ */ Ie.jsx(rn, { label: "Show customer summary", children: /* @__PURE__ */ Ie.jsx(
            An,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3, children: /* @__PURE__ */ Ie.jsx(rn, { label: "Show tags", children: /* @__PURE__ */ Ie.jsx(
            An,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3, children: /* @__PURE__ */ Ie.jsx(rn, { label: "Show points balance", children: /* @__PURE__ */ Ie.jsx(
            An,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3, children: /* @__PURE__ */ Ie.jsx(rn, { label: "Show available rewards", children: /* @__PURE__ */ Ie.jsx(
            An,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(pe, { span: 3 }),
          a && L !== null && /* @__PURE__ */ Ie.jsx(pe, { children: a({
            value: L,
            onChange: E,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ Ie.jsx(
          pi,
          {
            integrationType: bS,
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Om = { exports: {} }, yo = {}, _S;
function o5() {
  if (_S) return yo;
  _S = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return yo.Fragment = r, yo.jsx = s, yo.jsxs = s, yo;
}
var Os = {}, xS;
function s5() {
  return xS || (xS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Os.Fragment = i, Os.jsx = Un, Os.jsxs = Kn;
  })()), Os;
}
var SS;
function l5() {
  return SS || (SS = 1, process.env.NODE_ENV === "production" ? Om.exports = o5() : Om.exports = s5()), Om.exports;
}
var hn = l5();
const c5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, u5 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": c5
};
function d5(e) {
  return u5[e] ?? {};
}
function NS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function m5(e) {
  if (Array.isArray(e)) return e;
}
function p5(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], u = !0, p = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(u = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); u = !0) ;
    } catch (d) {
      p = !0, a = d;
    } finally {
      try {
        if (!u && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (p) throw a;
      }
    }
    return l;
  }
}
function f5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h5(e, n) {
  return m5(e) || p5(e, n) || y5(e, n) || f5();
}
function y5(e, n) {
  if (e) {
    if (typeof e == "string") return NS(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? NS(e, n) : void 0;
  }
}
const pF = Object.entries, jS = Object.setPrototypeOf, g5 = Object.isFrozen, v5 = Object.getPrototypeOf, k5 = Object.getOwnPropertyDescriptor;
let Mt = Object.freeze, qt = Object.seal, va = Object.create, fF = typeof Reflect < "u" && Reflect, hy = fF.apply, yy = fF.construct;
Mt || (Mt = function(e) {
  return e;
});
qt || (qt = function(e) {
  return e;
});
hy || (hy = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
yy || (yy = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const go = jt(Array.prototype.forEach), b5 = jt(Array.prototype.lastIndexOf), wS = jt(Array.prototype.pop), da = jt(Array.prototype.push), _5 = jt(Array.prototype.splice), Si = Array.isArray, Oo = jt(String.prototype.toLowerCase), Rm = jt(String.prototype.toString), CS = jt(String.prototype.match), vo = jt(String.prototype.replace), FS = jt(String.prototype.indexOf), x5 = jt(String.prototype.trim), S5 = jt(Number.prototype.toString), N5 = jt(Boolean.prototype.toString), IS = typeof BigInt > "u" ? null : jt(BigInt.prototype.toString), $S = typeof Symbol > "u" ? null : jt(Symbol.prototype.toString), $t = jt(Object.prototype.hasOwnProperty), ko = jt(Object.prototype.toString), Rt = jt(RegExp.prototype.test), Oi = j5(TypeError);
function jt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return hy(e, n, i);
  };
}
function j5(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return yy(e, r);
  };
}
function Wn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Oo;
  if (jS && jS(e, null), !Si(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (g5(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function w5(e) {
  for (let n = 0; n < e.length; n++)
    $t(e, n) || (e[n] = null);
  return e;
}
function Jt(e) {
  const n = va(null);
  for (const i of pF(e)) {
    var r = h5(i, 2);
    const a = r[0], o = r[1];
    $t(e, a) && (Si(o) ? n[a] = w5(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Jt(o) : n[a] = o);
  }
  return n;
}
function C5(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return S5(e);
    case "boolean":
      return N5(e);
    case "bigint":
      return IS ? IS(e) : "0";
    case "symbol":
      return $S ? $S(e) : "Symbol()";
    case "undefined":
      return ko(e);
    case "function":
    case "object": {
      if (e === null)
        return ko(e);
      const n = e, r = Lr(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : ko(i);
      }
      return ko(e);
    }
    default:
      return ko(e);
  }
}
function Lr(e, n) {
  for (; e !== null; ) {
    const i = k5(e, n);
    if (i) {
      if (i.get)
        return jt(i.get);
      if (typeof i.value == "function")
        return jt(i.value);
    }
    e = v5(e);
  }
  function r() {
    return null;
  }
  return r;
}
function F5(e) {
  try {
    return Rt(e, ""), !0;
  } catch {
    return !1;
  }
}
const ES = Mt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Pm = Mt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Am = Mt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), I5 = Mt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Lm = Mt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), $5 = Mt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), TS = Mt(["#text"]), DS = Mt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Vm = Mt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), OS = Mt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Rs = Mt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), E5 = qt(/{{[\w\W]*|^[\w\W]*}}/g), T5 = qt(/<%[\w\W]*|^[\w\W]*%>/g), D5 = qt(/\${[\w\W]*/g), O5 = qt(/^data-[\-\w.\u00B7-\uFFFF]+$/), R5 = qt(/^aria-[\-\w]+$/), RS = qt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), P5 = qt(/^(?:\w+script|data):/i), A5 = qt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), L5 = qt(/^html$/i), V5 = qt(/^[a-z][.\w]*(-[.\w]+)+$/i), PS = qt(/<[/\w!]/g), z5 = qt(/<[/\w]/g), U5 = qt(/<\/no(script|embed|frames)/i), M5 = qt(/\/>/i), Ar = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, B5 = function() {
  return typeof window > "u" ? null : window;
}, q5 = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, AS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, bi = function(e, n, r, i) {
  return $t(e, n) && Si(e[n]) ? Wn(i.base ? Jt(i.base) : {}, e[n], i.transform) : r;
};
function hF() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : B5();
  const n = (X) => hF(X);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Ar.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, u = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const d = e.DOMParser, f = e.trustedTypes, h = l.prototype, v = Lr(h, "cloneNode"), I = Lr(h, "remove"), w = Lr(h, "nextSibling"), j = Lr(h, "childNodes"), _ = Lr(h, "parentNode"), y = Lr(h, "shadowRoot"), L = Lr(h, "attributes"), E = s && s.prototype ? Lr(s.prototype, "nodeType") : null, C = s && s.prototype ? Lr(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const X = r.createElement("template");
    X.content && X.content.ownerDocument && (r = X.content.ownerDocument);
  }
  let F, z = "", Q, Z = !1, te = 0;
  const G = function() {
    if (te > 0)
      throw Oi('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, B = function(X) {
    G(), te++;
    try {
      return F.createHTML(X);
    } finally {
      te--;
    }
  }, R = function(X) {
    G(), te++;
    try {
      return F.createScriptURL(X);
    } finally {
      te--;
    }
  }, U = function() {
    return Z || (Q = q5(f, a), Z = !0), Q;
  }, ee = r, Se = ee.implementation, fe = ee.createNodeIterator, ye = ee.createDocumentFragment, ve = ee.getElementsByTagName, K = i.importNode;
  let _e = AS();
  n.isSupported = typeof pF == "function" && typeof _ == "function" && Se && Se.createHTMLDocument !== void 0;
  const Te = E5, J = T5, Ke = D5, an = O5, we = R5, Me = P5, Re = A5, Be = V5;
  let Ae = RS, Ge = null;
  const Ce = Wn({}, [...ES, ...Pm, ...Am, ...Lm, ...TS]);
  let qe = null;
  const en = Wn({}, [...DS, ...Vm, ...OS, ...Rs]);
  let ie = Object.seal(va(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), se = null, xe = null;
  const Le = Object.seal(va(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Pe = !0, yn = !0, T = !1, x = !0, D = !1, H = !0, Y = !1, A = !1, M = null, ae = null, ge = !1, Ne = !1, tn = !1, gn = !1, nn = !0, dn = !1;
  const wn = "user-content-";
  let xn = !0, Cn = !1, Ze = {}, kn = null;
  const ze = Wn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let mn = null;
  const pn = Wn({}, ["audio", "video", "img", "source", "image", "track"]);
  let jn = null;
  const qn = Wn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Nn = "http://www.w3.org/1998/Math/MathML", Pn = "http://www.w3.org/2000/svg", bn = "http://www.w3.org/1999/xhtml";
  let Sn = bn, Ln = !1, Vn = null;
  const In = Wn({}, [Nn, Pn, bn], Rm), Fn = Mt(["mi", "mo", "mn", "ms", "mtext"]);
  let zn = Wn({}, Fn);
  const Hn = Mt(["annotation-xml"]);
  let Un = Wn({}, Hn);
  const Kn = Wn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const c = ["application/xhtml+xml", "text/html"], m = "text/html";
  let g = null, $ = null;
  const O = r.createElement("form"), N = function(X) {
    return X instanceof RegExp || X instanceof Function;
  }, S = function() {
    let X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if ($ && $ === X)
      return;
    (!X || typeof X != "object") && (X = {}), X = Jt(X), t = // eslint-disable-next-line unicorn/prefer-includes
    c.indexOf(X.PARSER_MEDIA_TYPE) === -1 ? m : X.PARSER_MEDIA_TYPE, g = t === "application/xhtml+xml" ? Rm : Oo, Ge = bi(X, "ALLOWED_TAGS", Ce, {
      transform: g
    }), qe = bi(X, "ALLOWED_ATTR", en, {
      transform: g
    }), Vn = bi(X, "ALLOWED_NAMESPACES", In, {
      transform: Rm
    }), jn = bi(X, "ADD_URI_SAFE_ATTR", qn, {
      transform: g,
      base: qn
    }), mn = bi(X, "ADD_DATA_URI_TAGS", pn, {
      transform: g,
      base: pn
    }), kn = bi(X, "FORBID_CONTENTS", ze, {
      transform: g
    }), se = bi(X, "FORBID_TAGS", Jt({}), {
      transform: g
    }), xe = bi(X, "FORBID_ATTR", Jt({}), {
      transform: g
    }), Ze = $t(X, "USE_PROFILES") ? X.USE_PROFILES && typeof X.USE_PROFILES == "object" ? Jt(X.USE_PROFILES) : X.USE_PROFILES : !1, Pe = X.ALLOW_ARIA_ATTR !== !1, yn = X.ALLOW_DATA_ATTR !== !1, T = X.ALLOW_UNKNOWN_PROTOCOLS || !1, x = X.ALLOW_SELF_CLOSE_IN_ATTR !== !1, D = X.SAFE_FOR_TEMPLATES || !1, H = X.SAFE_FOR_XML !== !1, Y = X.WHOLE_DOCUMENT || !1, Ne = X.RETURN_DOM || !1, tn = X.RETURN_DOM_FRAGMENT || !1, gn = X.RETURN_TRUSTED_TYPE || !1, ge = X.FORCE_BODY || !1, nn = X.SANITIZE_DOM !== !1, dn = X.SANITIZE_NAMED_PROPS || !1, xn = X.KEEP_CONTENT !== !1, Cn = X.IN_PLACE || !1, Ae = F5(X.ALLOWED_URI_REGEXP) ? X.ALLOWED_URI_REGEXP : RS, Sn = typeof X.NAMESPACE == "string" ? X.NAMESPACE : bn, zn = $t(X, "MATHML_TEXT_INTEGRATION_POINTS") && X.MATHML_TEXT_INTEGRATION_POINTS && typeof X.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Jt(X.MATHML_TEXT_INTEGRATION_POINTS) : Wn({}, Fn), Un = $t(X, "HTML_INTEGRATION_POINTS") && X.HTML_INTEGRATION_POINTS && typeof X.HTML_INTEGRATION_POINTS == "object" ? Jt(X.HTML_INTEGRATION_POINTS) : Wn({}, Hn);
    const $e = $t(X, "CUSTOM_ELEMENT_HANDLING") && X.CUSTOM_ELEMENT_HANDLING && typeof X.CUSTOM_ELEMENT_HANDLING == "object" ? Jt(X.CUSTOM_ELEMENT_HANDLING) : va(null);
    if (ie = va(null), $t($e, "tagNameCheck") && N($e.tagNameCheck) && (ie.tagNameCheck = $e.tagNameCheck), $t($e, "attributeNameCheck") && N($e.attributeNameCheck) && (ie.attributeNameCheck = $e.attributeNameCheck), $t($e, "allowCustomizedBuiltInElements") && typeof $e.allowCustomizedBuiltInElements == "boolean" && (ie.allowCustomizedBuiltInElements = $e.allowCustomizedBuiltInElements), qt(ie), D && (yn = !1), tn && (Ne = !0), Ze && (Ge = Wn({}, TS), qe = va(null), Ze.html === !0 && (Wn(Ge, ES), Wn(qe, DS)), Ze.svg === !0 && (Wn(Ge, Pm), Wn(qe, Vm), Wn(qe, Rs)), Ze.svgFilters === !0 && (Wn(Ge, Am), Wn(qe, Vm), Wn(qe, Rs)), Ze.mathMl === !0 && (Wn(Ge, Lm), Wn(qe, OS), Wn(qe, Rs))), Le.tagCheck = null, Le.attributeCheck = null, $t(X, "ADD_TAGS") && (typeof X.ADD_TAGS == "function" ? Le.tagCheck = X.ADD_TAGS : Si(X.ADD_TAGS) && (Ge === Ce && (Ge = Jt(Ge)), Wn(Ge, X.ADD_TAGS, g))), $t(X, "ADD_ATTR") && (typeof X.ADD_ATTR == "function" ? Le.attributeCheck = X.ADD_ATTR : Si(X.ADD_ATTR) && (qe === en && (qe = Jt(qe)), Wn(qe, X.ADD_ATTR, g))), $t(X, "ADD_URI_SAFE_ATTR") && Si(X.ADD_URI_SAFE_ATTR) && Wn(jn, X.ADD_URI_SAFE_ATTR, g), $t(X, "FORBID_CONTENTS") && Si(X.FORBID_CONTENTS) && (kn === ze && (kn = Jt(kn)), Wn(kn, X.FORBID_CONTENTS, g)), $t(X, "ADD_FORBID_CONTENTS") && Si(X.ADD_FORBID_CONTENTS) && (kn === ze && (kn = Jt(kn)), Wn(kn, X.ADD_FORBID_CONTENTS, g)), xn && (Ge["#text"] = !0), Y && Wn(Ge, ["html", "head", "body"]), Ge.table && (Wn(Ge, ["tbody"]), delete se.tbody), X.TRUSTED_TYPES_POLICY) {
      if (typeof X.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Oi('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof X.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Oi('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const He = F;
      F = X.TRUSTED_TYPES_POLICY;
      try {
        z = B("");
      } catch (un) {
        throw F = He, un;
      }
    } else X.TRUSTED_TYPES_POLICY === null ? (F = void 0, z = "") : (F === void 0 && (F = U()), F && typeof z == "string" && (z = B("")));
    Mt && Mt(X), $ = X;
  }, ne = Wn({}, [...Pm, ...Am, ...I5]), q = Wn({}, [...Lm, ...$5]), W = function(X, $e, He) {
    return $e.namespaceURI === bn ? X === "svg" : $e.namespaceURI === Nn ? X === "svg" && (He === "annotation-xml" || zn[He]) : !!ne[X];
  }, le = function(X, $e, He) {
    return $e.namespaceURI === bn ? X === "math" : $e.namespaceURI === Pn ? X === "math" && Un[He] : !!q[X];
  }, Ue = function(X, $e, He) {
    return $e.namespaceURI === Pn && !Un[He] || $e.namespaceURI === Nn && !zn[He] ? !1 : !q[X] && (Kn[X] || !ne[X]);
  }, De = function(X) {
    let $e = _(X);
    (!$e || !$e.tagName) && ($e = {
      namespaceURI: Sn,
      tagName: "template"
    });
    const He = Oo(X.tagName), un = Oo($e.tagName);
    return Vn[X.namespaceURI] ? X.namespaceURI === Pn ? W(He, $e, un) : X.namespaceURI === Nn ? le(He, $e, un) : X.namespaceURI === bn ? Ue(He, $e, un) : !!(t === "application/xhtml+xml" && Vn[X.namespaceURI]) : !1;
  }, re = function(X) {
    da(n.removed, {
      element: X
    });
    try {
      _(X).removeChild(X);
    } catch {
      if (I(X), !_(X))
        throw Oi("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, fn = function(X) {
    const $e = j(X);
    if ($e) {
      const un = [];
      go($e, (Rn) => {
        da(un, Rn);
      }), go(un, (Rn) => {
        try {
          I(Rn);
        } catch {
        }
      });
    }
    const He = L(X);
    if (He)
      for (let un = He.length - 1; un >= 0; --un) {
        const Rn = He[un], nt = Rn && Rn.name;
        if (typeof nt == "string")
          try {
            X.removeAttribute(nt);
          } catch {
          }
      }
  }, On = function(X, $e) {
    try {
      da(n.removed, {
        attribute: $e.getAttributeNode(X),
        from: $e
      });
    } catch {
      da(n.removed, {
        attribute: null,
        from: $e
      });
    }
    if ($e.removeAttribute(X), X === "is")
      if (Ne || tn)
        try {
          re($e);
        } catch {
        }
      else
        try {
          $e.setAttribute(X, "");
        } catch {
        }
  }, Gn = function(X) {
    const $e = L(X);
    if ($e)
      for (let He = $e.length - 1; He >= 0; --He) {
        const un = $e[He], Rn = un && un.name;
        if (!(typeof Rn != "string" || qe[g(Rn)]))
          try {
            X.removeAttribute(Rn);
          } catch {
          }
      }
  }, FI = function(X) {
    const $e = [X];
    for (; $e.length > 0; ) {
      const He = $e.pop();
      (E ? E(He) : He.nodeType) === Ar.element && Gn(He);
      const un = j(He);
      if (un)
        for (let Rn = un.length - 1; Rn >= 0; --Rn)
          $e.push(un[Rn]);
    }
  }, yv = function(X) {
    let $e = null, He = null;
    if (ge)
      X = "<remove></remove>" + X;
    else {
      const nt = CS(X, /^[\r\n\t ]+/);
      He = nt && nt[0];
    }
    t === "application/xhtml+xml" && Sn === bn && (X = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + X + "</body></html>");
    const un = F ? B(X) : X;
    if (Sn === bn)
      try {
        $e = new d().parseFromString(un, t);
      } catch {
      }
    if (!$e || !$e.documentElement) {
      $e = Se.createDocument(Sn, "template", null);
      try {
        $e.documentElement.innerHTML = Ln ? z : un;
      } catch {
      }
    }
    const Rn = $e.body || $e.documentElement;
    return X && He && Rn.insertBefore(r.createTextNode(He), Rn.childNodes[0] || null), Sn === bn ? ve.call($e, Y ? "html" : "body")[0] : Y ? $e.documentElement : Rn;
  }, gv = function(X) {
    return fe.call(
      X.ownerDocument || X,
      X,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, fs = function(X) {
    return X = vo(X, Te, " "), X = vo(X, J, " "), X = vo(X, Ke, " "), X;
  }, hc = function(X) {
    var $e;
    X.normalize();
    const He = fe.call(
      X.ownerDocument || X,
      X,
      // eslint-disable-next-line no-bitwise
      u.SHOW_TEXT | u.SHOW_COMMENT | u.SHOW_CDATA_SECTION | u.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let un = He.nextNode();
    for (; un; )
      un.data = fs(un.data), un = He.nextNode();
    const Rn = ($e = X.querySelectorAll) === null || $e === void 0 ? void 0 : $e.call(X, "template");
    Rn && go(Rn, (nt) => {
      ia(nt.content) && hc(nt.content);
    });
  }, hs = function(X) {
    const $e = C ? C(X) : null;
    return typeof $e != "string" || g($e) !== "form" ? !1 : typeof X.nodeName != "string" || typeof X.textContent != "string" || typeof X.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    X.attributes !== L(X) || typeof X.removeAttribute != "function" || typeof X.setAttribute != "function" || typeof X.namespaceURI != "string" || typeof X.insertBefore != "function" || typeof X.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    X.nodeType !== E(X) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    X.childNodes !== j(X);
  }, ia = function(X) {
    if (!E || typeof X != "object" || X === null)
      return !1;
    try {
      return E(X) === Ar.documentFragment;
    } catch {
      return !1;
    }
  }, Ka = function(X) {
    if (!E || typeof X != "object" || X === null)
      return !1;
    try {
      return typeof E(X) == "number";
    } catch {
      return !1;
    }
  };
  function Jr(X, $e, He) {
    X.length !== 0 && go(X, (un) => {
      un.call(n, $e, He, $);
    });
  }
  const II = function(X, $e) {
    return !!(H && X.hasChildNodes() && !Ka(X.firstElementChild) && Rt(PS, X.textContent) && Rt(PS, X.innerHTML) || H && X.namespaceURI === bn && $e === "style" && Ka(X.firstElementChild) || X.nodeType === Ar.processingInstruction || H && X.nodeType === Ar.comment && Rt(z5, X.data));
  }, $I = function(X, $e) {
    if (!se[$e] && bv($e) && (ie.tagNameCheck instanceof RegExp && Rt(ie.tagNameCheck, $e) || ie.tagNameCheck instanceof Function && ie.tagNameCheck($e)))
      return !1;
    if (xn && !kn[$e]) {
      const He = _(X), un = j(X);
      if (un && He) {
        const Rn = un.length;
        for (let nt = Rn - 1; nt >= 0; --nt) {
          const rt = Cn ? un[nt] : v(un[nt], !0);
          He.insertBefore(rt, w(X));
        }
      }
    }
    return re(X), !0;
  }, vv = function(X) {
    if (Jr(_e.beforeSanitizeElements, X, null), hs(X))
      return re(X), !0;
    const $e = g(C ? C(X) : X.nodeName);
    if (Jr(_e.uponSanitizeElement, X, {
      tagName: $e,
      allowedTags: Ge
    }), II(X, $e))
      return re(X), !0;
    if (se[$e] || !(Le.tagCheck instanceof Function && Le.tagCheck($e)) && !Ge[$e])
      return $I(X, $e);
    if ((E ? E(X) : X.nodeType) === Ar.element && !De(X) || ($e === "noscript" || $e === "noembed" || $e === "noframes") && Rt(U5, X.innerHTML))
      return re(X), !0;
    if (D && X.nodeType === Ar.text) {
      const He = fs(X.textContent);
      X.textContent !== He && (da(n.removed, {
        element: X.cloneNode()
      }), X.textContent = He);
    }
    return Jr(_e.afterSanitizeElements, X, null), !1;
  }, kv = function(X, $e, He) {
    if (xe[$e] || nn && ($e === "id" || $e === "name") && (He in r || He in O))
      return !1;
    const un = qe[$e] || Le.attributeCheck instanceof Function && Le.attributeCheck($e, X);
    if (!(yn && Rt(an, $e)) && !(Pe && Rt(we, $e))) {
      if (un) {
        if (!jn[$e] && !Rt(Ae, vo(He, Re, "")) && !(($e === "src" || $e === "xlink:href" || $e === "href") && X !== "script" && FS(He, "data:") === 0 && mn[X]) && !(T && !Rt(Me, vo(He, Re, ""))) && He)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(bv(X) && (ie.tagNameCheck instanceof RegExp && Rt(ie.tagNameCheck, X) || ie.tagNameCheck instanceof Function && ie.tagNameCheck(X)) && (ie.attributeNameCheck instanceof RegExp && Rt(ie.attributeNameCheck, $e) || ie.attributeNameCheck instanceof Function && ie.attributeNameCheck($e, X)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        $e === "is" && ie.allowCustomizedBuiltInElements && (ie.tagNameCheck instanceof RegExp && Rt(ie.tagNameCheck, He) || ie.tagNameCheck instanceof Function && ie.tagNameCheck(He)))
      ) return !1;
    }
    return !0;
  }, EI = Wn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), bv = function(X) {
    return !EI[Oo(X)] && Rt(Be, X);
  }, TI = function(X, $e, He, un) {
    if (F && typeof f == "object" && typeof f.getAttributeType == "function" && !He)
      switch (f.getAttributeType(X, $e)) {
        case "TrustedHTML":
          return B(un);
        case "TrustedScriptURL":
          return R(un);
      }
    return un;
  }, DI = function(X, $e, He, un) {
    try {
      He ? X.setAttributeNS(He, $e, un) : X.setAttribute($e, un), hs(X) ? re(X) : wS(n.removed);
    } catch {
      On($e, X);
    }
  }, _v = function(X) {
    Jr(_e.beforeSanitizeAttributes, X, null);
    const $e = X.attributes;
    if (!$e || hs(X))
      return;
    const He = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: qe,
      forceKeepAttr: void 0
    };
    let un = $e.length;
    const Rn = g(X.nodeName);
    for (; un--; ) {
      const nt = $e[un], rt = nt.name, Ii = nt.namespaceURI, yi = nt.value, ar = g(rt), gi = yi;
      let Qt = rt === "value" ? gi : x5(gi);
      if (He.attrName = ar, He.attrValue = Qt, He.keepAttr = !0, He.forceKeepAttr = void 0, Jr(_e.uponSanitizeAttribute, X, He), Qt = He.attrValue, dn && (ar === "id" || ar === "name") && FS(Qt, wn) !== 0 && (On(rt, X), Qt = wn + Qt), H && Rt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Qt)) {
        On(rt, X);
        continue;
      }
      if (ar === "attributename" && CS(Qt, "href")) {
        On(rt, X);
        continue;
      }
      if (!He.forceKeepAttr) {
        if (!He.keepAttr) {
          On(rt, X);
          continue;
        }
        if (!x && Rt(M5, Qt)) {
          On(rt, X);
          continue;
        }
        if (D && (Qt = fs(Qt)), !kv(Rn, ar, Qt)) {
          On(rt, X);
          continue;
        }
        Qt = TI(Rn, ar, Ii, Qt), Qt !== gi && DI(X, rt, Ii, Qt);
      }
    }
    Jr(_e.afterSanitizeAttributes, X, null);
  }, ys = function(X) {
    let $e = null;
    const He = gv(X);
    for (Jr(_e.beforeSanitizeShadowDOM, X, null); $e = He.nextNode(); )
      if (Jr(_e.uponSanitizeShadowNode, $e, null), vv($e), _v($e), ia($e.content) && ys($e.content), (E ? E($e) : $e.nodeType) === Ar.element) {
        const un = y($e);
        ia(un) && (yc(un), ys(un));
      }
    Jr(_e.afterSanitizeShadowDOM, X, null);
  }, yc = function(X) {
    const $e = [{
      node: X,
      shadow: null
    }];
    for (; $e.length > 0; ) {
      const He = $e.pop();
      if (He.shadow) {
        ys(He.shadow);
        continue;
      }
      const un = He.node, Rn = (E ? E(un) : un.nodeType) === Ar.element, nt = j(un);
      if (nt)
        for (let rt = nt.length - 1; rt >= 0; --rt)
          $e.push({
            node: nt[rt],
            shadow: null
          });
      if (Rn) {
        const rt = C ? C(un) : null;
        if (typeof rt == "string" && g(rt) === "template") {
          const Ii = un.content;
          ia(Ii) && $e.push({
            node: Ii,
            shadow: null
          });
        }
      }
      if (Rn) {
        const rt = y(un);
        ia(rt) && $e.push({
          node: null,
          shadow: rt
        }, {
          node: rt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(X) {
    let $e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, He = null, un = null, Rn = null, nt = null;
    if (Ln = !X, Ln && (X = "<!-->"), typeof X != "string" && !Ka(X) && (X = C5(X), typeof X != "string"))
      throw Oi("dirty is not a string, aborting");
    if (!n.isSupported)
      return X;
    A ? (Ge = M, qe = ae) : S($e), (_e.uponSanitizeElement.length > 0 || _e.uponSanitizeAttribute.length > 0) && (Ge = Jt(Ge)), _e.uponSanitizeAttribute.length > 0 && (qe = Jt(qe)), n.removed = [];
    const rt = Cn && typeof X != "string" && Ka(X);
    if (rt) {
      const ar = C ? C(X) : X.nodeName;
      if (typeof ar == "string") {
        const gi = g(ar);
        if (!Ge[gi] || se[gi])
          throw Oi("root node is forbidden and cannot be sanitized in-place");
      }
      if (hs(X))
        throw Oi("root node is clobbered and cannot be sanitized in-place");
      try {
        yc(X);
      } catch (gi) {
        throw fn(X), gi;
      }
    } else if (Ka(X))
      He = yv("<!---->"), un = He.ownerDocument.importNode(X, !0), un.nodeType === Ar.element && un.nodeName === "BODY" || un.nodeName === "HTML" ? He = un : He.appendChild(un), yc(un);
    else {
      if (!Ne && !D && !Y && // eslint-disable-next-line unicorn/prefer-includes
      X.indexOf("<") === -1)
        return F && gn ? B(X) : X;
      if (He = yv(X), !He)
        return Ne ? null : gn ? z : "";
    }
    He && ge && re(He.firstChild);
    const Ii = gv(rt ? X : He);
    try {
      for (; Rn = Ii.nextNode(); )
        vv(Rn), _v(Rn), ia(Rn.content) && ys(Rn.content);
    } catch (ar) {
      throw rt && fn(X), ar;
    }
    if (rt)
      return go(n.removed, (ar) => {
        ar.element && FI(ar.element);
      }), D && hc(X), X;
    if (Ne) {
      if (D && hc(He), tn)
        for (nt = ye.call(He.ownerDocument); He.firstChild; )
          nt.appendChild(He.firstChild);
      else
        nt = He;
      return (qe.shadowroot || qe.shadowrootmode) && (nt = K.call(i, nt, !0)), nt;
    }
    let yi = Y ? He.outerHTML : He.innerHTML;
    return Y && Ge["!doctype"] && He.ownerDocument && He.ownerDocument.doctype && He.ownerDocument.doctype.name && Rt(L5, He.ownerDocument.doctype.name) && (yi = "<!DOCTYPE " + He.ownerDocument.doctype.name + `>
` + yi), D && (yi = fs(yi)), F && gn ? B(yi) : yi;
  }, n.setConfig = function() {
    let X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    S(X), A = !0, M = Ge, ae = qe;
  }, n.clearConfig = function() {
    $ = null, A = !1, M = null, ae = null, F = Q, z = "";
  }, n.isValidAttribute = function(X, $e, He) {
    $ || S({});
    const un = g(X), Rn = g($e);
    return kv(un, Rn, He);
  }, n.addHook = function(X, $e) {
    typeof $e == "function" && $t(_e, X) && da(_e[X], $e);
  }, n.removeHook = function(X, $e) {
    if ($t(_e, X)) {
      if ($e !== void 0) {
        const He = b5(_e[X], $e);
        return He === -1 ? void 0 : _5(_e[X], He, 1)[0];
      }
      return wS(_e[X]);
    }
  }, n.removeHooks = function(X) {
    $t(_e, X) && (_e[X] = []);
  }, n.removeAllHooks = function() {
    _e = AS();
  }, n;
}
var H5 = hF();
const W5 = "_messageContainer_1rxr4_1", K5 = "_chip_1rxr4_7", G5 = "_chipLabel_1rxr4_10", Y5 = "_chipValue_1rxr4_13", Ps = {
  messageContainer: W5,
  chip: K5,
  chipLabel: G5,
  chipValue: Y5
}, LS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, Q5 = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Xe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: u,
      email: p,
      phone_number: d
    } = i.customer;
    return s ?? l ?? u ?? p ?? d ?? o;
  };
  return /* @__PURE__ */ hn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ hn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ hn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ hn.jsx(Je, { content: "Conversation Attributes", children: /* @__PURE__ */ hn.jsx(
        Dy,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ hn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ hn.jsx(Yn, { className: Ps.chip, children: /* @__PURE__ */ hn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ hn.jsxs(ct, { className: Ps.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ hn.jsx(ct, { className: Ps.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ hn.jsx(
      b,
      {
        className: Ps.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? LS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? LS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ hn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ hn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ hn.jsx(P.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ hn.jsx(P.Paragraph, { variant: "4", children: /* @__PURE__ */ hn.jsx(c$, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ hn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: H5.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ hn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ hn.jsx(
      u$,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ hn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, J5 = "_conversation_1draa_1", X5 = "_conversationSubLine_1draa_9", Z5 = "_modal_1draa_14", zm = {
  conversation: J5,
  conversationSubLine: X5,
  modal: Z5
}, eq = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), nq = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), tq = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = ue(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ hn.jsxs(b, { className: zm.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ hn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ hn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ hn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ hn.jsx(P.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ hn.jsx(Bn, { size: "small", variant: "info", children: Qn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ hn.jsx(
          P.Heading,
          {
            variant: "heading-4",
            className: zm.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ hn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ hn.jsx(Yn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ hn.jsx(Je, { content: "Show conversation preview", children: /* @__PURE__ */ hn.jsx(
        mr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ hn.jsxs(
      Et,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: zm.modal,
        children: [
          /* @__PURE__ */ hn.jsx(
            Tt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ hn.jsx(Dt, { children: /* @__PURE__ */ hn.jsx(
            Q5,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: eq(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: nq(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, rq = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = ue(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Xn(
    () => e?.sort((u, p) => p?.created_at.localeCompare(u?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ hn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((u, p) => /* @__PURE__ */ hn.jsx(
      tq,
      {
        conversation: u,
        conversationContext: n
      },
      `${p}-${u?.id}`
    )),
    s && /* @__PURE__ */ hn.jsxs(
      et,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, iq = d5(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), aq = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = ue([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((d) => !!d).map((d) => `'${d}'`).join(","), { useQuery: s } = _n(), { data: l, loading: u, error: p } = s(iq, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Xe(() => {
    if (l?.Miuros) {
      const d = l?.Miuros?.findTickets?.data;
      d && i(d);
    }
  }, [l]), p ? /* @__PURE__ */ hn.jsx(Tn, { error: p }) : u ? /* @__PURE__ */ hn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ hn.jsx(vn, {}) }) : r?.length === 0 ? /* @__PURE__ */ hn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ hn.jsx(
    rq,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, gy = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], Um = "MIUROS", oq = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, sq = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = St({
    mode: "onChange",
    defaultValues: oq
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: I
  } = si({
    integrationId: e,
    integrationType: Um,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: w,
    error: j,
    isWidgetUnknown: _,
    refetch: y,
    widgetConfiguration: L
  } = li({
    integrationId: e,
    fieldDefinitions: gy,
    form: l,
    onMisconfigured: I
  }), { renderConditions: E, setRenderConditions: C, renderConditionsForSubmit: F } = ci({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), z = (Z) => di(Z, {
    fieldDefinitions: gy,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: F
  }), Q = l.watch("name");
  return /* @__PURE__ */ hn.jsxs(
    ui,
    {
      form: l,
      integrationId: e,
      onValidSubmit: z,
      error: j ?? h,
      onRetry: j ? y : void 0,
      isLoading: f || w,
      isWidgetUnknown: _,
      children: [
        v && /* @__PURE__ */ hn.jsx(mi, { cause: v }),
        /* @__PURE__ */ hn.jsxs(mt, { children: [
          /* @__PURE__ */ hn.jsx(pe, { children: /* @__PURE__ */ hn.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ hn.jsx(
            An,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ hn.jsx(pe, { span: 3, children: /* @__PURE__ */ hn.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ hn.jsx(pe, { span: 3 }),
          /* @__PURE__ */ hn.jsx(pe, { span: 3, children: /* @__PURE__ */ hn.jsx(
            tt,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ hn.jsx(pe, { span: 3 }),
          /* @__PURE__ */ hn.jsx(pe, { span: 3, children: /* @__PURE__ */ hn.jsx(
            Zo,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ hn.jsx(pe, { span: 3 }),
          /* @__PURE__ */ hn.jsx(pe, { span: 3, children: /* @__PURE__ */ hn.jsx(
            tt,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (Z) => !Number.isNaN(Number.parseInt(Z, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ hn.jsx(pe, { span: 3 }),
          !s && e && /* @__PURE__ */ hn.jsx(
            Da,
            {
              configuration: n,
              integrationId: e,
              integrationType: Um,
              label: "Authorize"
            }
          ),
          o && E !== null && /* @__PURE__ */ hn.jsx(pe, { children: o({
            value: E,
            onChange: C,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ hn.jsx(
          pi,
          {
            integrationType: Um,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Mm = { exports: {} }, bo = {}, VS;
function lq() {
  if (VS) return bo;
  VS = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return bo.Fragment = r, bo.jsx = s, bo.jsxs = s, bo;
}
var As = {}, zS;
function cq() {
  return zS || (zS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    As.Fragment = i, As.jsx = Un, As.jsxs = Kn;
  })()), As;
}
var US;
function uq() {
  return US || (US = 1, process.env.NODE_ENV === "production" ? Mm.exports = lq() : Mm.exports = cq()), Mm.exports;
}
var Fe = uq();
const dq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, mq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, pq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, fq = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": dq,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": mq,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": pq
};
function Rg(e) {
  return fq[e] ?? {};
}
const hq = Rg(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), yq = Rg(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), gq = Rg(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function vy(e = !1, n) {
  const [r, i] = ue(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const vq = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, yF = "DD MMM YYYY @ HH:mm", kq = "_list_2c4dq_1", bq = "_listItem_2c4dq_4", _q = "_copyIcon_2c4dq_12", Wi = {
  list: kq,
  listItem: bq,
  copyIcon: _q
}, ky = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = vy(), l = 14, {
    first_name: u,
    last_name: p,
    address1: d,
    address2: f,
    city: h,
    zip: v,
    country_code: I
  } = e ?? {}, w = `${u} ${p}`.trim() || void 0, j = `${h} ${v}`.trim() || void 0, _ = [w, d, f, j, I].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(he, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(vn, { size: l }) : /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: _.map((y, L) => /* @__PURE__ */ Fe.jsx(ct, { children: y }, L)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(Je, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: l,
          name: "exclamation",
          className: Wi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Je, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(_.join(", ")),
          className: Wi.copyIcon
        }
      ) })
    ] })
  ] });
}, xq = "_wrapper_1nher_1", Sq = {
  wrapper: xq
}, Nq = ({
  customer: e,
  store: n
}) => {
  const { track: r } = $n(), { isCopied: i, copy: a } = vy(), { isCopied: o, copy: s } = vy(), { useQuery: l } = _n(), u = e?.id, {
    loading: p,
    error: d,
    data: f
  } = l(yq, {
    skip: !u,
    variables: {
      customerId: u?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !p && h?.addresses?.[0] ? h.addresses[0] : void 0, I = (h?.addresses?.length ?? 0) > 1;
  if (Xe(() => {
    v && r("recharge:profile:received");
  }, [v, r]), d)
    return /* @__PURE__ */ Fe.jsx(Tn, { error: d });
  if (!e)
    return null;
  const {
    id: w,
    phone: j,
    email: _,
    first_name: y,
    last_name: L,
    created_at: E,
    has_valid_payment_method: C
  } = e, F = 14, z = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${w}` : null, Q = `${y || ""} ${L || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: Sq.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(P.Heading, { variant: "heading-2", children: Q }),
    E && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: Qn(E).format(yF) })
    ] }),
    _ && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: F, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(P.ExternalLink, { href: `mailto:${_}`, children: _ })
      ] }),
      /* @__PURE__ */ Fe.jsx(Je, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: F,
          name: i ? "done" : "copy",
          onClick: () => a(_),
          className: Wi.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: F, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ Fe.jsx(Je, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: F,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: Wi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      ky,
      {
        address: v,
        icon: "home",
        isLoading: p,
        hasMultipleAddresses: I
      }
    ),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: F, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: F,
          name: C ? "check-circle" : "close-circle-filled",
          color: C ? "green.500" : "red.500"
        }
      )
    ] }),
    z && /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(he, { size: F, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        P.ExternalLink,
        {
          href: z,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, jq = "_order_1dlaa_1", wq = "_orderIsOpen_1dlaa_9", Cq = "_orderHeader_1dlaa_12", Fq = "_note_1dlaa_16", Ls = {
  order: jq,
  orderIsOpen: wq,
  orderHeader: Cq,
  note: Fq
}, Iq = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = $n(), [a, o] = ue(n), {
    id: s,
    status: l,
    charge: u,
    currency: p,
    note: d,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: I,
    is_prepaid: w
  } = e, j = 14, _ = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = u?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    b,
    {
      className: dt(Ls.order, {
        [Ls.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ls.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Fe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: Qn(f).format(yF) }) }),
                /* @__PURE__ */ Fe.jsxs(P.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          d && /* @__PURE__ */ Fe.jsx(Je, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            P.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Ls.note,
              children: d
            }
          ) }),
          l && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(he, { size: j, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: vq(l) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(he, { size: j, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: w ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(he, { size: j, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(he, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(P.Paragraph, { variant: "4", children: [
                I,
                " ",
                p
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            ky,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            ky,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          _ && /* @__PURE__ */ Fe.jsx(
            Bt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Fe.jsx(he, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, $q = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = $n(), { useQuery: i } = _n(), {
    loading: a,
    error: o,
    data: s
  } = i(gq, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, u = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Fe.jsx(Tn, { error: o });
  const p = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(P.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Fe.jsx(Bn, { variant: "success", size: "small", children: u.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(vn, {}) }),
      !a && u.length === 0 && /* @__PURE__ */ Fe.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(P.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && u.length > 0 && /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: u.map((d, f) => /* @__PURE__ */ Fe.jsx(
        Iq,
        {
          order: d,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${d.id}`
      )) }),
      p && /* @__PURE__ */ Fe.jsx(
        Bt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(p, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Fe.jsx(he, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, Eq = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(P.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(Qe, { className: Wi.list, children: [
      /* @__PURE__ */ Fe.jsx(Qe.Text, { variant: "dense", className: Wi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(Qe.Text, { variant: "dense", className: Wi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(P.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, Tq = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = _n(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: u,
    error: p,
    data: d
  } = r(hq, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !u && d ? d?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !u && d ? d?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (p) {
    const v = p.graphQLErrors;
    return zl({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ul({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Fe.jsx(Tn, { error: p });
  }
  return u ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(vn, {}) }) : f ? l ? /* @__PURE__ */ Fe.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Fe.jsx(Nq, { customer: f, store: h }),
        o && /* @__PURE__ */ Fe.jsx(Eq, { customer: f }),
        s && /* @__PURE__ */ Fe.jsx($q, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, by = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Dq = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, Oq = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = St({
    mode: "onChange",
    defaultValues: Dq
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = si({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = li({
    integrationId: e,
    fieldDefinitions: by,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: C } = ci({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => di(Q, {
    fieldDefinitions: by,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ Fe.jsxs(
    ui,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Fe.jsx(mi, { cause: h }),
        /* @__PURE__ */ Fe.jsxs(mt, { children: [
          /* @__PURE__ */ Fe.jsx(pe, { children: /* @__PURE__ */ Fe.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Fe.jsx(
            An,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            Zo,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3, children: /* @__PURE__ */ Fe.jsx(rn, { label: "Displays details of a customer", children: /* @__PURE__ */ Fe.jsx(
            An,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3, children: /* @__PURE__ */ Fe.jsx(rn, { label: "Displays the subscription overview", children: /* @__PURE__ */ Fe.jsx(
            An,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3, children: /* @__PURE__ */ Fe.jsx(rn, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Fe.jsx(
            An,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(pe, { span: 3 }),
          a && L !== null && /* @__PURE__ */ Fe.jsx(pe, { children: a({
            value: L,
            onChange: E,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          pi,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_1lmjg_48{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1lmjg_53{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1lmjg_61{text-align:center}._inputSeparator_1lmjg_65{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1lmjg_70{color:var(--dixa-typography-color-link)}._noIssuesFound_1lmjg_74{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_1lmjg_79{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1lmjg_89{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1lmjg_89:last-child{box-shadow:none}._listItemHighlighted_1lmjg_97{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_1lmjg_100{cursor:pointer}._fullWidth_1lmjg_104{width:100%}._boxWrapper_1lmjg_108{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_1lmjg_114{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bm = { exports: {} }, _o = {}, MS;
function Rq() {
  if (MS) return _o;
  MS = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return _o.Fragment = r, _o.jsx = s, _o.jsxs = s, _o;
}
var Vs = {}, BS;
function Pq() {
  return BS || (BS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Vs.Fragment = i, Vs.jsx = Un, Vs.jsxs = Kn;
  })()), Vs;
}
var qS;
function Aq() {
  return qS || (qS = 1, process.env.NODE_ENV === "production" ? Bm.exports = Rq() : Bm.exports = Pq()), Bm.exports;
}
var ke = Aq(), gF = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(gF || {}), wa = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(wa || {});
const Lq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Vq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, zq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, Uq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, Mq = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": Lq,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': Vq,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": zq,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": Uq
};
function oc(e) {
  return Mq[e] ?? {};
}
const Bq = oc(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), qq = oc(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), Hq = oc(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), Wq = oc(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), Kq = "_list_1lmjg_79", Gq = "_listItem_1lmjg_89", Yq = "_listItemHighlighted_1lmjg_97", Qq = "_listItemEdit_1lmjg_100", Jq = "_clickableIcon_1lmjg_114", Fr = {
  list: Kq,
  listItem: Gq,
  listItemHighlighted: Yq,
  listItemEdit: Qq,
  clickableIcon: Jq
}, Pg = "rivoLoyaltyShopifyApiHostName", vF = "https://admin.shopify.com";
function kF(e) {
  return e.split(".")[0];
}
const Xq = "_wrapper_1xucg_1", HS = {
  wrapper: Xq
}, Zq = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = $n(), { isCopied: i, copy: a } = ir(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: u,
    verified_email: p
  } = o, d = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ ke.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ke.jsxs(b, { className: HS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(
      b,
      {
        justifyContent: "space-between",
        className: HS.block,
        alignItems: "center",
        children: /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-2", children: f })
      }
    ),
    u && /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ ke.jsx(he, { size: d, name: "mail" }),
        /* @__PURE__ */ ke.jsx(P.ExternalLink, { href: `mailto:${u}`, children: u }),
        /* @__PURE__ */ ke.jsx(
          Je,
          {
            content: p ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ ke.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ke.jsx(
              he,
              {
                size: d,
                color: p ? "green.500" : "red.500",
                name: p ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ ke.jsx(Je, { content: "Copy Email", children: /* @__PURE__ */ ke.jsx(
        he,
        {
          size: d,
          name: i ? "done" : "copy",
          onClick: () => a(u),
          className: Fr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ke.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(he, { size: d, name: "sign-in" }),
        /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ ke.jsx(
        he,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ ke.jsx(he, { size: d, name: "external-link" }),
      /* @__PURE__ */ ke.jsx(
        P.ExternalLink,
        {
          href: e6(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function e6(e, n) {
  const r = kF(e);
  return `${vF}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const n6 = "_list_rxh85_1", t6 = "_listItem_rxh85_6", WS = {
  list: n6,
  listItem: t6
}, r6 = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = _n(), {
    loading: i,
    error: a,
    data: o
  } = r(qq, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, u = () => a ? /* @__PURE__ */ ke.jsx(Tn, { error: a }) : i ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(vn, {}) }) : s.length === 0 ? /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ ke.jsx(Qe, { className: WS.list, children: s.map((p) => /* @__PURE__ */ ke.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: WS.listItem,
      children: [
        /* @__PURE__ */ ke.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ ke.jsx(
          P.ExternalLink,
          {
            href: i6(
              n,
              p.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: p.title
          }
        )
      ]
    },
    p.product_id
  )) });
  return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-3", children: "Favorite products" }),
    u()
  ] }) });
};
function i6(e, n) {
  const r = kF(e);
  return `${vF}/store/${r}/products/${n}`;
}
const a6 = "_modalBody_1clhs_1", o6 = {
  modalBody: a6
};
function s6(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function l6(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const c6 = gF, zs = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, u6 = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = $n(), [u, p] = ue(r), [d, f] = ue(""), [h, v] = ue(!0), [I, w] = ue(), j = {
    min: 0,
    max: 1e5
  }, [_, { loading: y }] = o(
    Wq,
    {
      onCompleted: () => {
        const te = u > r ? zs.addPoints : zs.removePoints;
        s({
          title: "Success",
          text: te.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(te.successEventName), Z();
      }
    }
  ), L = () => {
    p(r), f(""), v(!0), w(void 0);
  };
  Xe(() => {
    n && L();
  }, [n]);
  const E = !!I, C = s6(u, j), F = l6(r, u), z = () => {
    if (u !== r) {
      const te = u > r ? zs.addPoints : zs.removePoints, G = !h;
      _({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: u - r,
            // eslint-disable-next-line camelcase
            ...d && { internal_note: d },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: c6.Manual,
            // eslint-disable-next-line camelcase
            skip_email: G
          }
        }
      }).catch(() => {
        l(te.failEventName), w([te.failEventText]);
      });
    }
  }, Q = () => {
    L(), i();
  }, Z = () => {
    a(), Q();
  };
  return /* @__PURE__ */ ke.jsxs(
    Et,
    {
      isOpen: n,
      onClose: Q,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ ke.jsx(Tt, { title: "Change points", onClose: Q }),
        /* @__PURE__ */ ke.jsxs(Dt, { className: o6.modalBody, children: [
          /* @__PURE__ */ ke.jsxs(mt, { children: [
            /* @__PURE__ */ ke.jsx(pe, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ ke.jsx(
              ur,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: j.min,
                max: j.max,
                meta: {
                  error: C,
                  warning: F
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (te) => p(te?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ ke.jsx(pe, { span: 6, children: /* @__PURE__ */ ke.jsx(
              ur,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: d,
                  onChange: (te) => f(te?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ ke.jsx(pe, { span: 6, children: /* @__PURE__ */ ke.jsx(rn, { label: "Notify the customer by email", children: /* @__PURE__ */ ke.jsx(
              Oy,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => v(!h)
                }
              }
            ) }) })
          ] }),
          !y && E && /* @__PURE__ */ ke.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ ke.jsx(Qe, { children: I?.map((te, G) => /* @__PURE__ */ ke.jsx(
            Qe.Item,
            {
              variant: "dense",
              title: te,
              contentLeft: /* @__PURE__ */ ke.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            G
          )) }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          Ht,
          {
            confirmName: "Save",
            confirmOnClick: () => z(),
            confirmProps: {
              isLoading: y,
              loadingIndicator: /* @__PURE__ */ ke.jsx(vn, { size: 16 }),
              disabled: !!(C || F)
            },
            cancelOnClick: Q
          }
        )
      ]
    }
  );
}, ma = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = Gw(n);
  return /* @__PURE__ */ ke.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: dt(Fr.listItem, {
        [Fr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ ke.jsx(Je, { content: r, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: e }),
        a ? n : Gi(n)
      ] }) })
    }
  );
}, KS = {
  [wa.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [wa.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [wa.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, d6 = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? KS[i.loyalty_status] : KS[wa.Guest], o = a?.name === wa.Excluded, s = i.lifetime_earnings_tally, l = i.total_spent ?? 0, u = i.points_tally ?? 0, p = i.next_vip_tier, d = i.next_vip_tier?.to_spend_or_earn, f = p?.name ?? "None", [h, v] = ue(!1), I = 10, w = () => /* @__PURE__ */ ke.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: dt(Fr.listItem),
      children: /* @__PURE__ */ ke.jsx(Je, { content: a.tooltip, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ ke.jsx(Bn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), j = () => o ? w() : /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: dt(
          Fr.listItem,
          Fr.listItemHighlighted,
          {
            [Fr.listItemEdit]: n
          }
        ),
        onClick: () => n ? v(!0) : void 0,
        children: /* @__PURE__ */ ke.jsx(Je, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ ke.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ ke.jsx(
                  he,
                  {
                    name: "pen",
                    size: I,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: Gi(u) })
              ]
            }
          )
        ] }) })
      }
    ),
    d != null && f && /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: d
      }
    ),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s
      }
    ),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l
      }
    ),
    w(),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ ke.jsx(
      ma,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ ke.jsx(Qe, { className: Fr.list, children: j() })
    ] }),
    /* @__PURE__ */ ke.jsx(
      u6,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: u,
        onClose: () => v(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, m6 = ({
  ordersCount: e
}) => /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ ke.jsx(Qe, { className: Fr.list, children: /* @__PURE__ */ ke.jsx(Qe.Text, { variant: "dense", className: Fr.listItem, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), p6 = "_reward_1gmba_1", f6 = "_voucherCode_1gmba_14", GS = {
  reward: p6,
  voucherCode: f6
}, h6 = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = ir(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ ke.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", className: GS.reward, children: [
    /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ke.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ ke.jsxs(Bn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ ke.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ ke.jsx(he, { size: 14, name: "tag" }),
            /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", className: GS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ ke.jsx(Je, { content: "Copy reward code", children: /* @__PURE__ */ ke.jsx(
            he,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: Fr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, y6 = ({
  customer: e
}) => {
  const { useQuery: n } = _n(), {
    loading: r,
    error: i,
    data: a
  } = n(Hq, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => g6({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ ke.jsx(Tn, { error: i }) : r ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(vn, {}) }) : o.length > 0 ? /* @__PURE__ */ ke.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ ke.jsx(
    h6,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(P.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function g6(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const v6 = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, u = r[Pg].toString(), { useQuery: p } = _n(), { track: d } = $n(), [f, h] = ue(!1), v = n?.customer?.email, {
    loading: I,
    error: w,
    data: j,
    refetch: _
  } = p(Bq, {
    skip: !v,
    variables: {
      email: v
    }
  }), y = !I && j ? j.RivoLoyalty?.return_customer?.data : void 0;
  Xe(() => {
    !I && y && !f && (d("rivoloyalty:customer:received"), h(!0));
  }, [I, y]);
  const L = () => /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ke.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (w) {
    const E = w.graphQLErrors;
    return Oa({ errors: E }) ? L() : zl({ errors: E }) ? /* @__PURE__ */ ke.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ul({ errors: E }) ? /* @__PURE__ */ ke.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ke.jsx(Tn, { error: w });
  }
  return I ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(vn, {}) }) : !v || !y ? L() : /* @__PURE__ */ ke.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ ke.jsx(
          Zq,
          {
            customerDetails: y,
            rivoLoyaltyShopifyApiHostName: u
          }
        ),
        i && /* @__PURE__ */ ke.jsx(
          m6,
          {
            ordersCount: y.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ ke.jsx(
          d6,
          {
            customer: y,
            refetchCustomerData: _,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ ke.jsx(
          r6,
          {
            customerId: y.attributes.id,
            rivoLoyaltyShopifyApiHostName: u
          }
        ),
        l && /* @__PURE__ */ ke.jsx(y6, { customer: y })
      ]
    }
  );
};
var us = (e) => e.type === "checkbox", Ui = (e) => e instanceof Date, tr = (e) => e == null;
const bF = (e) => typeof e == "object";
var bt = (e) => !tr(e) && !Array.isArray(e) && bF(e) && !Ui(e), _F = (e) => bt(e) && e.target ? us(e.target) ? e.target.checked : e.target.value : e, k6 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, xF = (e, n) => e.has(k6(n)), b6 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return bt(n) && n.hasOwnProperty("isPrototypeOf");
}, Ag = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Lt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Ag && (e instanceof Blob || i)) && (r || bt(e)))
    if (n = r ? [] : {}, !r && !b6(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Lt(e[a]));
  else
    return e;
  return n;
}
var sc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], yt = (e) => e === void 0, sn = (e, n, r) => {
  if (!n || !bt(e))
    return r;
  const i = sc(n.split(/[,[\].]+?/)).reduce((a, o) => tr(a) ? a : a[o], e);
  return yt(i) || i === e ? yt(e[n]) ? r : e[n] : i;
}, hr = (e) => typeof e == "boolean", Lg = (e) => /^\w*$/.test(e), SF = (e) => sc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), at = (e, n, r) => {
  let i = -1;
  const a = Lg(n) ? [n] : SF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const p = e[l];
      u = bt(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const Tl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ir = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ti = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, _6 = Ee.createContext(null), Vg = () => Ee.useContext(_6);
var NF = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Ir.all && (n._proxyFormState[s] = !i || Ir.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function x6(e) {
  const n = Vg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ee.useState(r._formState), u = Ee.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = Ee.useRef(a);
  return p.current = a, Ee.useEffect(() => r._subscribe({
    name: p.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), Ee.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), Ee.useMemo(() => NF(s, r, u.current, !1), [s, r]);
}
var qr = (e) => typeof e == "string", jF = (e, n, r, i, a) => qr(e) ? (i && n.watch.add(e), sn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), sn(r, o))) : (i && (n.watchAll = !0), r);
function S6(e) {
  const n = Vg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ee.useRef(i), u = Ee.useRef(a);
  l.current = i, Ee.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(jF(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [p, d] = Ee.useState(r._getWatch(i, a));
  return Ee.useEffect(() => r._removeUnmounted()), p;
}
function N6(e) {
  const n = Vg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = xF(a._names.array, r), l = S6({
    control: a,
    name: r,
    defaultValue: sn(a._formValues, r, sn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = x6({
    control: a,
    name: r,
    exact: !0
  }), p = Ee.useRef(e), d = Ee.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...hr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ee.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!sn(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!sn(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!sn(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!sn(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => sn(u.errors, r)
    }
  }), [u, r]), h = Ee.useCallback((j) => d.current.onChange({
    target: {
      value: _F(j),
      name: r
    },
    type: Tl.CHANGE
  }), [r]), v = Ee.useCallback(() => d.current.onBlur({
    target: {
      value: sn(a._formValues, r),
      name: r
    },
    type: Tl.BLUR
  }), [r, a._formValues]), I = Ee.useCallback((j) => {
    const _ = sn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), w = Ee.useMemo(() => ({
    name: r,
    value: l,
    ...hr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: I
  }), [r, i, u.disabled, h, v, I, l]);
  return Ee.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...hr(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const _ = (y, L) => {
      const E = sn(a._fields, y);
      E && E._f && (E._f.mount = L);
    };
    if (_(r, !0), j) {
      const y = Lt(sn(a._options.defaultValues, r));
      at(a._defaultValues, r, y), yt(sn(a._formValues, r)) && at(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), Ee.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ee.useMemo(() => ({
    field: w,
    formState: u,
    fieldState: f
  }), [w, u, f]);
}
var j6 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Uo = (e) => Array.isArray(e) ? e : [e], YS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, _y = (e) => tr(e) || !bF(e);
function Ni(e, n) {
  if (_y(e) || _y(n))
    return e === n;
  if (Ui(e) && Ui(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ui(o) && Ui(s) || bt(o) && bt(s) || Array.isArray(o) && Array.isArray(s) ? !Ni(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Zt = (e) => bt(e) && !Object.keys(e).length, zg = (e) => e.type === "file", $r = (e) => typeof e == "function", Dl = (e) => {
  if (!Ag)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, wF = (e) => e.type === "select-multiple", Ug = (e) => e.type === "radio", w6 = (e) => Ug(e) || us(e), qm = (e) => Dl(e) && e.isConnected;
function C6(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = yt(e) ? i++ : e[n[i++]];
  return e;
}
function F6(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !yt(e[n]))
      return !1;
  return !0;
}
function Ct(e, n) {
  const r = Array.isArray(n) ? n : Lg(n) ? [n] : SF(n), i = r.length === 1 ? e : C6(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (bt(i) && Zt(i) || Array.isArray(i) && F6(i)) && Ct(e, r.slice(0, -1)), e;
}
var CF = (e) => {
  for (const n in e)
    if ($r(e[n]))
      return !0;
  return !1;
};
function Ol(e, n = {}) {
  const r = Array.isArray(e);
  if (bt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || bt(e[i]) && !CF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ol(e[i], n[i])) : tr(e[i]) || (n[i] = !0);
  return n;
}
function FF(e, n, r) {
  const i = Array.isArray(e);
  if (bt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || bt(e[a]) && !CF(e[a]) ? yt(n) || _y(r[a]) ? r[a] = Array.isArray(e[a]) ? Ol(e[a], []) : { ...Ol(e[a]) } : FF(e[a], tr(n) ? {} : n[a], r[a]) : r[a] = !Ni(e[a], n[a]);
  return r;
}
var xo = (e, n) => FF(e, n, Ol(n));
const QS = {
  value: !1,
  isValid: !1
}, JS = { value: !0, isValid: !0 };
var IF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !yt(e[0].attributes.value) ? yt(e[0].value) || e[0].value === "" ? JS : { value: e[0].value, isValid: !0 } : JS
    ) : QS;
  }
  return QS;
}, $F = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => yt(e) ? e : n ? e === "" ? NaN : e && +e : r && qr(e) ? new Date(e) : i ? i(e) : e;
const XS = {
  isValid: !1,
  value: null
};
var EF = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, XS) : XS;
function ZS(e) {
  const n = e.ref;
  return zg(n) ? n.files : Ug(n) ? EF(e.refs).value : wF(n) ? [...n.selectedOptions].map(({ value: r }) => r) : us(n) ? IF(e.refs).value : $F(yt(n.value) ? e.ref.value : n.value, e);
}
var I6 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = sn(n, o);
    s && at(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Rl = (e) => e instanceof RegExp, So = (e) => yt(e) ? e : Rl(e) ? e.source : bt(e) ? Rl(e.value) ? e.value.source : e.value : e, e0 = (e) => ({
  isOnSubmit: !e || e === Ir.onSubmit,
  isOnBlur: e === Ir.onBlur,
  isOnChange: e === Ir.onChange,
  isOnAll: e === Ir.all,
  isOnTouch: e === Ir.onTouched
});
const n0 = "AsyncFunction";
var $6 = (e) => !!e && !!e.validate && !!($r(e.validate) && e.validate.constructor.name === n0 || bt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === n0)), E6 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), t0 = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Mo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = sn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Mo(l, n))
          break;
      } else if (bt(l) && Mo(l, n))
        break;
    }
  }
};
function r0(e, n, r) {
  const i = sn(e, r);
  if (i || Lg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = sn(n, o), l = sn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var T6 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Zt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Ir.all));
}, D6 = (e, n, r) => !e || !n || e === n || Uo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), O6 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, R6 = (e, n) => !sc(sn(e, n)).length && Ct(e, n), P6 = (e, n, r) => {
  const i = Uo(sn(e, r));
  return at(i, "root", n[r]), at(e, r, i), e;
}, ll = (e) => qr(e);
function i0(e, n, r = "validate") {
  if (ll(e) || Array.isArray(e) && e.every(ll) || hr(e) && !e)
    return {
      type: r,
      message: ll(e) ? e : "",
      ref: n
    };
}
var pa = (e) => bt(e) && !Rl(e) ? e : {
  value: e,
  message: ""
}, a0 = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: p, minLength: d, min: f, max: h, pattern: v, validate: I, name: w, valueAsNumber: j, mount: _ } = e._f, y = sn(r, w);
  if (!_ || n.has(w))
    return {};
  const L = l ? l[0] : s, E = (B) => {
    a && L.reportValidity && (L.setCustomValidity(hr(B) ? "" : B || ""), L.reportValidity());
  }, C = {}, F = Ug(s), z = us(s), Q = F || z, Z = (j || zg(s)) && yt(s.value) && yt(y) || Dl(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, te = j6.bind(null, w, i, C), G = (B, R, U, ee = ti.maxLength, Se = ti.minLength) => {
    const fe = B ? R : U;
    C[w] = {
      type: B ? ee : Se,
      message: fe,
      ref: s,
      ...te(B ? ee : Se, fe)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Q && (Z || tr(y)) || hr(y) && !y || z && !IF(l).isValid || F && !EF(l).isValid)) {
    const { value: B, message: R } = ll(u) ? { value: !!u, message: u } : pa(u);
    if (B && (C[w] = {
      type: ti.required,
      message: R,
      ref: L,
      ...te(ti.required, R)
    }, !i))
      return E(R), C;
  }
  if (!Z && (!tr(f) || !tr(h))) {
    let B, R;
    const U = pa(h), ee = pa(f);
    if (!tr(y) && !isNaN(y)) {
      const Se = s.valueAsNumber || y && +y;
      tr(U.value) || (B = Se > U.value), tr(ee.value) || (R = Se < ee.value);
    } else {
      const Se = s.valueAsDate || new Date(y), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), ye = s.type == "time", ve = s.type == "week";
      qr(U.value) && y && (B = ye ? fe(y) > fe(U.value) : ve ? y > U.value : Se > new Date(U.value)), qr(ee.value) && y && (R = ye ? fe(y) < fe(ee.value) : ve ? y < ee.value : Se < new Date(ee.value));
    }
    if ((B || R) && (G(!!B, U.message, ee.message, ti.max, ti.min), !i))
      return E(C[w].message), C;
  }
  if ((p || d) && !Z && (qr(y) || o && Array.isArray(y))) {
    const B = pa(p), R = pa(d), U = !tr(B.value) && y.length > +B.value, ee = !tr(R.value) && y.length < +R.value;
    if ((U || ee) && (G(U, B.message, R.message), !i))
      return E(C[w].message), C;
  }
  if (v && !Z && qr(y)) {
    const { value: B, message: R } = pa(v);
    if (Rl(B) && !y.match(B) && (C[w] = {
      type: ti.pattern,
      message: R,
      ref: s,
      ...te(ti.pattern, R)
    }, !i))
      return E(R), C;
  }
  if (I) {
    if ($r(I)) {
      const B = await I(y, r), R = i0(B, L);
      if (R && (C[w] = {
        ...R,
        ...te(ti.validate, R.message)
      }, !i))
        return E(R.message), C;
    } else if (bt(I)) {
      let B = {};
      for (const R in I) {
        if (!Zt(B) && !i)
          break;
        const U = i0(await I[R](y, r), L, R);
        U && (B = {
          ...U,
          ...te(R, U.message)
        }, E(U.message), i && (C[w] = B));
      }
      if (!Zt(B) && (C[w] = {
        ref: L,
        ...B
      }, !i))
        return C;
    }
  }
  return E(!0), C;
};
const A6 = {
  mode: Ir.onSubmit,
  reValidateMode: Ir.onChange,
  shouldFocusError: !0
};
function L6(e = {}) {
  let n = {
    ...A6,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: $r(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = bt(n.defaultValues) || bt(n.values) ? Lt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Lt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, p = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: YS(),
    state: YS()
  }, v = e0(n.mode), I = e0(n.reValidateMode), w = n.criteriaMode === Ir.all, j = (T) => (x) => {
    clearTimeout(p), p = setTimeout(T, x);
  }, _ = async (T) => {
    if (!n.disabled && (d.isValid || f.isValid || T)) {
      const x = n.resolver ? Zt((await Z()).errors) : await G(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (T, x) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((T || Array.from(l.mount)).forEach((D) => {
      D && (x ? at(r.validatingFields, D, x) : Ct(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Zt(r.validatingFields)
    }));
  }, L = (T, x = [], D, H, Y = !0, A = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, A && Array.isArray(sn(i, T))) {
        const M = D(sn(i, T), H.argA, H.argB);
        Y && at(i, T, M);
      }
      if (A && Array.isArray(sn(r.errors, T))) {
        const M = D(sn(r.errors, T), H.argA, H.argB);
        Y && at(r.errors, T, M), R6(r.errors, T);
      }
      if ((d.touchedFields || f.touchedFields) && A && Array.isArray(sn(r.touchedFields, T))) {
        const M = D(sn(r.touchedFields, T), H.argA, H.argB);
        Y && at(r.touchedFields, T, M);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = xo(a, o)), h.state.next({
        name: T,
        isDirty: R(T, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      at(o, T, x);
  }, E = (T, x) => {
    at(r.errors, T, x), h.state.next({
      errors: r.errors
    });
  }, C = (T) => {
    r.errors = T, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (T, x, D, H) => {
    const Y = sn(i, T);
    if (Y) {
      const A = sn(o, T, yt(D) ? sn(a, T) : D);
      yt(A) || H && H.defaultChecked || x ? at(o, T, x ? A : ZS(Y._f)) : Se(T, A), s.mount && _();
    }
  }, z = (T, x, D, H, Y) => {
    let A = !1, M = !1;
    const ae = {
      name: T
    };
    if (!n.disabled) {
      if (!D || H) {
        (d.isDirty || f.isDirty) && (M = r.isDirty, r.isDirty = ae.isDirty = R(), A = M !== ae.isDirty);
        const ge = Ni(sn(a, T), x);
        M = !!sn(r.dirtyFields, T), ge ? Ct(r.dirtyFields, T) : at(r.dirtyFields, T, !0), ae.dirtyFields = r.dirtyFields, A = A || (d.dirtyFields || f.dirtyFields) && M !== !ge;
      }
      if (D) {
        const ge = sn(r.touchedFields, T);
        ge || (at(r.touchedFields, T, D), ae.touchedFields = r.touchedFields, A = A || (d.touchedFields || f.touchedFields) && ge !== D);
      }
      A && Y && h.state.next(ae);
    }
    return A ? ae : {};
  }, Q = (T, x, D, H) => {
    const Y = sn(r.errors, T), A = (d.isValid || f.isValid) && hr(x) && r.isValid !== x;
    if (n.delayError && D ? (u = j(() => E(T, D)), u(n.delayError)) : (clearTimeout(p), u = null, D ? at(r.errors, T, D) : Ct(r.errors, T)), (D ? !Ni(Y, D) : Y) || !Zt(H) || A) {
      const M = {
        ...H,
        ...A && hr(x) ? { isValid: x } : {},
        errors: r.errors,
        name: T
      };
      r = {
        ...r,
        ...M
      }, h.state.next(M);
    }
  }, Z = async (T) => {
    y(T, !0);
    const x = await n.resolver(o, n.context, I6(T || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(T), x;
  }, te = async (T) => {
    const { errors: x } = await Z(T);
    if (T)
      for (const D of T) {
        const H = sn(x, D);
        H ? at(r.errors, D, H) : Ct(r.errors, D);
      }
    else
      r.errors = x;
    return x;
  }, G = async (T, x, D = {
    valid: !0
  }) => {
    for (const H in T) {
      const Y = T[H];
      if (Y) {
        const { _f: A, ...M } = Y;
        if (A) {
          const ae = l.array.has(A.name), ge = Y._f && $6(Y._f);
          ge && d.validatingFields && y([H], !0);
          const Ne = await a0(Y, l.disabled, o, w, n.shouldUseNativeValidation && !x, ae);
          if (ge && d.validatingFields && y([H]), Ne[A.name] && (D.valid = !1, x))
            break;
          !x && (sn(Ne, A.name) ? ae ? P6(r.errors, Ne, A.name) : at(r.errors, A.name, Ne[A.name]) : Ct(r.errors, A.name));
        }
        !Zt(M) && await G(M, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const T of l.unMount) {
      const x = sn(i, T);
      x && (x._f.refs ? x._f.refs.every((D) => !qm(D)) : !qm(x._f.ref)) && Be(T);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (T, x) => !n.disabled && (T && x && at(o, T, x), !Ni(Te(), a)), U = (T, x, D) => jF(T, l, {
    ...s.mount ? o : yt(x) ? a : qr(T) ? { [T]: x } : x
  }, D, x), ee = (T) => sc(sn(s.mount ? o : a, T, n.shouldUnregister ? sn(a, T, []) : [])), Se = (T, x, D = {}) => {
    const H = sn(i, T);
    let Y = x;
    if (H) {
      const A = H._f;
      A && (!A.disabled && at(o, T, $F(x, A)), Y = Dl(A.ref) && tr(x) ? "" : x, wF(A.ref) ? [...A.ref.options].forEach((M) => M.selected = Y.includes(M.value)) : A.refs ? us(A.ref) ? A.refs.length > 1 ? A.refs.forEach((M) => (!M.defaultChecked || !M.disabled) && (M.checked = Array.isArray(Y) ? !!Y.find((ae) => ae === M.value) : Y === M.value)) : A.refs[0] && (A.refs[0].checked = !!Y) : A.refs.forEach((M) => M.checked = M.value === Y) : zg(A.ref) ? A.ref.value = "" : (A.ref.value = Y, A.ref.type || h.state.next({
        name: T,
        values: Lt(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && z(T, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && _e(T);
  }, fe = (T, x, D) => {
    for (const H in x) {
      const Y = x[H], A = `${T}.${H}`, M = sn(i, A);
      (l.array.has(T) || bt(Y) || M && !M._f) && !Ui(Y) ? fe(A, Y, D) : Se(A, Y, D);
    }
  }, ye = (T, x, D = {}) => {
    const H = sn(i, T), Y = l.array.has(T), A = Lt(x);
    at(o, T, A), Y ? (h.array.next({
      name: T,
      values: Lt(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: T,
      dirtyFields: xo(a, o),
      isDirty: R(T, A)
    })) : H && !H._f && !tr(A) ? fe(T, A, D) : Se(T, A, D), t0(T, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? T : void 0,
      values: Lt(o)
    });
  }, ve = async (T) => {
    s.mount = !0;
    const x = T.target;
    let D = x.name, H = !0;
    const Y = sn(i, D), A = (M) => {
      H = Number.isNaN(M) || Ui(M) && isNaN(M.getTime()) || Ni(M, sn(o, D, M));
    };
    if (Y) {
      let M, ae;
      const ge = x.type ? ZS(Y._f) : _F(T), Ne = T.type === Tl.BLUR || T.type === Tl.FOCUS_OUT, tn = !E6(Y._f) && !n.resolver && !sn(r.errors, D) && !Y._f.deps || O6(Ne, sn(r.touchedFields, D), r.isSubmitted, I, v), gn = t0(D, l, Ne);
      at(o, D, ge), Ne ? (Y._f.onBlur && Y._f.onBlur(T), u && u(0)) : Y._f.onChange && Y._f.onChange(T);
      const nn = z(D, ge, Ne), dn = !Zt(nn) || gn;
      if (!Ne && h.state.next({
        name: D,
        type: T.type,
        values: Lt(o)
      }), tn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && _() : Ne || _()), dn && h.state.next({ name: D, ...gn ? {} : nn });
      if (!Ne && gn && h.state.next({ ...r }), n.resolver) {
        const { errors: wn } = await Z([D]);
        if (A(ge), H) {
          const xn = r0(r.errors, i, D), Cn = r0(wn, i, xn.name || D);
          M = Cn.error, D = Cn.name, ae = Zt(wn);
        }
      } else
        y([D], !0), M = (await a0(Y, l.disabled, o, w, n.shouldUseNativeValidation))[D], y([D]), A(ge), H && (M ? ae = !1 : (d.isValid || f.isValid) && (ae = await G(i, !0)));
      H && (Y._f.deps && _e(Y._f.deps), Q(D, ae, M, nn));
    }
  }, K = (T, x) => {
    if (sn(r.errors, x) && T.focus)
      return T.focus(), 1;
  }, _e = async (T, x = {}) => {
    let D, H;
    const Y = Uo(T);
    if (n.resolver) {
      const A = await te(yt(T) ? T : Y);
      D = Zt(A), H = T ? !Y.some((M) => sn(A, M)) : D;
    } else T ? (H = (await Promise.all(Y.map(async (A) => {
      const M = sn(i, A);
      return await G(M && M._f ? { [A]: M } : M);
    }))).every(Boolean), !(!H && !r.isValid) && _()) : H = D = await G(i);
    return h.state.next({
      ...!qr(T) || (d.isValid || f.isValid) && D !== r.isValid ? {} : { name: T },
      ...n.resolver || !T ? { isValid: D } : {},
      errors: r.errors
    }), x.shouldFocus && !H && Mo(i, K, T ? Y : l.mount), H;
  }, Te = (T) => {
    const x = {
      ...s.mount ? o : a
    };
    return yt(T) ? x : qr(T) ? sn(x, T) : T.map((D) => sn(x, D));
  }, J = (T, x) => ({
    invalid: !!sn((x || r).errors, T),
    isDirty: !!sn((x || r).dirtyFields, T),
    error: sn((x || r).errors, T),
    isValidating: !!sn(r.validatingFields, T),
    isTouched: !!sn((x || r).touchedFields, T)
  }), Ke = (T) => {
    T && Uo(T).forEach((x) => Ct(r.errors, x)), h.state.next({
      errors: T ? r.errors : {}
    });
  }, an = (T, x, D) => {
    const H = (sn(i, T, { _f: {} })._f || {}).ref, Y = sn(r.errors, T) || {}, { ref: A, message: M, type: ae, ...ge } = Y;
    at(r.errors, T, {
      ...ge,
      ...x,
      ref: H
    }), h.state.next({
      name: T,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, we = (T, x) => $r(T) ? h.state.subscribe({
    next: (D) => T(U(void 0, x), D)
  }) : U(T, x, !0), Me = (T) => h.state.subscribe({
    next: (x) => {
      D6(T.name, x.name, T.exact) && T6(x, T.formState || d, Pe, T.reRenderRoot) && T.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, Re = (T) => (s.mount = !0, f = {
    ...f,
    ...T.formState
  }, Me({
    ...T,
    formState: f
  })), Be = (T, x = {}) => {
    for (const D of T ? Uo(T) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (Ct(i, D), Ct(o, D)), !x.keepError && Ct(r.errors, D), !x.keepDirty && Ct(r.dirtyFields, D), !x.keepTouched && Ct(r.touchedFields, D), !x.keepIsValidating && Ct(r.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && Ct(a, D);
    h.state.next({
      values: Lt(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: R() } : {}
    }), !x.keepIsValid && _();
  }, Ae = ({ disabled: T, name: x }) => {
    (hr(T) && s.mount || T || l.disabled.has(x)) && (T ? l.disabled.add(x) : l.disabled.delete(x));
  }, Ge = (T, x = {}) => {
    let D = sn(i, T);
    const H = hr(x.disabled) || hr(n.disabled);
    return at(i, T, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: T } },
        name: T,
        mount: !0,
        ...x
      }
    }), l.mount.add(T), D ? Ae({
      disabled: hr(x.disabled) ? x.disabled : n.disabled,
      name: T
    }) : F(T, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: So(x.min),
        max: So(x.max),
        minLength: So(x.minLength),
        maxLength: So(x.maxLength),
        pattern: So(x.pattern)
      } : {},
      name: T,
      onChange: ve,
      onBlur: ve,
      ref: (Y) => {
        if (Y) {
          Ge(T, x), D = sn(i, T);
          const A = yt(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, M = w6(A), ae = D._f.refs || [];
          if (M ? ae.find((ge) => ge === A) : A === D._f.ref)
            return;
          at(i, T, {
            _f: {
              ...D._f,
              ...M ? {
                refs: [
                  ...ae.filter(qm),
                  A,
                  ...Array.isArray(sn(a, T)) ? [{}] : []
                ],
                ref: { type: A.type, name: T }
              } : { ref: A }
            }
          }), F(T, !1, void 0, A);
        } else
          D = sn(i, T, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(xF(l.array, T) && s.action) && l.unMount.add(T);
      }
    };
  }, Ce = () => n.shouldFocusError && Mo(i, K, l.mount), qe = (T) => {
    hr(T) && (h.state.next({ disabled: T }), Mo(i, (x, D) => {
      const H = sn(i, D);
      H && (x.disabled = H._f.disabled || T, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || T;
      }));
    }, 0, !1));
  }, en = (T, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = Lt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: A, values: M } = await Z();
      r.errors = A, Y = M;
    } else
      await G(i);
    if (l.disabled.size)
      for (const A of l.disabled)
        at(Y, A, void 0);
    if (Ct(r.errors, "root"), Zt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await T(Y, D);
      } catch (A) {
        H = A;
      }
    } else
      x && await x({ ...r.errors }, D), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Zt(r.errors) && !H,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), H)
      throw H;
  }, ie = (T, x = {}) => {
    sn(i, T) && (yt(x.defaultValue) ? ye(T, Lt(sn(a, T))) : (ye(T, x.defaultValue), at(a, T, Lt(x.defaultValue))), x.keepTouched || Ct(r.touchedFields, T), x.keepDirty || (Ct(r.dirtyFields, T), r.isDirty = x.defaultValue ? R(T, Lt(sn(a, T))) : R()), x.keepError || (Ct(r.errors, T), d.isValid && _()), h.state.next({ ...r }));
  }, se = (T, x = {}) => {
    const D = T ? Lt(T) : a, H = Lt(D), Y = Zt(T), A = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const M = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(xo(a, o))
        ]);
        for (const ae of Array.from(M))
          sn(r.dirtyFields, ae) ? at(A, ae, sn(o, ae)) : ye(ae, sn(A, ae));
      } else {
        if (Ag && yt(T))
          for (const M of l.mount) {
            const ae = sn(i, M);
            if (ae && ae._f) {
              const ge = Array.isArray(ae._f.refs) ? ae._f.refs[0] : ae._f.ref;
              if (Dl(ge)) {
                const Ne = ge.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const M of l.mount)
          ye(M, sn(A, M));
      }
      o = Lt(A), h.array.next({
        values: { ...A }
      }), h.state.next({
        values: { ...A }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !Ni(T, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? xo(a, o) : r.dirtyFields : x.keepDefaultValues && T ? xo(a, T) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (T, x) => se($r(T) ? T(o) : T, x), Le = (T, x = {}) => {
    const D = sn(i, T), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && $r(Y.select) && Y.select());
    }
  }, Pe = (T) => {
    r = {
      ...r,
      ...T
    };
  }, yn = {
    control: {
      register: Ge,
      unregister: Be,
      getFieldState: J,
      handleSubmit: en,
      setError: an,
      _subscribe: Me,
      _runSchema: Z,
      _getWatch: U,
      _getDirty: R,
      _setValid: _,
      _setFieldArray: L,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: ee,
      _reset: se,
      _resetDefaultValues: () => $r(n.defaultValues) && n.defaultValues().then((T) => {
        xe(T, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(T) {
        s = T;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(T) {
        l = T;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(T) {
        n = {
          ...n,
          ...T
        };
      }
    },
    subscribe: Re,
    trigger: _e,
    register: Ge,
    handleSubmit: en,
    watch: we,
    setValue: ye,
    getValues: Te,
    reset: xe,
    resetField: ie,
    clearErrors: Ke,
    unregister: Be,
    setError: an,
    setFocus: Le,
    getFieldState: J
  };
  return {
    ...yn,
    formControl: yn
  };
}
function V6(e = {}) {
  const n = Ee.useRef(void 0), r = Ee.useRef(void 0), [i, a] = Ee.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: $r(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: $r(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : L6(e),
    formState: i
  }, e.formControl && e.defaultValues && !$r(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ee.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ee.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ee.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ee.useEffect(() => {
    e.values && !Ni(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ee.useEffect(() => {
    e.errors && !Zt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ee.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ee.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = NF(i, o), n.current;
}
var Us = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function TF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Hm = { exports: {} }, No = {}, o0;
function z6() {
  if (o0) return No;
  o0 = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return No.Fragment = r, No.jsx = s, No.jsxs = s, No;
}
var Ms = {}, s0;
function U6() {
  return s0 || (s0 = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Ms.Fragment = i, Ms.jsx = Un, Ms.jsxs = Kn;
  })()), Ms;
}
var l0;
function M6() {
  return l0 || (l0 = 1, process.env.NODE_ENV === "production" ? Hm.exports = z6() : Hm.exports = U6()), Hm.exports;
}
var Bo = M6();
function B6(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Wm, c0;
function Fi() {
  if (c0) return Wm;
  c0 = 1;
  var e = Array.isArray;
  return Wm = e, Wm;
}
var Km, u0;
function DF() {
  if (u0) return Km;
  u0 = 1;
  var e = typeof Us == "object" && Us && Us.Object === Object && Us;
  return Km = e, Km;
}
var Gm, d0;
function Qr() {
  if (d0) return Gm;
  d0 = 1;
  var e = DF(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Gm = r, Gm;
}
var Ym, m0;
function ds() {
  if (m0) return Ym;
  m0 = 1;
  var e = Qr(), n = e.Symbol;
  return Ym = n, Ym;
}
var Qm, p0;
function q6() {
  if (p0) return Qm;
  p0 = 1;
  var e = ds(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var p = !0;
    } catch {
    }
    var d = i.call(s);
    return p && (l ? s[a] = u : delete s[a]), d;
  }
  return Qm = o, Qm;
}
var Jm, f0;
function H6() {
  if (f0) return Jm;
  f0 = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Jm = r, Jm;
}
var Xm, h0;
function qa() {
  if (h0) return Xm;
  h0 = 1;
  var e = ds(), n = q6(), r = H6(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Xm = s, Xm;
}
var Zm, y0;
function ta() {
  if (y0) return Zm;
  y0 = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Zm = e, Zm;
}
var ep, g0;
function Mg() {
  if (g0) return ep;
  g0 = 1;
  var e = qa(), n = ta(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return ep = i, ep;
}
var np, v0;
function W6() {
  if (v0) return np;
  v0 = 1;
  var e = Fi(), n = Mg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return np = a, np;
}
var tp, k0;
function Ha() {
  if (k0) return tp;
  k0 = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return tp = e, tp;
}
var rp, b0;
function OF() {
  if (b0) return rp;
  b0 = 1;
  var e = qa(), n = Ha(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == r || u == o;
  }
  return rp = s, rp;
}
var ip, _0;
function K6() {
  if (_0) return ip;
  _0 = 1;
  var e = Qr(), n = e["__core-js_shared__"];
  return ip = n, ip;
}
var ap, x0;
function G6() {
  if (x0) return ap;
  x0 = 1;
  var e = K6(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return ap = r, ap;
}
var op, S0;
function RF() {
  if (S0) return op;
  S0 = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return op = r, op;
}
var sp, N0;
function Y6() {
  if (N0) return sp;
  N0 = 1;
  var e = OF(), n = G6(), r = Ha(), i = RF(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, p = l.hasOwnProperty, d = RegExp(
    "^" + u.call(p).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return sp = f, sp;
}
var lp, j0;
function Q6() {
  if (j0) return lp;
  j0 = 1;
  function e(n, r) {
    return n?.[r];
  }
  return lp = e, lp;
}
var cp, w0;
function ra() {
  if (w0) return cp;
  w0 = 1;
  var e = Y6(), n = Q6();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return cp = r, cp;
}
var up, C0;
function lc() {
  if (C0) return up;
  C0 = 1;
  var e = ra(), n = e(Object, "create");
  return up = n, up;
}
var dp, F0;
function J6() {
  if (F0) return dp;
  F0 = 1;
  var e = lc();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return dp = n, dp;
}
var mp, I0;
function X6() {
  if (I0) return mp;
  I0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return mp = e, mp;
}
var pp, $0;
function Z6() {
  if ($0) return pp;
  $0 = 1;
  var e = lc(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return pp = a, pp;
}
var fp, E0;
function eH() {
  if (E0) return fp;
  E0 = 1;
  var e = lc(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return fp = i, fp;
}
var hp, T0;
function nH() {
  if (T0) return hp;
  T0 = 1;
  var e = lc(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return hp = r, hp;
}
var yp, D0;
function tH() {
  if (D0) return yp;
  D0 = 1;
  var e = J6(), n = X6(), r = Z6(), i = eH(), a = nH();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, yp = o, yp;
}
var gp, O0;
function rH() {
  if (O0) return gp;
  O0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return gp = e, gp;
}
var vp, R0;
function PF() {
  if (R0) return vp;
  R0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return vp = e, vp;
}
var kp, P0;
function cc() {
  if (P0) return kp;
  P0 = 1;
  var e = PF();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return kp = n, kp;
}
var bp, A0;
function iH() {
  if (A0) return bp;
  A0 = 1;
  var e = cc(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return bp = i, bp;
}
var _p, L0;
function aH() {
  if (L0) return _p;
  L0 = 1;
  var e = cc();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return _p = n, _p;
}
var xp, V0;
function oH() {
  if (V0) return xp;
  V0 = 1;
  var e = cc();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return xp = n, xp;
}
var Sp, z0;
function sH() {
  if (z0) return Sp;
  z0 = 1;
  var e = cc();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Sp = n, Sp;
}
var Np, U0;
function uc() {
  if (U0) return Np;
  U0 = 1;
  var e = rH(), n = iH(), r = aH(), i = oH(), a = sH();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Np = o, Np;
}
var jp, M0;
function Bg() {
  if (M0) return jp;
  M0 = 1;
  var e = ra(), n = Qr(), r = e(n, "Map");
  return jp = r, jp;
}
var wp, B0;
function lH() {
  if (B0) return wp;
  B0 = 1;
  var e = tH(), n = uc(), r = Bg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return wp = i, wp;
}
var Cp, q0;
function cH() {
  if (q0) return Cp;
  q0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Cp = e, Cp;
}
var Fp, H0;
function dc() {
  if (H0) return Fp;
  H0 = 1;
  var e = cH();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Fp = n, Fp;
}
var Ip, W0;
function uH() {
  if (W0) return Ip;
  W0 = 1;
  var e = dc();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Ip = n, Ip;
}
var $p, K0;
function dH() {
  if (K0) return $p;
  K0 = 1;
  var e = dc();
  function n(r) {
    return e(this, r).get(r);
  }
  return $p = n, $p;
}
var Ep, G0;
function mH() {
  if (G0) return Ep;
  G0 = 1;
  var e = dc();
  function n(r) {
    return e(this, r).has(r);
  }
  return Ep = n, Ep;
}
var Tp, Y0;
function pH() {
  if (Y0) return Tp;
  Y0 = 1;
  var e = dc();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Tp = n, Tp;
}
var Dp, Q0;
function AF() {
  if (Q0) return Dp;
  Q0 = 1;
  var e = lH(), n = uH(), r = dH(), i = mH(), a = pH();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Dp = o, Dp;
}
var Op, J0;
function fH() {
  if (J0) return Op;
  J0 = 1;
  var e = AF(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var p = i.apply(this, s);
      return o.cache = u.set(l, p) || u, p;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Op = r, Op;
}
var Rp, X0;
function hH() {
  if (X0) return Rp;
  X0 = 1;
  var e = fH(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Rp = r, Rp;
}
var Pp, Z0;
function yH() {
  if (Z0) return Pp;
  Z0 = 1;
  var e = hH(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, p) {
      o.push(u ? p.replace(r, "$1") : l || s);
    }), o;
  });
  return Pp = i, Pp;
}
var Ap, eN;
function LF() {
  if (eN) return Ap;
  eN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Ap = e, Ap;
}
var Lp, nN;
function gH() {
  if (nN) return Lp;
  nN = 1;
  var e = ds(), n = LF(), r = Fi(), i = Mg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return Lp = s, Lp;
}
var Vp, tN;
function vH() {
  if (tN) return Vp;
  tN = 1;
  var e = gH();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Vp = n, Vp;
}
var zp, rN;
function Wa() {
  if (rN) return zp;
  rN = 1;
  var e = Fi(), n = W6(), r = yH(), i = vH();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return zp = a, zp;
}
var Up, iN;
function mc() {
  if (iN) return Up;
  iN = 1;
  var e = Mg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Up = n, Up;
}
var Mp, aN;
function VF() {
  if (aN) return Mp;
  aN = 1;
  var e = Wa(), n = mc();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Mp = r, Mp;
}
var Bp, oN;
function zF() {
  if (oN) return Bp;
  oN = 1;
  var e = ra(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Bp = n, Bp;
}
var qp, sN;
function UF() {
  if (sN) return qp;
  sN = 1;
  var e = zF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return qp = n, qp;
}
var Hp, lN;
function qg() {
  if (lN) return Hp;
  lN = 1;
  var e = UF(), n = PF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Hp = a, Hp;
}
var Wp, cN;
function Hg() {
  if (cN) return Wp;
  cN = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Wp = r, Wp;
}
var Kp, uN;
function kH() {
  if (uN) return Kp;
  uN = 1;
  var e = qg(), n = Wa(), r = Hg(), i = Ha(), a = mc();
  function o(s, l, u, p) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var I = a(l[d]), w = u;
      if (I === "__proto__" || I === "constructor" || I === "prototype")
        return s;
      if (d != h) {
        var j = v[I];
        w = p ? p(j, I, v) : void 0, w === void 0 && (w = i(j) ? j : r(l[d + 1]) ? [] : {});
      }
      e(v, I, w), v = v[I];
    }
    return s;
  }
  return Kp = o, Kp;
}
var Gp, dN;
function bH() {
  if (dN) return Gp;
  dN = 1;
  var e = VF(), n = kH(), r = Wa();
  function i(a, o, s) {
    for (var l = -1, u = o.length, p = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(p, r(d, a), f);
    }
    return p;
  }
  return Gp = i, Gp;
}
var Yp, mN;
function _H() {
  if (mN) return Yp;
  mN = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Yp = e, Yp;
}
var Qp, pN;
function xH() {
  if (pN) return Qp;
  pN = 1;
  var e = qa(), n = ta(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Qp = i, Qp;
}
var Jp, fN;
function Wg() {
  if (fN) return Jp;
  fN = 1;
  var e = xH(), n = ta(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Jp = o, Jp;
}
var Xp, hN;
function Kg() {
  if (hN) return Xp;
  hN = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Xp = n, Xp;
}
var Zp, yN;
function SH() {
  if (yN) return Zp;
  yN = 1;
  var e = Wa(), n = Wg(), r = Fi(), i = Hg(), a = Kg(), o = mc();
  function s(l, u, p) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && p(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Zp = s, Zp;
}
var ef, gN;
function NH() {
  if (gN) return ef;
  gN = 1;
  var e = _H(), n = SH();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return ef = r, ef;
}
var nf, vN;
function jH() {
  if (vN) return nf;
  vN = 1;
  var e = bH(), n = NH();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return nf = r, nf;
}
var tf, kN;
function Gg() {
  if (kN) return tf;
  kN = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return tf = e, tf;
}
var rf, bN;
function wH() {
  if (bN) return rf;
  bN = 1;
  var e = ds(), n = Wg(), r = Fi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return rf = a, rf;
}
var af, _N;
function CH() {
  if (_N) return af;
  _N = 1;
  var e = Gg(), n = wH();
  function r(i, a, o, s, l) {
    var u = -1, p = i.length;
    for (o || (o = n), l || (l = []); ++u < p; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? r(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return af = r, af;
}
var of, xN;
function FH() {
  if (xN) return of;
  xN = 1;
  var e = CH();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return of = n, of;
}
var sf, SN;
function IH() {
  if (SN) return sf;
  SN = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return sf = e, sf;
}
var lf, NN;
function $H() {
  if (NN) return lf;
  NN = 1;
  var e = IH(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), p = Array(u); ++l < u; )
        p[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(p), e(i, this, d);
    };
  }
  return lf = r, lf;
}
var cf, jN;
function EH() {
  if (jN) return cf;
  jN = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return cf = e, cf;
}
var uf, wN;
function MF() {
  if (wN) return uf;
  wN = 1;
  function e(n) {
    return n;
  }
  return uf = e, uf;
}
var df, CN;
function TH() {
  if (CN) return df;
  CN = 1;
  var e = EH(), n = zF(), r = MF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return df = i, df;
}
var mf, FN;
function DH() {
  if (FN) return mf;
  FN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return mf = i, mf;
}
var pf, IN;
function OH() {
  if (IN) return pf;
  IN = 1;
  var e = TH(), n = DH(), r = n(e);
  return pf = r, pf;
}
var ff, $N;
function BF() {
  if ($N) return ff;
  $N = 1;
  var e = FH(), n = $H(), r = OH();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return ff = i, ff;
}
var hf, EN;
function RH() {
  if (EN) return hf;
  EN = 1;
  var e = jH(), n = BF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return hf = r, hf;
}
var PH = RH();
const qF = /* @__PURE__ */ TF(PH), AH = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function HF(e) {
  const n = qF(e, AH);
  return {
    controller: N6(n),
    controllerProps: n
  };
}
const LH = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function VH(e) {
  const { controller: n, controllerProps: r } = HF(e), i = {
    ...qF(e, LH),
    required: B6(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var yf, TN;
function zH() {
  if (TN) return yf;
  TN = 1;
  var e = uc();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return yf = n, yf;
}
var gf, DN;
function UH() {
  if (DN) return gf;
  DN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return gf = e, gf;
}
var vf, ON;
function MH() {
  if (ON) return vf;
  ON = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return vf = e, vf;
}
var kf, RN;
function BH() {
  if (RN) return kf;
  RN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return kf = e, kf;
}
var bf, PN;
function qH() {
  if (PN) return bf;
  PN = 1;
  var e = uc(), n = Bg(), r = AF(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return bf = a, bf;
}
var _f, AN;
function HH() {
  if (AN) return _f;
  AN = 1;
  var e = uc(), n = zH(), r = UH(), i = MH(), a = BH(), o = qH();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, _f = s, _f;
}
var xf, LN;
function WH() {
  if (LN) return xf;
  LN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return xf = e, xf;
}
var Sf, VN;
function ms() {
  if (VN) return Sf;
  VN = 1;
  var e = qg(), n = UF();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, p = a.length; ++u < p; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return Sf = r, Sf;
}
var Nf, zN;
function KH() {
  if (zN) return Nf;
  zN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Nf = e, Nf;
}
var cl = { exports: {} }, jf, UN;
function GH() {
  if (UN) return jf;
  UN = 1;
  function e() {
    return !1;
  }
  return jf = e, jf;
}
cl.exports;
var MN;
function WF() {
  return MN || (MN = 1, (function(e, n) {
    var r = Qr(), i = GH(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, u = l ? l.isBuffer : void 0, p = u || i;
    e.exports = p;
  })(cl, cl.exports)), cl.exports;
}
var wf, BN;
function YH() {
  if (BN) return wf;
  BN = 1;
  var e = qa(), n = Kg(), r = ta(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", p = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", I = "[object String]", w = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", y = "[object Float32Array]", L = "[object Float64Array]", E = "[object Int8Array]", C = "[object Int16Array]", F = "[object Int32Array]", z = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", Z = "[object Uint16Array]", te = "[object Uint32Array]", G = {};
  G[y] = G[L] = G[E] = G[C] = G[F] = G[z] = G[Q] = G[Z] = G[te] = !0, G[i] = G[a] = G[j] = G[o] = G[_] = G[s] = G[l] = G[u] = G[p] = G[d] = G[f] = G[h] = G[v] = G[I] = G[w] = !1;
  function B(R) {
    return r(R) && n(R.length) && !!G[e(R)];
  }
  return wf = B, wf;
}
var Cf, qN;
function Yg() {
  if (qN) return Cf;
  qN = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Cf = e, Cf;
}
var ul = { exports: {} };
ul.exports;
var HN;
function Qg() {
  return HN || (HN = 1, (function(e, n) {
    var r = DF(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(ul, ul.exports)), ul.exports;
}
var Ff, WN;
function QH() {
  if (WN) return Ff;
  WN = 1;
  var e = YH(), n = Yg(), r = Qg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Ff = a, Ff;
}
var If, KN;
function KF() {
  if (KN) return If;
  KN = 1;
  var e = KH(), n = Wg(), r = Fi(), i = WF(), a = Hg(), o = QH(), s = Object.prototype, l = s.hasOwnProperty;
  function u(p, d) {
    var f = r(p), h = !f && n(p), v = !f && !h && i(p), I = !f && !h && !v && o(p), w = f || h || v || I, j = w ? e(p.length, String) : [], _ = j.length;
    for (var y in p)
      (d || l.call(p, y)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      I && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, _))) && j.push(y);
    return j;
  }
  return If = u, If;
}
var $f, GN;
function Jg() {
  if (GN) return $f;
  GN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return $f = n, $f;
}
var Ef, YN;
function GF() {
  if (YN) return Ef;
  YN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Ef = e, Ef;
}
var Tf, QN;
function JH() {
  if (QN) return Tf;
  QN = 1;
  var e = GF(), n = e(Object.keys, Object);
  return Tf = n, Tf;
}
var Df, JN;
function XH() {
  if (JN) return Df;
  JN = 1;
  var e = Jg(), n = JH(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Df = a, Df;
}
var Of, XN;
function YF() {
  if (XN) return Of;
  XN = 1;
  var e = OF(), n = Kg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Of = r, Of;
}
var Rf, ZN;
function Xg() {
  if (ZN) return Rf;
  ZN = 1;
  var e = KF(), n = XH(), r = YF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Rf = i, Rf;
}
var Pf, ej;
function ZH() {
  if (ej) return Pf;
  ej = 1;
  var e = ms(), n = Xg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Pf = r, Pf;
}
var Af, nj;
function eW() {
  if (nj) return Af;
  nj = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Af = e, Af;
}
var Lf, tj;
function nW() {
  if (tj) return Lf;
  tj = 1;
  var e = Ha(), n = Jg(), r = eW(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), u = [];
    for (var p in s)
      p == "constructor" && (l || !a.call(s, p)) || u.push(p);
    return u;
  }
  return Lf = o, Lf;
}
var Vf, rj;
function Zg() {
  if (rj) return Vf;
  rj = 1;
  var e = KF(), n = nW(), r = YF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Vf = i, Vf;
}
var zf, ij;
function tW() {
  if (ij) return zf;
  ij = 1;
  var e = ms(), n = Zg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return zf = r, zf;
}
var dl = { exports: {} };
dl.exports;
var aj;
function rW() {
  return aj || (aj = 1, (function(e, n) {
    var r = Qr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(p, d) {
      if (d)
        return p.slice();
      var f = p.length, h = l ? l(f) : new p.constructor(f);
      return p.copy(h), h;
    }
    e.exports = u;
  })(dl, dl.exports)), dl.exports;
}
var Uf, oj;
function iW() {
  if (oj) return Uf;
  oj = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Uf = e, Uf;
}
var Mf, sj;
function aW() {
  if (sj) return Mf;
  sj = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Mf = e, Mf;
}
var Bf, lj;
function QF() {
  if (lj) return Bf;
  lj = 1;
  function e() {
    return [];
  }
  return Bf = e, Bf;
}
var qf, cj;
function ev() {
  if (cj) return qf;
  cj = 1;
  var e = aW(), n = QF(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return qf = o, qf;
}
var Hf, uj;
function oW() {
  if (uj) return Hf;
  uj = 1;
  var e = ms(), n = ev();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Hf = r, Hf;
}
var Wf, dj;
function nv() {
  if (dj) return Wf;
  dj = 1;
  var e = GF(), n = e(Object.getPrototypeOf, Object);
  return Wf = n, Wf;
}
var Kf, mj;
function JF() {
  if (mj) return Kf;
  mj = 1;
  var e = Gg(), n = nv(), r = ev(), i = QF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Kf = o, Kf;
}
var Gf, pj;
function sW() {
  if (pj) return Gf;
  pj = 1;
  var e = ms(), n = JF();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Gf = r, Gf;
}
var Yf, fj;
function XF() {
  if (fj) return Yf;
  fj = 1;
  var e = Gg(), n = Fi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Yf = r, Yf;
}
var Qf, hj;
function lW() {
  if (hj) return Qf;
  hj = 1;
  var e = XF(), n = ev(), r = Xg();
  function i(a) {
    return e(a, r, n);
  }
  return Qf = i, Qf;
}
var Jf, yj;
function ZF() {
  if (yj) return Jf;
  yj = 1;
  var e = XF(), n = JF(), r = Zg();
  function i(a) {
    return e(a, r, n);
  }
  return Jf = i, Jf;
}
var Xf, gj;
function cW() {
  if (gj) return Xf;
  gj = 1;
  var e = ra(), n = Qr(), r = e(n, "DataView");
  return Xf = r, Xf;
}
var Zf, vj;
function uW() {
  if (vj) return Zf;
  vj = 1;
  var e = ra(), n = Qr(), r = e(n, "Promise");
  return Zf = r, Zf;
}
var eh, kj;
function dW() {
  if (kj) return eh;
  kj = 1;
  var e = ra(), n = Qr(), r = e(n, "Set");
  return eh = r, eh;
}
var nh, bj;
function mW() {
  if (bj) return nh;
  bj = 1;
  var e = ra(), n = Qr(), r = e(n, "WeakMap");
  return nh = r, nh;
}
var th, _j;
function tv() {
  if (_j) return th;
  _j = 1;
  var e = cW(), n = Bg(), r = uW(), i = dW(), a = mW(), o = qa(), s = RF(), l = "[object Map]", u = "[object Object]", p = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), I = s(n), w = s(r), j = s(i), _ = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != p || i && y(new i()) != d || a && y(new a()) != f) && (y = function(L) {
    var E = o(L), C = E == u ? L.constructor : void 0, F = C ? s(C) : "";
    if (F)
      switch (F) {
        case v:
          return h;
        case I:
          return l;
        case w:
          return p;
        case j:
          return d;
        case _:
          return f;
      }
    return E;
  }), th = y, th;
}
var rh, xj;
function pW() {
  if (xj) return rh;
  xj = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return rh = r, rh;
}
var ih, Sj;
function fW() {
  if (Sj) return ih;
  Sj = 1;
  var e = Qr(), n = e.Uint8Array;
  return ih = n, ih;
}
var ah, Nj;
function rv() {
  if (Nj) return ah;
  Nj = 1;
  var e = fW();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return ah = n, ah;
}
var oh, jj;
function hW() {
  if (jj) return oh;
  jj = 1;
  var e = rv();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return oh = n, oh;
}
var sh, wj;
function yW() {
  if (wj) return sh;
  wj = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return sh = n, sh;
}
var lh, Cj;
function gW() {
  if (Cj) return lh;
  Cj = 1;
  var e = ds(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return lh = i, lh;
}
var ch, Fj;
function vW() {
  if (Fj) return ch;
  Fj = 1;
  var e = rv();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return ch = n, ch;
}
var uh, Ij;
function kW() {
  if (Ij) return uh;
  Ij = 1;
  var e = rv(), n = hW(), r = yW(), i = gW(), a = vW(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", p = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", I = "[object DataView]", w = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", y = "[object Int16Array]", L = "[object Int32Array]", E = "[object Uint8Array]", C = "[object Uint8ClampedArray]", F = "[object Uint16Array]", z = "[object Uint32Array]";
  function Q(Z, te, G) {
    var B = Z.constructor;
    switch (te) {
      case v:
        return e(Z);
      case o:
      case s:
        return new B(+Z);
      case I:
        return n(Z, G);
      case w:
      case j:
      case _:
      case y:
      case L:
      case E:
      case C:
      case F:
      case z:
        return a(Z, G);
      case l:
        return new B();
      case u:
      case f:
        return new B(Z);
      case p:
        return r(Z);
      case d:
        return new B();
      case h:
        return i(Z);
    }
  }
  return uh = Q, uh;
}
var dh, $j;
function bW() {
  if ($j) return dh;
  $j = 1;
  var e = Ha(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return dh = r, dh;
}
var mh, Ej;
function _W() {
  if (Ej) return mh;
  Ej = 1;
  var e = bW(), n = nv(), r = Jg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return mh = i, mh;
}
var ph, Tj;
function xW() {
  if (Tj) return ph;
  Tj = 1;
  var e = tv(), n = ta(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return ph = i, ph;
}
var fh, Dj;
function SW() {
  if (Dj) return fh;
  Dj = 1;
  var e = xW(), n = Yg(), r = Qg(), i = r && r.isMap, a = i ? n(i) : e;
  return fh = a, fh;
}
var hh, Oj;
function NW() {
  if (Oj) return hh;
  Oj = 1;
  var e = tv(), n = ta(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return hh = i, hh;
}
var yh, Rj;
function jW() {
  if (Rj) return yh;
  Rj = 1;
  var e = NW(), n = Yg(), r = Qg(), i = r && r.isSet, a = i ? n(i) : e;
  return yh = a, yh;
}
var gh, Pj;
function wW() {
  if (Pj) return gh;
  Pj = 1;
  var e = HH(), n = WH(), r = qg(), i = ZH(), a = tW(), o = rW(), s = iW(), l = oW(), u = sW(), p = lW(), d = ZF(), f = tv(), h = pW(), v = kW(), I = _W(), w = Fi(), j = WF(), _ = SW(), y = Ha(), L = jW(), E = Xg(), C = Zg(), F = 1, z = 2, Q = 4, Z = "[object Arguments]", te = "[object Array]", G = "[object Boolean]", B = "[object Date]", R = "[object Error]", U = "[object Function]", ee = "[object GeneratorFunction]", Se = "[object Map]", fe = "[object Number]", ye = "[object Object]", ve = "[object RegExp]", K = "[object Set]", _e = "[object String]", Te = "[object Symbol]", J = "[object WeakMap]", Ke = "[object ArrayBuffer]", an = "[object DataView]", we = "[object Float32Array]", Me = "[object Float64Array]", Re = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Ge = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", qe = "[object Uint16Array]", en = "[object Uint32Array]", ie = {};
  ie[Z] = ie[te] = ie[Ke] = ie[an] = ie[G] = ie[B] = ie[we] = ie[Me] = ie[Re] = ie[Be] = ie[Ae] = ie[Se] = ie[fe] = ie[ye] = ie[ve] = ie[K] = ie[_e] = ie[Te] = ie[Ge] = ie[Ce] = ie[qe] = ie[en] = !0, ie[R] = ie[U] = ie[J] = !1;
  function se(xe, Le, Pe, yn, T, x) {
    var D, H = Le & F, Y = Le & z, A = Le & Q;
    if (Pe && (D = T ? Pe(xe, yn, T, x) : Pe(xe)), D !== void 0)
      return D;
    if (!y(xe))
      return xe;
    var M = w(xe);
    if (M) {
      if (D = h(xe), !H)
        return s(xe, D);
    } else {
      var ae = f(xe), ge = ae == U || ae == ee;
      if (j(xe))
        return o(xe, H);
      if (ae == ye || ae == Z || ge && !T) {
        if (D = Y || ge ? {} : I(xe), !H)
          return Y ? u(xe, a(D, xe)) : l(xe, i(D, xe));
      } else {
        if (!ie[ae])
          return T ? xe : {};
        D = v(xe, ae, H);
      }
    }
    x || (x = new e());
    var Ne = x.get(xe);
    if (Ne)
      return Ne;
    x.set(xe, D), L(xe) ? xe.forEach(function(nn) {
      D.add(se(nn, Le, Pe, nn, xe, x));
    }) : _(xe) && xe.forEach(function(nn, dn) {
      D.set(dn, se(nn, Le, Pe, dn, xe, x));
    });
    var tn = A ? Y ? d : p : Y ? C : E, gn = M ? void 0 : tn(xe);
    return n(gn || xe, function(nn, dn) {
      gn && (dn = nn, nn = xe[dn]), r(D, dn, se(nn, Le, Pe, dn, xe, x));
    }), D;
  }
  return gh = se, gh;
}
var vh, Aj;
function CW() {
  if (Aj) return vh;
  Aj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return vh = e, vh;
}
var kh, Lj;
function FW() {
  if (Lj) return kh;
  Lj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return kh = e, kh;
}
var bh, Vj;
function IW() {
  if (Vj) return bh;
  Vj = 1;
  var e = VF(), n = FW();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return bh = r, bh;
}
var _h, zj;
function $W() {
  if (zj) return _h;
  zj = 1;
  var e = Wa(), n = CW(), r = IW(), i = mc(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, u) {
    u = e(u, l);
    var p = -1, d = u.length;
    if (!d)
      return !0;
    for (; ++p < d; ) {
      var f = i(u[p]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && p < d - 1)
        return !1;
    }
    var h = r(l, u);
    return h == null || delete h[i(n(u))];
  }
  return _h = s, _h;
}
var xh, Uj;
function EW() {
  if (Uj) return xh;
  Uj = 1;
  var e = qa(), n = nv(), r = ta(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function p(d) {
    if (!r(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return xh = p, xh;
}
var Sh, Mj;
function TW() {
  if (Mj) return Sh;
  Mj = 1;
  var e = EW();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Sh = n, Sh;
}
var Nh, Bj;
function DW() {
  if (Bj) return Nh;
  Bj = 1;
  var e = LF(), n = wW(), r = $W(), i = Wa(), a = ms(), o = TW(), s = BF(), l = ZF(), u = 1, p = 2, d = 4, f = s(function(h, v) {
    var I = {};
    if (h == null)
      return I;
    var w = !1;
    v = e(v, function(_) {
      return _ = i(_, h), w || (w = _.length > 1), _;
    }), a(h, l(h), I), w && (I = n(I, u | p | d, o));
    for (var j = v.length; j--; )
      r(I, v[j]);
    return I;
  });
  return Nh = f, Nh;
}
DW();
var OW = MF();
const RW = /* @__PURE__ */ TF(OW), fa = ({
  transformValue: e = RW,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = HF(a);
  return /* @__PURE__ */ Bo.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Bo.jsx(
      hl,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Bo.jsx(Qw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, qj = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = VH(e);
  return /* @__PURE__ */ Bo.jsx(rn, { ...i, children: /* @__PURE__ */ Bo.jsx(
    _r,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: rn.getStatus(i.meta)
    }
  ) });
}, xy = [
  {
    key: "rivoLoyaltyApiKey",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: Pg,
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], Hj = "RIVOLOYALTY", Bs = "Rivo Loyalty", PW = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [Pg]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, AW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = V6({
    mode: "onChange",
    defaultValues: PW
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = si({
    integrationId: e,
    integrationType: Hj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = li({
    integrationId: e,
    fieldDefinitions: xy,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: C } = ci({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => di(Q, {
    fieldDefinitions: xy,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ ke.jsxs(
    ui,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ ke.jsx(mi, { cause: h }),
        /* @__PURE__ */ ke.jsxs(mt, { children: [
          /* @__PURE__ */ ke.jsx(pe, { children: /* @__PURE__ */ ke.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3, children: /* @__PURE__ */ ke.jsx(
            qj,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3, children: /* @__PURE__ */ ke.jsx(
            qj,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: "Shopify API host name",
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (Q) => Iy(Q) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Zo,
            {
              name: "rivoLoyaltyApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3, children: /* @__PURE__ */ ke.jsx(rn, { label: "Show orders overview", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3, children: /* @__PURE__ */ ke.jsx(rn, { label: "Show loyalty", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3, children: /* @__PURE__ */ ke.jsx(rn, { label: "Allow adjusting loyalty points", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3, children: /* @__PURE__ */ ke.jsx(rn, { label: "Show favorite products", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3 }),
          /* @__PURE__ */ ke.jsx(pe, { span: 3, children: /* @__PURE__ */ ke.jsx(rn, { label: "Show available rewards", children: /* @__PURE__ */ ke.jsx(
            fa,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && L !== null && /* @__PURE__ */ ke.jsx(pe, { children: a({
            value: L,
            onChange: E,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          pi,
          {
            integrationType: Hj,
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ke.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ke.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ke.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Bs,
                  " integration, all links between Dixa and ",
                  Bs,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ke.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  Bs,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ke.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Bs,
                  " ",
                  'integration "',
                  z,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_yc0fe_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._order_yc0fe_6{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_yc0fe_6:hover,._orderIsOpen_yc0fe_14{border-color:var(--dixa-color-neutral-400)}._orderHeader_yc0fe_17{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var jh = { exports: {} }, jo = {}, Wj;
function LW() {
  if (Wj) return jo;
  Wj = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return jo.Fragment = r, jo.jsx = s, jo.jsxs = s, jo;
}
var qs = {}, Kj;
function VW() {
  return Kj || (Kj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    qs.Fragment = i, qs.jsx = Un, qs.jsxs = Kn;
  })()), qs;
}
var Gj;
function zW() {
  return Gj || (Gj = 1, process.env.NODE_ENV === "production" ? jh.exports = LW() : jh.exports = VW()), jh.exports;
}
var k = zW();
const Yj = "__PairingContext__", UW = () => globalThis[Yj] ?? (() => {
  const e = Yw({});
  return globalThis[Yj] = e, e;
})(), MW = UW(), BW = () => Ey(MW), qW = "_banner_d9pot_1", HW = "_list_d9pot_8", Qj = {
  banner: qW,
  list: HW
}, Jj = "https://apps.shopify.com/dixa-dashboard", WW = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, eI = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = BW(), [i, a] = ue(!1), [o, s] = ue(null), l = WW[n], u = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const d = await r();
        window.open(
          d ?? Jj,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Jj, "_blank", "noopener,noreferrer");
  }, p = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Qj.banner, children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(he, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(p, { className: Qj.list, children: l.listItems.map((d, f) => /* @__PURE__ */ k.jsx("li", { children: d }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(P.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      et,
      {
        onClick: u,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(vn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, KW = (e) => /* @__PURE__ */ k.jsx(eI, { ...e, bannerVariant: "install" }), GW = (e) => /* @__PURE__ */ k.jsx(eI, { ...e, bannerVariant: "migration" }), YW = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], QW = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], JW = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: KW
  }
], XW = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], Xj = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: GW,
    additionalProperties: { renderAboveForm: !0 }
  }
], nI = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Zj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Iy(e)
  },
  ...nI
];
var ka = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(ka || {}), Ki = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Ki || {}), Mr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Mr || {}), tI = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(tI || {}), Li = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Li || {}), ii = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(ii || {}), ml = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(ml || {}), rI = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(rI || {});
const ZW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, e9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, n9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, t9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, r9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, i9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, a9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, o9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, s9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, l9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, c9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, u9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, d9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, m9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, p9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, f9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, h9 = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": ZW,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": e9,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": n9,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": t9,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": r9,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": i9,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": a9,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": o9,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": s9,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": l9,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": c9,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": u9,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": d9,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": m9,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": p9,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": f9
};
function Nr(e) {
  return h9[e] ?? {};
}
const y9 = Nr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), g9 = Nr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), v9 = Nr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), k9 = Nr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), iv = Nr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), b9 = Nr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), _9 = Nr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), x9 = Nr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), S9 = Nr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), N9 = Nr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), j9 = Nr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), w9 = Nr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), iI = ql`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, C9 = ql`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, F9 = ({
  conversationContext: e
}) => {
  const { useQuery: n } = _n(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: u,
    data: p,
    refetch: d,
    networkStatus: f
  } = n(y9, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: u,
    customerData: p,
    refetchCustomer: d,
    customerNetworkStatus: f
  };
}, I9 = () => {
  const { useLazyQuery: e } = _n(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(g9);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Wr(e = !1, n) {
  const [r, i] = ue(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const $9 = "_list_alvh6_1", E9 = "_listItem_alvh6_4", T9 = "_fullWidth_alvh6_15", D9 = "_boxWrapper_alvh6_19", Gt = {
  list: $9,
  listItem: E9,
  fullWidth: T9,
  boxWrapper: D9
}, O9 = "_modal_1vkwz_1", R9 = "_disabled_1vkwz_5", wh = {
  modal: O9,
  disabled: R9
}, ew = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Ki.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Ki.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Ki.Unknown
  }
], nw = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Mr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Mr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Mr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Mr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Mr.Unsubscribed
  }
], P9 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = $n(), { useMutation: l, showNotification: u } = _n(), [p, d] = ue(), [f, h] = ue(), [v, I] = rk(!0), [w, j] = rk(!0), _ = !!p, y = e.customer?.email, L = e.customer?.phone_number, E = e.customer?.given_name, C = e.customer?.family_name, F = {
    email: y ?? "",
    phone: L ?? "",
    firstName: E ?? "",
    lastName: C ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, z = St({
    defaultValues: F
  });
  Xe(() => {
    f?.forEach((R) => {
      const U = R?.field?.[0];
      U && (z.setError(U, {
        type: "server",
        message: R.message
      }), z.setFocus(U));
    });
  }, [f, z]);
  const [Q, { error: Z, reset: te }] = l(j9, {
    onError: (R) => {
      d(R.message), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (R) => {
      const U = R?.Shopify?.customerCreate?.userErrors || [];
      U.length > 0 ? (h(U), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), u({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), G = ft(
    (R) => {
      a(!0), d(void 0), Q({
        variables: {
          input: {
            firstName: R.firstName,
            lastName: R.lastName,
            ...v && { email: R.email },
            ...w && { phone: R.phone },
            ...R.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: R.smsMarketingState,
                marketingOptInLevel: R.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Q, a, w, v]
  ), B = () => {
    r(!1), te(), d(void 0), z.reset(F);
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: n, onClose: B, className: wh.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Create new customer", onClose: B }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(mt, { children: [
      /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "First name",
          name: "firstName",
          control: z.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Last name",
          name: "lastName",
          control: z.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Email",
          name: "email",
          control: z.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: dt({
              [wh.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                hl,
                {
                  disabled: !w,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => I()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Phone",
          name: "phone",
          control: z.control,
          rules: {
            required: w ? "Phone is required" : void 0
          },
          componentProps: {
            className: dt({
              [wh.disabled]: !w
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                hl,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: w,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
        Dr,
        {
          control: z.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (R, U) => R === U,
            getItemTitleByValue: (R) => {
              const U = nw.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: U.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: U.description })
                  ]
                }
              );
            }
          },
          children: nw.map((R) => /* @__PURE__ */ k.jsx(vt.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
        Dr,
        {
          control: z.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (R, U) => R === U,
            getItemTitleByValue: (R) => {
              const U = ew.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: U.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: U.description })
                  ]
                }
              );
            }
          },
          children: ew.map((R) => /* @__PURE__ */ k.jsx(vt.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      _ && /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(he, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { children: p })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Ht,
      {
        confirmProps: {
          disabled: !(z.formState.isValid && z.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
        },
        confirmOnClick: z.handleSubmit(G),
        cancelOnClick: B,
        confirmName: Z ? "Close" : "Save",
        cancelName: Z ? void 0 : "Cancel"
      }
    )
  ] });
}, A9 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = ue(!1), [a, o] = ue(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      et,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(he, { size: 14, name: "user-plus", color: "green.500" }),
        className: Gt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      P9,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, av = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, Sy = "DD MMM YYYY @ HH:mm", L9 = "_wrapper_10fld_1", V9 = "_copyIcon_10fld_7", Hs = {
  wrapper: L9,
  copyIcon: V9
}, z9 = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Wr(), { isCopied: l, copy: u } = Wr(), { track: p } = $n();
  if (!e)
    return null;
  const {
    id: d,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: I = [],
    verifiedEmail: w
  } = e, j = h?.emailAddress, _ = v?.phoneNumber, y = av(d), L = `https://${n}/admin/customers/${y ?? ""}`, E = i && a === dr.refetch, C = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Hs.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: f }),
        E ? /* @__PURE__ */ k.jsx(vn, { size: C }) : /* @__PURE__ */ k.jsx(Je, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: C,
            name: "sync",
            onClick: () => {
              p("shopify:refreshed", { shopifyId: d }), r();
            },
            className: Hs.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(he, { size: C, name: "mail" }),
          /* @__PURE__ */ k.jsx(P.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ k.jsx(
            Je,
            {
              content: w ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                he,
                {
                  size: C,
                  color: w ? "green.500" : "red.500",
                  name: w ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Je, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: C,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: Hs.copyIcon
          }
        ) })
      ] }),
      _ && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(he, { size: C, name: "phone" }),
          /* @__PURE__ */ k.jsx(P.ExternalLink, { href: `tel:${_}`, children: _ })
        ] }),
        /* @__PURE__ */ k.jsx(Je, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: C,
            name: l ? "done" : "copy",
            onClick: () => u(_),
            className: Hs.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(he, { size: C, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          P.ExternalLink,
          {
            href: L,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    I.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: I.map((F) => /* @__PURE__ */ k.jsx(Yn, { children: F }, `${d}-${F}`)) })
    ] })
  ] });
}, U9 = "_creationModal_pbe64_1", M9 = "_detailsModal_pbe64_5", B9 = "_percentageSuffix_pbe64_9", Ch = {
  creationModal: U9,
  detailsModal: M9,
  percentageSuffix: B9
}, q9 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, H9 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: tI.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, tw = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], rw = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], iw = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], W9 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = ir(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Qe, { children: [
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            he,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: Qn(e?.startsAt).format(It) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(rn, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      _r,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, K9 = "shopify-discount-code-form", aw = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, G9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = $n(), { useMutation: i, showNotification: a } = _n(), [o, s] = ue(
    []
  ), [l, u] = ue(), p = St({
    mode: "all",
    defaultValues: aw
  });
  Xe(() => {
    o?.forEach((C) => {
      const F = C?.field?.[1];
      F && p.setError(F, {
        type: "server",
        message: C.message
      });
    });
  }, [o, p]);
  const d = !!l, f = p.watch("minimumRequirementOption"), h = p.watch("customerGetsOption"), v = Xn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    I,
    {
      loading: w,
      error: j,
      reset: _
    }
  ] = i(w9, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (C) => {
      const F = C?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (F && F.length > 0)
        s(F);
      else {
        const z = C?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        z && "codes" in z && u(z), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    p.setValue("code", q9(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, L = (C) => {
    I({
      variables: {
        input: H9(C)
      }
    });
  }, E = () => {
    p.reset(aw), s([]), _(), u(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Et,
    {
      isOpen: e,
      onClose: E,
      className: dt({
        [Ch.creationModal]: !d,
        [Ch.detailsModal]: d
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          Tt,
          {
            title: d ? "Discount code details" : "Create new discount code",
            onClose: E
          }
        ),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          d && /* @__PURE__ */ k.jsx(W9, { codeDiscount: l }),
          !d && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: K9, onSubmit: p.handleSubmit(L), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              Bl,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(mt, { children: [
              /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Title",
                  name: "title",
                  control: p.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
                Dr,
                {
                  control: p.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (C, F) => C === F,
                    onChange: () => {
                      p.setValue("customerGets", void 0), p.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (C) => {
                      const F = tw.find(
                        (z) => z.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: tw.map((C) => /* @__PURE__ */ k.jsx(vt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: p.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (C) => {
                      if (C) {
                        if (h === "percentage" && (C < 0 || C > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && C < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Ch.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Code",
                  name: "code",
                  control: p.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
                Dr,
                {
                  control: p.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (C, F) => C === F,
                    onChange: () => {
                      p.setValue("minimumRequirementValue", void 0), p.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (C) => {
                      const F = rw.find(
                        (z) => z.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: rw.map((C) => /* @__PURE__ */ k.jsx(vt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: p.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (C) => {
                      if (C && f !== "none" && C < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
                Dr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: p.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (C, F) => C === F,
                    getItemTitleByValue: (C) => {
                      const F = iw.find(
                        (z) => z.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: iw.map((C) => /* @__PURE__ */ k.jsx(vt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ k.jsx(Tn, { error: j })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ht,
          {
            confirmProps: {
              disabled: !d && !(p.formState.isValid && p.formState.isDirty),
              isLoading: w,
              loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
            },
            confirmName: d ? "Close" : "Save",
            confirmOnClick: d ? E : p.handleSubmit(L),
            cancelOnClick: d ? void 0 : E
          }
        )
      ]
    }
  );
}, Y9 = ({ code: e }) => {
  const { isCopied: n, copy: r } = Wr();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(he, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          mr,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, Q9 = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Qe, { children: i.map((a) => /* @__PURE__ */ k.jsx(Qe.Item, { className: Gt.listItem, children: /* @__PURE__ */ k.jsx(Y9, { code: a.code }, a.id) }, a.id)) })
  ] });
}, J9 = "_modal_11d6e_1", X9 = "_modalBody_11d6e_4", Z9 = "_codeContainer_11d6e_9", Fh = {
  modal: J9,
  modalBody: X9,
  codeContainer: Z9
}, e7 = [50, 100, 250], aI = 50, n7 = {
  maxNumberOfCodesToDisplay: aI
}, t7 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = _n(), [i, a] = ue(
    aI
  ), [o, s] = ue([]), l = o.length === 0, u = o.length > i, p = St({
    mode: "all",
    defaultValues: n7
  }), { loading: d, error: f } = r(b9, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const I = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      I && I.length > 0 && s(I);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: e, onClose: h, className: Fh.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(Dt, { className: Fh.modalBody, children: [
      u && /* @__PURE__ */ k.jsx(mt, { children: /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
        Dr,
        {
          control: p.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: v }) })
          },
          children: e7.map((v) => /* @__PURE__ */ k.jsx(vt.Item, { value: v, children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(vn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !d && l && /* @__PURE__ */ k.jsx(
        yl,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !d && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: Fh.codeContainer, children: /* @__PURE__ */ k.jsx(Q9, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(Ht, { confirmName: "Close", confirmOnClick: h })
  ] });
}, r7 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = ue(!1), [i, a] = ue(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          et,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          et,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      t7,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      G9,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, i7 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? Hw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case ka.Invalid:
      case ka.NotSubscribed:
      case Mr.NotSubscribed:
        return "red.500";
      case ka.Pending:
      case Mr.Pending:
      case ka.Unsubscribed:
      case Mr.Unsubscribed:
        return "orange.500";
      case ka.Subscribed:
      case Mr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Ki.SingleOptIn:
      case Ki.ConfirmedOptIn:
        return "green.500";
      case Ki.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: u
  } = n ?? {}, {
    marketingState: p,
    marketingUpdatedAt: d,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Je, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Bn, { size: "small", variant: "info", children: Qn(l).format(Sy) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Je, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Yn, { color: o(u), children: i(u) }) }),
        /* @__PURE__ */ k.jsx(Je, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Yn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(he, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      d && /* @__PURE__ */ k.jsx(Je, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Bn, { size: "small", variant: "info", children: Qn(d).format(Sy) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Je, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Yn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Je, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Yn, { color: a(p), children: i(p) }) })
      ] })
    ] })
  ] });
}, a7 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: rI.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, ow = [
  {
    value: ii.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: ii.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: ii.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: ii.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: ii.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: ii.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: ii.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], sw = [
  {
    value: ml.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: ml.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: ml.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], oI = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), ba = (e) => o7(s7(e)), o7 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), s7 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, Ri = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  zt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      ur,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), l7 = "_modal_1wlra_1", c7 = {
  modal: l7
};
function lw(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const cw = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], uw = "shopify-shiping-address-form", u7 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: u
}) => {
  const { useMutation: p, showNotification: d } = _n(), { track: f } = $n(), [h, v] = ue(!1), [I, w] = ue({}), j = !l, [
    _,
    { error: y, reset: L }
  ] = p(_9, {
    onError: () => {
      v(!1), d({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (G) => {
      v(!1);
      const B = G?.Shopify?.orderUpdate?.userErrors;
      if (B != null && B.length > 0) {
        const R = B.reduce(
          (U, ee) => {
            const Se = ee.field;
            if (Se == null || Se.length === 0)
              return U;
            const fe = Se[Se.length - 1];
            return fe != null && (U[fe] = ee.message), U;
          },
          {}
        );
        w(R);
      } else
        d({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), u(), te();
    }
  }), E = ft(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: cw.find(
        (G) => G === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: C, handleSubmit: F, formState: z, reset: Q } = St({
    mode: "all",
    defaultValues: E()
  }), Z = F((G) => {
    if (j) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: B, ...R } = G, U = {
        ...R,
        countryCode: B
      };
      _({
        variables: {
          input: {
            id: a,
            shippingAddress: U
          }
        }
      });
    } else
      l(G), te();
  });
  Xe(() => {
    r && Q(E());
  }, [r, n, Q, E]);
  const te = () => {
    Q(E()), w({}), L(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Et,
    {
      isOpen: r,
      onClose: te,
      className: c7.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: e, onClose: () => te() }),
        /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: uw, onSubmit: Z, children: [
          y && /* @__PURE__ */ k.jsx(Tn, { error: y }),
          /* @__PURE__ */ k.jsxs(mt, { children: [
            /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                control: C,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                control: C,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ri,
              {
                required: !0,
                control: C,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 6, children: /* @__PURE__ */ k.jsx(
              Dr,
              {
                name: "countryCodeV2",
                control: C,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (G) => G ? lw(G) : ""
                },
                children: cw.filter((G) => s.includes(G)).map((G) => /* @__PURE__ */ k.jsx(vt.Item, { value: G, children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: lw(G) }) }, G))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Ht,
          {
            confirmProps: {
              disabled: !(z.isValid && z.isDirty),
              type: "submit",
              form: uw,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
            },
            confirmOnClick: () => {
              y && te();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), te();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, d7 = "_clickableIcon_33mqm_1", Ih = {
  clickableIcon: d7
}, dw = ({
  formFieldName: e,
  ...n
}) => {
  const r = Gr(), { field: i } = Zy({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    Ny,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, Ny = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: u,
  openByDefault: p = !1
}) => {
  const [d, f] = ue(!1), [h, v] = ue(p), { isCopied: I, copy: w } = Wr(), { track: j } = $n(), _ = 14, y = o && (!!r || !!l), L = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), E = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), C = n?.countryCodeV2 && KI(n.countryCodeV2), F = ft(() => [
    E,
    n?.company,
    n?.address1,
    n?.address2,
    L,
    n?.province,
    C
  ].filter(Boolean).join(`
`), [n, E, L, C]);
  if (!n)
    return null;
  const z = () => {
    i && r && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { size: _, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Ih.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: _,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            E && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: E }),
            n?.company && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.address2 }),
            L && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: L }),
            n?.province && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.province }),
            C && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: C })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(Je, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: _,
            name: "pen",
            onClick: () => z(),
            className: Ih.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Je, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: _,
            name: I ? "done" : "copy",
            onClick: () => w(F()),
            className: Ih.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      u7,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: d,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: u
      }
    )
  ] });
}, ov = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Gr(), i = Po({ control: r.control, name: "lineItems" }), a = Po({
    control: r.control,
    name: "billingAddress"
  }), o = Po({
    control: r.control,
    name: "shippingAddress"
  }), s = Xn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (p) => n.includes(p.id)
  ) : i, [i, n]), l = Xn(() => !s || s.length === 0 ? 0 : s.reduce((p, d) => {
    const f = d.priceRangeV2?.minVariantPrice?.amount || 0, h = d.quantity || 0;
    return p + f * h;
  }, 0), [s]), u = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        dw,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        dw,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${u}` })
    ] }),
    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, m7 = "_productTableHeader_6h6pl_1", p7 = "_productImage_6h6pl_5", qo = {
  productTableHeader: m7,
  productImage: p7
}, sv = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, f7 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Gr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), u = sv(e);
  return /* @__PURE__ */ k.jsxs(st.Tr, { children: [
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      u && /* @__PURE__ */ k.jsx(
        Ra,
        {
          src: u,
          alt: e.title,
          className: qo.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
      tt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(mr, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, h7 = 300, wo = 2, y7 = 25, g7 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = _n(), [i, a] = ue(""), [o, s] = ue([]), l = Gr(), u = l.watch("selectedProductId"), [p, { loading: d, networkStatus: f }] = n(iv, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (w) => {
      const j = w?.Shopify?.products?.nodes || [];
      s(
        j.filter((_) => !!_).sort((_, y) => _.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  Ji(
    () => {
      i.trim().length >= wo && !d && f === dr.ready ? p({
        variables: {
          query: i.trim(),
          productCount: y7,
          mediaCount: 1
        }
      }) : i.trim().length < wo && s([]);
    },
    h7,
    [i]
  ), Xe(() => {
    if (!u) return;
    const w = o.find(
      (j) => j.id === u
    );
    w && e(w), l.setValue("selectedProductId", void 0);
  }, [u, o, l, e]);
  const h = d && f !== dr.ready, v = i.trim().length >= wo, I = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    Dr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${wo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (w) => {
          const j = o.find(
            (_) => _.id === w
          );
          return j ? /* @__PURE__ */ k.jsx(P.Paragraph, { children: j.title }) : null;
        },
        filter: {
          value: i,
          onChange: (w) => {
            a(w.target.value);
          }
        },
        onToggleDropdown: (w) => {
          !w && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(vt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(vn, {}) }) }),
        !h && o.map((w) => {
          const j = w.totalInventory <= 0, _ = sv(w);
          return /* @__PURE__ */ k.jsx(
            vt.Item,
            {
              value: w.id,
              isDisabled: j,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  _ && /* @__PURE__ */ k.jsx(
                    Ra,
                    {
                      src: _,
                      alt: w.title,
                      className: qo.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    d$,
                    {
                      text: w.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: w.title })
                ] }),
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", children: j ? "Out of stock" : `${w.totalInventory} in stock` })
              ] })
            },
            w.id
          );
        }),
        I && /* @__PURE__ */ k.jsx(vt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          yl,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(vt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          yl,
          {
            title: "Search for products",
            description: `Type at least ${wo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, lv = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: u
}) => {
  const p = Gr(), d = p.watch("lineItems"), f = !!d?.length, h = n && f ? d.filter(
    (j) => !o.includes(j?.id)
  ) : [], v = h.length > 0 && h.every(
    (j) => a.includes(j?.id)
  ), I = h.some(
    (j) => a.includes(j?.id)
  ) && !v, w = ft(
    (j) => {
      const _ = p.getValues("lineItems"), y = _.findIndex(
        (L) => L?.id === j.id
      );
      if (y > -1) {
        const L = p.getValues(`lineItems.${y}.quantity`) || 0, E = [..._];
        E[y] = {
          ...E[y],
          quantity: L + 1
        }, p.setValue("lineItems", E);
      } else
        p.setValue("lineItems", [
          ..._,
          { ...j, quantity: 1 }
        ]);
    },
    [p]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(g7, { onProductSelected: w }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Gt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(vn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Gt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          yl,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      st,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: qo.productTable,
        children: [
          /* @__PURE__ */ k.jsx(st.Thead, { className: qo.productTableHeader, children: /* @__PURE__ */ k.jsxs(st.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(st.Th, { children: /* @__PURE__ */ k.jsx(
              xv,
              {
                checked: v,
                indeterminate: I,
                onChange: () => u?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(st.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(st.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(st.Tbody, { children: d?.map((j, _) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                f7,
                {
                  product: j,
                  index: _,
                  onRemove: () => {
                    const B = d.filter(
                      (R, U) => U !== _
                    );
                    p.setValue("lineItems", B);
                  }
                },
                `${j?.id}-${_}`
              );
            const y = j, L = y.priceRangeV2.minVariantPrice.amount, E = y.priceRangeV2.minVariantPrice.currencyCode, C = `lineItems.${_}.quantity`, F = p.watch(C) || 0, z = L * F, Q = sv(y), Z = a.includes(y.id), te = o.includes(y.id), G = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              st.Tr,
              {
                style: te ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
                    xv,
                    {
                      checked: Z,
                      disabled: te,
                      onChange: () => l?.(y.id, !Z)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Q && /* @__PURE__ */ k.jsx(
                      Ra,
                      {
                        src: Q,
                        alt: y.title,
                        className: qo.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: y.title }),
                      te && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${L} ${E}` }) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(
                    tt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: te || G <= 1,
                      name: C,
                      control: p.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: G,
                        tabIndex: 0
                      }
                    },
                    `${C}-${p.watch(C)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${z} ${E}` }) }),
                  !r && /* @__PURE__ */ k.jsx(st.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    mr,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const B = d.filter(
                          (R, U) => U !== _
                        );
                        p.setValue("lineItems", B), Z && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${_}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, sI = ({
  previousOrderStatus: e
} = {}) => {
  const n = Gr();
  return /* @__PURE__ */ k.jsx(
    Dr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = ow.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: ow.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(vt.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, lI = () => {
  const e = Gr();
  return /* @__PURE__ */ k.jsx(
    Dr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = sw.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: sw.map((n) => /* @__PURE__ */ k.jsx(vt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, v7 = "_modal_1mprq_1", k7 = {
  modal: v7
}, $h = "create-shopify-order-form", b7 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = $n(), [u, p] = ue(!1), [
    d,
    f
  ] = ue(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: ii.Pending,
    fulfillmentStatus: void 0
  }, [I, w] = ue([]), j = St({
    mode: "all",
    defaultValues: v
  }), _ = j.watch("lineItems").length > 0, y = () => {
    j.reset(v), w([]), i(!1);
  };
  Xe(() => {
    I.length > 0 && j.setValue("tags", I, { shouldDirty: !0 });
  }, [I, j]);
  const [L, { error: E }] = o(
    iI,
    {
      onError: () => {
        p(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), p(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [C, { error: F }] = o(
    C9,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), z = (Z) => {
    const te = Z.lineItems.map((R) => ({
      productId: R.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: R.priceRangeV2.maxVariantPrice.amount,
          currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: R.quantity
    }));
    p(!0);
    const G = ba(Z?.billingAddress), B = ba(
      Z?.shippingAddress
    );
    L({
      variables: {
        order: {
          lineItems: te,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Z.customNote,
          tags: Z.tags,
          financialStatus: Z.financialStatus,
          fulfillmentStatus: Z.fulfillmentStatus,
          shippingAddress: B,
          billingAddress: G
        }
      }
    });
  }, Q = (Z) => {
    const te = Z.lineItems.map((R) => ({
      title: R.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: R.priceRangeV2.maxVariantPrice.amount,
        currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: R.quantity
    }));
    f(!0);
    const G = ba(Z?.billingAddress), B = ba(
      Z?.shippingAddress
    );
    C({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Z.customNote,
          tags: Z.tags,
          lineItems: te,
          shippingAddress: B,
          billingAddress: G
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Et,
    {
      isOpen: e,
      onClose: y,
      className: k7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(Xy, { ...j, children: /* @__PURE__ */ k.jsx("form", { id: $h, children: /* @__PURE__ */ k.jsxs(mt, { children: [
            /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(lv, {}) }),
            /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
              zt,
              {
                name: "tags",
                render: ({ fieldState: { error: Z } }) => /* @__PURE__ */ k.jsx(
                  rn,
                  {
                    label: "Tags",
                    meta: {
                      error: Z?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (te) => {
                          te.key === "Enter" && (te.preventDefault(), te.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ml,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: I,
                            onChange: (te) => {
                              w(te);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(sI, {}),
              /* @__PURE__ */ k.jsx(lI, {}),
              /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(pe, { span: 2, children: /* @__PURE__ */ k.jsx(rn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Gt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(ov, {})
              }
            ) }) })
          ] }) }) }),
          (E || F) && /* @__PURE__ */ k.jsx(Tn, { error: E || F })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ht,
          {
            confirmProps: {
              type: "submit",
              form: $h,
              disabled: !_ || u,
              isLoading: u,
              loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(z),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(Q)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: $h,
                disabled: !_ || d,
                isLoading: d,
                loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, _7 = "_modal_al73g_1", x7 = {
  modal: _7
}, mw = [
  {
    label: "Customer",
    value: Li.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Li.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Li.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Li.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Li.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Li.Staff,
    description: "Staff made an error."
  }
], S7 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = $n(), { useMutation: u, showNotification: p } = _n(), [d, f] = ue([]), h = d.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, I = St({
    defaultValues: v
  }), [w, { error: j, reset: _ }] = u(S9, {
    onError: () => {
      o(!1), p({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (E) => {
      const C = E.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (C.length > 0)
        o(!1), f(C), p({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const F = E.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, F ? 0 : 4e3), p({
          title: "Success",
          text: `${F ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = ft(
    (E) => {
      E.reason != null && (o(!0), w({
        variables: {
          orderId: E.orderId,
          reason: E.reason,
          refundMethod: E.refundMethod,
          restock: E.restock,
          notifyCustomer: E.notifyCustomer,
          staffNote: E.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), L = () => {
    i(!1), _(), f([]), I.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: n, onClose: L, className: x7.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: `Cancel order ${r}`, onClose: L }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(mt, { children: [
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
        Dr,
        {
          control: I.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (E, C) => E === C,
            getItemTitleByValue: (E) => {
              if (!E)
                return "";
              const C = mw.find(
                (F) => F.value === E
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: C.label }),
                /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: C.description })
              ] });
            }
          },
          children: mw.map((E) => /* @__PURE__ */ k.jsx(vt.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: E.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: E.description })
          ] }) }, E.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(rn, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        An,
        {
          control: I.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(rn, { label: "Restock items", children: /* @__PURE__ */ k.jsx(An, { control: I.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(rn, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(An, { control: I.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          name: "staffNote",
          label: "Staff note",
          control: I.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: d.map((E) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(he, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: E.code }),
            /* @__PURE__ */ k.jsxs(P.Paragraph, { children: [
              "(",
              E.field?.join(","),
              ") ",
              E.message
            ] })
          ]
        },
        E.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Ht,
      {
        confirmProps: {
          disabled: !(I.formState.isValid && I.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
        },
        confirmOnClick: I.handleSubmit(y),
        cancelOnClick: L,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, N7 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = ue(!1), [s, l] = ue(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      et,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          he,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Gt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      S7,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, j7 = "_modal_1mprq_1", w7 = {
  modal: j7
}, C7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: u } = _n(), { track: p } = $n(), [d, f] = ue(!1), [h, v] = ue(e?.tags || []), I = "duplicate-shopify-order-form", w = (B) => ({
    firstName: B?.firstName,
    lastName: B?.lastName,
    company: B?.company,
    address1: B?.address1,
    address2: B?.address2,
    city: B?.city,
    provinceCode: B?.provinceCode,
    zip: B?.zip,
    countryCode: B?.countryCodeV2,
    phone: B?.phone
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: w(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: w(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, _ = St({
    mode: "all",
    defaultValues: j
  }), y = _.watch("lineItems").length > 0, L = Xn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), E = Xn(
    () => oI(L),
    [L]
  ), {
    data: C,
    loading: F,
    error: z
  } = u(iv, {
    skip: !E,
    variables: {
      query: E,
      productCount: L.length,
      mediaCount: 1
    }
  });
  Xe(() => {
    z && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [z, l]), Xe(() => {
    if (!r || F || !C || _.getValues("lineItems")?.length)
      return;
    const B = C?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((U) => {
      const ee = B.find(
        (Se) => Se.id === U.product?.id
      );
      ee && R.push({
        ...ee,
        quantity: U.quantity || 1,
        sku: U.sku,
        discountedUnitPrice: U.discountedUnitPriceSet?.shopMoney
      });
    }), R.length > 0 && _.setValue("lineItems", R, { shouldDirty: !0 });
  }, [r, C, F, e, _]), Xe(() => {
    (h.length > 0 || (_.getValues("tags") || []).length > 0) && _.setValue("tags", h, { shouldDirty: !0 });
  }, [h, _]);
  const [Q, { error: Z }] = s(
    iI,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), p("shopify:order:duplicate:failed"), G();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), p("shopify:order:duplicate:succeeded"), G();
      }
    }
  ), te = (B) => {
    const R = B.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), U = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Q({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: R,
          shippingLines: U,
          note: B.customNote,
          tags: B.tags,
          financialStatus: B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          shippingAddress: ba(B?.shippingAddress),
          billingAddress: ba(B?.billingAddress)
        }
      }
    });
  }, G = () => {
    _.reset(j), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Et,
    {
      isOpen: r,
      onClose: G,
      className: w7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(Tt, { title: `Duplicate order ${n}`, onClose: G }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(Xy, { ..._, children: /* @__PURE__ */ k.jsx("form", { id: I, children: /* @__PURE__ */ k.jsxs(mt, { children: [
            /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(lv, { loading: F }) }),
            /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
              zt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ k.jsx(
                  rn,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (R) => {
                          R.key === "Enter" && (R.preventDefault(), R.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ml,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (R) => {
                              v(R);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(pe, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                sI,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(lI, {}),
              /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(pe, { span: 2, children: /* @__PURE__ */ k.jsx(rn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Gt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(ov, {})
              }
            ) }) })
          ] }) }) }),
          Z && /* @__PURE__ */ k.jsx(Tn, { error: Z })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ht,
          {
            confirmProps: {
              type: "submit",
              form: I,
              disabled: !y || d || F,
              isLoading: d || F,
              loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: _.handleSubmit(te)
          }
        )
      ]
    }
  );
}, F7 = "_copyIcon_1dlzg_1", I7 = {
  copyIcon: F7
}, $7 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Wr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (l) => l > 0
  ), s = n.map(
    ({ title: l, quantity: u, variantTitle: p }) => p ? `${u}x ${l} (${p})` : `${u}x ${l}`
  ).join(`
`);
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(he, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ k.jsx(Je, { content: "Copy line items", children: /* @__PURE__ */ k.jsx(
            he,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(s),
              className: I7.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Yn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Qe, { children: n.map(({ id: l, title: u, quantity: p, variantTitle: d, image: f }) => {
      const h = r[l], v = h > 0, I = h > 1 ? `Refunded (${h} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Qe.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { children: p }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "4", children: [
            u,
            " ",
            d && `(${d})`,
            v && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", color: "red.500", children: I })
          ] }),
          contentRight: f?.url && /* @__PURE__ */ k.jsx(Ra, { src: `${f?.url}&height=48`, alt: u })
        },
        `list-${e}-${l}`
      );
    }) })
  ] });
}, E7 = ql`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, T7 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, cI = (e) => {
  const n = {}, r = T7(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, D7 = "_modal_21e62_1", O7 = {
  modal: D7
}, pw = "partial-refund-shopify-order-form", R7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = $n(), { useQuery: u } = _n(), [p, d] = ue(!1), [f, h] = ue([]), v = Xn(
    () => e?.refunds ? cI(e) : {},
    [e]
  ), I = Xn(
    () => (e?.lineItems || []).filter((B) => (v[B.id] || 0) >= (B.quantity || 0)).map((B) => B.product?.id).filter((B) => !!B),
    [e, v]
  ), w = Xn(() => {
    const B = {};
    return (e?.lineItems || []).forEach((R) => {
      if (R.product?.id) {
        const U = v[R.id] || 0, ee = Math.max(
          0,
          (R.quantity || 0) - U
        );
        B[R.product.id] = ee;
      }
    }), B;
  }, [e, v]), j = Xn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), _ = Xn(
    () => oI(j),
    [j]
  ), {
    data: y,
    loading: L,
    error: E
  } = u(iv, {
    skip: !_,
    variables: {
      query: _,
      productCount: j.length,
      mediaCount: 1
    }
  });
  Xe(() => {
    E && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [E, s]);
  const C = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, F = St({
    mode: "all",
    defaultValues: C
  }), z = f.length > 0, [Q, { error: Z }] = o(
    E7,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), G();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), G();
      }
    }
  );
  Xe(() => {
    if (!r || L || !y || F.getValues("lineItems")?.length)
      return;
    const B = y?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((U) => {
      const ee = B.find(
        (Se) => Se.id === U.product?.id
      );
      if (ee) {
        const Se = v[U.id] || 0, fe = (U.quantity || 1) - Se;
        R.push({
          ...ee,
          quantity: fe > 0 ? fe : U.quantity || 1
        });
      }
    }), R.length > 0 && (F.setValue("lineItems", R, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    L,
    e,
    F,
    v
  ]);
  const te = (B) => {
    d(!0);
    const R = (B.lineItems || []).filter(
      (U) => f.includes(U.id)
    ).map((U) => {
      const ee = e?.lineItems?.find(
        (ve) => ve.product?.id === U.id
      ), Se = v[ee?.id || ""] || 0, fe = (ee?.quantity || 0) - Se, ye = Math.max(
        0,
        Math.min(fe, U.quantity || 0)
      );
      return ee && ye > 0 ? { lineItemId: ee.id, quantity: ye } : void 0;
    }).filter((U) => !!U);
    Q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: R,
          note: B.customNote || void 0,
          notify: !0
        }
      }
    });
  }, G = () => {
    F.reset(C), d(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: r, onClose: G, className: O7.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: `Refund order ${n}`, onClose: G }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(Xy, { ...F, children: /* @__PURE__ */ k.jsx("form", { id: pw, children: /* @__PURE__ */ k.jsxs(mt, { children: [
        /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
          lv,
          {
            loading: L,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: I,
            maxQuantities: w,
            onToggleSelect: (B, R) => {
              h((U) => R ? Array.from(/* @__PURE__ */ new Set([...U, B])) : U.filter((ee) => ee !== B));
            },
            onToggleSelectAll: (B) => {
              const R = (F.getValues("lineItems") || []).map((U) => U.id).filter((U) => !I.includes(U));
              h(B ? R : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(pe, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          tt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(pe, { span: 2, children: /* @__PURE__ */ k.jsx(rn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Gt.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              ov,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      Z && /* @__PURE__ */ k.jsx(Tn, { error: Z })
    ] }),
    /* @__PURE__ */ k.jsx(
      Ht,
      {
        confirmProps: {
          type: "submit",
          form: pw,
          disabled: !z || p || L,
          isLoading: p || L,
          loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: F.handleSubmit(te)
      }
    )
  ] });
}, P7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = _n(), { track: l } = $n(), { suggestedRefund: u, currencyCode: p, id: d, name: f } = e, h = parseFloat(String(u?.amount)), v = !isNaN(h) && h > 0, [I] = a(x9, {
    onError: (_) => {
      setTimeout(() => j(_), 500);
    },
    onCompleted: (_) => {
      const y = _.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? j(
        new e1({
          graphQLErrors: y.map((L) => ({
            message: L.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), w = ft(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: d });
    const { amount: _, ...y } = u;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(P.Paragraph, { children: [
        "You are about to refund ",
        _,
        " ",
        p,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: d }), I({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: d })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    d,
    f,
    p,
    u,
    v,
    s,
    I,
    l
  ]), j = ft(
    (_) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Tn, { error: _ }),
          /* @__PURE__ */ k.jsx(
            Bt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    et,
    {
      variant: "secondary",
      onClick: w,
      disabled: u?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(he, { size: 14, name: "undo" }),
      className: Gt.fullWidth,
      children: "Full refund"
    }
  ) });
}, A7 = "_modal_al73g_1", L7 = {
  modal: A7
}, V7 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = $n(), { useMutation: s, showNotification: l } = _n(), [u, p] = ue(n), [d, f] = ue(!1), h = St({
    defaultValues: {
      tags: n
    }
  });
  Xe(() => {
    u && h.setValue("tags", u, { shouldDirty: !0 });
  }, [u]);
  const [v, { error: I, reset: w }] = s(N9, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = ft(
    (y) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((L) => {
        const E = L.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: E });
      });
    },
    [e, h, v]
  ), _ = () => {
    i(!1), w();
  };
  return /* @__PURE__ */ k.jsxs(Et, { isOpen: r, onClose: _, className: L7.modal, children: [
    /* @__PURE__ */ k.jsx(Tt, { title: "Manage tags for order", onClose: _ }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(mt, { children: /* @__PURE__ */ k.jsx(pe, { children: /* @__PURE__ */ k.jsx(
        zt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            rn,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Ml,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (L) => p(L)
                }
              )
            }
          )
        }
      ) }) }),
      I && /* @__PURE__ */ k.jsx(Tn, { error: I })
    ] }),
    /* @__PURE__ */ k.jsx(
      Ht,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: d,
          loadingIndicator: /* @__PURE__ */ k.jsx(vn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: _,
        confirmName: I ? "Close" : "Save",
        cancelName: I ? void 0 : "Cancel"
      }
    )
  ] });
}, z7 = "_editIcon_1yp2k_1", U7 = "_copyIcon_1yp2k_2", fw = {
  editIcon: z7,
  copyIcon: U7
}, M7 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = ue(!1), { isCopied: o, copy: s } = Wr(), l = 14, u = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !u && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            u && n.map((p, d) => /* @__PURE__ */ k.jsx(Bn, { size: "small", variant: "primary", children: p }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Je, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: l,
            name: "pen",
            className: fw.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        u && /* @__PURE__ */ k.jsx(Je, { content: "Copy tags", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: l,
            name: o ? "done" : "copy",
            className: fw.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      V7,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, B7 = "_icon_cddi1_1", q7 = "_link_cddi1_6", hw = {
  icon: B7,
  link: q7
}, H7 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Wr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Qe.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        P.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: hw.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Je, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        he,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: hw.icon
        }
      ) })
    }
  );
}, W7 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(he, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Qe, { children: e.map((n) => /* @__PURE__ */ k.jsx(H7, { trackingInfo: n }, n.number)) })
] }), K7 = "_copyIcon_yc0fe_1", G7 = "_order_yc0fe_6", Y7 = "_orderIsOpen_yc0fe_14", Q7 = "_orderHeader_yc0fe_17", ha = {
  copyIcon: K7,
  order: G7,
  orderIsOpen: Y7,
  orderHeader: Q7
}, J7 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: u,
  displayPartialRefundOrder: p,
  refetchOrders: d
}) => {
  const { track: f } = $n(), { isCopied: h, copy: v } = Wr(), { isCopied: I, copy: w } = Wr(), { isCopied: j, copy: _ } = Wr(), [y, L] = ue(!1), [E, C] = ue(!1), [F, z] = ue(r), {
    id: Q,
    name: Z,
    createdAt: te,
    status: G,
    currentTotalPriceSet: B,
    currencyCode: R,
    lineItems: U,
    billingAddress: ee,
    shippingAddress: Se,
    trackingInfos: fe,
    tags: ye
  } = e, ve = !!Se, K = av(Q), _e = `https://${l}/admin/orders/${K ?? ""}`, Te = B?.shopMoney?.amount ?? 0, J = G.includes("cancelled"), Ke = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: R
  }).format(Te), an = e?.refunds ? cI(e) : {}, we = !!U?.length && U.every((Me) => (an[Me.id] || 0) >= (Me.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: dt(ha.order, {
        [ha.orderIsOpen]: F
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ha.orderHeader,
            onClick: () => z(!F),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                te && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: Qn(te).format(Sy) }) }),
                /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "1", children: [
                  "Order ",
                  Z
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: F ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        F && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: Z.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Je, { content: "Copy order number", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => v(Z.replace("#", "")),
                    className: ha.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: G })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Je, { content: "Copy order status", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: j ? "done" : "copy",
                    onClick: () => _(G),
                    className: ha.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: Ke })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Je, { content: "Copy order value", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: I ? "done" : "copy",
                    onClick: () => w(Te),
                    className: ha.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            M7,
            {
              orderId: Q,
              tags: ye,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            Ny,
            {
              openByDefault: !ve,
              labelText: "Billing address",
              address: ee,
              shippingCountryCodes: i,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            Ny,
            {
              openByDefault: ve,
              shopifyId: n,
              orderId: Q,
              icon: "map-pin",
              labelText: "Shipping address",
              address: Se,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            $7,
            {
              orderId: Q,
              lineItems: U,
              refundedQuantities: an
            }
          ),
          /* @__PURE__ */ k.jsx(W7, { trackingInfos: fe }),
          (o || p) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              P7,
              {
                order: e,
                shopifyId: n,
                refetchOrders: d,
                orderLink: _e
              }
            ),
            p && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              et,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => C(!0),
                className: Gt.fullWidth,
                disabled: J || we,
                children: "Partial refund"
              }
            ) })
          ] }),
          (u || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            u && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              et,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => L(!0),
                className: Gt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              N7,
              {
                orderId: Q,
                orderName: Z,
                disabled: J,
                refetchOrders: d
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            Bt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_e, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: Q
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        y && /* @__PURE__ */ k.jsx(
          C7,
          {
            order: e,
            shopifyId: n,
            orderName: Z,
            isOpen: y,
            setIsOpen: L,
            refetchOrders: d
          }
        ),
        E && /* @__PURE__ */ k.jsx(
          R7,
          {
            order: e,
            orderName: Z,
            isOpen: E,
            setIsOpen: C,
            refetchOrders: () => {
              d();
            }
          }
        )
      ]
    }
  );
}, X7 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: u,
  shopifyCustomer: p
}) => {
  const { track: d } = $n(), [f, h] = ue([]), [v, I] = ue(!1), w = av(p?.id), j = `https://${n}/admin/orders?customer_id=${w ?? ""}`, {
    getCustomerOrders: _,
    isCustomerOrdersLoading: y,
    customerOrdersError: L,
    customerOrders: E,
    refetchCustomerOrders: C
  } = I9();
  return Xe(() => {
    !y && w && _({
      variables: {
        query: `customer_id:${w}`
      }
    });
  }, [w]), Xe(() => {
    const F = E?.Shopify?.orders?.edges;
    F && h(a7({ ordersData: F }));
  }, [E]), p ? L ? /* @__PURE__ */ k.jsx(Tn, { error: L }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(Bn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      et,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => I(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(vn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((F, z) => /* @__PURE__ */ k.jsx(
        J7,
        {
          order: F,
          openByDefault: z === 0,
          shopifyId: p?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: u,
          customerCountryCodes: e,
          refetchOrders: C,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${z}-${F.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        Bt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
          onClick: () => d("shopify:view:all:orders:clicked", {
            shopifyId: p?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      b7,
      {
        isOpen: v,
        setIsOpen: I,
        shopifyCustomer: p,
        refetchCustomerOrders: C,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, Z7 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Qe, { className: Gt.list, children: [
      /* @__PURE__ */ k.jsx(Qe.Text, { variant: "dense", className: Gt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { variant: "dense", className: Gt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, eK = "_segmentName_1dkhk_1", nK = {
  segmentName: eK
}, tK = 100, Ws = 10, rK = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = _n(), [i, a] = ue([]), [o, s] = ue(Ws), [l, u] = ue(!1), p = Xn(
    () => i.filter((w) => w.isMember).length,
    [i]
  ), { loading: d, error: f } = n(
    v9,
    {
      skip: !e,
      variables: {
        first: tK
      },
      onCompleted: (w) => {
        const j = w?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const _ = j.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, L) => y.name.localeCompare(L.name));
          a(_), h({
            variables: {
              customerId: e,
              segmentIds: _.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: I }
  ] = r(k9, {
    onCompleted: (w) => {
      const j = w?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const _ = i.map((y) => {
          const L = j.find(
            (E) => E.segmentId === y.id
          );
          return {
            ...y,
            ...L?.isMember && { isMember: L.isMember }
          };
        }).sort(
          (y, L) => y.isMember === L.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(_);
      }
    }
  });
  return Xe(() => {
    s(l ? i.length : Ws);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Segment membership" }),
      !d && /* @__PURE__ */ k.jsx(Bn, { variant: "success", size: "small", children: p })
    ] }),
    d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(vn, {}) }),
    !d && i.length === 0 && /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Tn, { error: f }),
    I && /* @__PURE__ */ k.jsx(Tn, { error: I }),
    !d && i.length > 0 && /* @__PURE__ */ k.jsxs(Qe, { className: Gt.list, children: [
      i.slice(0, o).map(({ id: w, name: j, isMember: _ }) => /* @__PURE__ */ k.jsx(Qe.Text, { className: Gt.listItem, children: /* @__PURE__ */ k.jsx(
        Je,
        {
          content: `${_ ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", className: nK.segmentName, children: j }),
            v && /* @__PURE__ */ k.jsx(vn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              he,
              {
                color: _ ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, w)),
      i.length > Ws && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        et,
        {
          variant: "secondary",
          onClick: () => u(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Ws} more`
        }
      ) })
    ] })
  ] }) : null;
}, iK = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = F9({ conversationContext: e }), [l, u] = ue(), [p, d] = ue(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, I = n.enableEditShippingAddress ?? !1, w = n.displayEmailMarketingConsent ?? !1, j = n.displayOrdersOverview ?? !1, _ = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, L = n.displayDiscountCodes ?? !1, E = n.displayCreateOrder ?? !1, C = n.displayDuplicateOrder ?? !1, F = n.displayCreateDraftOrder ?? !1, z = n.displayPartialRefundOrder ?? !1;
  if (Xe(() => {
    const Q = a?.Shopify?.customers?.edges[0]?.node;
    Q && !r ? (d(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(Q)) : u(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(Tn, { error: i, retry: o });
  if (!r && !i && !l) {
    const Q = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              A9,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              Bt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Q, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== dr.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(vn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          z9,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        j && /* @__PURE__ */ k.jsx(
          Z7,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        _ && /* @__PURE__ */ k.jsx(rK, { shopifyId: l?.id }),
        w && /* @__PURE__ */ k.jsx(i7, { customer: l }),
        L && /* @__PURE__ */ k.jsx(
          r7,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          X7,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: E,
            displayCreateDraftOrder: F,
            enableEditShippingAddress: I,
            customerCountryCodes: p,
            displayDuplicateOrder: C,
            displayPartialRefundOrder: z
          }
        )
      ]
    }
  );
}, Pt = [];
for (let e = 0; e < 256; ++e)
  Pt.push((e + 256).toString(16).slice(1));
function aK(e, n = 0) {
  return (Pt[e[n + 0]] + Pt[e[n + 1]] + Pt[e[n + 2]] + Pt[e[n + 3]] + "-" + Pt[e[n + 4]] + Pt[e[n + 5]] + "-" + Pt[e[n + 6]] + Pt[e[n + 7]] + "-" + Pt[e[n + 8]] + Pt[e[n + 9]] + "-" + Pt[e[n + 10]] + Pt[e[n + 11]] + Pt[e[n + 12]] + Pt[e[n + 13]] + Pt[e[n + 14]] + Pt[e[n + 15]]).toLowerCase();
}
const oK = new Uint8Array(16);
function sK() {
  return crypto.getRandomValues(oK);
}
function lK(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : cK(e);
}
function cK(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? sK();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, aK(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Eh = { exports: {} }, Co = {}, yw;
function uK() {
  if (yw) return Co;
  yw = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Co.Fragment = r, Co.jsx = s, Co.jsxs = s, Co;
}
var Ks = {}, gw;
function dK() {
  return gw || (gw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Ks.Fragment = i, Ks.jsx = Un, Ks.jsxs = Kn;
  })()), Ks;
}
var vw;
function mK() {
  return vw || (vw = 1, process.env.NODE_ENV === "production" ? Eh.exports = uK() : Eh.exports = dK()), Eh.exports;
}
var V = mK(), uI = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(uI || {}), jy = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(jy || {});
const pK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, fK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, hK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, yK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, gK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, vK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, kK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, bK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, _K = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, xK = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": pK,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": fK,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": hK,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": yK,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": gK,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": vK,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": kK,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": bK,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": _K
};
function hi(e) {
  return xK[e] ?? {};
}
const SK = hi(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), NK = hi(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), jK = hi(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), wK = hi(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), CK = hi(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), FK = hi(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), IK = hi(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), $K = hi(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), EK = hi(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), TK = ({
  contactId: e
}) => {
  const { useQuery: n } = _n(), { track: r } = $n(), [i, a] = ue(), [o, s] = ue(), [l, u] = ue(), {
    loading: p,
    error: d,
    data: f,
    refetch: h
  } = n(SK, {
    skip: !e,
    variables: { contactId: e }
  });
  return Xe(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !p && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && u(
      v?.consents?.filter(
        (I) => I !== null
      ) || void 0
    )), !p && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, p]), Xn(
    () => ({
      isLoading: p,
      error: d,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [d, i, o, l]
  );
};
function pl(e = !1, n) {
  const [r, i] = ue(e);
  return Xe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const DK = {
  count: 0,
  items: []
}, OK = ({
  contactId: e
}) => {
  const { useQuery: n } = _n(), { track: r } = $n(), [i, a] = ue(DK), {
    loading: o,
    error: s,
    data: l
  } = n(wK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Xe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const u = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, p = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, d = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (p?.count ?? 0) + (d?.count ?? 0) + (u?.count ?? 0),
        items: [
          ...p.items ?? [],
          ...u.items ?? [],
          ...d.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: u.count ?? 0,
        smsReceived: p.count ?? 0,
        postalReceived: d.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, RK = {
  count: 0,
  totalCount: 0,
  items: []
}, PK = ({
  contactId: e
}) => {
  const { useQuery: n } = _n(), { track: r } = $n(), [i, a] = ue(
    RK
  ), {
    loading: o,
    error: s,
    data: l
  } = n(CK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Xe(() => {
    const u = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && u) {
      a(
        u
      );
      const { count: p } = u;
      p && r("voyado:transactions:received", { count: p });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, AK = ({
  conversationContext: e
}) => {
  const { useQuery: n } = _n(), [r, i] = ue(void 0), [a, o] = ue(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: u,
    error: p,
    data: d,
    refetch: f
  } = n(jK, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Xe(() => {
    const h = d?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [d?.Voyado, u]), {
    isLoading: u,
    contactId: r,
    hasMultipleContacts: a,
    error: p,
    refetch: f
  };
}, LK = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = _n(), [i, a] = ue(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: u
  } = r(NK, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Xe(() => {
    const p = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && p && Object.hasOwn(p, "memberlevel")) {
      const d = p?.memberlevel;
      a({
        levelName: d?.levelName,
        remainingToUpgrade: d?.remainingToUpgrade,
        basedOnRewardPoints: d?.basedOnRewardPoints,
        levelId: d?.levelId,
        latestChange: d?.latestChange,
        expires: d?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Xn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: u
    }),
    [o, s, i, u]
  );
}, VK = "_pointer_ls8kj_48", zK = "_list_ls8kj_53", UK = "_listItem_ls8kj_63", pt = {
  pointer: VK,
  list: zK,
  listItem: UK
}, MK = "_modalBody_1clhs_1", BK = {
  modalBody: MK
}, qK = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = _n(), { track: l } = $n(), u = r?.id, p = r?.balance ?? 0, d = {
    balance: p?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = St({
    defaultValues: d,
    mode: "onChange"
  }), I = Po({ control: f }), w = parseInt(I?.balance ?? "0", 10), j = p === w, _ = j ? "Change the value to update the points" : "", y = w < 0, L = y ? "Points can not be negative" : "", E = I.description === "", C = E ? "Description can not be empty" : "";
  Xe(() => {
    w > p ? h(
      "transactionType",
      jy.Addition
    ) : w < p && h(
      "transactionType",
      jy.Deduction
    );
  }, [p, w, h]);
  const [F, { loading: z, error: Q, reset: Z }] = o(EK, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), te = () => {
    if (u) {
      const B = lK();
      F({
        variables: {
          input: {
            accountId: u,
            transactionId: B,
            amount: Math.abs(w - p),
            transactionType: I.transactionType,
            description: I.description,
            source: uI.UpdateBalance
          }
        }
      }).then(async (R) => {
        R?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), G());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, G = () => {
    v(d), Z(), n();
  };
  return /* @__PURE__ */ V.jsxs(
    Et,
    {
      isOpen: e,
      onClose: G,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ V.jsx(Tt, { title: "Update points balance", onClose: G }),
        /* @__PURE__ */ V.jsxs(Dt, { className: BK.modalBody, children: [
          /* @__PURE__ */ V.jsxs(mt, { children: [
            /* @__PURE__ */ V.jsx(pe, { span: 6, children: /* @__PURE__ */ V.jsx(
              zt,
              {
                name: "balance",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ V.jsx(
                  ur,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: _ || L
                    },
                    input: {
                      ...B,
                      value: B.value.toString(),
                      onChange: (R) => B.onChange(R)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ V.jsx(pe, { span: 6, children: /* @__PURE__ */ V.jsx(
              zt,
              {
                name: "description",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ V.jsx(
                  ur,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: B,
                    meta: {
                      warning: C
                    }
                  }
                )
              }
            ) })
          ] }),
          Q && /* @__PURE__ */ V.jsx(Tn, { error: Q })
        ] }),
        /* @__PURE__ */ V.jsx(
          Ht,
          {
            confirmName: "Save",
            confirmOnClick: () => te(),
            confirmProps: {
              isLoading: z,
              disabled: j || y || E,
              loadingIndicator: /* @__PURE__ */ V.jsx(vn, { size: 16 })
            },
            cancelOnClick: G
          }
        )
      ]
    }
  );
}, HK = "_wrapper_1ge6c_1", WK = "_block_1ge6c_12", kw = {
  wrapper: HK,
  block: WK
}, KK = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = _n(), { isCopied: i, copy: a } = pl(), { isCopied: o, copy: s } = pl(), { isCopied: l, copy: u } = pl(), [p, d] = ue(!1), [f, h] = ue(), [v, I] = ue(!1), {
    loading: w,
    data: j,
    refetch: _
  } = r(IK, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Xe(() => {
    if (j) {
      const ee = j?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [j]);
  const y = !!f?.id, L = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: E,
    lastName: C,
    street: F,
    zipCode: z,
    city: Q,
    country: Z,
    isRegistrationCompleted: te,
    email: G,
    mobilePhone: B
  } = e, R = 14, U = `${E || ""} ${C || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", className: kw.wrapper, children: [
    /* @__PURE__ */ V.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: kw.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-2", children: U }),
          w && /* @__PURE__ */ V.jsx(vn, { size: 12 }),
          y && !w && /* @__PURE__ */ V.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ V.jsxs(Bn, { size: "small", variant: "warning", children: [
              L,
              " points"
            ] }),
            /* @__PURE__ */ V.jsx(Je, { content: "Update points balance", children: /* @__PURE__ */ V.jsx(
              he,
              {
                name: "pen",
                size: 12,
                onClick: () => d(!0),
                className: pt.pointer
              }
            ) }),
            v && /* @__PURE__ */ V.jsx(Je, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ V.jsx(
              he,
              {
                name: "info",
                size: 12,
                className: pt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (F || Q || z || Z || B || G) && /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
      B && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(he, { size: R, name: "phone" }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: B })
        ] }),
        /* @__PURE__ */ V.jsx(
          he,
          {
            size: R,
            name: o ? "done" : "copy",
            onClick: () => s(B),
            className: pt.pointer
          }
        )
      ] }),
      G && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(he, { size: R, name: "mail" }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: G })
        ] }),
        /* @__PURE__ */ V.jsx(
          he,
          {
            size: R,
            name: i ? "done" : "copy",
            onClick: () => a(G),
            className: pt.pointer
          }
        )
      ] }),
      (F || Q || z || Z) && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ V.jsx(he, { size: R, name: "home" }),
          /* @__PURE__ */ V.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ V.jsx(ct, { children: F }),
            /* @__PURE__ */ V.jsxs(ct, { children: [
              z,
              " ",
              Q
            ] }),
            /* @__PURE__ */ V.jsx(ct, { children: Z })
          ] })
        ] }),
        /* @__PURE__ */ V.jsx(
          he,
          {
            size: R,
            name: l ? "done" : "copy",
            onClick: () => u(`${F}, ${z} ${Q}, ${Z}`),
            className: pt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(he, { size: R, name: "sign-in" }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ V.jsx(
          he,
          {
            name: te ? "check-circle-filled" : "close-circle-filled",
            color: te ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ V.jsx(
      qK,
      {
        isOpen: p,
        pointsAccount: f,
        onClose: () => d(!1),
        setHasPointsBeenUpdated: I,
        refetchPointsQuery: _
      }
    )
  ] });
}, GK = "_list_yud4a_7", YK = "_listItem_yud4a_11", QK = "_listItemTooltip_yud4a_15", JK = "_listItemTimestamp_yud4a_18", Gs = {
  list: GK,
  listItem: YK,
  listItemTooltip: QK,
  listItemTimestamp: JK
}, XK = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ V.jsx(Qe, { className: Gs.list, children: e.map((n, r) => /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: Gs.listItem, children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ V.jsx(Je, { content: n?.comment, children: /* @__PURE__ */ V.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: dt({
          [Gs.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { className: Gs.listItemTimestamp, children: Qn(n.date).format(It) }),
          n?.comment && /* @__PURE__ */ V.jsx(he, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ V.jsx(
      he,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), ZK = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Qn(e.latestChange).format(It) : null, o = e?.expires ? `${Qn(e.expires).fromNow()} (${Qn(e.expires).format(It)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ V.jsx(Je, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ V.jsx(
        he,
        {
          name: "question",
          size: 14,
          className: pt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ V.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ V.jsxs(Qe, { className: pt.list, children: [
      s && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Je, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ V.jsx(Bn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Je, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ V.jsx(Bn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Je, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ V.jsx(Bn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Je, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ V.jsx(Je, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, eG = "_tagHover_kzbzk_1", nG = "_channelUnsubscribed_kzbzk_6", bw = {
  tagHover: eG,
  channelUnsubscribed: nG
}, Th = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = $n(), { useMutation: l } = _n(), [u, p] = ue(!1), [d, { loading: f }] = l($K), h = async ({
    newPreference: I,
    isSubscribed: w,
    channelType: j
  }) => {
    p(!0), (await d({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...I
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? w ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : w ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => p(!1));
    }, 1e3);
  }, v = u || f;
  return /* @__PURE__ */ V.jsx(Je, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ V.jsx(
    Yn,
    {
      className: bw.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ V.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: dt({
            [bw.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ V.jsx(vn, { size: 16 }) : /* @__PURE__ */ V.jsx(he, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, tG = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        Th,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ V.jsx(
        Th,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ V.jsx(
        Th,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, rG = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: u,
    refetch: p,
    attributes: d,
    preferences: f,
    consents: h
  } = TK({ contactId: e }), {
    isLoading: v,
    error: I,
    memberLevel: w
  } = LK({ contactId: e, skip: !s }), j = v || l, _ = Xn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return u || I ? Oa({
    errors: u?.graphQLErrors || I?.graphQLErrors || []
  }) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(P.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ V.jsx(Tn, { error: u || I }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(P.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    r && /* @__PURE__ */ V.jsx(
      KK,
      {
        contactAttributes: d,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ V.jsx(ZK, { memberLevel: w }),
    i && /* @__PURE__ */ V.jsx(
      tG,
      {
        refetchContact: p,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ V.jsx(XK, { contactConsents: _ })
  ] });
}, wy = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, iG = "_list_zu4s7_1", aG = "_listItem_zu4s7_4", oG = "_listSum_zu4s7_7", Ys = {
  list: iG,
  listItem: aG,
  listSum: oG
}, sG = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ V.jsxs(Qe, { className: Ys.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ V.jsx(Qe.Text, { variant: "dense", className: Ys.listItem, children: /* @__PURE__ */ V.jsx(Je, { content: s, children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ V.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ V.jsx(b, { flex: "auto", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ V.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: wy(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ V.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: dt(Ys.listItem, Ys.listSum),
      children: /* @__PURE__ */ V.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: wy(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), lG = "_transaction_1kr8d_1", cG = "_transactionIsOpen_1kr8d_9", uG = "_transactionHeader_1kr8d_12", dG = "_transactionHeaderSubLine_1kr8d_15", mG = "_transactionHeaderAlignItemRight_1kr8d_19", ya = {
  transaction: lG,
  transactionIsOpen: cG,
  transactionHeader: uG,
  transactionHeaderSubLine: dG,
  transactionHeaderAlignItemRight: mG
}, pG = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: u,
    lineItems: p,
    localCurrency: d,
    localNetPriceSum: f
  } = e, h = d ?? "", v = f ?? 0, I = p?.length ? p : [];
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: dt(ya.transaction, {
        [ya.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ya.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ V.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: Qn(o).format(It) }),
                  /* @__PURE__ */ V.jsxs(
                    P.Heading,
                    {
                      variant: "heading-4",
                      className: ya.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ V.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ya.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-4", children: wy(v, h) }),
                      /* @__PURE__ */ V.jsxs(
                        P.Heading,
                        {
                          variant: "heading-4",
                          className: ya.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ V.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ V.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ V.jsx(Ty, {}),
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-2", children: s }),
                u && /* @__PURE__ */ V.jsx(Yn, { children: /* @__PURE__ */ V.jsx(b, { alignItems: "center", children: u }) }),
                /* @__PURE__ */ V.jsx(
                  sG,
                  {
                    lineItems: I,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, fG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = PK({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ V.jsx(Tn, { error: r }) : /* @__PURE__ */ V.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
          s === 0 && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, u) => /* @__PURE__ */ V.jsx(
            pG,
            {
              transaction: l,
              openByDefault: u === 0
            },
            u
          ))
        ] })
      ]
    }
  );
}, hG = "_message_unsvt_48", yG = "_messageIsOpen_unsvt_56", gG = "_messageHeader_unsvt_60", vG = "_messageText_unsvt_64", kG = "_buttonLink_unsvt_86", Fo = {
  message: hG,
  messageIsOpen: yG,
  messageHeader: gG,
  messageText: vG,
  buttonLink: kG
}, Dh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Oh = (e, n) => n && e in Dh && n in Dh[e] ? Dh[e][n] : null, bG = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n), { track: a } = $n();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: u,
    isTransactional: p,
    status: d,
    messageLink: f,
    messageText: h
  } = e, v = l ? Oh("type", l) : null, I = u ? Oh("source", u) : null, w = d ? Oh("status", d) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: dt(Fo.message, {
        [Fo.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Fo.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
                    /* @__PURE__ */ V.jsx(he, { name: v, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: Qn(s).format(It) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ V.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ V.jsx(Ty, {}),
          /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            w && /* @__PURE__ */ V.jsx(Yn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(he, { name: w }),
              " ",
              d
            ] }) }),
            I && /* @__PURE__ */ V.jsx(Yn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(he, { name: I }),
              " ",
              u
            ] }) }),
            p && /* @__PURE__ */ V.jsx(Yn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(he, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", className: Fo.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ V.jsx(
            Bt,
            {
              slotEnd: /* @__PURE__ */ V.jsx(he, { name: "external-link" }),
              variant: "tertiary",
              className: Fo.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, _G = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = OK({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ V.jsx(Tn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ V.jsx(Bn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      l && o?.map((u, p) => /* @__PURE__ */ V.jsx(
        bG,
        {
          message: u || void 0,
          openByDefault: p === 0
        },
        p
      )),
      !l && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, pc = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, _w = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = pl(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = ft(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(he, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ V.jsx(Je, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ V.jsx(
      he,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: pt.pointer
      }
    ) })
  ] });
}, xG = "_order_19t4p_1", SG = "_orderIsOpen_19t4p_9", NG = "_orderHeader_19t4p_12", jG = "_orderIconColor_19t4p_15", zr = {
  order: xG,
  orderIsOpen: SG,
  orderHeader: NG,
  orderIconColor: jG
}, wG = "_delivery_1m9nb_1", CG = "_deliveryCode_1m9nb_4", Rh = {
  delivery: wG,
  deliveryCode: CG
}, FG = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = ir();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ V.jsx(
      he,
      {
        size: l,
        name: "eye",
        className: zr.orderIconColor
      }
    ),
    /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ V.jsx(
        Je,
        {
          content: /* @__PURE__ */ V.jsxs(P.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Qn(s).format(It)
          ] }),
          children: /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ V.jsx(
              P.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ V.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Rh.delivery,
                    children: [
                      /* @__PURE__ */ V.jsx(he, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ V.jsx(
              P.Paragraph,
              {
                variant: "4",
                className: dt(Rh.delivery, Rh.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ V.jsx(Je, { content: "Copy tracking code", children: /* @__PURE__ */ V.jsx(
      he,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: pt.pointer
      }
    ) })
  ] });
}, IG = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        he,
        {
          size: 14,
          name: "file-text",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ V.jsx(Qe, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ V.jsx(Qe.Item, { className: pt.listItem, children: /* @__PURE__ */ V.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ V.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ V.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: pt.listItemAlignRight,
              children: [
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: pc({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, $G = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        he,
        {
          size: 14,
          name: "tag",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ V.jsx(Qe, { className: pt.list, children: r?.map((i) => /* @__PURE__ */ V.jsx(
      Qe.Item,
      {
        className: pt.listItem,
        contentLeft: /* @__PURE__ */ V.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ V.jsx(
          Je,
          {
            content: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ V.jsx(b, { children: /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: pc({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ V.jsx(
          Ra,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, EG = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        he,
        {
          size: 14,
          name: "credit-card",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ V.jsx(Qe, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ V.jsx(
      Qe.Item,
      {
        className: pt.listItem,
        children: /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ V.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: pt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "5", children: Qn(i?.paidAt).format(It) }),
                    /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: pc({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, TG = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: u,
    createdAt: p,
    lastChangedAt: d,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: I
  } = e, w = 14;
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: dt(zr.order, {
        [zr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: zr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                p && /* @__PURE__ */ V.jsx(b, { alignItems: "center", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: Qn(p).format(It) }) }),
                /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ V.jsx(
                mr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              he,
              {
                size: w,
                name: "activity",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ V.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ V.jsx(Je, { content: "Internal status", children: /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ V.jsx(Je, { content: "External status", children: /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: s }) }) }),
                /* @__PURE__ */ V.jsx(Je, { content: "Last updated at", children: /* @__PURE__ */ V.jsx(P.Paragraph, { as: "span", variant: "5", children: Qn(d).format(It) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              he,
              {
                size: w,
                name: "chart-bar",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: pc({
                value: I,
                currencyCode: l
              }) })
            ] })
          ] }),
          u && /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              he,
              {
                size: w,
                name: "channels",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", children: /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: u }) }) })
            ] })
          ] }),
          /* @__PURE__ */ V.jsx(_w, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ V.jsx(
            _w,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ V.jsx(FG, { delivery: e.delivery }),
          /* @__PURE__ */ V.jsx($G, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ V.jsx(IG, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ V.jsx(
            EG,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, DG = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || Oa({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ V.jsx(Tn, { error: e }) : /* @__PURE__ */ V.jsx(V.Fragment, { children: r }), OG = ({
  contactId: e
}) => {
  const { useQuery: n } = _n(), [r, i] = ue([]), { track: a } = $n(), {
    loading: o,
    error: s,
    data: l
  } = n(FK, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Xe(() => {
    if (l?.Voyado) {
      const u = l?.Voyado.Orders_GetAllByContact;
      if (!o && u?.items) {
        i(u.items);
        const { totalCount: p } = u;
        p && a("voyado:orders:received", { count: p });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ V.jsx(P.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ V.jsx(Bn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsx(DG, { error: s, itemCount: r.length, children: r.map((u, p) => /* @__PURE__ */ V.jsx(
      TG,
      {
        order: u,
        openByDefault: p === 0
      },
      p
    )) })
  ] }) : null;
}, RG = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = AK({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: u,
    showPreferences: p,
    showAudiences: d,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: I
  } = n;
  return s ? /* @__PURE__ */ V.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ V.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Oa({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ V.jsx(Tn, { error: o }) : !u && !p && !d && !f && !h && !v ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(vn, {}) }) : /* @__PURE__ */ V.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ V.jsx(rG, { contactId: i, settings: n }),
        h && /* @__PURE__ */ V.jsx(_G, { contactId: i }),
        v && /* @__PURE__ */ V.jsx(fG, { contactId: i }),
        I && /* @__PURE__ */ V.jsx(OG, { contactId: i }),
        !l && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ V.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, Cy = [
  {
    key: "voyadoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], PG = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, AG = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = St({
    mode: "onChange",
    defaultValues: PG
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = si({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: I,
    error: w,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: y
  } = li({
    integrationId: e,
    fieldDefinitions: Cy,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: C } = ci({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), F = (Q) => di(Q, {
    fieldDefinitions: Cy,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: C
  }), z = s.watch("name");
  return /* @__PURE__ */ V.jsxs(
    ui,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: w ?? f,
      onRetry: w ? _ : void 0,
      isLoading: d || I,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ V.jsx(mi, { cause: h }),
        /* @__PURE__ */ V.jsxs(mt, { children: [
          /* @__PURE__ */ V.jsx(pe, { children: /* @__PURE__ */ V.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(
            Zo,
            {
              name: "voyadoApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(
            tt,
            {
              name: "apiHostName",
              label: "API URL",
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(rn, { label: "Show the customer attributes", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(rn, { label: "Show preferences", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(rn, { label: "Show audiences", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(rn, { label: "Show consents", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(rn, { label: "Show the last 5 messages", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(rn, { label: "Show customer transactions", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(rn, { label: "Show orders by contact", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          /* @__PURE__ */ V.jsx(pe, { span: 3, children: /* @__PURE__ */ V.jsx(rn, { label: "Show member level", children: /* @__PURE__ */ V.jsx(
            An,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(pe, { span: 3 }),
          a && L !== null && /* @__PURE__ */ V.jsx(pe, { children: a({
            value: L,
            onChange: E,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ V.jsx(
          pi,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: z,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_11mz1_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_11mz1_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_11mz1_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_11mz1_63:last-child{box-shadow:none}._listItemHighlighted_11mz1_72{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ph = { exports: {} }, Io = {}, xw;
function LG() {
  if (xw) return Io;
  xw = 1;
  var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Io.Fragment = r, Io.jsx = s, Io.jsxs = s, Io;
}
var Qs = {}, Sw;
function VG() {
  return Sw || (Sw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ee, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), I = Symbol.iterator, w = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = I && t[I] || t[w];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          m[g - 1] = arguments[g];
        L("error", t, m);
      }
    }
    function L(t, c, m) {
      {
        var g = _.ReactDebugCurrentFrame, $ = g.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var O = m.map(function(N) {
          return String(N);
        });
        O.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, O);
      }
    }
    var E = !1, C = !1, F = !1, z = !1, Q = !1, Z;
    Z = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || z || t === v || E || C || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Z || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var g = t.displayName;
      if (g)
        return g;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var $ = t, O = $._payload, N = $._init;
            try {
              return R(N(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, Se, fe, ye, ve, K, _e, Te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Se = console.log, fe = console.info, ye = console.warn, ve = console.error, K = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function an() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, t, {
              value: Se
            }),
            info: U({}, t, {
              value: fe
            }),
            warn: U({}, t, {
              value: ye
            }),
            error: U({}, t, {
              value: ve
            }),
            group: U({}, t, {
              value: K
            }),
            groupCollapsed: U({}, t, {
              value: _e
            }),
            groupEnd: U({}, t, {
              value: Te
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Me;
    function Re(t, c, m) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch ($) {
            var g = $.stack.trim().match(/\n( *(at )?)/);
            Me = g && g[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Be = !1, Ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ge();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var g;
      Be = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Ke();
      try {
        if (c) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (re) {
              g = re;
            }
            Reflect.construct(t, [], N);
          } else {
            try {
              N.call();
            } catch (re) {
              g = re;
            }
            t.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            g = re;
          }
          t();
        }
      } catch (re) {
        if (re && g && typeof re.stack == "string") {
          for (var S = re.stack.split(`
`), ne = g.stack.split(`
`), q = S.length - 1, W = ne.length - 1; q >= 1 && W >= 0 && S[q] !== ne[W]; )
            W--;
          for (; q >= 1 && W >= 0; q--, W--)
            if (S[q] !== ne[W]) {
              if (q !== 1 || W !== 1)
                do
                  if (q--, W--, W < 0 || S[q] !== ne[W]) {
                    var le = `
` + S[q].replace(" at new ", " at ");
                    return t.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, le), le;
                  }
                while (q >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        Be = !1, we.current = O, an(), Error.prepareStackTrace = $;
      }
      var Ue = t ? t.displayName || t.name : "", De = Ue ? Re(Ue) : "";
      return typeof t == "function" && Ae.set(t, De), De;
    }
    function qe(t, c, m) {
      return Ce(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function ie(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case p:
          return Re("Suspense");
        case d:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return qe(t.render);
          case f:
            return ie(t.type, c, m);
          case h: {
            var g = t, $ = g._payload, O = g._init;
            try {
              return ie(O($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, xe = {}, Le = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(m);
      } else
        Le.setExtraStackFrame(null);
    }
    function yn(t, c, m, g, $) {
      {
        var O = Function.call.bind(se);
        for (var N in t)
          if (O(t, N)) {
            var S = void 0;
            try {
              if (typeof t[N] != "function") {
                var ne = Error((g || "React class") + ": " + m + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[N](c, N, g, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (q) {
              S = q;
            }
            S && !(S instanceof Error) && (Pe($), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", m, N, typeof S), Pe(null)), S instanceof Error && !(S.message in xe) && (xe[S.message] = !0, Pe($), y("Failed %s type: %s", m, S.message), Pe(null));
          }
      }
    }
    var T = Array.isArray;
    function x(t) {
      return T(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function A(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var M = _.ReactCurrentOwner, ae = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, Ne;
    function tn(t) {
      if (se.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (se.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function nn(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function dn(t, c) {
      {
        var m = function() {
          ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function wn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, g, $, O, N) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: N,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function Cn(t, c, m, g, $) {
      {
        var O, N = {}, S = null, ne = null;
        m !== void 0 && (A(m), S = "" + m), gn(c) && (A(c.key), S = "" + c.key), tn(c) && (ne = c.ref, nn(c));
        for (O in c)
          se.call(c, O) && !ae.hasOwnProperty(O) && (N[O] = c[O]);
        if (t && t.defaultProps) {
          var q = t.defaultProps;
          for (O in q)
            N[O] === void 0 && (N[O] = q[O]);
        }
        if (S || ne) {
          var W = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(N, W), ne && wn(N, W);
        }
        return xn(t, S, ne, $, g, M.current, N);
      }
    }
    var Ze = _.ReactCurrentOwner, kn = _.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var c = t._owner, m = ie(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(m);
      } else
        kn.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function pn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Pn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), ze(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, g), ze(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var m = 0; m < t.length; m++) {
            var g = t[m];
            pn(g) && bn(g, c);
          }
        else if (pn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var O = $.call(t), N; !(N = O.next()).done; )
              pn(N.value) && bn(N.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var g = R(c);
          yn(m, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !mn) {
          mn = !0;
          var $ = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var g = c[m];
          if (g !== "children" && g !== "key") {
            ze(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), ze(null);
            break;
          }
        }
        t.ref !== null && (ze(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var In = {};
    function Fn(t, c, m, g, $, O) {
      {
        var N = te(t);
        if (!N) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? S += ne : S += jn();
          var q;
          t === null ? q = "null" : x(t) ? q = "array" : t !== void 0 && t.$$typeof === n ? (q = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : q = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, S);
        }
        var W = Cn(t, c, m, $, O);
        if (W == null)
          return W;
        if (N) {
          var le = c.children;
          if (le !== void 0)
            if (g)
              if (x(le)) {
                for (var Ue = 0; Ue < le.length; Ue++)
                  Sn(le[Ue], t);
                Object.freeze && Object.freeze(le);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(le, t);
        }
        if (se.call(c, "key")) {
          var De = R(t), re = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), fn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!In[De + fn]) {
            var On = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, fn, De, On, De), In[De + fn] = !0;
          }
        }
        return t === i ? Vn(W) : Ln(W), W;
      }
    }
    function zn(t, c, m) {
      return Fn(t, c, m, !0);
    }
    function Hn(t, c, m) {
      return Fn(t, c, m, !1);
    }
    var Un = Hn, Kn = zn;
    Qs.Fragment = i, Qs.jsx = Un, Qs.jsxs = Kn;
  })()), Qs;
}
var Nw;
function zG() {
  return Nw || (Nw = 1, process.env.NODE_ENV === "production" ? Ph.exports = LG() : Ph.exports = VG()), Ph.exports;
}
var Ve = zG();
const UG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, MG = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": UG
};
function BG(e) {
  return MG[e] ?? {};
}
const qG = BG(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), HG = "_copyIcon_11mz1_48", WG = "_list_11mz1_53", KG = "_listItem_11mz1_63", GG = "_listItemHighlighted_11mz1_72", Ta = {
  copyIcon: HG,
  list: WG,
  listItem: KG,
  listItemHighlighted: GG
}, YG = "_wrapper_1xucg_1", QG = "_externalLink_1xucg_7", Ah = {
  wrapper: YG,
  externalLink: QG
}, JG = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = ir(), { isCopied: i, copy: a } = ir();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: u,
    account_created_at: p
  } = e, d = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ve.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ve.jsxs(b, { className: Ah.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ve.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Ah.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-2", children: f })
      }
    ),
    p && /* @__PURE__ */ Ve.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", children: Qn(p).format(It) })
    ] }),
    l && /* @__PURE__ */ Ve.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ve.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ve.jsx(he, { size: d, name: "mail" }),
        /* @__PURE__ */ Ve.jsx("span", { className: Ah.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ve.jsx(Je, { content: "Copy email", children: /* @__PURE__ */ Ve.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ve.jsx(
        he,
        {
          size: d,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: Ta.copyIcon
        }
      ) }) })
    ] }),
    u && /* @__PURE__ */ Ve.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ve.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ve.jsx(he, { size: d, name: "phone" }),
        /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", children: u })
      ] }),
      /* @__PURE__ */ Ve.jsx(Je, { content: "Copy phone number", children: /* @__PURE__ */ Ve.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ve.jsx(
        he,
        {
          size: d,
          name: i ? "done" : "copy",
          onClick: () => a(u),
          className: Ta.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Zn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = Gw(n);
  return /* @__PURE__ */ Ve.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: dt(Ta.listItem, {
        [Ta.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ve.jsx(Je, { content: r, children: /* @__PURE__ */ Ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", children: e }),
        a ? n : Gi(n)
      ] }) })
    }
  );
}, XG = ({
  loyalty: e
}) => /* @__PURE__ */ Ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ve.jsxs(Qe, { className: Ta.list, children: [
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), ZG = 0.8, e8 = 0.4, jw = (e) => {
  if (e != null)
    return e >= ZG ? /* @__PURE__ */ Ve.jsx(Bn, { variant: "success", size: "small", children: "Positive" }) : e <= e8 ? /* @__PURE__ */ Ve.jsx(Bn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ve.jsx(Bn, { variant: "warning", size: "small", children: "Neutral" });
}, n8 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ve.jsxs(Qe, { className: Ta.list, children: [
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: jw(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: jw(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Qn(e.last_review_date).format(
          It
        )
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Zn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ve.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ve.jsx(Bn, { variant: "info", size: "small", children: /* @__PURE__ */ Ve.jsx(Ve.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), t8 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = _n(), { track: i } = $n(), [a, o] = ue(), [s, l] = ue(!1), u = e?.customer?.email, p = e?.customer?.phone_number, d = !u && !p, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showUserGeneratedContent ?? !1, I = n?.displayLoyalty ?? !1, w = n?.displaySubscriptions ?? !1, j = !f, _ = !h && !v && !I && !w, {
    loading: y,
    error: L,
    data: E
  } = r(qG, {
    skip: d || j,
    variables: {
      ...u && { email: u },
      ...!u && p && { phone: p },
      storeId: f,
      expand: "all"
    }
  });
  if (Xe(() => {
    const C = E?.Yotpo?.getCustomers?.customers?.[0];
    C ? (o(C), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [E?.Yotpo, y]), j)
    return /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ve.jsx(
      Tn,
      {
        error: new e1({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (d)
    return /* @__PURE__ */ Ve.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (_)
    return /* @__PURE__ */ Ve.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (y)
    return /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ve.jsx(vn, {}) });
  if (s)
    return /* @__PURE__ */ Ve.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ve.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (L) {
    const C = L.graphQLErrors;
    return zl({ errors: C }) ? /* @__PURE__ */ Ve.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ul({ errors: C }) ? /* @__PURE__ */ Ve.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ve.jsx(Tn, { error: L });
  }
  return /* @__PURE__ */ Ve.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ve.jsx(JG, { customerDetails: a }),
        v && /* @__PURE__ */ Ve.jsx(
          n8,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        I && /* @__PURE__ */ Ve.jsx(XG, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var ps = (e) => e.type === "checkbox", Mi = (e) => e instanceof Date, rr = (e) => e == null;
const dI = (e) => typeof e == "object";
var _t = (e) => !rr(e) && !Array.isArray(e) && dI(e) && !Mi(e), mI = (e) => _t(e) && e.target ? ps(e.target) ? e.target.checked : e.target.value : e, r8 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, pI = (e, n) => e.has(r8(n)), i8 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return _t(n) && n.hasOwnProperty("isPrototypeOf");
}, cv = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Vt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(cv && (e instanceof Blob || i)) && (r || _t(e)))
    if (n = r ? [] : {}, !r && !i8(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Vt(e[a]));
  else
    return e;
  return n;
}
var fc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], gt = (e) => e === void 0, ln = (e, n, r) => {
  if (!n || !_t(e))
    return r;
  const i = fc(n.split(/[,[\].]+?/)).reduce((a, o) => rr(a) ? a : a[o], e);
  return gt(i) || i === e ? gt(e[n]) ? r : e[n] : i;
}, yr = (e) => typeof e == "boolean", uv = (e) => /^\w*$/.test(e), fI = (e) => fc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ot = (e, n, r) => {
  let i = -1;
  const a = uv(n) ? [n] : fI(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const p = e[l];
      u = _t(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const Pl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Er = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ri = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, a8 = Ee.createContext(null), dv = () => Ee.useContext(a8);
var hI = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Er.all && (n._proxyFormState[s] = !i || Er.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function o8(e) {
  const n = dv(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ee.useState(r._formState), u = Ee.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = Ee.useRef(a);
  return p.current = a, Ee.useEffect(() => r._subscribe({
    name: p.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), Ee.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), Ee.useMemo(() => hI(s, r, u.current, !1), [s, r]);
}
var Hr = (e) => typeof e == "string", yI = (e, n, r, i, a) => Hr(e) ? (i && n.watch.add(e), ln(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), ln(r, o))) : (i && (n.watchAll = !0), r);
function gI(e) {
  const n = dv(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ee.useRef(i), u = Ee.useRef(a);
  l.current = i, Ee.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(yI(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [p, d] = Ee.useState(r._getWatch(i, a));
  return Ee.useEffect(() => r._removeUnmounted()), p;
}
function s8(e) {
  const n = dv(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = pI(a._names.array, r), l = gI({
    control: a,
    name: r,
    defaultValue: ln(a._formValues, r, ln(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = o8({
    control: a,
    name: r,
    exact: !0
  }), p = Ee.useRef(e), d = Ee.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...yr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ee.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!ln(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!ln(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!ln(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!ln(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => ln(u.errors, r)
    }
  }), [u, r]), h = Ee.useCallback((j) => d.current.onChange({
    target: {
      value: mI(j),
      name: r
    },
    type: Pl.CHANGE
  }), [r]), v = Ee.useCallback(() => d.current.onBlur({
    target: {
      value: ln(a._formValues, r),
      name: r
    },
    type: Pl.BLUR
  }), [r, a._formValues]), I = Ee.useCallback((j) => {
    const _ = ln(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (y) => j.setCustomValidity(y),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), w = Ee.useMemo(() => ({
    name: r,
    value: l,
    ...yr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: I
  }), [r, i, u.disabled, h, v, I, l]);
  return Ee.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...yr(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const _ = (y, L) => {
      const E = ln(a._fields, y);
      E && E._f && (E._f.mount = L);
    };
    if (_(r, !0), j) {
      const y = Vt(ln(a._options.defaultValues, r));
      ot(a._defaultValues, r, y), gt(ln(a._formValues, r)) && ot(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), Ee.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ee.useMemo(() => ({
    field: w,
    formState: u,
    fieldState: f
  }), [w, u, f]);
}
const ww = (e) => e.render(s8(e));
var l8 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ho = (e) => Array.isArray(e) ? e : [e], Cw = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Fy = (e) => rr(e) || !dI(e);
function ji(e, n) {
  if (Fy(e) || Fy(n))
    return e === n;
  if (Mi(e) && Mi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Mi(o) && Mi(s) || _t(o) && _t(s) || Array.isArray(o) && Array.isArray(s) ? !ji(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var er = (e) => _t(e) && !Object.keys(e).length, mv = (e) => e.type === "file", Tr = (e) => typeof e == "function", Al = (e) => {
  if (!cv)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, vI = (e) => e.type === "select-multiple", pv = (e) => e.type === "radio", c8 = (e) => pv(e) || ps(e), Lh = (e) => Al(e) && e.isConnected;
function u8(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = gt(e) ? i++ : e[n[i++]];
  return e;
}
function d8(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !gt(e[n]))
      return !1;
  return !0;
}
function Ft(e, n) {
  const r = Array.isArray(n) ? n : uv(n) ? [n] : fI(n), i = r.length === 1 ? e : u8(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (_t(i) && er(i) || Array.isArray(i) && d8(i)) && Ft(e, r.slice(0, -1)), e;
}
var kI = (e) => {
  for (const n in e)
    if (Tr(e[n]))
      return !0;
  return !1;
};
function Ll(e, n = {}) {
  const r = Array.isArray(e);
  if (_t(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || _t(e[i]) && !kI(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ll(e[i], n[i])) : rr(e[i]) || (n[i] = !0);
  return n;
}
function bI(e, n, r) {
  const i = Array.isArray(e);
  if (_t(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || _t(e[a]) && !kI(e[a]) ? gt(n) || Fy(r[a]) ? r[a] = Array.isArray(e[a]) ? Ll(e[a], []) : { ...Ll(e[a]) } : bI(e[a], rr(n) ? {} : n[a], r[a]) : r[a] = !ji(e[a], n[a]);
  return r;
}
var $o = (e, n) => bI(e, n, Ll(n));
const Fw = {
  value: !1,
  isValid: !1
}, Iw = { value: !0, isValid: !0 };
var _I = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !gt(e[0].attributes.value) ? gt(e[0].value) || e[0].value === "" ? Iw : { value: e[0].value, isValid: !0 } : Iw
    ) : Fw;
  }
  return Fw;
}, xI = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => gt(e) ? e : n ? e === "" ? NaN : e && +e : r && Hr(e) ? new Date(e) : i ? i(e) : e;
const $w = {
  isValid: !1,
  value: null
};
var SI = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, $w) : $w;
function Ew(e) {
  const n = e.ref;
  return mv(n) ? n.files : pv(n) ? SI(e.refs).value : vI(n) ? [...n.selectedOptions].map(({ value: r }) => r) : ps(n) ? _I(e.refs).value : xI(gt(n.value) ? e.ref.value : n.value, e);
}
var m8 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = ln(n, o);
    s && ot(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Vl = (e) => e instanceof RegExp, Eo = (e) => gt(e) ? e : Vl(e) ? e.source : _t(e) ? Vl(e.value) ? e.value.source : e.value : e, Tw = (e) => ({
  isOnSubmit: !e || e === Er.onSubmit,
  isOnBlur: e === Er.onBlur,
  isOnChange: e === Er.onChange,
  isOnAll: e === Er.all,
  isOnTouch: e === Er.onTouched
});
const Dw = "AsyncFunction";
var p8 = (e) => !!e && !!e.validate && !!(Tr(e.validate) && e.validate.constructor.name === Dw || _t(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Dw)), f8 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Ow = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Wo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = ln(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Wo(l, n))
          break;
      } else if (_t(l) && Wo(l, n))
        break;
    }
  }
};
function Rw(e, n, r) {
  const i = ln(e, r);
  if (i || uv(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = ln(n, o), l = ln(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var h8 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return er(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Er.all));
}, y8 = (e, n, r) => !e || !n || e === n || Ho(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), g8 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, v8 = (e, n) => !fc(ln(e, n)).length && Ft(e, n), k8 = (e, n, r) => {
  const i = Ho(ln(e, r));
  return ot(i, "root", n[r]), ot(e, r, i), e;
}, fl = (e) => Hr(e);
function Pw(e, n, r = "validate") {
  if (fl(e) || Array.isArray(e) && e.every(fl) || yr(e) && !e)
    return {
      type: r,
      message: fl(e) ? e : "",
      ref: n
    };
}
var ga = (e) => _t(e) && !Vl(e) ? e : {
  value: e,
  message: ""
}, Aw = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: p, minLength: d, min: f, max: h, pattern: v, validate: I, name: w, valueAsNumber: j, mount: _ } = e._f, y = ln(r, w);
  if (!_ || n.has(w))
    return {};
  const L = l ? l[0] : s, E = (B) => {
    a && L.reportValidity && (L.setCustomValidity(yr(B) ? "" : B || ""), L.reportValidity());
  }, C = {}, F = pv(s), z = ps(s), Q = F || z, Z = (j || mv(s)) && gt(s.value) && gt(y) || Al(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, te = l8.bind(null, w, i, C), G = (B, R, U, ee = ri.maxLength, Se = ri.minLength) => {
    const fe = B ? R : U;
    C[w] = {
      type: B ? ee : Se,
      message: fe,
      ref: s,
      ...te(B ? ee : Se, fe)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Q && (Z || rr(y)) || yr(y) && !y || z && !_I(l).isValid || F && !SI(l).isValid)) {
    const { value: B, message: R } = fl(u) ? { value: !!u, message: u } : ga(u);
    if (B && (C[w] = {
      type: ri.required,
      message: R,
      ref: L,
      ...te(ri.required, R)
    }, !i))
      return E(R), C;
  }
  if (!Z && (!rr(f) || !rr(h))) {
    let B, R;
    const U = ga(h), ee = ga(f);
    if (!rr(y) && !isNaN(y)) {
      const Se = s.valueAsNumber || y && +y;
      rr(U.value) || (B = Se > U.value), rr(ee.value) || (R = Se < ee.value);
    } else {
      const Se = s.valueAsDate || new Date(y), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), ye = s.type == "time", ve = s.type == "week";
      Hr(U.value) && y && (B = ye ? fe(y) > fe(U.value) : ve ? y > U.value : Se > new Date(U.value)), Hr(ee.value) && y && (R = ye ? fe(y) < fe(ee.value) : ve ? y < ee.value : Se < new Date(ee.value));
    }
    if ((B || R) && (G(!!B, U.message, ee.message, ri.max, ri.min), !i))
      return E(C[w].message), C;
  }
  if ((p || d) && !Z && (Hr(y) || o && Array.isArray(y))) {
    const B = ga(p), R = ga(d), U = !rr(B.value) && y.length > +B.value, ee = !rr(R.value) && y.length < +R.value;
    if ((U || ee) && (G(U, B.message, R.message), !i))
      return E(C[w].message), C;
  }
  if (v && !Z && Hr(y)) {
    const { value: B, message: R } = ga(v);
    if (Vl(B) && !y.match(B) && (C[w] = {
      type: ri.pattern,
      message: R,
      ref: s,
      ...te(ri.pattern, R)
    }, !i))
      return E(R), C;
  }
  if (I) {
    if (Tr(I)) {
      const B = await I(y, r), R = Pw(B, L);
      if (R && (C[w] = {
        ...R,
        ...te(ri.validate, R.message)
      }, !i))
        return E(R.message), C;
    } else if (_t(I)) {
      let B = {};
      for (const R in I) {
        if (!er(B) && !i)
          break;
        const U = Pw(await I[R](y, r), L, R);
        U && (B = {
          ...U,
          ...te(R, U.message)
        }, E(U.message), i && (C[w] = B));
      }
      if (!er(B) && (C[w] = {
        ref: L,
        ...B
      }, !i))
        return C;
    }
  }
  return E(!0), C;
};
const b8 = {
  mode: Er.onSubmit,
  reValidateMode: Er.onChange,
  shouldFocusError: !0
};
function _8(e = {}) {
  let n = {
    ...b8,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Tr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = _t(n.defaultValues) || _t(n.values) ? Vt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Vt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, p = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: Cw(),
    state: Cw()
  }, v = Tw(n.mode), I = Tw(n.reValidateMode), w = n.criteriaMode === Er.all, j = (T) => (x) => {
    clearTimeout(p), p = setTimeout(T, x);
  }, _ = async (T) => {
    if (!n.disabled && (d.isValid || f.isValid || T)) {
      const x = n.resolver ? er((await Z()).errors) : await G(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (T, x) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((T || Array.from(l.mount)).forEach((D) => {
      D && (x ? ot(r.validatingFields, D, x) : Ft(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !er(r.validatingFields)
    }));
  }, L = (T, x = [], D, H, Y = !0, A = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, A && Array.isArray(ln(i, T))) {
        const M = D(ln(i, T), H.argA, H.argB);
        Y && ot(i, T, M);
      }
      if (A && Array.isArray(ln(r.errors, T))) {
        const M = D(ln(r.errors, T), H.argA, H.argB);
        Y && ot(r.errors, T, M), v8(r.errors, T);
      }
      if ((d.touchedFields || f.touchedFields) && A && Array.isArray(ln(r.touchedFields, T))) {
        const M = D(ln(r.touchedFields, T), H.argA, H.argB);
        Y && ot(r.touchedFields, T, M);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = $o(a, o)), h.state.next({
        name: T,
        isDirty: R(T, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      ot(o, T, x);
  }, E = (T, x) => {
    ot(r.errors, T, x), h.state.next({
      errors: r.errors
    });
  }, C = (T) => {
    r.errors = T, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (T, x, D, H) => {
    const Y = ln(i, T);
    if (Y) {
      const A = ln(o, T, gt(D) ? ln(a, T) : D);
      gt(A) || H && H.defaultChecked || x ? ot(o, T, x ? A : Ew(Y._f)) : Se(T, A), s.mount && _();
    }
  }, z = (T, x, D, H, Y) => {
    let A = !1, M = !1;
    const ae = {
      name: T
    };
    if (!n.disabled) {
      if (!D || H) {
        (d.isDirty || f.isDirty) && (M = r.isDirty, r.isDirty = ae.isDirty = R(), A = M !== ae.isDirty);
        const ge = ji(ln(a, T), x);
        M = !!ln(r.dirtyFields, T), ge ? Ft(r.dirtyFields, T) : ot(r.dirtyFields, T, !0), ae.dirtyFields = r.dirtyFields, A = A || (d.dirtyFields || f.dirtyFields) && M !== !ge;
      }
      if (D) {
        const ge = ln(r.touchedFields, T);
        ge || (ot(r.touchedFields, T, D), ae.touchedFields = r.touchedFields, A = A || (d.touchedFields || f.touchedFields) && ge !== D);
      }
      A && Y && h.state.next(ae);
    }
    return A ? ae : {};
  }, Q = (T, x, D, H) => {
    const Y = ln(r.errors, T), A = (d.isValid || f.isValid) && yr(x) && r.isValid !== x;
    if (n.delayError && D ? (u = j(() => E(T, D)), u(n.delayError)) : (clearTimeout(p), u = null, D ? ot(r.errors, T, D) : Ft(r.errors, T)), (D ? !ji(Y, D) : Y) || !er(H) || A) {
      const M = {
        ...H,
        ...A && yr(x) ? { isValid: x } : {},
        errors: r.errors,
        name: T
      };
      r = {
        ...r,
        ...M
      }, h.state.next(M);
    }
  }, Z = async (T) => {
    y(T, !0);
    const x = await n.resolver(o, n.context, m8(T || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(T), x;
  }, te = async (T) => {
    const { errors: x } = await Z(T);
    if (T)
      for (const D of T) {
        const H = ln(x, D);
        H ? ot(r.errors, D, H) : Ft(r.errors, D);
      }
    else
      r.errors = x;
    return x;
  }, G = async (T, x, D = {
    valid: !0
  }) => {
    for (const H in T) {
      const Y = T[H];
      if (Y) {
        const { _f: A, ...M } = Y;
        if (A) {
          const ae = l.array.has(A.name), ge = Y._f && p8(Y._f);
          ge && d.validatingFields && y([H], !0);
          const Ne = await Aw(Y, l.disabled, o, w, n.shouldUseNativeValidation && !x, ae);
          if (ge && d.validatingFields && y([H]), Ne[A.name] && (D.valid = !1, x))
            break;
          !x && (ln(Ne, A.name) ? ae ? k8(r.errors, Ne, A.name) : ot(r.errors, A.name, Ne[A.name]) : Ft(r.errors, A.name));
        }
        !er(M) && await G(M, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const T of l.unMount) {
      const x = ln(i, T);
      x && (x._f.refs ? x._f.refs.every((D) => !Lh(D)) : !Lh(x._f.ref)) && Be(T);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (T, x) => !n.disabled && (T && x && ot(o, T, x), !ji(Te(), a)), U = (T, x, D) => yI(T, l, {
    ...s.mount ? o : gt(x) ? a : Hr(T) ? { [T]: x } : x
  }, D, x), ee = (T) => fc(ln(s.mount ? o : a, T, n.shouldUnregister ? ln(a, T, []) : [])), Se = (T, x, D = {}) => {
    const H = ln(i, T);
    let Y = x;
    if (H) {
      const A = H._f;
      A && (!A.disabled && ot(o, T, xI(x, A)), Y = Al(A.ref) && rr(x) ? "" : x, vI(A.ref) ? [...A.ref.options].forEach((M) => M.selected = Y.includes(M.value)) : A.refs ? ps(A.ref) ? A.refs.length > 1 ? A.refs.forEach((M) => (!M.defaultChecked || !M.disabled) && (M.checked = Array.isArray(Y) ? !!Y.find((ae) => ae === M.value) : Y === M.value)) : A.refs[0] && (A.refs[0].checked = !!Y) : A.refs.forEach((M) => M.checked = M.value === Y) : mv(A.ref) ? A.ref.value = "" : (A.ref.value = Y, A.ref.type || h.state.next({
        name: T,
        values: Vt(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && z(T, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && _e(T);
  }, fe = (T, x, D) => {
    for (const H in x) {
      const Y = x[H], A = `${T}.${H}`, M = ln(i, A);
      (l.array.has(T) || _t(Y) || M && !M._f) && !Mi(Y) ? fe(A, Y, D) : Se(A, Y, D);
    }
  }, ye = (T, x, D = {}) => {
    const H = ln(i, T), Y = l.array.has(T), A = Vt(x);
    ot(o, T, A), Y ? (h.array.next({
      name: T,
      values: Vt(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: T,
      dirtyFields: $o(a, o),
      isDirty: R(T, A)
    })) : H && !H._f && !rr(A) ? fe(T, A, D) : Se(T, A, D), Ow(T, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? T : void 0,
      values: Vt(o)
    });
  }, ve = async (T) => {
    s.mount = !0;
    const x = T.target;
    let D = x.name, H = !0;
    const Y = ln(i, D), A = (M) => {
      H = Number.isNaN(M) || Mi(M) && isNaN(M.getTime()) || ji(M, ln(o, D, M));
    };
    if (Y) {
      let M, ae;
      const ge = x.type ? Ew(Y._f) : mI(T), Ne = T.type === Pl.BLUR || T.type === Pl.FOCUS_OUT, tn = !f8(Y._f) && !n.resolver && !ln(r.errors, D) && !Y._f.deps || g8(Ne, ln(r.touchedFields, D), r.isSubmitted, I, v), gn = Ow(D, l, Ne);
      ot(o, D, ge), Ne ? (Y._f.onBlur && Y._f.onBlur(T), u && u(0)) : Y._f.onChange && Y._f.onChange(T);
      const nn = z(D, ge, Ne), dn = !er(nn) || gn;
      if (!Ne && h.state.next({
        name: D,
        type: T.type,
        values: Vt(o)
      }), tn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && _() : Ne || _()), dn && h.state.next({ name: D, ...gn ? {} : nn });
      if (!Ne && gn && h.state.next({ ...r }), n.resolver) {
        const { errors: wn } = await Z([D]);
        if (A(ge), H) {
          const xn = Rw(r.errors, i, D), Cn = Rw(wn, i, xn.name || D);
          M = Cn.error, D = Cn.name, ae = er(wn);
        }
      } else
        y([D], !0), M = (await Aw(Y, l.disabled, o, w, n.shouldUseNativeValidation))[D], y([D]), A(ge), H && (M ? ae = !1 : (d.isValid || f.isValid) && (ae = await G(i, !0)));
      H && (Y._f.deps && _e(Y._f.deps), Q(D, ae, M, nn));
    }
  }, K = (T, x) => {
    if (ln(r.errors, x) && T.focus)
      return T.focus(), 1;
  }, _e = async (T, x = {}) => {
    let D, H;
    const Y = Ho(T);
    if (n.resolver) {
      const A = await te(gt(T) ? T : Y);
      D = er(A), H = T ? !Y.some((M) => ln(A, M)) : D;
    } else T ? (H = (await Promise.all(Y.map(async (A) => {
      const M = ln(i, A);
      return await G(M && M._f ? { [A]: M } : M);
    }))).every(Boolean), !(!H && !r.isValid) && _()) : H = D = await G(i);
    return h.state.next({
      ...!Hr(T) || (d.isValid || f.isValid) && D !== r.isValid ? {} : { name: T },
      ...n.resolver || !T ? { isValid: D } : {},
      errors: r.errors
    }), x.shouldFocus && !H && Wo(i, K, T ? Y : l.mount), H;
  }, Te = (T) => {
    const x = {
      ...s.mount ? o : a
    };
    return gt(T) ? x : Hr(T) ? ln(x, T) : T.map((D) => ln(x, D));
  }, J = (T, x) => ({
    invalid: !!ln((x || r).errors, T),
    isDirty: !!ln((x || r).dirtyFields, T),
    error: ln((x || r).errors, T),
    isValidating: !!ln(r.validatingFields, T),
    isTouched: !!ln((x || r).touchedFields, T)
  }), Ke = (T) => {
    T && Ho(T).forEach((x) => Ft(r.errors, x)), h.state.next({
      errors: T ? r.errors : {}
    });
  }, an = (T, x, D) => {
    const H = (ln(i, T, { _f: {} })._f || {}).ref, Y = ln(r.errors, T) || {}, { ref: A, message: M, type: ae, ...ge } = Y;
    ot(r.errors, T, {
      ...ge,
      ...x,
      ref: H
    }), h.state.next({
      name: T,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, we = (T, x) => Tr(T) ? h.state.subscribe({
    next: (D) => T(U(void 0, x), D)
  }) : U(T, x, !0), Me = (T) => h.state.subscribe({
    next: (x) => {
      y8(T.name, x.name, T.exact) && h8(x, T.formState || d, Pe, T.reRenderRoot) && T.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, Re = (T) => (s.mount = !0, f = {
    ...f,
    ...T.formState
  }, Me({
    ...T,
    formState: f
  })), Be = (T, x = {}) => {
    for (const D of T ? Ho(T) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (Ft(i, D), Ft(o, D)), !x.keepError && Ft(r.errors, D), !x.keepDirty && Ft(r.dirtyFields, D), !x.keepTouched && Ft(r.touchedFields, D), !x.keepIsValidating && Ft(r.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && Ft(a, D);
    h.state.next({
      values: Vt(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: R() } : {}
    }), !x.keepIsValid && _();
  }, Ae = ({ disabled: T, name: x }) => {
    (yr(T) && s.mount || T || l.disabled.has(x)) && (T ? l.disabled.add(x) : l.disabled.delete(x));
  }, Ge = (T, x = {}) => {
    let D = ln(i, T);
    const H = yr(x.disabled) || yr(n.disabled);
    return ot(i, T, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: T } },
        name: T,
        mount: !0,
        ...x
      }
    }), l.mount.add(T), D ? Ae({
      disabled: yr(x.disabled) ? x.disabled : n.disabled,
      name: T
    }) : F(T, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Eo(x.min),
        max: Eo(x.max),
        minLength: Eo(x.minLength),
        maxLength: Eo(x.maxLength),
        pattern: Eo(x.pattern)
      } : {},
      name: T,
      onChange: ve,
      onBlur: ve,
      ref: (Y) => {
        if (Y) {
          Ge(T, x), D = ln(i, T);
          const A = gt(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, M = c8(A), ae = D._f.refs || [];
          if (M ? ae.find((ge) => ge === A) : A === D._f.ref)
            return;
          ot(i, T, {
            _f: {
              ...D._f,
              ...M ? {
                refs: [
                  ...ae.filter(Lh),
                  A,
                  ...Array.isArray(ln(a, T)) ? [{}] : []
                ],
                ref: { type: A.type, name: T }
              } : { ref: A }
            }
          }), F(T, !1, void 0, A);
        } else
          D = ln(i, T, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(pI(l.array, T) && s.action) && l.unMount.add(T);
      }
    };
  }, Ce = () => n.shouldFocusError && Wo(i, K, l.mount), qe = (T) => {
    yr(T) && (h.state.next({ disabled: T }), Wo(i, (x, D) => {
      const H = ln(i, D);
      H && (x.disabled = H._f.disabled || T, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || T;
      }));
    }, 0, !1));
  }, en = (T, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = Vt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: A, values: M } = await Z();
      r.errors = A, Y = M;
    } else
      await G(i);
    if (l.disabled.size)
      for (const A of l.disabled)
        ot(Y, A, void 0);
    if (Ft(r.errors, "root"), er(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await T(Y, D);
      } catch (A) {
        H = A;
      }
    } else
      x && await x({ ...r.errors }, D), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: er(r.errors) && !H,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), H)
      throw H;
  }, ie = (T, x = {}) => {
    ln(i, T) && (gt(x.defaultValue) ? ye(T, Vt(ln(a, T))) : (ye(T, x.defaultValue), ot(a, T, Vt(x.defaultValue))), x.keepTouched || Ft(r.touchedFields, T), x.keepDirty || (Ft(r.dirtyFields, T), r.isDirty = x.defaultValue ? R(T, Vt(ln(a, T))) : R()), x.keepError || (Ft(r.errors, T), d.isValid && _()), h.state.next({ ...r }));
  }, se = (T, x = {}) => {
    const D = T ? Vt(T) : a, H = Vt(D), Y = er(T), A = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const M = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys($o(a, o))
        ]);
        for (const ae of Array.from(M))
          ln(r.dirtyFields, ae) ? ot(A, ae, ln(o, ae)) : ye(ae, ln(A, ae));
      } else {
        if (cv && gt(T))
          for (const M of l.mount) {
            const ae = ln(i, M);
            if (ae && ae._f) {
              const ge = Array.isArray(ae._f.refs) ? ae._f.refs[0] : ae._f.ref;
              if (Al(ge)) {
                const Ne = ge.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const M of l.mount)
          ye(M, ln(A, M));
      }
      o = Vt(A), h.array.next({
        values: { ...A }
      }), h.state.next({
        values: { ...A }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !ji(T, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? $o(a, o) : r.dirtyFields : x.keepDefaultValues && T ? $o(a, T) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (T, x) => se(Tr(T) ? T(o) : T, x), Le = (T, x = {}) => {
    const D = ln(i, T), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && Tr(Y.select) && Y.select());
    }
  }, Pe = (T) => {
    r = {
      ...r,
      ...T
    };
  }, yn = {
    control: {
      register: Ge,
      unregister: Be,
      getFieldState: J,
      handleSubmit: en,
      setError: an,
      _subscribe: Me,
      _runSchema: Z,
      _getWatch: U,
      _getDirty: R,
      _setValid: _,
      _setFieldArray: L,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: ee,
      _reset: se,
      _resetDefaultValues: () => Tr(n.defaultValues) && n.defaultValues().then((T) => {
        xe(T, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(T) {
        s = T;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(T) {
        l = T;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(T) {
        n = {
          ...n,
          ...T
        };
      }
    },
    subscribe: Re,
    trigger: _e,
    register: Ge,
    handleSubmit: en,
    watch: we,
    setValue: ye,
    getValues: Te,
    reset: xe,
    resetField: ie,
    clearErrors: Ke,
    unregister: Be,
    setError: an,
    setFocus: Le,
    getFieldState: J
  };
  return {
    ...yn,
    formControl: yn
  };
}
function x8(e = {}) {
  const n = Ee.useRef(void 0), r = Ee.useRef(void 0), [i, a] = Ee.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Tr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Tr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : _8(e),
    formState: i
  }, e.formControl && e.defaultValues && !Tr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ee.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ee.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ee.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ee.useEffect(() => {
    e.values && !ji(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ee.useEffect(() => {
    e.errors && !er(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ee.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ee.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = hI(i, o), n.current;
}
const S8 = "_settingsWrapper_1ycvy_1", N8 = "_settingsWrapperHeader_1ycvy_6", j8 = "_settingsWrapperContent_1ycvy_10", w8 = "_settingsWrapperContentCode_1ycvy_18", C8 = "_settingsWrapperContentCURL_1ycvy_26", To = {
  settingsWrapper: S8,
  settingsWrapperHeader: N8,
  settingsWrapperContent: j8,
  settingsWrapperContentCode: w8,
  settingsWrapperContentCURL: C8
}, F8 = ({
  handleChangeText: e
}) => {
  const [n, r] = ue(!1), { isCopied: i, copy: a } = ir(), { control: o } = x8({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = gI({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", u = ft(() => {
    const p = s.storeId, d = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${p || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${d ? ` \\
  --data '{"secret":"${d}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ve.jsx(Ve.Fragment, { children: /* @__PURE__ */ Ve.jsx(pe, { span: 6, children: /* @__PURE__ */ Ve.jsxs(b, { flexDirection: "column", className: To.settingsWrapper, children: [
    /* @__PURE__ */ Ve.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: To.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ve.jsx(he, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ve.jsxs(
      b,
      {
        flexDirection: "column",
        className: To.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ve.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ve.jsx(
            Bl,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ve.jsxs("ol", { children: [
                /* @__PURE__ */ Ve.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ve.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ve.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ve.jsx("span", { className: To.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ve.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ve.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ve.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ve.jsx(
            ww,
            {
              name: "storeId",
              control: o,
              render: ({ field: p }) => /* @__PURE__ */ Ve.jsx(
                ur,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...p,
                    onChange: (d) => {
                      p.onChange(d), e({
                        target: {
                          name: "yotpoStoreId",
                          value: d?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ve.jsx(
            ww,
            {
              name: "secret",
              control: o,
              render: ({ field: p }) => /* @__PURE__ */ Ve.jsx(
                ur,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: p
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
            /* @__PURE__ */ Ve.jsx(rn, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ve.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: To.settingsWrapperContentCURL,
                children: u()
              }
            ) }),
            /* @__PURE__ */ Ve.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ve.jsx(
              Je,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ve.jsx(
                  et,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(u()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, I8 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], $8 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Da
  }
], E8 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: F8
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], T8 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, D8 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, O8 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: JW,
  featureSettings: []
} : n ? {
  authSettings: XW,
  featureSettings: [...nI]
} : e ? {
  authSettings: [
    ...Xj,
    ...YW
  ],
  featureSettings: [...Zj]
} : {
  authSettings: [
    ...Xj,
    ...QW
  ],
  featureSettings: [...Zj]
}, NI = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, R8 = NI(
  $8,
  E8
), P8 = NI(
  XV,
  ZV
), jI = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = D8(a?.value, r), s = i !== void 0 ? i : T8(
    r
  );
  return o !== void 0 ? o : s;
}, fv = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = O8(n), s = R8(r), l = P8(i);
  return {
    SHOPIFY: {
      widget: iK,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: jL,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: Xh,
      WidgetSettings: FL
    },
    GITHUB: {
      widget: CA,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: Yh,
      WidgetSettings: IA
    },
    MIUROS: {
      widget: aq,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: gy,
      WidgetSettings: sq
    },
    KLAVIYO: {
      widget: QV,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...JV]
    },
    LINEAR: {
      widget: NB,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: py,
      WidgetSettings: wB
    },
    VOYADO: {
      widget: RG,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Cy,
      WidgetSettings: AG
    },
    LOYALTYLION: {
      widget: r5,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: fy,
      WidgetSettings: a5
    },
    RECHARGE: {
      widget: Tq,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: by,
      WidgetSettings: Oq
    },
    BRAZE: {
      widget: BD,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...qD]
    },
    YOTPO: {
      widget: t8,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...I8]
    },
    INGRID: {
      widget: t2,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Qh,
      WidgetSettings: i2
    },
    RIVOLOYALTY: {
      widget: v6,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: xy,
      WidgetSettings: AW
    }
  };
}, A8 = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? GI(r, e.defaultValue) : YI(r, e.defaultValue);
}, L8 = (e, n) => e.map((r) => ({
  key: r.key,
  value: A8(r, n)
})), V8 = (e, n) => e.map(({ key: r, type: i, defaultValue: a }) => ({
  key: r,
  value: jI({
    key: r,
    configuration: n,
    settingType: i,
    settingDefault: a
  })
})), z8 = ({ fieldDefinitions: e, settingsConfiguration: n }, r) => e ? L8(
  e.filter(({ secret: i }) => !i),
  r
) : V8(
  (n ?? []).filter(({ secret: i }) => !i),
  r
), U8 = (e) => {
  const n = fv();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: u
    }) => {
      const d = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: z8(d, o),
        misconfigured: s,
        renderConditions: l,
        icon: d.icon,
        iconColors: d.iconColors,
        widget: d.widget,
        integrationKey: u
      };
    }
  );
}, AY = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: u,
  renderConditionMatchedIndicator: p,
  widgetAnnotations: d
}) => {
  const f = Bi(
    {}
  ), h = (F) => (f.current[F] || (f.current[F] = { current: null }), f.current[F]), { track: v } = $n(), I = Xn(
    () => U8(e),
    [e]
  ), w = {
    headline: "",
    text: "",
    onConfirm: () => C(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [j, _] = ue(w), [y, L] = ue(!1), E = (F) => {
    L(!0), _(F);
  }, C = () => {
    L(!1), _(w);
  };
  return /* @__PURE__ */ We.jsxs(We.Fragment, { children: [
    I.map(
      ({
        id: F,
        name: z,
        type: Q,
        widget: Z,
        settings: te,
        misconfigured: G,
        renderConditions: B,
        icon: R,
        iconColors: U,
        integrationKey: ee
      }, Se) => {
        const fe = `partner-integration-${Q}`, ye = d?.get(F) === !1, ve = /* @__PURE__ */ We.jsx(Dy, { icon: R, color: U }), K = te?.reduce(
          (_e, Te) => (_e[Te.key] = Te.value, _e),
          {}
        );
        return s ? /* @__PURE__ */ We.jsx("div", { className: "icon-holder", children: ve }, `partner-icon-${F}`) : /* @__PURE__ */ We.jsxs(
          xr,
          {
            onToggle: () => {
              v(
                o(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: F,
                  widgetType: Q.toLowerCase()
                }
              ), a(ee);
            },
            isOpen: o(ee),
            className: fe,
            containerRef: (_e) => {
              h(ee).current = _e;
            },
            children: [
              /* @__PURE__ */ We.jsx(
                xr.Header,
                {
                  className: dt({
                    [hD.unmatchedHeader]: ye
                  }),
                  wrap: "normal",
                  avatar: ve,
                  slotBeforeTitle: u?.(
                    ee,
                    Se,
                    h(ee)
                  ),
                  slotAfterTitle: /* @__PURE__ */ We.jsx(We.Fragment, { children: l?.(ee) }),
                  children: /* @__PURE__ */ We.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    z,
                    p?.(
                      B ?? [],
                      F
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ We.jsx(xr.Content, { children: G ? /* @__PURE__ */ We.jsx(Tn, { isMisconfigured: !0 }) : /* @__PURE__ */ We.jsx(
                Jw.Provider,
                {
                  value: {
                    onError: (_e, Te) => console.warn(
                      `Something went wrong with a partner widget of type '${Q}' and id '${F}'`,
                      _e,
                      Te
                    )
                  },
                  children: /* @__PURE__ */ We.jsx(
                    D1,
                    {
                      integrationId: F,
                      type: Q,
                      configuration: n,
                      showNotification: i,
                      showModal: E,
                      children: i$(Z, {
                        conversationContext: r,
                        settings: K
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ We.jsx(
      Kw,
      {
        isOpen: y,
        setIsOpen: L,
        headline: j.headline,
        text: j.text,
        confirmLabel: j.confirmLabel,
        confirmVariant: j.confirmVariant,
        cancelLabel: j.cancelLabel,
        cancelVariant: j.cancelVariant,
        onConfirm: j.onConfirm ? () => {
          try {
            j.onConfirm && j.onConfirm();
          } finally {
            L(!1), _(w);
          }
        } : void 0,
        onCancel: j.onCancel ? () => {
          try {
            j.onCancel && j.onCancel();
          } finally {
            L(!1), _(w);
          }
        } : void 0,
        children: j.children
      }
    )
  ] });
}, M8 = ql`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function LY(e, { skip: n = !1 } = {}) {
  const [r, i] = ue([]), [a, o] = ue(!1);
  return Xe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), T1(e).query({
      query: M8
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (u) => u != null
        ).map((u) => ({
          ...u,
          integrationKey: `partner-integration-${u.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const B8 = ({
  widgetConfiguration: e
}) => {
  const n = Xn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Xn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, q8 = "FULL_ACCESS", H8 = "2", W8 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((u) => u.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [q8],
        version: H8
      })
    }).then((l) => l.json())
  };
}, K8 = "dixaApiToken", hv = "dixaApiTokenId", wI = "dixaApiTokenName", Lw = (e) => [hv, wI].every(
  (r) => e.find((i) => i?.key === r)
);
function G8({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = Y8(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const Y8 = (e) => [
  {
    key: K8,
    value: e.value,
    secret: !0
  },
  {
    key: hv,
    value: e.id,
    secret: !1
  },
  {
    key: wI,
    value: e.name,
    secret: !1
  }
], Q8 = "_wrapper_1lmim_1", J8 = "_wrapperBox_1lmim_4", X8 = "_wrapperBoxErrorBorder_1lmim_9", Vh = {
  wrapper: Q8,
  wrapperBox: J8,
  wrapperBoxErrorBorder: X8
}, Z8 = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: u,
  handleChangeText: p
}) => {
  const f = o?.find(
    (L) => L.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, I = `Insert your ${h.label.toLowerCase()}`, w = `Insert your ${v.label.toLowerCase()}`, [j, _] = ue({
    username: "",
    password: ""
  }), y = ft(
    (L) => {
      p({
        target: {
          name: s,
          value: L
        }
      });
    },
    [s, p]
  );
  return Xe(() => {
    y(
      j.username !== "" && j.password !== "" ? window.btoa(`${j.username}:${j.password}`) : ""
    );
  }, [j]), /* @__PURE__ */ We.jsx(
    rn,
    {
      required: e,
      label: a,
      meta: l,
      className: Vh.wrapper,
      children: /* @__PURE__ */ We.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: dt(Vh.wrapperBox, {
            [Vh.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ We.jsx(
              ur,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: I,
                input: {
                  name: s,
                  value: j.username,
                  onChange: (L) => _({
                    username: L?.target.value ?? "",
                    password: j.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ We.jsx(
              ur,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: w,
                input: {
                  name: s,
                  value: j.password,
                  onChange: (L) => _({
                    username: j.username,
                    password: L?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function Vw({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: u,
  handleEditSecret: p,
  getValueByKey: d,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: I,
  prefix: w,
  integrationId: j,
  integrationType: _,
  configuration: y,
  settings: L,
  otherProps: E
}) {
  const C = v === "custom" && E?.component, F = d(n)?.value;
  return C ? /* @__PURE__ */ We.jsx(
    C,
    {
      configuration: y,
      integrationId: j,
      integrationType: _,
      label: r,
      settings: L,
      getValueByKey: d,
      widgetSettingsKey: n,
      handleChangeSelect: u,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ We.jsxs(We.Fragment, { children: [
    /* @__PURE__ */ We.jsx(pe, { span: 3, children: /* @__PURE__ */ We.jsx(
      eY,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: p,
        isCreationMode: I,
        children: v === "input" ? /* @__PURE__ */ We.jsx(
          ur,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: F,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: w,
            ...e && !I && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => p(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ We.jsx(
          Z8,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: I,
            label: r,
            widgetSettingsKey: n,
            settings: L,
            meta: { error: h[n] },
            handleEditSecret: p,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ We.jsx(rn, { label: r, children: /* @__PURE__ */ We.jsx(
          Oy,
          {
            input: {
              name: n,
              value: "",
              checked: F,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ We.jsx(rn, { label: r, children: /* @__PURE__ */ We.jsx(
          _i,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (z) => u(n, z),
            getItemTitleByValue: (z) => z ? /* @__PURE__ */ We.jsx(P.Paragraph, { children: z.label }) : /* @__PURE__ */ We.jsx(We.Fragment, {}),
            value: F ? [
              {
                label: (E?.selectItems || []).find(
                  (z) => z.value === F
                )?.label,
                value: F
              }
            ] : [],
            equalityFn: (z, Q) => z.value === Q.value,
            children: (E?.selectItems || []).map((z) => /* @__PURE__ */ We.jsx(vt.Item, { value: z, children: z.label }, z.value))
          }
        ) }) : /* @__PURE__ */ We.jsx(We.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ We.jsx(pe, { span: 3 })
  ] });
}
function eY({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ We.jsx(rn, { label: n, children: /* @__PURE__ */ We.jsxs(
    et,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ko = "partner-integrations-widget-name-form-field", zw = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: u
  }) => ({
    key: i,
    value: jI({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...u && { customValidation: u }
  })
), nY = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = ue(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = ue({}), s = (E) => i(E), l = (E) => !E || E === "", u = (E) => {
    const { [E]: C, ...F } = a;
    o(F);
  }, p = (E) => ({
    ...E,
    settings: E.settings.filter(({ isEditing: C }) => C).map(({ key: C, value: F, secret: z }) => ({
      key: C,
      value: F,
      secret: z
    }))
  }), d = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (E) => {
    if (!E)
      return;
    const {
      target: { name: C, value: F }
    } = E;
    a[C] && !l(F) && u(C), i({
      ...r,
      settings: r.settings.map(
        (z) => z.key === C ? { ...z, value: F } : z
      )
    });
  }, h = (E) => {
    if (!E)
      return;
    const {
      target: { name: C, checked: F }
    } = E;
    i({
      ...r,
      settings: r.settings.map(
        (z) => z.key === C ? { ...z, value: F } : z
      )
    });
  }, v = (E, C) => {
    if (!C)
      return;
    const { selectedValues: F } = C, z = F?.[0];
    if (z) {
      const Q = r.settings.map(
        (Z) => Z.key === E ? { ...Z, value: z?.value } : Z
      );
      i({
        ...r,
        settings: Q
      });
    } else {
      const Q = r.settings.filter(
        (Z) => Z.key !== E
      );
      i({
        ...r,
        settings: Q
      });
    }
  }, I = (E) => {
    i({
      ...r,
      enabled: E
    });
  }, w = (E) => {
    if (!E)
      return;
    const {
      target: { value: C }
    } = E;
    a[Ko] && !l(C) && u(Ko), i({
      ...r,
      name: C
    });
  }, j = (E, C) => {
    const { settings: F } = r, z = F.map((Q) => Q.key === C ? {
      ...Q,
      isEditing: E,
      ...!E && { value: "" }
    } : Q);
    a[C] && !E && u(C), i({
      ...r,
      settings: z
    });
  }, _ = (E) => r.settings.find(
    (C) => C.key === E
  ), y = async (E) => {
    E.preventDefault(), L() && n(p(r));
  }, L = () => {
    const E = {}, { name: C, settings: F } = r;
    return l(C) && (E[Ko] = d.input), F.forEach(
      ({ key: z, value: Q, required: Z, isEditing: te, type: G, customValidation: B }) => {
        if (Z && te)
          if (B) {
            const R = B(Q);
            typeof R == "string" && (E[z] = R);
          } else
            typeof Q == "string" && l(Q) && (E[z] = d[G]);
      }
    ), o(E), !Object.keys(E)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: I,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: j,
    handleChangeName: w,
    handleSubmit: y,
    getSettingValueByKey: _,
    initializeFormData: s,
    validate: L
  };
}, tY = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], Uw = "The configuration of the integration is not correct. Please check the settings.", rY = (e) => {
  const n = fv()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ We.jsx(n, { ...e }) : /* @__PURE__ */ We.jsx(iY, { ...e });
}, iY = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = $n(), { deleteDixaApiToken: u, createDixaApiToken: p } = W8({
    type: n,
    baseUrl: a.baseUrl
  }), f = _$().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, v = tY.includes(n), [I, w] = ue(), [j, _] = ue(!1), [y, L] = ue(!1), [E, C] = ue(!1), [F, z] = ue(null), [Q, Z] = ue(), [te, G] = ue(h ? [] : null);
  Xe(() => {
    G(h ? [] : null);
  }, [e, h]), Xe(() => {
    Q && te === null && G(Q.renderConditions ?? []);
  }, [Q, te]);
  const { isInboundOAuth: B } = QI(), R = B && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: U,
    isShopifyMarketplaceApp: ee,
    initialValuesForShopify: Se
  } = B8({
    featureFlags: a.featureFlags,
    widgetConfiguration: Q
  }), fe = n === "YOTPO" && !!Q?.additionalProperties?.isUsingOAuth, ye = n === "KLAVIYO" && !!Q?.additionalProperties?.isUsingOAuth, ve = h && n === "SHOPIFY", Te = fv({
    SHOPIFY: {
      hasShopifyOAuth: U,
      isShopifyMarketplaceApp: ee,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: fe,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: ye,
      isCreationMode: h
    }
  })[n].settingsConfiguration ?? [], J = Te.filter(({ type: H }) => H !== "hidden").filter(({ hideOnCreate: H }) => h ? !H : !0), Ke = J.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm === !0
  ), an = J.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm !== !0
  ), {
    error: we,
    loading: Me,
    refetch: Re
  } = v$(JI, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (H) => {
      if (Object.keys(H).length === 0)
        C(!0);
      else {
        C(!1);
        const Y = H?.Management?.widgetConfigurations?.[0];
        Y && Z({
          ...Y,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${Y.id}`,
          additionalProperties: Y.additionalProperties ?? void 0
        });
      }
    }
  }), [Be, { error: Ae }] = Sv(
    h ? XI : ZI,
    {
      onError: (H) => {
        w(H), _(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (H) => {
        if (_(!1), Object.keys(H).length !== 0) {
          if (h && r(
            H.Management?.createWidgetConfiguration?.id
          ), !h) {
            const A = H.Management?.updateWidgetConfiguration;
            A?.misconfigured ? z(
              A.misconfigurationCause ?? Uw
            ) : z(null);
          }
          if ((h || s) && te) {
            const Y = (Q?.renderConditions?.length ?? 0) > 0;
            e$(
              l,
              h,
              te,
              Y
            );
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Ge] = Sv(n$, {
    onError: (H) => {
      w(H), _(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      _(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ce,
    handleIsEnabled: qe,
    errors: en,
    handleChangeText: ie,
    handleChangeBoolean: se,
    handleChangeSelect: xe,
    handleEditSecret: Le,
    handleChangeName: Pe,
    handleSubmit: yn,
    getSettingValueByKey: T,
    initializeFormData: x
  } = nY({
    onSubmit: async (H) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), _(!0);
      const Y = H.settings.map(
        (ge) => typeof ge.value == "boolean" ? { ...ge, value: ge.value.toString() } : ge
      ), A = Lw(Y) && h;
      let M = [];
      if (A) {
        const ge = await p().catch(
          (Ne) => {
            _(!1), console.warn("API-Token (creation) error resonse", Ne), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        ge?.data && (M = G8({
          token: ge.data,
          settings: Y
        }));
      }
      const ae = {
        ...H,
        settings: [
          ...M.length > 0 ? M : Y
        ]
      };
      (A && M.length > 1 || !A && M.length === 0) && (Be({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...ae,
          ...(h || !!s) && te !== null && { renderConditions: te }
        }
      }), Y.forEach(
        (Ne) => Ne.secret && Le(!1, Ne.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: zw({
          settingsFromBackend: Se,
          settingsConfiguration: Te,
          creating: !0
        })
      }
    }
  });
  Xe(() => {
    if (Q) {
      const H = zw({
        settingsFromBackend: Q.settings,
        settingsConfiguration: Te
      });
      x({
        enabled: !!Q.enabled,
        name: Q.name,
        settings: H
      }), Q.misconfigured ? z(
        Q?.misconfigurationCause ?? Uw
      ) : z(null);
    }
  }, [Q]);
  const D = Xn(() => o ? !o.isCoupled : !0, [o]);
  return we || Ae || I ? /* @__PURE__ */ We.jsx(
    Tn,
    {
      error: we || I,
      retry: we ? Re : void 0
    }
  ) : j || Me ? /* @__PURE__ */ We.jsx(vn, { "data-testid": "widget-settings-loading" }) : E ? /* @__PURE__ */ We.jsxs(P.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ We.jsx(Yn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ We.jsxs("form", { children: [
    F && /* @__PURE__ */ We.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ We.jsx(
      Bl,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ We.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ We.jsx(P.Paragraph, { children: F }),
          /* @__PURE__ */ We.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ We.jsx(P.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ We.jsx(P.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ We.jsxs(
      mt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          Ke.map(
            ({ key: H, label: Y, ...A }) => /* @__PURE__ */ We.jsx(
              Vw,
              {
                widgetSettingsKey: H,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: T,
                isSecret: !1,
                label: Y,
                placeholder: "",
                required: !1,
                errors: en,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: Te,
                otherProps: A
              },
              H
            )
          ),
          !ve && /* @__PURE__ */ We.jsxs(We.Fragment, { children: [
            /* @__PURE__ */ We.jsx(pe, { children: /* @__PURE__ */ We.jsx(rn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ We.jsx(
              Oy,
              {
                input: {
                  name: "enabled",
                  checked: Ce.enabled,
                  value: "dummy",
                  onChange: (H) => qe(H.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ We.jsx(pe, { span: 3, children: /* @__PURE__ */ We.jsx(
              ur,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Ko,
                  value: Ce.name,
                  onChange: Pe
                },
                meta: {
                  error: en[Ko]
                }
              }
            ) }),
            /* @__PURE__ */ We.jsx(pe, { span: 3 })
          ] }),
          !ve && s && te !== null && /* @__PURE__ */ We.jsx(pe, { children: s({
            value: te,
            onChange: G,
            configurationKey: Q?.id
          }) }),
          an?.map(
            ({
              key: H,
              secret: Y,
              label: A,
              placeholder: M = "",
              required: ae = !1,
              type: ge,
              prefix: Ne,
              readOnly: tn,
              ...gn
            }) => {
              const { settings: nn } = Ce, dn = nn.find(
                (wn) => wn.key === H
              );
              return /* @__PURE__ */ We.jsx(a$, { children: /* @__PURE__ */ We.jsx(
                Vw,
                {
                  widgetSettingsKey: H,
                  isEditingField: !!dn?.isEditing,
                  handleEditSecret: Le,
                  handleChangeText: ie,
                  handleChangeBoolean: se,
                  handleChangeSelect: xe,
                  getValueByKey: T,
                  isSecret: Y,
                  label: A,
                  placeholder: M,
                  required: ae,
                  errors: en,
                  type: ge,
                  isCreationMode: h,
                  prefix: Ne,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: tn,
                  settings: Te,
                  otherProps: gn
                }
              ) }, H);
            }
          )
        ]
      }
    ),
    !ve && /* @__PURE__ */ We.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ We.jsx(et, { onClick: yn, children: R }),
      !h && /* @__PURE__ */ We.jsx(
        Je,
        {
          content: "The widget is used in automations",
          disabled: D,
          children: /* @__PURE__ */ We.jsx(
            et,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), L(!0);
              },
              disabled: !D,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ We.jsx(
      Kw,
      {
        isOpen: y,
        setIsOpen: L,
        confirmVariant: v ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Lw(Ce.settings)) {
            const H = Ce.settings.find(
              ({ key: Y }) => Y === hv
            )?.value;
            H && u(H).catch((Y) => {
              console.warn("API-Token (deletion) error response", Y), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Ge({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ We.jsx(b, { children: v ? /* @__PURE__ */ We.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ We.jsx(
            he,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ We.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ We.jsxs(P.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ We.jsxs(P.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ We.jsxs(P.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ce.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ We.jsxs(We.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ce.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, VY = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ We.jsx(
  Jw.Provider,
  {
    value: {
      onError: (l, u) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        u
      )
    },
    children: /* @__PURE__ */ We.jsx(
      D1,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ We.jsx(
          rY,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), Mw = "__PairingContext__", CI = globalThis[Mw] ?? (() => {
  const e = Yw({});
  return globalThis[Mw] = e, e;
})(), zY = () => Ey(CI), UY = ({
  value: e,
  children: n
}) => /* @__PURE__ */ We.jsx(CI.Provider, { value: e, children: n });
var Js = { exports: {} }, Bw;
function aY() {
  if (Bw) return Js.exports;
  Bw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(C, F, z) {
    return Function.prototype.apply.call(C, F, z);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(C) {
    return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
  } : r = function(C) {
    return Object.getOwnPropertyNames(C);
  };
  function i(E) {
    console && console.warn && console.warn(E);
  }
  var a = Number.isNaN || function(C) {
    return C !== C;
  };
  function o() {
    o.init.call(this);
  }
  Js.exports = o, Js.exports.once = _, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(E) {
    if (typeof E != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof E);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(E) {
      if (typeof E != "number" || E < 0 || a(E))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + E + ".");
      s = E;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(C) {
    if (typeof C != "number" || C < 0 || a(C))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + C + ".");
    return this._maxListeners = C, this;
  };
  function u(E) {
    return E._maxListeners === void 0 ? o.defaultMaxListeners : E._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return u(this);
  }, o.prototype.emit = function(C) {
    for (var F = [], z = 1; z < arguments.length; z++) F.push(arguments[z]);
    var Q = C === "error", Z = this._events;
    if (Z !== void 0)
      Q = Q && Z.error === void 0;
    else if (!Q)
      return !1;
    if (Q) {
      var te;
      if (F.length > 0 && (te = F[0]), te instanceof Error)
        throw te;
      var G = new Error("Unhandled error." + (te ? " (" + te.message + ")" : ""));
      throw G.context = te, G;
    }
    var B = Z[C];
    if (B === void 0)
      return !1;
    if (typeof B == "function")
      n(B, this, F);
    else
      for (var R = B.length, U = I(B, R), z = 0; z < R; ++z)
        n(U[z], this, F);
    return !0;
  };
  function p(E, C, F, z) {
    var Q, Z, te;
    if (l(F), Z = E._events, Z === void 0 ? (Z = E._events = /* @__PURE__ */ Object.create(null), E._eventsCount = 0) : (Z.newListener !== void 0 && (E.emit(
      "newListener",
      C,
      F.listener ? F.listener : F
    ), Z = E._events), te = Z[C]), te === void 0)
      te = Z[C] = F, ++E._eventsCount;
    else if (typeof te == "function" ? te = Z[C] = z ? [F, te] : [te, F] : z ? te.unshift(F) : te.push(F), Q = u(E), Q > 0 && te.length > Q && !te.warned) {
      te.warned = !0;
      var G = new Error("Possible EventEmitter memory leak detected. " + te.length + " " + String(C) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      G.name = "MaxListenersExceededWarning", G.emitter = E, G.type = C, G.count = te.length, i(G);
    }
    return E;
  }
  o.prototype.addListener = function(C, F) {
    return p(this, C, F, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(C, F) {
    return p(this, C, F, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(E, C, F) {
    var z = { fired: !1, wrapFn: void 0, target: E, type: C, listener: F }, Q = d.bind(z);
    return Q.listener = F, z.wrapFn = Q, Q;
  }
  o.prototype.once = function(C, F) {
    return l(F), this.on(C, f(this, C, F)), this;
  }, o.prototype.prependOnceListener = function(C, F) {
    return l(F), this.prependListener(C, f(this, C, F)), this;
  }, o.prototype.removeListener = function(C, F) {
    var z, Q, Z, te, G;
    if (l(F), Q = this._events, Q === void 0)
      return this;
    if (z = Q[C], z === void 0)
      return this;
    if (z === F || z.listener === F)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[C], Q.removeListener && this.emit("removeListener", C, z.listener || F));
    else if (typeof z != "function") {
      for (Z = -1, te = z.length - 1; te >= 0; te--)
        if (z[te] === F || z[te].listener === F) {
          G = z[te].listener, Z = te;
          break;
        }
      if (Z < 0)
        return this;
      Z === 0 ? z.shift() : w(z, Z), z.length === 1 && (Q[C] = z[0]), Q.removeListener !== void 0 && this.emit("removeListener", C, G || F);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(C) {
    var F, z, Q;
    if (z = this._events, z === void 0)
      return this;
    if (z.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : z[C] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete z[C]), this;
    if (arguments.length === 0) {
      var Z = Object.keys(z), te;
      for (Q = 0; Q < Z.length; ++Q)
        te = Z[Q], te !== "removeListener" && this.removeAllListeners(te);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (F = z[C], typeof F == "function")
      this.removeListener(C, F);
    else if (F !== void 0)
      for (Q = F.length - 1; Q >= 0; Q--)
        this.removeListener(C, F[Q]);
    return this;
  };
  function h(E, C, F) {
    var z = E._events;
    if (z === void 0)
      return [];
    var Q = z[C];
    return Q === void 0 ? [] : typeof Q == "function" ? F ? [Q.listener || Q] : [Q] : F ? j(Q) : I(Q, Q.length);
  }
  o.prototype.listeners = function(C) {
    return h(this, C, !0);
  }, o.prototype.rawListeners = function(C) {
    return h(this, C, !1);
  }, o.listenerCount = function(E, C) {
    return typeof E.listenerCount == "function" ? E.listenerCount(C) : v.call(E, C);
  }, o.prototype.listenerCount = v;
  function v(E) {
    var C = this._events;
    if (C !== void 0) {
      var F = C[E];
      if (typeof F == "function")
        return 1;
      if (F !== void 0)
        return F.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function I(E, C) {
    for (var F = new Array(C), z = 0; z < C; ++z)
      F[z] = E[z];
    return F;
  }
  function w(E, C) {
    for (; C + 1 < E.length; C++)
      E[C] = E[C + 1];
    E.pop();
  }
  function j(E) {
    for (var C = new Array(E.length), F = 0; F < C.length; ++F)
      C[F] = E[F].listener || E[F];
    return C;
  }
  function _(E, C) {
    return new Promise(function(F, z) {
      function Q(te) {
        E.removeListener(C, Z), z(te);
      }
      function Z() {
        typeof E.removeListener == "function" && E.removeListener("error", Q), F([].slice.call(arguments));
      }
      L(E, C, Z, { once: !0 }), C !== "error" && y(E, Q, { once: !0 });
    });
  }
  function y(E, C, F) {
    typeof E.on == "function" && L(E, "error", C, F);
  }
  function L(E, C, F, z) {
    if (typeof E.on == "function")
      z.once ? E.once(C, F) : E.on(C, F);
    else if (typeof E.addEventListener == "function")
      E.addEventListener(C, function Q(Z) {
        z.once && E.removeEventListener(C, Q), F(Z);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof E);
  }
  return Js.exports;
}
var oY = aY();
function MY() {
  const e = new oY.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  uD as GraphQLClientProvider,
  CI as PairingContext,
  UY as PairingProvider,
  AY as PartnerIntegrations,
  VY as PartnerIntegrationsSettings,
  fv as getWidgetDefinitions,
  MY as initializePartnerEventEmitter,
  zY as usePairing,
  LY as usePartnerIntegrationWidgetConfigurations,
  B8 as useShopifyConfiguration
};
